// src/components/map/map.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment DynamicMapFragment on EGDSBasicMap {\n    label\n    initialViewport\n    center {\n      latitude\n      longitude\n    }\n    zoom\n    bounds {\n      northeast {\n        latitude\n        longitude\n      }\n      southwest {\n        latitude\n        longitude\n      }\n    }\n    computedBoundsOptions {\n      coordinates {\n        latitude\n        longitude\n      }\n      gaiaId\n      lowerQuantile\n      upperQuantile\n      marginMultiplier\n      minMargin\n      minimumPins\n      interpolationRatio\n    }\n    config {\n      ... on EGDSDynamicMapConfig {\n        accessToken\n        egdsMapProvider\n        externalConfigEndpoint {\n          value\n        }\n        mapId\n      }\n    }\n    markers {\n      ... on EGDSMapFeature {\n        id\n        description\n        markerPosition {\n          latitude\n          longitude\n        }\n        type\n        markerStatus\n        qualifiers\n        text\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        onSelectAccessibilityMessage\n        onEnterAccessibilityMessage\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment MapCardContentFragment on EGDSImageCard {\n    id\n    title\n    subTitle\n    description\n    image {\n      aspectRatio\n      description\n      thumbnailClickAnalytics {\n        eventType\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      url\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment PlaceDisplayFragment on PlacesDialog {\n    placesDialogEGDSTextsContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      clearSavedPlaceIcon {\n        id\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesTypeaheadFragment on PlacesDialogTypeAheadContentSection {\n    content {\n      label\n      placeholder\n      renderType\n      typeaheadPlaceholder\n      typeaheadEmptyResultPlaceholder\n      typeaheadInfo {\n        client\n        regionType\n        isDestination\n        maxNumberOfResults\n        personalize\n        lineOfBusiness\n        packageType\n        typeaheadFeatures\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesSearchFragment on PlacesDialog {\n    placesDialogTypeAheadContentSection {\n      heading {\n        text\n      }\n      subHeading {\n        text\n      }\n      ...PlacesTypeaheadFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSSwitchFragment on UIToggle {\n    checked\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    checkedLabel\n    enabled\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedLabel\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesSwitchesFragment on PlacesDialog {\n    placesDialogUITogglesContentSection {\n      subHeading {\n        text\n      }\n      content {\n        ...SwitchToggleFragment\n      }\n    }\n  }\n  fragment SwitchToggleFragment on FilterOption {\n    checked\n    checkedLabel\n    enabled\n    uncheckedLabel\n    filteredValues\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment PlacesDialogFragment on PlacesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        closeText\n      }\n    }\n    trigger {\n      icon {\n        description\n        token\n      }\n      disabled\n    }\n    ...PlacesSearchFragment\n    ...PlaceDisplayFragment\n    ...PlacesSwitchesFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment MapActionsFragment on PropertyInfoMap {\n    callToAction {\n      action {\n        targetRef\n      }\n      button {\n        primary\n      }\n      event {\n        eventName\n        eventType\n        eventVersion\n      }\n    }\n    dialogs {\n      ...PlacesDialogFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query MapQuery($context: ContextInput!, $propertyId: String!, $shoppingContext: ShoppingContextInput) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      id\n      summary {\n        map {\n          egdsBasicMap {\n            ...DynamicMapFragment\n          }\n          mapInfoCards {\n            ...MapCardContentFragment\n          }\n          toolbar {\n            title\n            icon {\n              description\n            }\n          }\n          ...MapActionsFragment\n        }\n        location {\n          coordinates {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingJumpLinkFragment on PropertyInfoJumpLink {\n    icon {\n      iconId: id\n    }\n    sectionName\n    localizedName\n    accessibilityLabel\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityDescriptionJumpLinkFragment on PropertyInfoSection {\n    action {\n      ...LodgingJumpLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityContentFragment on PropertyInfoContent {\n    __typename\n    heading\n    items {\n      __typename\n      text\n    }\n    icon {\n      __typename\n      iconId: id\n    }\n    structuredData {\n      __typename\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityHeadingFragment on LodgingHeader {\n    __typename\n    text\n    subText\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitySectionFragment on PropertyInfoSection {\n    __typename\n    header {\n      ...AmenityHeadingFragment\n    }\n    contents {\n      ...AmenityContentFragment\n    }\n    ...AmenityDescriptionJumpLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityDescriptionFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        amenities {\n          ...AmenitySectionFragment\n        }\n        viewAmenitiesAdaptExAttemptEvents {\n          campaignId\n          events {\n            payloadId\n            eventType\n            eventTarget\n            banditDisplayed\n          }\n        }\n        reserveAdaptExSuccessEvents {\n          campaignId\n          events {\n            payloadId\n            eventType\n            eventTarget\n            banditDisplayed\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    iconSize: size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n\n    ... on Illustration {\n      ...IllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemGraphicsFragment on PropertyContentItemGraphics {\n    graphics {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemImagesFragment on PropertyContentItemImages {\n    contents {\n      image {\n        description\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemMarkupFragment on PropertyContentItemMarkup {\n    content {\n      text\n      markupType\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemTextFragment on PropertyContentItemText {\n    content {\n      primary {\n        value\n        icon {\n          iconId: id\n        }\n        egdsMark {\n          description\n          url {\n            value\n          }\n        }\n        state\n        subtexts\n      }\n      secondary {\n        value\n      }\n    }\n    expando {\n      expandedLabel\n      collapsedLabel\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemTextsFragment on PropertyContentItemTexts {\n    contents {\n      primary {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment SectionHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      iconId: id\n      description\n    }\n    headerImage {\n      description\n      url\n    }\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentFragment on PropertyContent {\n    maxColumns\n    header {\n      ...SectionHeaderFragment\n    }\n    expando {\n      expandButton {\n        text\n      }\n      collapseButton {\n        text\n      }\n    }\n    items {\n      __typename\n      ...PropertyContentItemGraphicsFragment\n      ...PropertyContentItemImagesFragment\n      ...PropertyContentItemMarkupFragment\n      ...PropertyContentItemTextFragment\n      ...PropertyContentItemTextsFragment\n    }\n\n    structuredData {\n      itemprop\n      itemscope\n      itemtype\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingLinkMessageFragment on LodgingLinkMessage {\n    accessibilityLabel\n    icon {\n      id\n      description\n      token\n    }\n    link {\n      clientSideAnalytics {\n        referrerId\n        linkName\n      }\n      uri {\n        relativePath\n        value\n      }\n    }\n    value\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionDetailedDialogFragment on PropertyContentSectionDetailedDialog {\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n          closeText\n        }\n        closeAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    trigger {\n      message\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionDialogFragment on PropertyContentSectionDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      message\n    }\n    content {\n      contents {\n        ... on EGDSParagraph {\n          text\n        }\n        ... on EGDSPlainText {\n          text\n        }\n        ... on EGDSInlineLink {\n          text\n          action {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            target\n          }\n        }\n      }\n    }\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentHeaderFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      id\n      description\n      size\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment AmenityReviewSummaryFragment on Highlights {\n    icon {\n      iconId: id\n      description\n      size\n    }\n    reviewSummaryHighlight {\n      __typename\n      header {\n        text\n        graphic {\n          ... on Icon {\n            id\n          }\n        }\n      }\n      content\n    }\n    clickAnalytics {\n      __typename\n      linkName\n      referrerId\n      eventType\n    }\n    impressionAnalytics {\n      __typename\n      event\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentItemFragment on PropertyInfoItem {\n    icon {\n      iconId: id\n      description\n      size\n    }\n    text\n    state\n    moreInfo\n    accessibilityLabel\n    highlights {\n      ...AmenityReviewSummaryFragment\n    }\n    subItems {\n      ... on EGDSTextIconList {\n        listItems {\n          ... on EGDSTextIconListItem {\n            text\n            icon {\n              id\n              description\n              token\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentItemsFragment on PropertyInfoContent {\n    items {\n      ...PropertyInfoContentItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    iconAnalytics {\n      linkName\n      referrerId\n    }\n    ...PropertyInfoContentItemsFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionListTypeDialogFragment on PropertyContentSectionListTypeDialog {\n    trigger {\n      analytics {\n        linkName\n        referrerId\n      }\n      icon {\n        id\n        description\n      }\n      message\n    }\n    dialogData: content {\n      ... on PropertyInfoContent {\n        ...PropertyInfoContentFragment\n      }\n    }\n    dialog {\n      ... on EGDSFullScreenDialog {\n        toolbar {\n          title\n        }\n      }\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionActionFragment on PropertyContentSectionAction {\n    ... on PropertyContentSectionDialog {\n      ...PropertyContentSectionDialogFragment\n    }\n    ... on PropertyContentSectionDetailedDialog {\n      ...PropertyContentSectionDetailedDialogFragment\n    }\n    ... on LodgingLinkMessage {\n      ...LodgingLinkMessageFragment\n    }\n    ... on PropertyContentSectionListTypeDialog {\n      ...PropertyContentSectionListTypeDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...IconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n      ... on HttpURI {\n        relativePath\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    heading\n    background\n    themes\n    rightIcon {\n      ...IconFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    buttons {\n      ...LodgingEGDSButtonFragment\n    }\n    impressionTracking {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentItemCardFragment on EGDSStandardMessagingCard {\n    ...EGDSStandardMessagingCardFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentElementGroupFragment on PropertyContentElementGroup {\n    elements {\n      ... on PropertyContent {\n        ...PropertyContentFragment\n      }\n      ... on EGDSStandardMessagingCard {\n        ...EGDSStandardMessagingCardFragment\n      }\n    }\n    maxColumns\n  }\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSubSectionFragment on PropertyContentSubSection {\n    header {\n      ...SectionHeaderFragment\n    }\n    elementsV2 {\n      ...PropertyContentElementGroupFragment\n    }\n    actions {\n      ...PropertyContentSectionActionFragment\n    }\n    expando {\n      expandButton {\n        text\n      }\n      collapseButton {\n        text\n      }\n    }\n    maxColumns\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionFragment on PropertyContentSection {\n    sectionName\n    header {\n      ...SectionHeaderFragment\n    }\n    bodySubSections {\n      ...PropertyContentSubSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyContentSectionGroupFragment on PropertyContentSectionGroup {\n    expando {\n      collapseButton {\n        text\n      }\n      expandButton {\n        text\n      }\n    }\n    sectionName\n    sections {\n      ...PropertyContentSectionFragment\n    }\n    action {\n      ...PropertyContentSectionActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment CleanlinessFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria) {\n      cleanliness {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  query PropertyCleanlinessQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      ...CleanlinessFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment GalleryButtonsFragment on PropertyImageGallery {\n    galleryButtons {\n      accessibility\n      icon {\n        description\n        id\n      }\n      action {\n        accessibility\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment CarouselContainerFragment on PropertyImageGallery {\n    label\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      lowResImage {\n        url\n      }\n      trackingId\n      imageId\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyImageFragment on PropertyImage {\n    alt\n    image {\n      url\n      description\n      thumbnailClickAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    lowResImage {\n      url\n    }\n    trackingId\n    imageId\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment MosaicContainerFragment on PropertyImageGallery {\n    label\n    images {\n      ...PropertyImageFragment\n    }\n    ...GalleryButtonsFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment MediaGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      thumbnail {\n        url\n        description\n      }\n      fallbackImage {\n        url\n        description\n      }\n      trackingId\n      imageId\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        fallbackImage {\n          url\n          description\n        }\n        trackingId\n        imageId\n      }\n    }\n    mediaGalleryDialog {\n      toolbar {\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment ThumbnailGalleryDialogFragment on PropertyImageGallery {\n    images {\n      alt\n      subjectId\n      image {\n        url\n        description\n        thumbnailClickAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      thumbnail {\n        url\n        description\n      }\n      trackingId\n      imageId\n      fallbackImage {\n        url\n        description\n      }\n    }\n    categories {\n      categoryId: id\n      name\n      images {\n        alt\n        subjectId\n        image {\n          url\n          description\n          thumbnailClickAnalytics {\n            linkName\n            referrerId\n          }\n        }\n        thumbnail {\n          url\n          description\n        }\n        fallbackImage {\n          url\n          description\n        }\n        imageId\n        trackingId\n      }\n    }\n    thumbnailGalleryDialog {\n      toolbar {\n        title\n        icon {\n          iconId: id\n          description\n        }\n      }\n      trigger {\n        accessibilityLabel\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyImageGalleryFragment on PropertyImageGallery {\n    ...MosaicContainerFragment\n    ...CarouselContainerFragment\n    ...MediaGalleryDialogFragment\n    ...ThumbnailGalleryDialogFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment AddressFragment on PropertyLocation {\n    coordinates {\n      latitude\n      longitude\n    }\n    address {\n      addressLine\n      city\n      countryCode\n      firstAddressLine\n      province\n    }\n    mapDialog {\n      trigger {\n        value\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryMapTriggerFragment on PropertyInfo {\n    summary {\n      location {\n        ...AddressFragment\n        staticImage {\n          description\n          url\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingDialogTriggerMessageFragment on LodgingDialogTriggerMessage {\n    accessibilityLabel\n    value\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment CleanlinessDialogFragment on CleanlinessDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyTakeoverAmenitiesFragment on PropertyTakeoverAmenities {\n    amenityClosures {\n      ...PropertyInfoContentFragment\n    }\n    highlight {\n      ...PropertyInfoContentFragment\n    }\n    property {\n      ...PropertyInfoContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  query PropertyAmenitiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      summary {\n        amenities(searchCriteria: $searchCriteria) {\n          takeover {\n            ...PropertyTakeoverAmenitiesFragment\n          }\n          viewAmenitiesAdaptExAttemptEvents {\n            campaignId\n            events {\n              payloadId\n              eventType\n              eventTarget\n              banditDisplayed\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  fragment SeeMorePropertyAmenitiesDialogFragment on AmenitiesDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  fragment SeeMoreActionFragment on SeeMoreAction {\n    __typename\n    ... on AmenitiesDialog {\n      ...SeeMorePropertyAmenitiesDialogFragment\n    }\n    ... on CleanlinessDialog {\n      ...CleanlinessDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoContentWithSeeMoreActionFragment on PropertyInfoContent {\n    header {\n      ...PropertyInfoContentHeaderFragment\n    }\n    ...PropertyInfoContentItemsFragment\n    seeMoreAction {\n      ...SeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDescriptionAndMoreInfoSectionFragment on PropertyDetails {\n    description {\n      ...LodgingEGDSParagraphFragment\n    }\n    contentSections {\n      ...PropertyInfoContentWithSeeMoreActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment RatingCountsFragment on PropertyReviewSummary {\n    ratingCounts {\n      count {\n        formatted\n      }\n      percent\n      rating\n      description\n      accessibilityLabel\n    }\n  }\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewSummaryDetailsFragment on PropertyReviewSummary {\n    reviewSummaryDetails {\n      label\n      formattedRatingOutOfMaxA11y {\n        value\n        accessibilityLabel\n      }\n    }\n  }\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyFilteredReviewsDialogFragment on PropertyFilteredReviewsDialog {\n    trigger {\n      ...LodgingDialogTriggerMessageFragment\n    }\n    ratingPercentage {\n      closeAnalytics {\n        referrerId\n        linkName\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewDisclaimerFragment on PropertyReviewSummary {\n    reviewDisclaimer\n    reviewDisclaimerHeading\n    strategy\n    reviewDisclaimerValues {\n      text\n    }\n    reviewDisclaimerLabel\n    reviewDisclaimerAnalytics {\n      referrerId\n      linkName\n    }\n    reviewDisclaimerUrl {\n      value\n      accessibilityLabel\n      link {\n        url\n      }\n    }\n    reviewDisclaimerAccessibilityLabel\n  }\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyReviewsBreakdownFragment on PropertyReviewSummary {\n    averageOverallRating {\n      formatted\n    }\n    averageOverallRatingValue {\n      formatted\n    }\n    superlative\n    strategy\n    propertyReviewCountDetails {\n      shortDescription\n    }\n    reviewDisclaimer\n    reviewDisclaimerLabel\n    ...ReviewDisclaimerFragment\n    totalCount {\n      raw\n    }\n    ...ReviewSummaryDetailsFragment\n    ...RatingCountsFragment\n    seeAllAction {\n      ...PropertyFilteredReviewsDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDetailsReviewsBreakdownFragment on PropertyReviewSummary {\n    ...PropertyReviewsBreakdownFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  query PropertyInfoDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput!\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      propertyDetails(searchCriteria: $searchCriteria) {\n        gallery {\n          ...PropertyImageGalleryFragment\n        }\n        heading {\n          ...LodgingEGDSHeadingFragment\n        }\n        rating {\n          ...LodgingEGDSRatingFragment\n        }\n        ...PropertyDescriptionAndMoreInfoSectionFragment\n      }\n\n      propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n        policies {\n          ...PropertyContentSectionGroupFragment\n        }\n        importantInfo {\n          ...PropertyContentSectionGroupFragment\n        }\n      }\n\n      summary {\n        nearbyPOIs {\n          header {\n            text\n          }\n        }\n      }\n      ...SummaryMapTriggerFragment\n    }\n\n    propertyReviewSummaries(context: $context, propertyIds: [$propertyId], searchCriteria: $searchCriteria) {\n      ...PropertyDetailsReviewsBreakdownFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesFooterFragment on SimilarProperties {\n    footer\n  }\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesHeaderFragment on SimilarProperties {\n    header\n  }\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingHeaderFragment on LodgingHeader {\n    text\n    label\n    subText\n  }\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyReviewsSummaryFragment on PropertyReviewsSummary {\n    localizedScore\n    localizedSubtitleA11y {\n      accessibilityLabel\n    }\n    localizedTotal\n  }\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesActionFragment on SimilarProperty {\n    title {\n      label\n      text\n    }\n    propertyId\n    image {\n      image {\n        url\n      }\n    }\n    price {\n      price {\n        options {\n          displayPrice {\n            amount\n            currencyInfo {\n              name\n            }\n          }\n        }\n      }\n    }\n    action {\n      actionDetails {\n        accessibilityLabel\n      }\n      text\n      linkUrl\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    subText\n    value\n    theme\n    state\n    accessibilityLabel\n    icon {\n      id\n      size\n      theme\n    }\n    mark {\n      id\n    }\n    egdsMark {\n      url {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesItemsFragment on SimilarProperty {\n    items {\n      ...LodgingEnrichedMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesPriceFragment on SimilarProperty {\n    price {\n      qualifier {\n        value\n      }\n      subText {\n        text\n      }\n      price {\n        options {\n          displayPrice {\n            formatted\n          }\n          leadingCaption\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  fragment SimilarPropertiesPropertiesFragment on SimilarProperties {\n    header\n    properties {\n      title {\n        ...LodgingHeaderFragment\n      }\n      reviews {\n        ...PropertyReviewsSummaryFragment\n      }\n      featuredMessages {\n        ...LodgingEGDSGraphicTextFragment\n      }\n      image {\n        image {\n          ...LodgingEGDSImageFragment\n        }\n      }\n      ...SimilarPropertiesItemsFragment\n      ...SimilarPropertiesPriceFragment\n      ...SimilarPropertiesActionFragment\n    }\n    galleryCarousel {\n      nextButtonText\n      previousButtonText\n    }\n    lodgingRecommendationClickstreamEvent {\n      recommendationResponseId\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  query SimilarPropertiesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $propertyRecommendationStrategy: PropertyRecommendationStrategy\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext) {\n      id\n      similarProperties(searchCriteria: $searchCriteria, propertyRecommendationStrategy: $propertyRecommendationStrategy) {\n        ...SimilarPropertiesHeaderFragment\n        ...SimilarPropertiesPropertiesFragment\n        ...SimilarPropertiesFooterFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  query PropertySpacesQuery($context: ContextInput!, $propertyId: String!) {\n    summary: propertySpaces(context: $context, propertyContentType: SUMMARY, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n    detailed: propertySpaces(context: $context, propertyContentType: DETAILED, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesSimplifiedViewFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  fragment BookByPhoneFragment on PropertyInfo {\n    telesales {\n      telesalesNumber {\n        phoneNumber\n        value\n      }\n      description {\n        value\n      }\n      tracking {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  fragment PoliciesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      policies {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  fragment SpecialFeaturesFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      specialFeatures {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  fragment ImportantInfoFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      importantInfo {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  fragment AboutThisPropertyFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisProperty {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  fragment HostProfileFragment on PropertyInfo {\n    propertyContentSectionGroups(searchCriteria: $searchCriteria, damageLiability: $damageLiability) {\n      __typename\n      aboutThisHost {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyDetailedAmenitiesFragment on PropertyInfo {\n    amenitiesSummary: propertyContentSectionGroups(amenitiesPropertyContentType: SUMMARY) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n    detailedAmenitiesContent: propertyContentSectionGroups(amenitiesPropertyContentType: DETAILED) {\n      amenities {\n        ...PropertyContentSectionGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  query DirectFeedbackCallToActionQuery($context: ContextInput!, $id: ID!) {\n    directFeedbackPromptById(context: $context, id: $id) {\n      callToAction {\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        icon {\n          id\n          size\n        }\n        primary\n      }\n    }\n  }\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  fragment __PropertyDirectFeedbackPromptIdFragment on PropertyInfo {\n    directFeedback {\n      __typename\n      callToAction {\n        promptId\n        contextValues {\n          key\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  fragment FaqFragment on PropertyFAQ {\n    question {\n      text\n    }\n    answer {\n      text\n    }\n  }\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  fragment FrequentlyAskedQuestionsFragment on PropertyInfo {\n    id\n    frequentlyAskedQuestions {\n      title {\n        text\n        subText\n      }\n      askAQuestion {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      faqs {\n        ...FaqFragment\n      }\n    }\n    offers(searchCriteria: $searchCriteria) @include(if: $isDateless) {\n      pricingFrequentlyAskedQuestions {\n        ...FaqFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  fragment GalleryFragment on PropertyInfo {\n    summary {\n      name\n      overview {\n        accessibilityLabel\n      }\n    }\n    propertyGallery {\n      ...PropertyImageGalleryFragment\n    }\n    id\n  }\n\n  ",
        "\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  fragment InventorySourceFragment on PropertyInfo {\n    summary {\n      propertySource {\n        accessibilityLabel\n        label\n        graphic {\n          __typename\n          ... on Mark {\n            description\n            id\n            size\n            token\n            url {\n              value\n            }\n          }\n        }\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  fragment LocationHighlightsFragment on PropertyInfo {\n    reviewInfo(searchCriteria: $searchCriteria) {\n      summary {\n        reviewHighlights {\n          ...PropertyInfoContentFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  fragment NavigationBarTabsFragment on PropertySummary {\n    navigationBarTabs {\n      localizedName\n      sectionName\n    }\n  }\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  fragment NavigationBarFragment on PropertyInfo {\n    summary {\n      ...NavigationBarTabsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  fragment RelevantAmenitiesItemFragment on PropertyInfoSection {\n    header {\n      text\n    }\n    contents {\n      items {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  fragment RelevantAmenitiesFragment on PropertyInfo {\n    __typename\n    summary {\n      __typename\n      amenities(searchCriteria: $searchCriteria) {\n        __typename\n        relevantAmenities {\n          ...RelevantAmenitiesItemFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  fragment SaveTripItemFragment on PropertyInfo {\n    saveTripItem(searchCriteria: $searchCriteria) {\n      ...TripsSaveItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  fragment ShortlistFragment on PropertyInfo {\n    summary {\n      name\n    }\n    shortList {\n      button {\n        checked\n        checkedAccessibilityLabel\n        checkedAnalytics {\n          linkName\n          referrerId\n        }\n        uncheckedAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewInfoFragment on PropertyInfoContent {\n    items {\n      icon {\n        description\n        iconId: id\n        size\n      }\n      text\n    }\n  }\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewTitleFragment on PropertyInfoContent {\n    header {\n      text\n    }\n  }\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  fragment SpaceOverviewFragment on PropertyInfo {\n    propertyHighlightedDetails {\n      ...SpaceOverviewTitleFragment\n      ...SpaceOverviewInfoFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyInfoTopReviewFragment on PropertyInfo {\n    topReviews(searchCriteria: $searchCriteria) {\n      highlighted {\n        value\n        icon {\n          iconId: id\n          description\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    text\n    size\n    theme\n  }\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyReviewRatingFragment on LodgingCardBadgedRating {\n    __typename\n    badge {\n      ...EGDSBadgeFragment\n    }\n    phrases {\n      phraseParts {\n        ... on EGDSPlainText {\n          accessibility\n          text\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryReviewsFragment on PropertyInfo {\n    reviewInfo(searchCriteria: $searchCriteria) {\n      summary {\n        averageOverallRating {\n          formatted\n          raw\n        }\n        averageOverallRatingValue {\n          formatted\n          raw\n        }\n        totalCount {\n          formatted\n          raw\n        }\n        superlative\n        overallScoreWithDescriptionA11y {\n          ...LodgingEnrichedMessageFragment\n        }\n        reviewDisclaimerLabel\n        reviewDisclaimerHeading\n        reviewDisclaimerValues {\n          text\n        }\n        propertyReviewCountDetails {\n          fullDescription\n          shortDescription\n        }\n        highlightMessage {\n          subtitle {\n            accessibilityLabel\n            text\n          }\n        }\n        strategy\n        seoData {\n          content\n          itemprop\n          itemscope\n        }\n        reviewRating {\n          ...PropertyReviewRatingFragment\n        }\n      }\n    }\n    ...PropertyInfoTopReviewFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesDialogFragment on PropertyAmenities {\n    amenitiesDialog {\n      toolbar {\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        icon {\n          iconId: id\n          description\n        }\n        title\n      }\n    }\n    takeover {\n      ...PropertyTakeoverAmenitiesFragment\n    }\n    viewAmenitiesAdaptExAttemptEvents {\n      campaignId\n      events {\n        payloadId\n        eventType\n        eventTarget\n        banditDisplayed\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        "\n  fragment AmenitiesLinkFragment on PropertyAmenities {\n    amenitiesDialog {\n      trigger {\n        value\n        accessibilityLabel\n        icon {\n          iconId: id\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryAmenitiesFragment on PropertyInfo {\n    summary {\n      amenities(searchCriteria: $searchCriteria) {\n        topAmenities {\n          ...PropertyInfoContentFragment\n        }\n        propertyContentPreferences {\n          ...PropertyContentFragment\n        }\n        ...AmenitiesLinkFragment\n        ...AmenitiesDialogFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryNearByPoisFragment on PropertyInfo {\n    summary {\n      nearbyPOIs {\n        heading\n        items {\n          text\n          icon {\n            iconId: id\n            description\n          }\n          moreInfo\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryBannerMessageFragment on PropertyInfo {\n    summary {\n      bannerMessage {\n        title {\n          icon {\n            id\n            description\n          }\n        }\n        subtitle {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryHeaderFragment on PropertyInfo {\n    summary {\n      name\n      latinAlphabetName\n      overview {\n        vipMessaging\n        starRating\n        propertyRating {\n          accessibility\n          rating\n        }\n      }\n      starRatingIcon {\n        description\n        iconId: id\n      }\n      featuredMessages {\n        icon {\n          iconId: id\n          description\n        }\n        value\n      }\n      tagline\n      messages {\n        ... on EGDSPlainText {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryChatbotLaunchFragment on PropertyInfo {\n    summary {\n      lodgingChatbot {\n        header {\n          text\n        }\n        action {\n          primary\n        }\n        content\n      }\n    }\n  }\n"
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryGeoFragment on PropertyInfo {\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryFragment on PropertyInfo {\n    ...SummaryAmenitiesFragment\n    ...SummaryMapTriggerFragment\n    ...SummaryNearByPoisFragment\n    ...SummaryHeaderFragment\n    ...SummaryReviewsFragment\n    ...SummaryBannerMessageFragment\n    ...SummaryChatbotLaunchFragment\n    ...LocationHighlightsFragment\n    ...RelevantAmenitiesFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundLinkFragment on LodgingLinkMessage {\n    link {\n      clientSideAnalytics {\n        linkName\n        referrerId\n      }\n      uri {\n        value\n      }\n    }\n    value\n    icon {\n      id\n      description\n    }\n  }\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundEditorialFragment on PropertyEditorial {\n    content\n    crossLinks {\n      ...WhatsAroundLinkFragment\n    }\n    title\n  }\n\n  ",
        "\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundMapFragment on PropertyWhatsAround {\n    staticImage {\n      description\n      url\n    }\n  }\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundIconFragment on Icon {\n    iconId: id\n  }\n"
    ]);
    _templateObject143 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundPoisItemFragment on PropertyInfoContent {\n    items {\n      text\n      moreInfo\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject144 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundPoisFragment on PropertyWhatsAround {\n    nearbyPOIs {\n      ...WhatsAroundPoisItemFragment\n      title\n      icon {\n        ...WhatsAroundIconFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject145 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _tagged_template_literal([
        "\n  fragment WhatsAroundFragment on PropertyInfo {\n    id\n    summary {\n      location {\n        whatsAround {\n          title\n          editorial {\n            ...WhatsAroundEditorialFragment\n          }\n          ...WhatsAroundPoisFragment\n          ...WhatsAroundMapFragment\n        }\n      }\n      map {\n        trigger {\n          value\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject146 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _tagged_template_literal([
        "\n  query PropertyDetailsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $isDateless: Boolean = true\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...AmenityDescriptionFragment\n      ...PoliciesFragment\n      ...PropertyDetailedAmenitiesFragment\n      ...ImportantInfoFragment\n      ...FrequentlyAskedQuestionsFragment\n      ...NavigationBarFragment\n      ...AboutThisPropertyFragment\n      ...WhatsAroundFragment\n      ...GalleryFragment\n      ...SummaryFragment\n      ...BookByPhoneFragment\n      ...SpaceOverviewFragment\n      ...InventorySourceFragment\n      ...ShortlistFragment\n      ...SaveTripItemFragment\n      ...AmenitiesSimplifiedViewFragment\n      ...RelevantAmenitiesFragment\n      ...SpecialFeaturesFragment\n      ...LocationHighlightsFragment\n      ...HostProfileFragment\n      ...__PropertyDirectFeedbackPromptIdFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject147 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _tagged_template_literal([
        "\n  query PropertyAdditionalActionsQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $isDateless: Boolean = true\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...FrequentlyAskedQuestionsFragment\n      ...HostProfileFragment\n      ...SaveTripItemFragment\n      ...ShortlistFragment\n      ...InventorySourceFragment\n      ...BookByPhoneFragment\n      ...__PropertyDirectFeedbackPromptIdFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject148 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _tagged_template_literal([
        "\n  query PropertyAmenitiesFeaturesQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n    $damageLiability: DamageLiability\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...AmenityDescriptionFragment\n      ...PoliciesFragment\n      ...ImportantInfoFragment\n      ...WhatsAroundFragment\n      ...AboutThisPropertyFragment\n      ...SpecialFeaturesFragment\n      ...PropertyDetailedAmenitiesFragment\n      ...AmenitiesSimplifiedViewFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject149 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _tagged_template_literal([
        "\n  query PropertyMainSectionQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...GalleryFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject150 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _tagged_template_literal([
        "\n  query PropertySummaryQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $shoppingContext: ShoppingContextInput\n    $searchCriteria: PropertySearchCriteriaInput\n  ) {\n    propertyInfo(context: $context, propertyId: $propertyId, shoppingContext: $shoppingContext, searchCriteria: $searchCriteria) {\n      id\n      ...SummaryFragment\n      ...RelevantAmenitiesFragment\n      ...LocationHighlightsFragment\n      ...SpaceOverviewFragment\n      ...NavigationBarFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject151 = function _templateObject() {
        return data;
    };
    return data;
}
import React10 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import distance from "@turf/distance";
import { point } from "@turf/helpers";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
// ../internal/src/components/map/dynamic-map.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkEGMaps, UitkEGMapsType } from "uitk-react-map";
// ../internal/src/components/map/geometry-utils.ts
var roundCoordinate = function(num) {
    var ONE_MILLION = 1e6;
    return Math.round((num + Number.EPSILON) * ONE_MILLION) / ONE_MILLION;
};
var boundingBoxToString = function(southwest, northeast) {
    var roundedSouthwest = southwest.map(roundCoordinate);
    var roundedNortheast = northeast.map(roundCoordinate);
    return "".concat(roundedSouthwest, ", ").concat(roundedNortheast);
};
var egBoundsToString = function(bounds) {
    var _bounds_sw_, _bounds_sw_1, _bounds_ne_, _bounds_ne_1;
    var boundingBox = [
        [
            (_bounds_sw_ = bounds.sw[0]) !== null && _bounds_sw_ !== void 0 ? _bounds_sw_ : 0,
            (_bounds_sw_1 = bounds.sw[1]) !== null && _bounds_sw_1 !== void 0 ? _bounds_sw_1 : 0
        ],
        [
            (_bounds_ne_ = bounds.ne[0]) !== null && _bounds_ne_ !== void 0 ? _bounds_ne_ : 0,
            (_bounds_ne_1 = bounds.ne[1]) !== null && _bounds_ne_1 !== void 0 ? _bounds_ne_1 : 0
        ]
    ];
    var emptyNumberList = [];
    var _boundingBox_, _boundingBox_1;
    return boundingBoxToString((_boundingBox_ = boundingBox[0]) !== null && _boundingBox_ !== void 0 ? _boundingBox_ : emptyNumberList, (_boundingBox_1 = boundingBox[1]) !== null && _boundingBox_1 !== void 0 ? _boundingBox_1 : emptyNumberList);
};
// ../internal/src/components/map/analytics/eg-clickstream-events.tsx
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var INTERACTION = "Interaction";
var IMPRESSION = "Impression";
var EVENT_CATEGORY = "maps";
var buildEvent = function(eventName, eventType, eventVersion) {
    return {
        event_name: eventName,
        event_type: eventType,
        event_version: eventVersion,
        event_category: EVENT_CATEGORY
    };
};
var buildData = function(event, attributes) {
    return _object_spread_props(_object_spread({}, attributes), {
        event: event
    });
};
function useEgMapClickstream() {
    var clickstreamTrack = useEgClickstream();
    var track = function(data) {
        if (clickstreamTrack) {
            clickstreamTrack(data);
        }
    };
    var trackMapInit = function(mapType, selectionId) {
        var event = buildEvent("map.initiated", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        var attributes = {
            map_obj: {
                map_provider: mapType,
                map_selection_type: "property",
                map_selection_id: selectionId
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPresented = function(boundingBox, mapId, viewMode) {
        var event = buildEvent("map.presented", IMPRESSION, "2.4.0" /* TWO_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                map_identifier: mapId,
                visible_bounding_box: boundingBox,
                view_mode: viewMode
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapViewportMoved = function(boundingBox, movementType, zoomLevel) {
        var event = buildEvent("map_viewport.viewed", INTERACTION, "3.2.0" /* THREE_TWO_ZERO */ );
        var attributes = {
            map_obj: {
                visible_bounding_box: boundingBox,
                movement_type: movementType,
                zoom_level: zoomLevel
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapContentPresented = function(options) {
        var event = buildEvent("map_content.presented", IMPRESSION, "3.4.0" /* THREE_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                tile_sets: options.tileSets,
                content_origin: options.origin
            },
            destination: {
                places_of_interest_count: options.placesOfInterestCount,
                restaurant_count: options.restaurantCount,
                grocery_count: options.groceryCount,
                transportation_count: options.transportationCount
            },
            map_product_detail: {
                product_cluster_count: options.productClusterCount,
                property_count: options.propertyCount
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlaceSelected = function(selectionId, geometryType, qualifiers, selectionType) {
        var event = buildEvent("map_place.selected", INTERACTION, "3.10.1" /* THREE_TEN_ONE */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType,
                geometry_type_name: geometryType,
                qualifiers: qualifiers
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPropertySelected = function(selectionId, selectionType) {
        var event = buildEvent("map_product.selected", INTERACTION, "1.0.1" /* ONE_ZERO_ONE */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceAdded = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.added", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceRemoved = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.removed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlacesDialogOpened = function() {
        var event = buildEvent("map_dialog.opened", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapPlacesDialogClosed = function() {
        var event = buildEvent("map_dialog.closed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapHidden = function() {
        var event = buildEvent("map.hidden", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        track(buildData(event, {}));
    };
    var clickTracker = useClickTracker();
    var trackMapFilterChanged = function(id, desc) {
        clickTracker(id, desc);
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapViewportMoved: trackMapViewportMoved,
        trackMapContentPresented: trackMapContentPresented,
        trackMapPlaceSelected: trackMapPlaceSelected,
        trackMapPropertySelected: trackMapPropertySelected,
        trackMapHidden: trackMapHidden,
        trackMapFilterChanged: trackMapFilterChanged,
        trackMapCustomPlaceAdded: trackMapCustomPlaceAdded,
        trackMapCustomPlaceRemoved: trackMapCustomPlaceRemoved,
        trackMapPlacesDialogOpened: trackMapPlacesDialogOpened,
        trackMapPlacesDialogClosed: trackMapPlacesDialogClosed
    };
}
// ../internal/src/components/map/analytics/event-helper.ts
import { UitkEGMapsQualifier } from "uitk-react-map";
var getVisibleFeatureCount = function(mapObj, featureFilter) {
    var combinedFilter = function(feature) {
        return featureFilter(feature) && feature.visible;
    };
    return mapObj.listFeatures(combinedFilter, mapObj.getBounds()).length;
};
var filterTransport = function(feature) {
    var _feature_qualifiers, _feature_qualifiers1, _feature_qualifiers2, _feature_qualifiers3, _feature_qualifiers4;
    return ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.AIRPORT)) || ((_feature_qualifiers1 = feature.qualifiers) === null || _feature_qualifiers1 === void 0 ? void 0 : _feature_qualifiers1.includes(UitkEGMapsQualifier.TRANSPORTATION)) || ((_feature_qualifiers2 = feature.qualifiers) === null || _feature_qualifiers2 === void 0 ? void 0 : _feature_qualifiers2.includes(UitkEGMapsQualifier.BUS_STATION)) || ((_feature_qualifiers3 = feature.qualifiers) === null || _feature_qualifiers3 === void 0 ? void 0 : _feature_qualifiers3.includes(UitkEGMapsQualifier.TRANSIT)) || ((_feature_qualifiers4 = feature.qualifiers) === null || _feature_qualifiers4 === void 0 ? void 0 : _feature_qualifiers4.includes(UitkEGMapsQualifier.METRO_STATION));
};
var getContentPresentedOptions = function(mapObj, origin) {
    var _mapObj;
    var enabledTilesets = (_mapObj = mapObj) === null || _mapObj === void 0 ? void 0 : _mapObj.getActiveTilesets();
    var clusterCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "cluster";
    });
    var propertyCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "property";
    });
    var transportationCount = getVisibleFeatureCount(mapObj, filterTransport);
    var poiCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.POINT_OF_INTEREST);
    });
    var groceryCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.GROCERY);
    });
    var restaurantCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.RESTAURANT);
    });
    return {
        transportationCount: transportationCount,
        groceryCount: groceryCount,
        restaurantCount: restaurantCount,
        placesOfInterestCount: poiCount,
        tileSets: enabledTilesets,
        productClusterCount: clusterCount,
        propertyCount: propertyCount,
        origin: origin
    };
};
var CONTENT_PRESENTED_DELAY = 200;
// ../internal/src/components/map/map-markers.tsx
var convertMarkers = function(mapMarkers) {
    return (mapMarkers !== null && mapMarkers !== void 0 ? mapMarkers : []).map(function(marker, index) {
        var type = (marker.type || "place").toString().toLowerCase();
        var status = (marker.markerStatus || "unknown").toString().toLowerCase();
        var ariaLabels;
        if (marker.onSelectAccessibilityMessage || marker.onEnterAccessibilityMessage) {
            ariaLabels = {
                default: marker.onEnterAccessibilityMessage || "",
                onSelect: marker.onSelectAccessibilityMessage || ""
            };
        }
        var _marker_text;
        return {
            id: marker.id || "index-".concat(index),
            name: (_marker_text = marker.text) !== null && _marker_text !== void 0 ? _marker_text : void 0,
            lat: marker.markerPosition.latitude,
            lng: marker.markerPosition.longitude,
            type: type,
            status: status,
            qualifiers: _to_consumable_array(marker.qualifiers),
            text: type === "place" ? marker.text || void 0 : void 0,
            price: type === "property" ? marker.text : void 0,
            ariaLabels: ariaLabels
        };
    });
};
// ../internal/src/components/map/dynamic-map.tsx
var trackMapViewportBoundChangedId = "trackMapViewportBoundChangedCb";
var trackMarkerSelectionId = "trackMarkerSelectionId";
var trackMapContentPresentedId = "trackMapContentPresentedId";
var __Fragment = gql(_templateObject());
var DynamicMap = function(param) {
    var children = param.children, className = param.className, data = param.data, beforeInit = param.beforeInit, onInit = param.onInit, supplementalFeatures = param.supplementalFeatures, onFeaturesPushed = param.onFeaturesPushed, egMapsConfig = param.egMapsConfig, selectedFeatureId = param.selectedFeatureId, viewMode = param.viewMode, _param_egDistancesEnabled = param.egDistancesEnabled, egDistancesEnabled = _param_egDistancesEnabled === void 0 ? false : _param_egDistancesEnabled, clientPadding = param.clientPadding, _param_height = param.height, height = _param_height === void 0 ? "100vh" : _param_height, _param_updateViewport = param.updateViewport, updateViewport = _param_updateViewport === void 0 ? true : _param_updateViewport;
    var _dynamicMapConfig, _dynamicMapConfig1;
    var _ref = data || {}, initialViewport = _ref.initialViewport, center = _ref.center, zoom = _ref.zoom, bounds = _ref.bounds, computedBoundsOptions = _ref.computedBoundsOptions, config = _ref.config, markers = _ref.markers;
    var mapRef = React.useRef();
    var initDone = React.useRef(false);
    var backupMapFragment = React.useRef();
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapViewportMoved = _useEgMapClickstream.trackMapViewportMoved, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapPlaceSelected = _useEgMapClickstream.trackMapPlaceSelected, trackMapPropertySelected = _useEgMapClickstream.trackMapPropertySelected, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var _useBexApi = useBexApi(), _useBexApi_context = _useBexApi.context, locale = _useBexApi_context.locale, currency = _useBexApi_context.currency;
    React.useEffect(function() {
        if (data) {
            backupMapFragment.current = data;
        }
    }, [
        data
    ]);
    var dynamicMapConfig = React.useMemo(function() {
        var _backupMapFragment_current;
        return config || ((_backupMapFragment_current = backupMapFragment.current) === null || _backupMapFragment_current === void 0 ? void 0 : _backupMapFragment_current.config);
    }, [
        config
    ]);
    React.useEffect(function() {
        return trackMapHidden;
    }, []);
    React.useEffect(function() {
        var _dynamicMapConfig;
        if ((_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider) {
            var _dynamicMapConfig1;
            var provider = ((_dynamicMapConfig1 = dynamicMapConfig) === null || _dynamicMapConfig1 === void 0 ? void 0 : _dynamicMapConfig1.egdsMapProvider) === "MAPBOX" /* MAPBOX */  ? "mapbox" : "google-maps";
            trackMapInit(provider, selectedFeatureId);
        }
    }, [
        (_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider
    ]);
    var cfg = React.useMemo(function() {
        if (dynamicMapConfig) {
            var _dynamicMapConfig_externalConfigEndpoint;
            var ret = egMapsConfig ? _object_spread({}, egMapsConfig) : {};
            if (className) {
                ret.additionalCssClass = className;
            }
            if (locale) {
                ret.locale = locale;
            }
            if (currency) {
                ret.iso4217CurrencyCode = currency;
            }
            if ((_dynamicMapConfig_externalConfigEndpoint = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint.value) {
                var _dynamicMapConfig_externalConfigEndpoint1;
                ret.externalConfigEndpoint = (_dynamicMapConfig_externalConfigEndpoint1 = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint1 === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint1.value;
            }
            if (dynamicMapConfig.mapId) {
                switch(dynamicMapConfig.egdsMapProvider){
                    case "MAPBOX" /* MAPBOX */ :
                        if (!ret.mapbox) {
                            ret.mapbox = {};
                        }
                        if (!ret.mapbox.mapboxAddConf) {
                            ret.mapbox.mapboxAddConf = {};
                        }
                        ret.mapbox.mapboxAddConf.style = dynamicMapConfig.mapId;
                        break;
                    case "GOOGLE" /* GOOGLE */ :
                    default:
                        if (!ret.googleMaps) {
                            ret.googleMaps = {};
                        }
                        if (!ret.googleMaps.gmapsAddConfig) {
                            ret.googleMaps.gmapsAddConfig = {};
                        }
                        ret.googleMaps.gmapsAddConfig.mapId = dynamicMapConfig.mapId;
                        break;
                }
            }
            return ret;
        }
    }, [
        dynamicMapConfig,
        locale,
        currency,
        egMapsConfig
    ]);
    var accessToken = (_dynamicMapConfig1 = dynamicMapConfig) === null || _dynamicMapConfig1 === void 0 ? void 0 : _dynamicMapConfig1.accessToken;
    var identifyMapType = function() {
        var _dynamicMapConfig;
        switch((_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider){
            case "MAPBOX" /* MAPBOX */ :
                return UitkEGMapsType.MAPBOX;
            case "GOOGLE" /* GOOGLE */ :
            default:
                return UitkEGMapsType.GOOGLE;
        }
    };
    var mapType = identifyMapType();
    var features = React.useMemo(function() {
        var _markers;
        return _to_consumable_array(convertMarkers((_markers = markers) === null || _markers === void 0 ? void 0 : _markers.map(function(m) {
            return m;
        }))).concat(_to_consumable_array(supplementalFeatures || []));
    }, [
        markers,
        supplementalFeatures
    ]);
    var featureCoordinates = React.useMemo(function() {
        var _features;
        return (_features = features) === null || _features === void 0 ? void 0 : _features.map(function(f) {
            return [
                f.lat,
                f.lng
            ];
        });
    }, [
        features
    ]);
    var computeBoundsViewport = function(b) {
        var _b, _b1, _b2, _b3;
        return {
            sw: [
                (_b = b) === null || _b === void 0 ? void 0 : _b.southwest.latitude,
                (_b1 = b) === null || _b1 === void 0 ? void 0 : _b1.southwest.longitude
            ],
            ne: [
                (_b2 = b) === null || _b2 === void 0 ? void 0 : _b2.northeast.latitude,
                (_b3 = b) === null || _b3 === void 0 ? void 0 : _b3.northeast.longitude
            ]
        };
    };
    var computeCenterAndZoomViewport = function(c, z) {
        var _c, _c1;
        return {
            center: [
                (_c = c) === null || _c === void 0 ? void 0 : _c.latitude,
                (_c1 = c) === null || _c1 === void 0 ? void 0 : _c1.longitude
            ],
            zoom: z
        };
    };
    var computeBoundsComputedViewport = function(coordinates, options) {
        var _options, _options1, _options2, _options3, _options4, _options5, _options6, _options7, _options8;
        return {
            useBoundsComputation: true,
            options: {
                gaiaId: ((_options = options) === null || _options === void 0 ? void 0 : _options.gaiaId) && !Number.isNaN(Number((_options1 = options) === null || _options1 === void 0 ? void 0 : _options1.gaiaId)) ? Number((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.gaiaId) : void 0,
                lowerQuantile: (_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.lowerQuantile,
                upperQuantile: (_options4 = options) === null || _options4 === void 0 ? void 0 : _options4.upperQuantile,
                marginMultiplier: (_options5 = options) === null || _options5 === void 0 ? void 0 : _options5.marginMultiplier,
                minMargin: (_options6 = options) === null || _options6 === void 0 ? void 0 : _options6.minMargin,
                minimumPins: (_options7 = options) === null || _options7 === void 0 ? void 0 : _options7.minimumPins,
                interpolationRatio: (_options8 = options) === null || _options8 === void 0 ? void 0 : _options8.interpolationRatio
            },
            coordinates: options.coordinates.length > 0 ? options.coordinates.map(function(c) {
                return [
                    c.latitude,
                    c.longitude
                ];
            }) : coordinates
        };
    };
    React.useEffect(function() {
        var map = mapRef.current;
        if (initDone.current && map && updateViewport) {
            var _featureCoordinates;
            if (bounds) {
                var _computeBoundsViewport = computeBoundsViewport(bounds), sw = _computeBoundsViewport.sw, ne = _computeBoundsViewport.ne;
                map.fitBounds(sw, ne, void 0, clientPadding);
            } else if (center !== null && zoom !== null) {
                var _computeCenterAndZoomViewport = computeCenterAndZoomViewport(center, zoom), c = _computeCenterAndZoomViewport.center, z = _computeCenterAndZoomViewport.zoom;
                map.centerAndZoomMap(c, z, clientPadding);
            } else if (computedBoundsOptions) {
                var _computeBoundsComputedViewport = computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions), useBoundsComputation = _computeBoundsComputedViewport.useBoundsComputation, options = _computeBoundsComputedViewport.options, coordinates = _computeBoundsComputedViewport.coordinates;
                map.boundsContaining(coordinates, useBoundsComputation, options).then(function(boundsWithCenter) {
                    var sw = boundsWithCenter.sw, ne = boundsWithCenter.ne;
                    map.fitBounds(sw, ne, void 0, clientPadding);
                });
            } else if (((_featureCoordinates = featureCoordinates) === null || _featureCoordinates === void 0 ? void 0 : _featureCoordinates.length) > 0) {
                map.fitLatLongs(featureCoordinates, void 0, clientPadding);
            }
        }
    }, [
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates,
        updateViewport,
        clientPadding
    ]);
    var initialViewportObject = React.useMemo(function() {
        switch(initialViewport){
            case "BOUNDS" /* BOUNDS */ :
                return bounds ? computeBoundsViewport(bounds) : void 0;
            case "CENTER_AND_ZOOM" /* CENTER_AND_ZOOM */ :
                return center && zoom !== null ? computeCenterAndZoomViewport(center, zoom) : void 0;
            case "COMPUTED_BOUNDS" /* COMPUTED_BOUNDS */ :
                return computedBoundsOptions ? computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions) : void 0;
            case "FIT_MARKERS" /* FIT_MARKERS */ :
            default:
                return featureCoordinates;
        }
    }, [
        initialViewport,
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates
    ]);
    var trackMapViewportBoundChangedCb = React.useCallback(function(event) {
        var _event;
        var boundChangeMovementMapping = {
            zoomIn: "zoom_in" /* ZOOM_IN */ ,
            zoomOut: "zoom_out" /* ZOOM_OUT */ ,
            drag: "pan" /* PAN */ ,
            zoomInKeyboard: "zoom_in" /* ZOOM_IN */ ,
            zoomOutKeyboard: "zoom_out" /* ZOOM_OUT */ ,
            pitch: "pan" /* PAN */ ,
            rotate: "pan" /* PAN */ ,
            touch: "pan" /* PAN */ ,
            moveKeyboard: "pan" /* PAN */ ,
            clusterExtent: "zoom_in" /* ZOOM_IN */ 
        };
        var boundsChangeType = (_event = event) === null || _event === void 0 ? void 0 : _event.originalEvent;
        var movementType = boundChangeMovementMapping[boundsChangeType];
        if (movementType !== void 0) {
            trackMapViewportMoved(egBoundsToString(event.bounds), movementType, event.zoom);
        }
    }, [
        trackMapViewportMoved
    ]);
    var trackMarkerClick = React.useCallback(function(feature) {
        if (feature) {
            var type = feature.type, _feature_id = feature.id, id = _feature_id === void 0 ? null : _feature_id;
            if (type && id !== null) {
                switch(type){
                    case "place":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , feature.qualifiers || [], "destination" /* DESTINATION */ );
                        break;
                    case "property":
                        trackMapPropertySelected(id.toString(), "property" /* PROPERTY */ );
                        break;
                    case "cluster":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , [], "cluster" /* CLUSTER */ );
                        break;
                    default:
                        break;
                }
            }
        }
    }, [
        trackMapPlaceSelected,
        trackMapPropertySelected
    ]);
    var tilesContentLoadedCallback = React.useCallback(function() {
        setTimeout(function() {
            var options = getContentPresentedOptions(mapRef.current, "tile" /* TILE */ );
            trackMapContentPresented(options);
        }, CONTENT_PRESENTED_DELAY);
    }, [
        trackMapContentPresented
    ]);
    var trackMarkerSelectionCb = React.useCallback(function(event) {
        if (event.action === "select") {
            trackMarkerClick(event.feature);
        }
    }, [
        trackMarkerClick
    ]);
    React.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        }
    }, [
        trackMapViewportBoundChangedCb
    ]);
    React.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        }
    }, [
        trackMarkerSelectionCb
    ]);
    React.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        }
    }, [
        tilesContentLoadedCallback
    ]);
    var internalBeforeInit = React.useCallback(function(map) {
        mapRef.current = map;
        map.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        map.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        map.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        if (beforeInit) {
            beforeInit(map);
        }
    }, []);
    var onInitInternal = React.useCallback(function(map) {
        initDone.current = true;
        if (map) {
            var mapId = "";
            switch(mapType){
                case UitkEGMapsType.MAPBOX:
                    mapId = map.readConfigParam("mapbox,mapboxAddConf,style");
                    break;
                case UitkEGMapsType.GOOGLE:
                default:
                    mapId = map.readConfigParam("googleMaps,gmapsAddConfig,mapId");
                    break;
            }
            var bbox = map.getBounds();
            if (bbox) {
                var bboxString = boundingBoxToString(bbox.sw, bbox.ne);
                trackMapPresented(bboxString, mapId, viewMode);
            }
        }
        if (onInit) {
            onInit(map);
        }
    }, [
        onInit,
        trackMapPresented,
        viewMode,
        mapType
    ]);
    var onFeaturesPushedInternal = React.useCallback(function(map, b) {
        if (b) {
            setTimeout(function() {
                var options = getContentPresentedOptions(map, "user" /* USER */ );
                trackMapContentPresented(options);
            }, CONTENT_PRESENTED_DELAY);
            if (onFeaturesPushed) {
                onFeaturesPushed(map, b);
            }
        }
    }, [
        onFeaturesPushed,
        trackMapContentPresented
    ]);
    if (!data && !initDone.current) {
        return /* @__PURE__ */ React.createElement("div", {
            style: {
                height: height
            }
        }, /* @__PURE__ */ React.createElement(UitkLayoutPosition, {
            type: "relative",
            position: {
                top: "center",
                left: "center"
            }
        }, /* @__PURE__ */ React.createElement(UitkPageLoader, {
            visible: true
        })));
    }
    return /* @__PURE__ */ React.createElement(UitkEGMaps, {
        accessToken: accessToken,
        mapType: mapType,
        initialViewport: initialViewportObject,
        beforeInit: internalBeforeInit,
        onInit: onInitInternal,
        height: height,
        mapConfig: cfg,
        features: features,
        onFeaturesPushed: onFeaturesPushedInternal,
        egDistancesEnabled: egDistancesEnabled,
        clientPadding: clientPadding
    }, children);
};
DynamicMap.displayName = "DynamicMap";
DynamicMap.fragment = __Fragment;
// ../internal/src/components/map/map-card-content.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment = gql2(_templateObject1());
var MapCardContent = function(props) {
    var data = props.data, size = props.size, imageRatio = props.imageRatio;
    if (!data || !data.title) {
        return null;
    }
    var image = data.image, subTitle = data.subTitle, title = data.title, id = data.id, description = data.description;
    var ratio = imageRatio || size === 1 /* COMPACT */  ? UitkFigureAspectRatioType.R3_4 : UitkFigureAspectRatioType.R4_3;
    var mapCardMinWidth = size === 1 /* COMPACT */  ? 351 : 720;
    var mapCardMinHeight = 63;
    return /* @__PURE__ */ React2.createElement(UitkCard, null, /* @__PURE__ */ React2.createElement("div", {
        "data-testid": "map-card-".concat(id)
    }), /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        alignItems: "start",
        columns: 4,
        style: {
            minHeight: mapCardMinHeight,
            minWidth: mapCardMinWidth
        }
    }, image ? /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, {
        colSpan: 1
    }, /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: ratio,
        roundcorner: [
            "startstart"
        ]
    }, "(", /* @__PURE__ */ React2.createElement(UitkImage, {
        src: image.url,
        alt: image.description,
        placeholderImage: true
    }))) : null, /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, {
        colSpan: 3
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(UitkCardContentSection, null, /* @__PURE__ */ React2.createElement(UitkHeading, null, title), description ? /* @__PURE__ */ React2.createElement(UitkText, {
        size: 200,
        spacing: "one"
    }, description) : null)), /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(UitkCardContentSection, null, subTitle ? /* @__PURE__ */ React2.createElement(UitkText, {
        size: 200
    }, subTitle) : null))))));
};
MapCardContent.fragment = fragment;
MapCardContent.displayName = "MapCardContent";
// src/components/map/map.tsx
import { ViewMedium as ViewMedium2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkEGMapsQualifier as UitkEGMapsQualifier2 } from "uitk-react-map";
import { UitkSheet as UitkSheet2 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
// src/components/map/analytics/map-analytics.tsx
var BASE_RFRR = "HOT.HIS.Module.Map";
var _obj;
var MapTracksDictionary = (_obj = {}, _define_property(_obj, "PAN" /* PAN */ , [
    "".concat(BASE_RFRR, ".Pan"),
    "User panning PWA HIS Map"
]), _define_property(_obj, "ZOOM_IN" /* ZOOM_IN */ , [
    "".concat(BASE_RFRR, ".Zoom.In"),
    "User zooming in on PWA HIS Map"
]), _define_property(_obj, "ZOOM_OUT" /* ZOOM_OUT */ , [
    "".concat(BASE_RFRR, ".Zoom.Out"),
    "User zooming out on PWA HIS Map"
]), _define_property(_obj, "CLOSE" /* CLOSE */ , [
    "".concat(BASE_RFRR, ".Link.Close"),
    "Close map dialog"
]), _obj);
var _obj1;
var MarkerTracksDictionary = (_obj1 = {}, _define_property(_obj1, "HOTEL" /* HOTEL */ , [
    "".concat(BASE_RFRR, ".HotelMarkerSelect"),
    "A hotel marker selected on HIS map"
]), _define_property(_obj1, "LANDMARK" /* LANDMARK */ , [
    "".concat(BASE_RFRR, ".PlaceMarkerSelect"),
    "A landmark marker selected on HIS map"
]), _define_property(_obj1, "AIRPORT" /* AIRPORT */ , [
    "".concat(BASE_RFRR, ".AirportMarkerSelect"),
    "An Airport marker selected on HIS map"
]), _define_property(_obj1, "RESTAURANT" /* RESTAURANT */ , [
    "".concat(BASE_RFRR, ".RestaurantMarkerSelect"),
    "A restaurant marker selected on HIS map"
]), _define_property(_obj1, "METRO" /* METRO */ , [
    "".concat(BASE_RFRR, ".TransitMarkerSelect"),
    "A train marker selected on HIS map"
]), _define_property(_obj1, "TRAIN" /* TRAIN */ , [
    "".concat(BASE_RFRR, ".TransitMarkerSelect"),
    "A train marker selected on HIS map"
]), _define_property(_obj1, "CIRCLE" /* CIRCLE */ , [
    "".concat(BASE_RFRR, ".CircleMarkerSelect"),
    "A circle marker selected on HIS map"
]), _obj1);
var _obj2;
var FilterTracksDictionary = (_obj2 = {}, _define_property(_obj2, "RESTAURANT_APPLIED" /* RESTAURANT */ , [
    "".concat(BASE_RFRR, ".RestaurantsFilterApplied"),
    "Show restaurants on HIS map"
]), _define_property(_obj2, "LANDMARK_APPLIED" /* LANDMARK */ , [
    "".concat(BASE_RFRR, ".LandmarksFilterApplied"),
    "Show landmarks on HIS map"
]), _define_property(_obj2, "BOTH_APPLIED" /* BOTH */ , [
    "".concat(BASE_RFRR, ".BothFiltersApplied"),
    "Show landmarks and restaurants on HIS map"
]), _define_property(_obj2, "NONE_APPLIED" /* NONE */ , [
    "".concat(BASE_RFRR, ".NoFiltersApplied"),
    "Show only airports and hotel on HIS map"
]), _obj2);
function useAnalytics(onCloseCallback) {
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var onClose = function() {
        if (onCloseCallback) {
            onCloseCallback();
        }
        trackMapHidden();
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapContentPresented: trackMapContentPresented,
        onClose: onClose
    };
}
// src/components/map/map-actions.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { useRefTargetScroll } from "@shared-ui/ref-context";
import { ViewMedium, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkButtonSize, UitkFloatingButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
// src/components/map/places-dialog.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { ViewLarge as ViewLarge2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/map/place-display.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkSubheading, UitkText as UitkText2 } from "uitk-react-text";
var __PlaceDisplayFragment = gql3(_templateObject2());
var PlaceDisplay = function(props) {
    var _data_placesDialogEGDSTextsContentSection_heading, _data_placesDialogEGDSTextsContentSection, _data, _data_placesDialogEGDSTextsContentSection1, _data1, _clearSavedPlaceIcon, _clearSavedPlaceIcon1;
    var data = props.data, savedFeature = props.savedFeature, saveCustomPlace = props.saveCustomPlace;
    var heading = (_data = data) === null || _data === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection = _data.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection_heading = _data_placesDialogEGDSTextsContentSection.heading) === null || _data_placesDialogEGDSTextsContentSection_heading === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection_heading.text;
    var clearSavedPlaceIcon = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_placesDialogEGDSTextsContentSection1 = _data1.placesDialogEGDSTextsContentSection) === null || _data_placesDialogEGDSTextsContentSection1 === void 0 ? void 0 : _data_placesDialogEGDSTextsContentSection1.clearSavedPlaceIcon;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React3.createElement(UitkHeading2, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React3.createElement(UitkSpacing, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex2, {
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React3.createElement(UitkIcon, {
        name: "place",
        size: UitkIconSize.SMALL
    })), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        grow: 10
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkText2, {
        weight: "bold"
    }, savedFeature.name), /* @__PURE__ */ React3.createElement(UitkSpacing, null, /* @__PURE__ */ React3.createElement(UitkSubheading, null, savedFeature.text)))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React3.createElement("button", {
        onClick: function() {
            return saveCustomPlace(void 0);
        },
        type: "button"
    }, /* @__PURE__ */ React3.createElement(UitkIcon, {
        id: (_clearSavedPlaceIcon = clearSavedPlaceIcon) === null || _clearSavedPlaceIcon === void 0 ? void 0 : _clearSavedPlaceIcon.id,
        name: "close",
        size: UitkIconSize.SMALL,
        title: (_clearSavedPlaceIcon1 = clearSavedPlaceIcon) === null || _clearSavedPlaceIcon1 === void 0 ? void 0 : _clearSavedPlaceIcon1.description
    }))))));
};
PlaceDisplay.fragment = __PlaceDisplayFragment;
PlaceDisplay.displayName = "placeDisplay";
// src/components/map/places-search.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText3 } from "uitk-react-text";
import { TypeaheadRenderType as TypeaheadRenderType2 } from "uitk-react-typeahead";
// src/components/map/places-typeahead.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { ESSAdapter, UitkTypeahead } from "uitk-react-typeahead";
var __PlacesTypeaheadFragment = gql4(_templateObject3());
var PlacesTypeahead = function(props) {
    var _identity, _data, _typeaheadContent, _typeaheadContent1, _typeaheadContent2, _typeaheadContent_typeaheadInfo, _typeaheadContent3, _typeaheadContent_typeaheadInfo1, _typeaheadContent4, _typeaheadContent_typeaheadInfo2, _typeaheadContent5;
    var data = props.data, handleChange = props.handleChange, essLogger = props.essLogger, strictFullscreen = props.strictFullscreen, renderType = props.renderType;
    var context = useBexApi2().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var expuserid = Number((_identity = identity) === null || _identity === void 0 ? void 0 : _identity.expUserId) || -1;
    var isProduction = process.env.NODE_ENV === "production";
    var _ref = identity || {}, guid = _ref.duaid;
    var typeaheadContent = (_data = data) === null || _data === void 0 ? void 0 : _data.content;
    var _typeaheadContent_label;
    var label = (_typeaheadContent_label = (_typeaheadContent = typeaheadContent) === null || _typeaheadContent === void 0 ? void 0 : _typeaheadContent.label) !== null && _typeaheadContent_label !== void 0 ? _typeaheadContent_label : "";
    var _typeaheadContent_placeholder;
    var placeholder = (_typeaheadContent_placeholder = (_typeaheadContent1 = typeaheadContent) === null || _typeaheadContent1 === void 0 ? void 0 : _typeaheadContent1.placeholder) !== null && _typeaheadContent_placeholder !== void 0 ? _typeaheadContent_placeholder : "";
    var _typeaheadContent_typeaheadEmptyResultPlaceholder;
    var noResultsPlaceholder = (_typeaheadContent_typeaheadEmptyResultPlaceholder = (_typeaheadContent2 = typeaheadContent) === null || _typeaheadContent2 === void 0 ? void 0 : _typeaheadContent2.typeaheadEmptyResultPlaceholder) !== null && _typeaheadContent_typeaheadEmptyResultPlaceholder !== void 0 ? _typeaheadContent_typeaheadEmptyResultPlaceholder : "";
    var _typeaheadContent_typeaheadInfo_client, _typeaheadContent_typeaheadInfo_maxNumberOfResults, _typeaheadContent_typeaheadInfo_regionType;
    var adapter = new ESSAdapter({
        client: (_typeaheadContent_typeaheadInfo_client = (_typeaheadContent3 = typeaheadContent) === null || _typeaheadContent3 === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo = _typeaheadContent3.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo === void 0 ? void 0 : _typeaheadContent_typeaheadInfo.client) !== null && _typeaheadContent_typeaheadInfo_client !== void 0 ? _typeaheadContent_typeaheadInfo_client : "Homepage",
        domain: isProduction ? void 0 : "https://www.expedia.com/",
        dest: true,
        expuserid: expuserid,
        features: "ta_hierarchy|postal_code|contextual_ta",
        guid: guid,
        lob: "HOTELS",
        locale: locale,
        maxResults: (_typeaheadContent_typeaheadInfo_maxNumberOfResults = (_typeaheadContent4 = typeaheadContent) === null || _typeaheadContent4 === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo1 = _typeaheadContent4.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo1 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo1.maxNumberOfResults) !== null && _typeaheadContent_typeaheadInfo_maxNumberOfResults !== void 0 ? _typeaheadContent_typeaheadInfo_maxNumberOfResults : 10,
        regionType: (_typeaheadContent_typeaheadInfo_regionType = (_typeaheadContent5 = typeaheadContent) === null || _typeaheadContent5 === void 0 ? void 0 : (_typeaheadContent_typeaheadInfo2 = _typeaheadContent5.typeaheadInfo) === null || _typeaheadContent_typeaheadInfo2 === void 0 ? void 0 : _typeaheadContent_typeaheadInfo2.regionType) !== null && _typeaheadContent_typeaheadInfo_regionType !== void 0 ? _typeaheadContent_typeaheadInfo_regionType : 2047,
        siteId: siteId,
        personalize: true,
        essLogger: essLogger
    });
    return /* @__PURE__ */ React4.createElement(UitkTypeahead, {
        adapter: adapter,
        icon: "place",
        name: "placesTypeAhead",
        onUpdate: handleChange,
        stid: "typeahead-adaptive",
        value: "",
        strictFullscreen: strictFullscreen,
        typeaheadPlaceholder: placeholder,
        typeaheadEmptyResultPlaceholder: noResultsPlaceholder,
        id: "placesTypeAhead",
        label: label,
        renderType: renderType
    });
};
PlacesTypeahead.fragment = __PlacesTypeaheadFragment;
PlacesTypeahead.displayName = "PlacesTypeahead";
// src/components/map/places-search.tsx
var __PlacesSearchFragment = gql5(_templateObject4(), PlacesTypeahead.fragment);
var PlacesSearch = function(props) {
    var _data, _typeAheadData_heading, _typeAheadData, _typeAheadData_subHeading, _typeAheadData1;
    var data = props.data, handleChange = props.handleChange, essLogger = props.essLogger;
    var typeAheadData = (_data = data) === null || _data === void 0 ? void 0 : _data.placesDialogTypeAheadContentSection;
    var heading = (_typeAheadData = typeAheadData) === null || _typeAheadData === void 0 ? void 0 : (_typeAheadData_heading = _typeAheadData.heading) === null || _typeAheadData_heading === void 0 ? void 0 : _typeAheadData_heading.text;
    var subHeading = (_typeAheadData1 = typeAheadData) === null || _typeAheadData1 === void 0 ? void 0 : (_typeAheadData_subHeading = _typeAheadData1.subHeading) === null || _typeAheadData_subHeading === void 0 ? void 0 : _typeAheadData_subHeading.text;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            blockstart: "one",
            blockend: "one"
        }
    }, heading && /* @__PURE__ */ React5.createElement(UitkHeading3, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React5.createElement(UitkSpacing2, {
        padding: {
            blockstart: "one",
            blockend: "three"
        }
    }, subHeading && /* @__PURE__ */ React5.createElement(UitkHeading3, {
        tag: "h4"
    }, /* @__PURE__ */ React5.createElement(UitkText3, {
        weight: "regular",
        inline: true
    }, subHeading))), typeAheadData && /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewSmall, null, /* @__PURE__ */ React5.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        essLogger: essLogger,
        strictFullscreen: true,
        renderType: TypeaheadRenderType2.DIALOG
    })), /* @__PURE__ */ React5.createElement(ViewLarge, null, /* @__PURE__ */ React5.createElement(PlacesTypeahead, {
        data: typeAheadData,
        handleChange: handleChange,
        essLogger: essLogger
    }))));
};
PlacesSearch.fragment = __PlacesSearchFragment;
PlacesSearch.displayName = "PlacesSearch";
// src/components/map/places-switches.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/lodging-egds-switch/lodging-egds-switch.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkSwitch } from "uitk-react-switch";
var __Fragment2 = gql6(_templateObject5());
var LodgingEGDSSwitch = function(_param) {
    var data = _param.data, checked = _param.checked, handleToggle = _param.handleToggle, props = _object_without_properties(_param, [
        "data",
        "checked",
        "handleToggle"
    ]);
    var initialCheck = data.checked, checkedAnalytics = data.checkedAnalytics, checkedLabel = data.checkedLabel, enabled = data.enabled, uncheckedAnalytics = data.uncheckedAnalytics, uncheckedLabel = data.uncheckedLabel;
    var _React6_useState = _sliced_to_array(React6.useState(checked !== null && checked !== void 0 ? checked : initialCheck), 2), isChecked = _React6_useState[0], setIsChecked = _React6_useState[1];
    React6.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : initialCheck);
    }, [
        checked,
        initialCheck
    ]);
    var track = useClickTracker2();
    var handleChange = React6.useCallback(function(event) {
        var _handleToggle;
        var _event_currentTarget = event.currentTarget, wasChecked = _event_currentTarget.checked;
        setIsChecked(wasChecked);
        if (checkedAnalytics && !wasChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && wasChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        (_handleToggle = handleToggle) === null || _handleToggle === void 0 ? void 0 : _handleToggle(wasChecked);
    }, [
        checkedAnalytics,
        handleToggle,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React6.createElement(UitkSwitch, _object_spread({
        id: isChecked ? checkedLabel : uncheckedLabel,
        disabled: !enabled,
        checked: isChecked,
        label: isChecked ? checkedLabel : uncheckedLabel,
        onChange: handleChange
    }, props));
};
LodgingEGDSSwitch.displayName = "EGDSSwitch";
LodgingEGDSSwitch.fragment = __Fragment2;
// src/components/map/places-switches.tsx
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText4 } from "uitk-react-text";
var __PlacesSwitchesFragment = gql7(_templateObject6());
function isFilterOption(content) {
    return content.__typename === "FilterOption";
}
var findToggledFilterIndex = function(toggledFilters, filteredValues) {
    return toggledFilters.map(function(qualifiers) {
        return qualifiers.join(",");
    }).indexOf(filteredValues.join(","));
};
var isToggledFilterSelected = function(toggledFilters, filteredValues) {
    return findToggledFilterIndex(toggledFilters, filteredValues) < 0;
};
var computeToggledFilters = function(data) {
    var _data_placesDialogUITogglesContentSection_content_filter_filter, _data_placesDialogUITogglesContentSection_content_filter, _data_placesDialogUITogglesContentSection_content, _data_placesDialogUITogglesContentSection, _data;
    return ((_data = data) === null || _data === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection = _data.placesDialogUITogglesContentSection) === null || _data_placesDialogUITogglesContentSection === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content = _data_placesDialogUITogglesContentSection.content) === null || _data_placesDialogUITogglesContentSection_content === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter = _data_placesDialogUITogglesContentSection_content.filter(isFilterOption)) === null || _data_placesDialogUITogglesContentSection_content_filter === void 0 ? void 0 : (_data_placesDialogUITogglesContentSection_content_filter_filter = _data_placesDialogUITogglesContentSection_content_filter.filter(function(toggle) {
        return !toggle.checked;
    })) === null || _data_placesDialogUITogglesContentSection_content_filter_filter === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_content_filter_filter.map(function(toggle) {
        return toggle.filteredValues;
    })) || [];
};
var PlacesSwitches = function(param) {
    var data = param.data, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters;
    var _data_placesDialogUITogglesContentSection_subHeading, _content;
    React7.useEffect(function() {
        if (!toggledFilters) {
            setToggledFilters(computeToggledFilters(data));
        }
    }, [
        toggledFilters
    ]);
    var handleToggle = React7.useCallback(function(checked, filteredValues) {
        var foundIndex = toggledFilters !== void 0 ? findToggledFilterIndex(toggledFilters, filteredValues) : -1;
        if (toggledFilters && foundIndex >= 0 && checked) {
            setToggledFilters(_to_consumable_array(toggledFilters.slice(0, foundIndex)).concat(_to_consumable_array(toggledFilters.slice(foundIndex + 1))));
        } else if (!checked && foundIndex < 0) {
            var values = toggledFilters ? _to_consumable_array(toggledFilters).concat([
                filteredValues
            ]) : [
                filteredValues
            ];
            setToggledFilters(values);
        }
    }, [
        toggledFilters,
        setToggledFilters
    ]);
    if (!data || !data.placesDialogUITogglesContentSection) {
        return null;
    }
    var subHeading = (_data_placesDialogUITogglesContentSection_subHeading = data.placesDialogUITogglesContentSection.subHeading) === null || _data_placesDialogUITogglesContentSection_subHeading === void 0 ? void 0 : _data_placesDialogUITogglesContentSection_subHeading.text;
    var content = data.placesDialogUITogglesContentSection.content;
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(UitkSpacing3, {
        padding: {
            blockstart: "six"
        }
    }, subHeading && /* @__PURE__ */ React7.createElement(UitkHeading4, {
        tag: "h4"
    }, /* @__PURE__ */ React7.createElement(UitkText4, {
        weight: "regular",
        inline: true
    }, subHeading))), (_content = content) === null || _content === void 0 ? void 0 : _content.filter(isFilterOption).map(function(toggle, idx) {
        var filteredValues = toggle.filteredValues, switchData = _object_without_properties(toggle, [
            "filteredValues"
        ]);
        var isChecked = toggledFilters !== void 0 ? isToggledFilterSelected(toggledFilters, filteredValues) : void 0;
        return /* @__PURE__ */ React7.createElement(UitkSpacing3, {
            padding: {
                blockstart: "three",
                blockend: "two"
            },
            key: "switch-".concat(idx)
        }, /* @__PURE__ */ React7.createElement(LodgingEGDSSwitch, {
            data: switchData,
            checked: isChecked,
            handleToggle: function(checked) {
                return handleToggle(checked, filteredValues);
            }
        }));
    }));
};
PlacesSwitches.fragment = __PlacesSwitchesFragment;
PlacesSwitches.displayName = "placesSwitches";
// src/components/map/places-dialog.tsx
var __PlacesDialogFragment = gql8(_templateObject7(), PlacesSearch.fragment, PlaceDisplay.fragment, PlacesSwitches.fragment);
var PlacesDialog = function(param) {
    var data = param.data, setSavedFeature = param.setSavedFeature, savedFeature = param.savedFeature, essLogger = param.essLogger, toggledFilters = param.toggledFilters, setToggledFilters = param.setToggledFilters, closeDialog = param.onClosePlacesDialog, showPlacesDialog = param.showPlacesDialog;
    var _data_trigger_icon, _data_trigger, _data, _data_dialog_toolbar, _data_dialog, _data1;
    var _useEgMapClickstream = useEgMapClickstream(), trackMapCustomPlaceAdded = _useEgMapClickstream.trackMapCustomPlaceAdded, trackMapCustomPlaceRemoved = _useEgMapClickstream.trackMapCustomPlaceRemoved;
    var saveCustomPlace = function(feature) {
        if (feature) {
            var featureDetail = feature.name || feature.text || feature.id.toString();
            trackMapCustomPlaceAdded("gaia" /* GAIA */ , featureDetail, feature.id.toString());
        } else if (savedFeature) {
            var featureDetail1 = savedFeature.name || savedFeature.text || savedFeature.id.toString();
            trackMapCustomPlaceRemoved("gaia" /* GAIA */ , featureDetail1, savedFeature.id.toString());
        }
        setSavedFeature(feature);
    };
    var getNameAndText = function(fullName, shortName, type) {
        var nameArray;
        if (type === "AIRPORT" /* AIRPORT */ ) {
            nameArray = shortName || fullName ? [
                shortName || fullName
            ] : [];
        } else {
            var _fullName;
            var _fullName_split;
            nameArray = (_fullName_split = (_fullName = fullName) === null || _fullName === void 0 ? void 0 : _fullName.split(", ")) !== null && _fullName_split !== void 0 ? _fullName_split : [];
        }
        return {
            name: nameArray.shift(),
            text: nameArray.join(", ")
        };
    };
    var handleTypeaheadChange = function(selection) {
        var _regionNames, _regionNames1;
        var selectionData = selection.data;
        var _ref = selectionData || {}, regionNames = _ref.regionNames, type = _ref.type, location = _ref.location, essId = _ref.essId;
        var _getNameAndText = getNameAndText((_regionNames = regionNames) === null || _regionNames === void 0 ? void 0 : _regionNames.fullName, (_regionNames1 = regionNames) === null || _regionNames1 === void 0 ? void 0 : _regionNames1.shortName, type), name = _getNameAndText.name, text = _getNameAndText.text;
        var _ref1 = location || {}, lat = _ref1.lat, long = _ref1.long;
        var idFromLatLong = "".concat(lat).concat(long).replace(/\./g, "");
        var _essId_sourceId;
        var feature = {
            id: (_essId_sourceId = essId.sourceId) !== null && _essId_sourceId !== void 0 ? _essId_sourceId : idFromLatLong,
            lat: parseFloat(lat),
            lng: parseFloat(long),
            type: "place",
            status: "unknown",
            name: name,
            text: text,
            qualifiers: [
                "searchedLocation"
            ],
            score: 1
        };
        saveCustomPlace(feature);
        closeDialog();
    };
    var dialogTitle = (_data = data) === null || _data === void 0 ? void 0 : (_data_trigger = _data.trigger) === null || _data_trigger === void 0 ? void 0 : (_data_trigger_icon = _data_trigger.icon) === null || _data_trigger_icon === void 0 ? void 0 : _data_trigger_icon.description;
    var _data_dialog_toolbar_closeText;
    var toolbarCloseText = (_data_dialog_toolbar_closeText = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_dialog = _data1.dialog) === null || _data_dialog === void 0 ? void 0 : (_data_dialog_toolbar = _data_dialog.toolbar) === null || _data_dialog_toolbar === void 0 ? void 0 : _data_dialog_toolbar.closeText) !== null && _data_dialog_toolbar_closeText !== void 0 ? _data_dialog_toolbar_closeText : "";
    var dialogLayout = /* @__PURE__ */ React8.createElement(UitkLayoutFlex3, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React8.createElement(UitkToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: toolbarCloseText
        },
        toolbarTitle: dialogTitle
    }), /* @__PURE__ */ React8.createElement(UitkSheetContent, null, savedFeature && /* @__PURE__ */ React8.createElement(PlaceDisplay, {
        data: data,
        savedFeature: savedFeature,
        saveCustomPlace: saveCustomPlace
    }), !savedFeature && /* @__PURE__ */ React8.createElement(PlacesSearch, {
        data: data,
        handleChange: handleTypeaheadChange,
        essLogger: essLogger
    }), /* @__PURE__ */ React8.createElement(PlacesSwitches, {
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        data: data
    })));
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Viewport2, null, /* @__PURE__ */ React8.createElement(ViewSmall2, null, /* @__PURE__ */ React8.createElement(UitkSheet, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 12
        },
        triggerRef: null
    }, dialogLayout)), /* @__PURE__ */ React8.createElement(ViewLarge2, null, /* @__PURE__ */ React8.createElement(UitkSheet, {
        isVisible: showPlacesDialog,
        type: "side",
        sideSheetLayout: {
            position: "leading",
            columns: 4
        },
        triggerRef: null
    }, dialogLayout))));
};
PlacesDialog.fragment = __PlacesDialogFragment;
PlacesDialog.displayName = "PlacesDialog";
// src/components/map/map-actions.tsx
var SCROLL_TIMEOUT = 1e3;
var __MapActionsFragment = gql9(_templateObject8(), PlacesDialog.fragment);
var MapActionsComponent = function(param) {
    var data = param.data, onClose = param.onClose, savedFeature = param.savedFeature, essLogger = param.essLogger, onTogglesChanged = param.onTogglesChanged, setSavedFeature = param.setSavedFeature, cardContent = param.cardContent, selectedFeatureType = param.selectedFeatureType;
    var _data, _data1, _placesDialogData_trigger_icon, _placesDialogData_trigger, _placesDialogData, _data2, _chooseARoomButton;
    var scrollTo = useRefTargetScroll().scrollTo;
    var _useEgMapClickstream = useEgMapClickstream(), trackMapPlacesDialogOpened = _useEgMapClickstream.trackMapPlacesDialogOpened, trackMapPlacesDialogClosed = _useEgMapClickstream.trackMapPlacesDialogClosed;
    var _React9_useState = _sliced_to_array(React9.useState(), 2), toggledFilters = _React9_useState[0], setToggledFilters = _React9_useState[1];
    var clickstreamTrack = useEgClickstream2();
    var placesDialogData = ((_data = data) === null || _data === void 0 ? void 0 : _data.dialogs) && ((_data1 = data) === null || _data1 === void 0 ? void 0 : _data1.dialogs[0]);
    var dialogTitle = (_placesDialogData = placesDialogData) === null || _placesDialogData === void 0 ? void 0 : (_placesDialogData_trigger = _placesDialogData.trigger) === null || _placesDialogData_trigger === void 0 ? void 0 : (_placesDialogData_trigger_icon = _placesDialogData_trigger.icon) === null || _placesDialogData_trigger_icon === void 0 ? void 0 : _placesDialogData_trigger_icon.description;
    var _React9_useState1 = _sliced_to_array(React9.useState(false), 2), showPlacesDialog = _React9_useState1[0], setShowPlacesDialog = _React9_useState1[1];
    var openPlacesDialog = function() {
        setShowPlacesDialog(true);
        trackMapPlacesDialogOpened();
    };
    var closePlacesDialog = function() {
        setShowPlacesDialog(false);
        trackMapPlacesDialogClosed();
    };
    var getUniqueFilterQualifiers = React9.useCallback(function(values) {
        var filteredQualifiers = values.flatMap(function(v) {
            return v;
        }) || [];
        return filteredQualifiers ? Array.from(new Set(filteredQualifiers)) : [];
    }, []);
    React9.useEffect(function() {
        var initialFilters = computeToggledFilters(placesDialogData);
        if (initialFilters.length > 0) {
            setToggledFilters(initialFilters);
        }
    }, []);
    React9.useEffect(function() {
        if (toggledFilters) {
            onTogglesChanged(getUniqueFilterQualifiers(toggledFilters));
        }
    }, [
        toggledFilters
    ]);
    var PlacesButton = /* @__PURE__ */ React9.createElement(UitkFloatingButton, {
        size: UitkButtonSize.LARGE,
        onClick: openPlacesDialog
    }, /* @__PURE__ */ React9.createElement(UitkIcon2, {
        name: "place"
    }), dialogTitle);
    var placesDialog = placesDialogData && /* @__PURE__ */ React9.createElement(PlacesDialog, {
        data: placesDialogData,
        setSavedFeature: setSavedFeature,
        savedFeature: savedFeature,
        essLogger: essLogger,
        toggledFilters: toggledFilters,
        setToggledFilters: setToggledFilters,
        onClosePlacesDialog: closePlacesDialog,
        showPlacesDialog: showPlacesDialog
    });
    var _ref = ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.callToAction) || {}, chooseARoomButton = _ref.button, chooseARoomAction = _ref.action, chooseARoomClickStreamEvent = _ref.event;
    var chooseARoomBtnLabel = (_chooseARoomButton = chooseARoomButton) === null || _chooseARoomButton === void 0 ? void 0 : _chooseARoomButton.primary;
    var onChooseARoomButtonClick = function() {
        trackMapChooseARoomBtnClick();
        onClose();
        var targetRef = (chooseARoomAction || {}).targetRef;
        if (targetRef) {
            setTimeout(function() {
                scrollTo(targetRef, []);
            }, SCROLL_TIMEOUT);
        }
    };
    var trackMapChooseARoomBtnClick = function() {
        var _ref = chooseARoomClickStreamEvent || {}, _ref_eventName = _ref.eventName, eventName = _ref_eventName === void 0 ? "" : _ref_eventName, _ref_eventType = _ref.eventType, eventType = _ref_eventType === void 0 ? "" : _ref_eventType, _ref_eventVersion = _ref.eventVersion, eventVersion = _ref_eventVersion === void 0 ? "" : _ref_eventVersion;
        if (eventName && eventType && eventVersion && clickstreamTrack) {
            var event = buildEvent(eventName, eventType, eventVersion);
            clickstreamTrack(buildData(event, {}));
        }
    };
    var mapCard = /* @__PURE__ */ React9.createElement(Viewport3, null, /* @__PURE__ */ React9.createElement(ViewSmall3, null, /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem3, {
        maxWidth: 351,
        alignSelf: "center"
    }, /* @__PURE__ */ React9.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, cardContent ? /* @__PURE__ */ React9.createElement(MapCardContent, {
        data: cardContent,
        size: 1 /* COMPACT */ 
    }) : null))), /* @__PURE__ */ React9.createElement(ViewMedium, null, /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem3, {
        maxWidth: 720,
        alignSelf: "center"
    }, /* @__PURE__ */ React9.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, cardContent ? /* @__PURE__ */ React9.createElement(MapCardContent, {
        data: cardContent,
        size: 0 /* STANDARD */ 
    }) : null))));
    var chooseARoomButtonVariant = /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem3, null, chooseARoomBtnLabel && /* @__PURE__ */ React9.createElement(UitkFloatingButton, {
        size: UitkButtonSize.LARGE,
        onClick: onChooseARoomButtonClick,
        name: chooseARoomBtnLabel
    }, chooseARoomBtnLabel));
    return /* @__PURE__ */ React9.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            bottom: "three"
        },
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React9.createElement(UitkLayoutFlex4, {
        space: "three",
        direction: "column"
    }, /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React9.createElement(UitkLayoutFlex4, {
        space: "four",
        justifyContent: "center"
    }, placesDialogData && /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem3, null, !showPlacesDialog && PlacesButton), /* @__PURE__ */ React9.createElement(Experiment, {
        name: "PEXO_PDP_choose_a_room_CTA_in_map_modal_EGTNL"
    }, /* @__PURE__ */ React9.createElement(ExperimentControl, null), /* @__PURE__ */ React9.createElement(ExperimentVariant, {
        bucket: 1
    }, chooseARoomButtonVariant)))), mapCard), placesDialog);
};
MapActionsComponent.displayName = "MapActions";
MapActionsComponent.fragment = __MapActionsFragment;
var MapActions = MapActionsComponent;
// src/components/map/map-viewport.ts
var excludeAirportFilter = function(param) {
    var qualifiers = param.qualifiers;
    var _qualifiers;
    return !((_qualifiers = qualifiers) === null || _qualifiers === void 0 ? void 0 : _qualifiers.find(function(qualifier) {
        return qualifier === "transport__airport";
    }));
};
var mapFeaturesToCoordinates = function(features) {
    return features.filter(excludeAirportFilter).map(function(feature) {
        return [
            feature.lat,
            feature.lng
        ];
    });
};
// src/components/map/map.tsx
var __MapQuery = gql10(_templateObject9(), DynamicMap.fragment, MapCardContent.fragment, MapActions.fragment);
var QUALIFIER_HIDDEN = "hidden";
var isEgdsMapFeature = function(mapMarker) {
    return mapMarker.__typename === "EGDSMapFeature";
};
var MapComponent = function(props) {
    var _propertyInfo_summary_location, _propertyInfo_summary, _propertyInfo, _propertyInfo_summary1, _propertyInfo1, _mapData, _egdsBasicMap_config, _egdsBasicMap, _egdsBasicMap1, _egMapsFeatures, _mapData1, _mapData2, _mapData_toolbar, _mapData3, _mapData_toolbar_icon, _mapData_toolbar1, _mapData4;
    var context = useBexApi3().context;
    var locale = context.locale;
    var inputs = props.inputs, beforeInit = props.beforeInit, onInit = props.onInit, onCloseCallback = props.onClose, setSavedFeature = props.setSavedFeature, savedFeature = props.savedFeature, essLogger = props.essLogger, clientPadding = props.clientPadding, triggerRef = props.triggerRef;
    var _React10_useState = _sliced_to_array(React10.useState(savedFeature), 2), internalSavedFeature = _React10_useState[0], setInternalSavedFeature = _React10_useState[1];
    var _React10_useState1 = _sliced_to_array(React10.useState([]), 2), filteredValues = _React10_useState1[0], setFilteredValues = _React10_useState1[1];
    var centerMapOnCustomFeatureAndSelectIt = React10.useRef(true);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__MapQuery, {
        variables: variables
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var mapRef = React10.useRef();
    var track = useClickTracker3();
    var _React10_useState2 = _sliced_to_array(React10.useState(), 2), cardContent = _React10_useState2[0], setCardContent = _React10_useState2[1];
    var _React10_useState3 = _sliced_to_array(React10.useState(), 2), selectedFeatureType = _React10_useState3[0], setSelectedFeatureType = _React10_useState3[1];
    var _React10_useState4 = _sliced_to_array(React10.useState(0), 2), sheetHeight = _React10_useState4[0], setSheetHeight = _React10_useState4[1];
    var VERTICAL_MARGINS = 48;
    React10.useEffect(function() {
        setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        var handleWindowResize = function() {
            setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var propertyInfo = (data !== null && data !== void 0 ? data : {}).propertyInfo;
    var propertyCoordinates = (_propertyInfo = propertyInfo) === null || _propertyInfo === void 0 ? void 0 : (_propertyInfo_summary = _propertyInfo.summary) === null || _propertyInfo_summary === void 0 ? void 0 : (_propertyInfo_summary_location = _propertyInfo_summary.location) === null || _propertyInfo_summary_location === void 0 ? void 0 : _propertyInfo_summary_location.coordinates;
    var mapData = (_propertyInfo1 = propertyInfo) === null || _propertyInfo1 === void 0 ? void 0 : (_propertyInfo_summary1 = _propertyInfo1.summary) === null || _propertyInfo_summary1 === void 0 ? void 0 : _propertyInfo_summary1.map;
    var egdsBasicMap = (_mapData = mapData) === null || _mapData === void 0 ? void 0 : _mapData.egdsBasicMap;
    var dynamicMapId = (_egdsBasicMap = egdsBasicMap) === null || _egdsBasicMap === void 0 ? void 0 : (_egdsBasicMap_config = _egdsBasicMap.config) === null || _egdsBasicMap_config === void 0 ? void 0 : _egdsBasicMap_config.mapId;
    var egMapsFeatures = (_egdsBasicMap1 = egdsBasicMap) === null || _egdsBasicMap1 === void 0 ? void 0 : _egdsBasicMap1.markers;
    var egFeatures = egMapsFeatures ? convertMarkers((_egMapsFeatures = egMapsFeatures) === null || _egMapsFeatures === void 0 ? void 0 : _egMapsFeatures.map(function(m) {
        return m;
    })) : [];
    var mapCards = (_mapData1 = mapData) === null || _mapData1 === void 0 ? void 0 : _mapData1.mapInfoCards;
    var onClose = useAnalytics(onCloseCallback).onClose;
    var doCenterMapOnCustomFeatureAndSelectIt = function(map, allFeatures, customFeature, propCoordinates) {
        var options = propCoordinates ? {
            centeredOn: [
                propCoordinates.latitude,
                propCoordinates.longitude
            ]
        } : void 0;
        var coordinates = mapFeaturesToCoordinates(customFeature ? _to_consumable_array(allFeatures).concat([
            customFeature
        ]) : allFeatures);
        map.boundsContaining(coordinates, true, options).then(function(param) {
            var sw = param.sw, ne = param.ne;
            map.fitBounds(sw, ne, true, clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%");
            if (internalSavedFeature) {
                map.selectFeature(customFeature.id, customFeature.type);
            }
        });
    };
    var internalOnFeaturePushed = React10.useCallback(function(map) {
        if (centerMapOnCustomFeatureAndSelectIt.current && internalSavedFeature) {
            doCenterMapOnCustomFeatureAndSelectIt(map, egFeatures, internalSavedFeature, propertyCoordinates);
            centerMapOnCustomFeatureAndSelectIt.current = false;
        }
        hideFeaturesFromToggles(map, egFeatures, filteredValues);
    }, [
        internalSavedFeature,
        egFeatures,
        propertyCoordinates,
        filteredValues
    ]);
    React10.useEffect(function() {
        if (!internalSavedFeature) {
            centerMapOnCustomFeatureAndSelectIt.current = true;
        }
        if (setSavedFeature) {
            setSavedFeature(internalSavedFeature);
        }
    }, [
        internalSavedFeature
    ]);
    React10.useEffect(function() {
        if (setSavedFeature && internalSavedFeature && propertyCoordinates) {
            var customPlace = point([
                internalSavedFeature.lng,
                internalSavedFeature.lat
            ]);
            var property = point([
                propertyCoordinates.longitude,
                propertyCoordinates.latitude
            ]);
            var d = distance(customPlace, property, {
                units: "miles"
            });
            if (d >= 80) {
                setSavedFeature(void 0);
                setInternalSavedFeature(void 0);
            }
        }
    }, [
        propertyCoordinates
    ]);
    var hideFeaturesFromToggles = function(map, features, filteredQualifiers) {
        var featuresToHide = [];
        var featuresToShow = [];
        features.forEach(function(feature) {
            var _feature_qualifiers;
            if ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.some(function(q) {
                return filteredQualifiers.includes(q);
            })) {
                featuresToHide.push({
                    id: feature.id,
                    type: feature.type
                });
            } else {
                featuresToShow.push({
                    id: feature.id,
                    type: feature.type
                });
            }
        });
        map.addQualifierToFeatures(featuresToHide, QUALIFIER_HIDDEN);
        map.removeQualifierFromFeatures(featuresToShow, QUALIFIER_HIDDEN);
    };
    React10.useEffect(function() {
        if (mapRef.current) {
            hideFeaturesFromToggles(mapRef.current, egFeatures, filteredValues);
        }
    }, [
        egFeatures,
        internalSavedFeature,
        filteredValues
    ]);
    var internalBeforeInit = React10.useCallback(function(mapObj) {
        mapRef.current = mapObj;
        if (beforeInit) {
            beforeInit(mapObj);
        }
    }, []);
    var internalOnInit = React10.useCallback(function(mapObj) {
        mapObj.addSelectionChangeListener(function(event) {
            var feature = event.feature;
            switch(event.action){
                case "select":
                    {
                        var _mapCards;
                        setCardContent(void 0);
                        setSelectedFeatureType(void 0);
                        var card = (_mapCards = mapCards) === null || _mapCards === void 0 ? void 0 : _mapCards.find(function(egCard) {
                            return egCard.id === feature.id;
                        });
                        if (card) {
                            var _egMapsFeatures_filter_find, _egMapsFeatures;
                            setCardContent(card);
                            setSelectedFeatureType(feature.type);
                            var markerDataAnalytics = (_egMapsFeatures = egMapsFeatures) === null || _egMapsFeatures === void 0 ? void 0 : (_egMapsFeatures_filter_find = _egMapsFeatures.filter(isEgdsMapFeature).find(function(marker) {
                                return feature.id === marker.id;
                            })) === null || _egMapsFeatures_filter_find === void 0 ? void 0 : _egMapsFeatures_filter_find.clientSideAnalytics;
                            if (markerDataAnalytics) {
                                track(markerDataAnalytics.referrerId, markerDataAnalytics.linkName);
                            }
                        } else {
                            setCardContent(void 0);
                            setSelectedFeatureType(void 0);
                        }
                        break;
                    }
                case "clearSelection":
                    setCardContent(void 0);
                    setSelectedFeatureType(void 0);
                    break;
                default:
                    break;
            }
        });
        if (onInit) {
            onInit(mapObj);
        }
    }, [
        egdsBasicMap
    ]);
    var googleMapsConfig = React10.useMemo(function() {
        return dynamicMapId ? {
            gmapsAddConfig: {
                mapId: dynamicMapId
            }
        } : void 0;
    }, [
        dynamicMapId
    ]);
    var egMapsConfig = React10.useMemo(function() {
        return {
            googleMaps: googleMapsConfig,
            locale: locale,
            markers: {
                place: {
                    show: _define_property({}, "unknown#".concat(QUALIFIER_HIDDEN), false),
                    textLabel: {
                        show: _define_property({}, UitkEGMapsQualifier2.METRO_STATION, false)
                    }
                }
            }
        };
    }, [
        locale,
        googleMapsConfig
    ]);
    var supplementalFeatures = React10.useMemo(function() {
        if (internalSavedFeature) {
            return [
                internalSavedFeature
            ];
        }
        return void 0;
    }, [
        internalSavedFeature
    ]);
    if (loading || error || !data || !egdsBasicMap) {
        return null;
    }
    var sheetProps = {
        returnFocusOnClose: true,
        triggerRef: triggerRef,
        isVisible: true
    };
    var sheetContent = /* @__PURE__ */ React10.createElement(React10.Fragment, null, ((_mapData2 = mapData) === null || _mapData2 === void 0 ? void 0 : _mapData2.toolbar) ? /* @__PURE__ */ React10.createElement(UitkToolbar2, {
        toolbarTitle: ((_mapData3 = mapData) === null || _mapData3 === void 0 ? void 0 : (_mapData_toolbar = _mapData3.toolbar) === null || _mapData_toolbar === void 0 ? void 0 : _mapData_toolbar.title) || "",
        navigationContent: {
            onClick: onClose,
            navType: "close",
            navIconLabel: (_mapData4 = mapData) === null || _mapData4 === void 0 ? void 0 : (_mapData_toolbar1 = _mapData4.toolbar) === null || _mapData_toolbar1 === void 0 ? void 0 : (_mapData_toolbar_icon = _mapData_toolbar1.icon) === null || _mapData_toolbar_icon === void 0 ? void 0 : _mapData_toolbar_icon.description
        }
    }) : null, /* @__PURE__ */ React10.createElement(DynamicMap, {
        data: egdsBasicMap,
        supplementalFeatures: supplementalFeatures,
        onInit: internalOnInit,
        beforeInit: internalBeforeInit,
        egMapsConfig: egMapsConfig,
        clientPadding: clientPadding !== null && clientPadding !== void 0 ? clientPadding : "0px 0px 20%",
        onFeaturesPushed: internalOnFeaturePushed,
        updateViewport: false
    }), mapData && /* @__PURE__ */ React10.createElement(MapActions, {
        setSavedFeature: setInternalSavedFeature,
        savedFeature: internalSavedFeature,
        essLogger: essLogger,
        onTogglesChanged: setFilteredValues,
        onClose: onClose,
        data: mapData,
        cardContent: cardContent,
        selectedFeatureType: selectedFeatureType
    }));
    return /* @__PURE__ */ React10.createElement(Viewport4, null, /* @__PURE__ */ React10.createElement(ViewSmall4, null, /* @__PURE__ */ React10.createElement(UitkSheet2, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), sheetContent)), /* @__PURE__ */ React10.createElement(ViewMedium2, null, /* @__PURE__ */ React10.createElement(Experiment2, {
        name: "PCC_PDP_centered_sheet_map_modal"
    }, /* @__PURE__ */ React10.createElement(ExperimentControl2, null, /* @__PURE__ */ React10.createElement(UitkSheet2, _object_spread({
        type: "full"
    }, sheetProps), sheetContent)), /* @__PURE__ */ React10.createElement(ExperimentVariant2, {
        bucket: 1
    }, /* @__PURE__ */ React10.createElement(UitkSheet2, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered",
        height: sheetHeight,
        centeredSheetSize: "medium"
    }), sheetContent)))));
};
MapComponent.displayName = "sharedui-Map";
var Map = MapComponent;
// src/components/amenity-description/amenity-description.tsx
import React16, { useEffect } from "react";
import { gql as gql16 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3, useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/utils/analytics.ts
var lightweightAdaptExMicroMessage = function(param) {
    var campaignId = param.campaignId, payloadId = param.payloadId, eventType = param.eventType, eventTarget = param.eventTarget, _param_banditDisplayed = param.banditDisplayed, banditDisplayed = _param_banditDisplayed === void 0 ? true : _param_banditDisplayed;
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: [
                {
                    payloadId: payloadId,
                    eventType: eventType,
                    eventTarget: eventTarget,
                    banditDisplayed: banditDisplayed
                }
            ]
        }
    };
};
var createAdaptExMicroMessage = function(campaignId, events) {
    var _events;
    var allEvents = (_events = events) === null || _events === void 0 ? void 0 : _events.reduce(function(acc, curr) {
        return _to_consumable_array(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var _eventType;
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: ((_eventType = eventType) === null || _eventType === void 0 ? void 0 : _eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (campaignId && events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
// src/components/amenity-description/amenity-description.tsx
import { useInView } from "react-intersection-observer";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { ViewLarge as ViewLarge3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkLayoutColumns } from "uitk-react-layout-columns";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
// src/components/amenity-description/amenity-description-jumplink.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/lodging-jumplink/lodging-jumplink.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll as useRefTargetScroll2 } from "@shared-ui/ref-context";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
var __LodgingJumpLinkFragment = gql11(_templateObject10());
var scrollOffsets = [
    {
        sectionName: "wizard",
        offsetMultiplier: 2
    },
    {
        sectionName: "navigation"
    }
];
var LodgingJumpLink = function(param) {
    var data = param.data, trackingDetails = param.trackingDetails;
    var _icon;
    var linkText = data.localizedName, icon = data.icon, sectionName = data.sectionName, accessibilityLabel = data.accessibilityLabel;
    var iconId = ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.iconId) || "";
    var scrollTo = useRefTargetScroll2().scrollTo;
    var track = useClickTracker4();
    var handleClick = React11.useCallback(function(e) {
        e.preventDefault();
        if (trackingDetails) {
            var _trackingDetails, _trackingDetails1;
            track((_trackingDetails = trackingDetails) === null || _trackingDetails === void 0 ? void 0 : _trackingDetails.id, (_trackingDetails1 = trackingDetails) === null || _trackingDetails1 === void 0 ? void 0 : _trackingDetails1.description, true);
        }
        if (sectionName) {
            scrollTo(sectionName, scrollOffsets);
        }
    }, [
        trackingDetails,
        track,
        scrollTo,
        sectionName
    ]);
    return /* @__PURE__ */ React11.createElement(UitkSpacing4, {
        padding: {
            blockstart: "three",
            blockend: "unset"
        }
    }, /* @__PURE__ */ React11.createElement(UitkLink, {
        align: "left",
        onClick: handleClick
    }, /* @__PURE__ */ React11.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React11.createElement("span", {
        "aria-hidden": accessibilityLabel !== null
    }, linkText), accessibilityLabel && /* @__PURE__ */ React11.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React11.createElement(UitkIcon3, {
        name: iconId
    }))));
};
LodgingJumpLink.displayName = "LodgingJumpLink";
LodgingJumpLink.fragment = __LodgingJumpLinkFragment;
// src/components/amenity-description/amenity-description-jumplink.tsx
var __AmenityDescriptionJumpLinkFragment = gql12(_templateObject11(), LodgingJumpLink.fragment);
var AmenityDescriptionJumpLink = function(param) {
    var action = param.data.action;
    if (!action) return null;
    return /* @__PURE__ */ React12.createElement(LodgingJumpLink, {
        data: action
    });
};
AmenityDescriptionJumpLink.displayName = "AmenityDescriptionJumpLink";
AmenityDescriptionJumpLink.fragment = __AmenityDescriptionJumpLinkFragment;
// src/components/amenity-description/__private/__fragments/amenity-content.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutColumnsItem } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText5 } from "uitk-react-text";
var __AmenityContentFragment = gql13(_templateObject12());
var AmenityContent = function(param) {
    var data = param.data;
    var _structuredData, _structuredData1, _structuredData2, _structuredData3, _structuredData4, _icon, _items;
    var _ref = data || {}, heading = _ref.heading, items = _ref.items, icon = _ref.icon, structuredData = _ref.structuredData;
    if (!heading) {
        return null;
    }
    var isAmenityFeature = ((_structuredData = structuredData) === null || _structuredData === void 0 ? void 0 : _structuredData.itemprop) === "amenityFeature";
    var isAmenityLanguage = ((_structuredData1 = structuredData) === null || _structuredData1 === void 0 ? void 0 : _structuredData1.itemprop) === "availableLanguage";
    return /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React13.createElement("div", null, /* @__PURE__ */ React13.createElement(UitkLayoutColumnsItem, {
        forceNoBreak: true
    }, /* @__PURE__ */ React13.createElement("div", {
        itemProp: (_structuredData2 = structuredData) === null || _structuredData2 === void 0 ? void 0 : _structuredData2.itemprop,
        itemScope: (_structuredData3 = structuredData) === null || _structuredData3 === void 0 ? void 0 : _structuredData3.itemscope,
        itemType: (_structuredData4 = structuredData) === null || _structuredData4 === void 0 ? void 0 : _structuredData4.itemtype
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlex5, {
        space: "two"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        padding: {
            inlineend: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkIcon4, {
        name: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.iconId) || "",
        size: UitkIconSize2.MEDIUM
    }))), /* @__PURE__ */ React13.createElement("span", {
        itemProp: isAmenityFeature ? "name" : void 0
    }, /* @__PURE__ */ React13.createElement(UitkHeading5, {
        tag: "h3",
        size: 5
    }, heading))), ((_items = items) === null || _items === void 0 ? void 0 : _items.length) > 0 && /* @__PURE__ */ React13.createElement(UitkSpacing5, {
        padding: {
            inlinestart: "twelve"
        }
    }, /* @__PURE__ */ React13.createElement("ul", {
        className: "no-bullet"
    }, items.map(function(item, index) {
        return /* @__PURE__ */ React13.createElement(UitkSpacing5, {
            margin: {
                blockstart: "two"
            },
            key: index
        }, /* @__PURE__ */ React13.createElement("li", {
            itemProp: isAmenityLanguage ? "name" : void 0
        }, /* @__PURE__ */ React13.createElement(UitkText5, {
            size: 300,
            theme: "default"
        }, item.text), isAmenityFeature && /* @__PURE__ */ React13.createElement("meta", {
            itemProp: "value",
            content: item.text
        })));
    })))))));
};
AmenityContent.displayName = "AmenityContent";
AmenityContent.fragment = __AmenityContentFragment;
// src/components/amenity-description/__private/__fragments/amenity-heading.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkHeading as UitkHeading6, UitkText as UitkText6 } from "uitk-react-text";
var __AmenityHeadingFragment = gql14(_templateObject13());
var AmenityHeading = function(param) {
    var data = param.data;
    var _ref = data || {}, text = _ref.text, subText = _ref.subText;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(UitkHeading6, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, text), subText && /* @__PURE__ */ React14.createElement(UitkText6, {
        spacing: "two"
    }, subText));
};
AmenityHeading.displayName = "AmenityHeading";
AmenityHeading.fragment = __AmenityHeadingFragment;
// src/components/amenity-description/__private/__fragments/amenity-section.tsx
var __AmenitySectionFragment = gql15(_templateObject14(), AmenityHeading.fragment, AmenityContent.fragment, AmenityDescriptionJumpLink.fragment);
var AmenitySection = function(param) {
    var data = param.data;
    var _contents;
    var _ref = data || {}, contents = _ref.contents, header = _ref.header;
    if (!((_contents = contents) === null || _contents === void 0 ? void 0 : _contents.length)) {
        return null;
    }
    return /* @__PURE__ */ React15.createElement(Viewport5, null, /* @__PURE__ */ React15.createElement(ViewSmall5, null, /* @__PURE__ */ React15.createElement(React15.Fragment, null, header && /* @__PURE__ */ React15.createElement(UitkSpacing6, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(AmenityHeading, {
        data: header
    }))), contents.map(function(content, index) {
        return /* @__PURE__ */ React15.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))), /* @__PURE__ */ React15.createElement(ViewLarge3, null, /* @__PURE__ */ React15.createElement(UitkLayoutGrid2, {
        columns: {
            medium: 3
        },
        space: "six"
    }, header && /* @__PURE__ */ React15.createElement(UitkLayoutGridItem2, {
        colSpan: 1
    }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(AmenityHeading, {
        data: header
    }))), /* @__PURE__ */ React15.createElement(UitkLayoutGridItem2, {
        colSpan: 2
    }, /* @__PURE__ */ React15.createElement(UitkLayoutColumns, {
        minWidth: "half_width",
        columns: 2,
        space: "twelve"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React15.createElement(AmenityContent, {
            key: "amenity-content-".concat(index),
            data: content
        });
    }))))));
};
AmenitySection.displayName = "AmenitySection";
AmenitySection.fragment = __AmenitySectionFragment;
// src/components/amenity-description/amenity-description.tsx
var __AmenityDescriptionFragment = gql16(_templateObject15(), AmenitySection.fragment);
var AmenityDescription = function(props) {
    var _data_summary, _data, _amenitySections;
    var data = props.data;
    var _ref = ((_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.amenities) || {}, amenitySections = _ref.amenities, adaptExAttemptEvents = _ref.viewAmenitiesAdaptExAttemptEvents;
    var amenitySectionLength = (_amenitySections = amenitySections) === null || _amenitySections === void 0 ? void 0 : _amenitySections.length;
    var _useExperiment = useExperiment("Amenity_category_reordering_"), exposure = _useExperiment.exposure, logExperiment = _useExperiment.logExperiment;
    var track = useClickstreamAnalytics().track;
    var _useInView = useInView({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView.ref, inView = _useInView.inView;
    useEffect(function() {
        var _adaptExAttemptEvents;
        if (inView && ((_adaptExAttemptEvents = adaptExAttemptEvents) === null || _adaptExAttemptEvents === void 0 ? void 0 : _adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                track(ITrackType.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: adaptExAttemptEvent.events[0].payloadId,
                        eventType: adaptExAttemptEvent.events[0].eventType,
                        eventTarget: adaptExAttemptEvent.events[0].eventTarget
                    })
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    useEffect(function() {
        if (inView && amenitySections && amenitySectionLength) {
            logExperiment(exposure);
        }
    }, [
        inView
    ]);
    if (!amenitySections || !amenitySectionLength) {
        return null;
    }
    var AmenityDescriptionRender = /* @__PURE__ */ React16.createElement(UitkSpacing7, {
        padding: {
            block: "six",
            small: {
                inline: "three"
            },
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React16.createElement(UitkCard2, {
        ref: ref
    }, amenitySections.map(function(amenitySection, index) {
        var isLastSection = index === amenitySectionLength - 1;
        var border = isLastSection ? void 0 : "bottom";
        return /* @__PURE__ */ React16.createElement(UitkSpacing7, {
            key: "amenity-section-".concat(index),
            margin: isLastSection ? void 0 : {
                blockend: "six"
            },
            padding: isLastSection ? void 0 : {
                blockend: "three"
            }
        }, /* @__PURE__ */ React16.createElement(UitkCardContentSection2, {
            border: border,
            padded: false
        }, /* @__PURE__ */ React16.createElement(AmenitySection, {
            data: amenitySection
        }), /* @__PURE__ */ React16.createElement(AmenityDescriptionJumpLink, {
            data: amenitySection
        })));
    })));
    return /* @__PURE__ */ React16.createElement(Experiment3, {
        name: "Amenity_category_reordering_"
    }, /* @__PURE__ */ React16.createElement(ExperimentControl3, null, AmenityDescriptionRender), /* @__PURE__ */ React16.createElement(ExperimentVariant3, {
        bucket: 1
    }, AmenityDescriptionRender));
};
AmenityDescription.displayName = "AmenityDescription";
AmenityDescription.fragment = __AmenityDescriptionFragment;
// src/components/amenity-description/amenities-adaptex-context.tsx
import React17, { createContext, useState } from "react";
var defaultState = {
    reserveAdaptExSuccessEvents: []
};
var defaultValue = [
    defaultState,
    function() {
        return void 0;
    }
];
var AmenitiesAdaptExContext = createContext(defaultValue);
var Provider = AmenitiesAdaptExContext.Provider;
var AmenitiesAdaptExProvider = function(param) {
    var children = param.children;
    var value = useState(defaultState);
    return /* @__PURE__ */ React17.createElement(Provider, {
        value: value
    }, children);
};
// src/components/property-cleanliness/property-cleanliness.tsx
import React54 from "react";
import { gql as gql52, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
// src/components/content-section-groups/cleanliness.tsx
import React53 from "react";
import { gql as gql51 } from "@apollo/client";
// src/components/content-section-groups/__private/__fragments/property-content-section-group.tsx
import React52 from "react";
import { gql as gql50 } from "@apollo/client";
import { ViewLarge as ViewLarge5, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkExpandoPeek as UitkExpandoPeek4 } from "uitk-react-expando";
// src/components/shared/__private/__fragments/property-content.tsx
import React28 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek as UitkExpandoPeek2 } from "uitk-react-expando";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// src/components/shared/__private/__fragments/property-content-item-graphics.tsx
import React22 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic.tsx
import React21 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/common/icon.tsx
import React18 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
var fragment2 = gql17(_templateObject16());
var _obj3;
var SPOTLIGHT_MAP = (_obj3 = {}, _define_property(_obj3, "INFO" /* INFO */ , "info"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj3, "WARNING" /* WARNING */ , "warning"), _obj3);
var _data_title, _data_theme, _data_spotLight;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    return /* @__PURE__ */ React18.createElement(UitkIcon5, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.iconSize ? UitkIconSize3[data.iconSize] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        shadow: Boolean(data.withBackground),
        spotlight: spotlight !== null && spotlight !== void 0 ? spotlight : SPOTLIGHT_MAP[(_data_spotLight = data.spotLight) !== null && _data_spotLight !== void 0 ? _data_spotLight : ""]
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = fragment2;
// ../internal/src/components/common/illustration.tsx
import React19 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment3 = gql18(_templateObject17());
var Illustration = function(param) {
    var className = param.className, data = param.data;
    return /* @__PURE__ */ React19.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link,
        className: className
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = fragment3;
// ../internal/src/components/common/mark.tsx
import React20 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var fragment4 = gql19(_templateObject18());
var Mark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React20.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize !== null && markSize !== void 0 ? markSize : data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment4;
// ../internal/src/components/common/ui-graphic.tsx
var __UIGraphicFragment = gql20(_templateObject19(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React21.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React21.createElement(Mark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React21.createElement(Illustration, {
                data: data,
                className: className
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// src/components/shared/__private/__fragments/property-content-item-graphics.tsx
var fragment5 = gql21(_templateObject20(), UiGraphic.fragment);
var PropertyContentItemGraphics = function(param) {
    var data = param.data;
    var graphics = data.graphics;
    if (!graphics || graphics.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React22.createElement(React22.Fragment, null, graphics.map(function(graphic, index) {
        return /* @__PURE__ */ React22.createElement(UiGraphic, {
            key: index,
            data: graphic
        });
    }));
};
PropertyContentItemGraphics.displayName = "PropertyContentItemGraphics";
PropertyContentItemGraphics.fragment = fragment5;
// src/components/shared/__private/__fragments/property-content-item-images.tsx
import React23 from "react";
import Lazyload from "react-lazy-load";
import { gql as gql22 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
var fragment6 = gql22(_templateObject21());
var PropertyContentItemImages = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var contents = data.contents;
    var structuredData = props.structuredData;
    if (!contents || contents.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React23.createElement(UitkSpacing8, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React23.createElement("div", {
        "data-stid": "content-image"
    }, /* @__PURE__ */ React23.createElement(UitkLayoutFlex6, {
        space: "half",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        return /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem5, {
            key: index
        }, /* @__PURE__ */ React23.createElement(Lazyload, {
            height: 64
        }, /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("img", {
            src: content.image.url,
            alt: content.image.description || "",
            height: "100%"
        }), structuredData && /* @__PURE__ */ React23.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: content.image.description
        }))));
    }))));
};
PropertyContentItemImages.displayName = "PropertyContentItemImages";
PropertyContentItemImages.fragment = fragment6;
// src/components/shared/__private/__fragments/property-content-item-markup.tsx
import React24 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkText as UitkText7 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var fragment7 = gql23(_templateObject22());
var PropertyContentItemMarkup = function(param) {
    var data = param.data;
    var text = data.content.text;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React24.createElement(UitkText7, {
        size: 300,
        spacing: "two",
        overflow: "wrap"
    }, /* @__PURE__ */ React24.createElement("div", {
        "data-stid": "content-markup"
    }, /* @__PURE__ */ React24.createElement(UitkUnformattedHtml, {
        htmlToParse: text
    })));
};
PropertyContentItemMarkup.displayName = "PropertyContentItemMarkup";
PropertyContentItemMarkup.fragment = fragment7;
// src/components/shared/__private/__fragments/property-content-item-text.tsx
import React25 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkIcon as UitkIcon6 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
var fragment8 = gql24(_templateObject23());
var PropertyContentItemText = function(param) {
    var data = param.data;
    var expando = data.expando, content = data.content;
    var _ref = expando || {}, expandedLabel = _ref.expandedLabel, collapsedLabel = _ref.collapsedLabel;
    var primary = content.primary, secondary = content.secondary;
    var value = primary.value, subtexts = primary.subtexts;
    var _React25_useState = _sliced_to_array(React25.useState(false), 2), isVisible = _React25_useState[0], setIsVisible = _React25_useState[1];
    var handleClick = React25.useCallback(function() {
        setIsVisible(function(prev) {
            return !prev;
        });
    }, [
        setIsVisible
    ]);
    var Content = React25.useMemo(function() {
        var _primary_icon, _primary_egdsMark, _primary, _secondary;
        return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement(UitkLayoutFlex7, {
            alignItems: "center"
        }, ((_primary_icon = primary.icon) === null || _primary_icon === void 0 ? void 0 : _primary_icon.iconId) && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React25.createElement(UitkSpacing9, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React25.createElement(UitkIcon6, {
            name: primary.icon.iconId
        }))), ((_primary_egdsMark = primary.egdsMark) === null || _primary_egdsMark === void 0 ? void 0 : _primary_egdsMark.url) && /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React25.createElement(UitkSpacing9, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React25.createElement(UitkMark2, {
            url: primary.egdsMark.url.value,
            description: primary.egdsMark.description
        }))), /* @__PURE__ */ React25.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React25.createElement(UitkText8, {
            theme: "default",
            size: 300,
            weight: ((_primary = primary) === null || _primary === void 0 ? void 0 : _primary.state) === "STRONG" ? "bold" : "regular"
        }, value, subtexts && subtexts.length > 0 && /* @__PURE__ */ React25.createElement(React25.Fragment, null, subtexts.map(function(subtext, index) {
            var _primary;
            return /* @__PURE__ */ React25.createElement(UitkText8, {
                key: index,
                theme: "default",
                size: 200,
                weight: ((_primary = primary) === null || _primary === void 0 ? void 0 : _primary.state) === "STRONG" ? "bold" : "regular"
            }, subtext);
        }))))), ((_secondary = secondary) === null || _secondary === void 0 ? void 0 : _secondary.value) && /* @__PURE__ */ React25.createElement(UitkText8, {
            spacing: "two",
            theme: "default",
            size: 300
        }, secondary.value));
    }, [
        primary,
        secondary,
        value,
        subtexts
    ]);
    if (!expando) {
        return Content;
    }
    return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement(UitkExpandoPeek, {
        isVisible: isVisible,
        handleClick: handleClick,
        lines: 4,
        expandLabel: collapsedLabel,
        collapseLabel: expandedLabel
    }, Content));
};
PropertyContentItemText.displayName = "PropertyContentItemText";
PropertyContentItemText.fragment = fragment8;
// src/components/shared/__private/__fragments/property-content-item-texts.tsx
import React26 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkText as UitkText9 } from "uitk-react-text";
var fragment9 = gql25(_templateObject24());
var PropertyContentItemTexts = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var _contents;
    var contents = data.contents;
    var structuredData = props.structuredData;
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, (_contents = contents) === null || _contents === void 0 ? void 0 : _contents.map(function(param, index) {
        var primary = param.primary;
        return primary.value && /* @__PURE__ */ React26.createElement(React26.Fragment, {
            key: "PropertyContentItemTexts-".concat(index)
        }, /* @__PURE__ */ React26.createElement(UitkText9, {
            theme: "default",
            spacing: "two",
            size: 300
        }, primary.value), structuredData && /* @__PURE__ */ React26.createElement("meta", {
            itemProp: structuredData.itemprop,
            content: primary.value
        }));
    }));
};
PropertyContentItemTexts.displayName = "PropertyContentItemTexts";
PropertyContentItemTexts.fragment = fragment9;
// src/components/shared/__private/__fragments/property-section-header.tsx
import React27 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkAvatar } from "uitk-react-avatar";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkMark as UitkMark3, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkHeading as UitkHeading7, UitkText as UitkText10 } from "uitk-react-text";
var fragment10 = gql26(_templateObject25());
var SectionHeader = function(_param) {
    var data = _param.data, props = _object_without_properties(_param, [
        "data"
    ]);
    var _url;
    var text = data.text, subText = data.subText, icon = data.icon, mark = data.mark, headerImage = data.headerImage;
    var singleLineHeader = props.singleLineHeader;
    var _ref = mark !== null && mark !== void 0 ? mark : {}, id = _ref.id, description = _ref.description, url = _ref.url;
    var RenderedSubtext = React27.useMemo(function() {
        return /* @__PURE__ */ React27.createElement(UitkText10, {
            inline: singleLineHeader,
            size: 400,
            spacing: "two"
        }, subText);
    }, [
        singleLineHeader,
        subText
    ]);
    if (!text && !mark) {
        return null;
    }
    return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(UitkLayoutFlex8, {
        space: "six"
    }, icon && /* @__PURE__ */ React27.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(UitkIcon7, {
        name: icon.iconId,
        description: icon.description
    }))), mark && /* @__PURE__ */ React27.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React27.createElement(React27.Fragment, null, id && /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(UitkMark3, {
        name: id,
        size: UitkMarkSize2.MEDIUM,
        description: description
    })), !id && ((_url = url) === null || _url === void 0 ? void 0 : _url.value) && /* @__PURE__ */ React27.createElement(UitkMark3, {
        url: url.value,
        size: UitkMarkSize2.MEDIUM,
        description: description
    }))), /* @__PURE__ */ React27.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React27.createElement(UitkLayoutGrid3, {
        columns: 4
    }, /* @__PURE__ */ React27.createElement(UitkLayoutGridItem3, {
        colSpan: headerImage ? 3 : 4
    }, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(UitkHeading7, _object_spread_props(_object_spread({}, props), {
        tabIndex: -1
    }), text, subText && singleLineHeader && /* @__PURE__ */ React27.createElement(React27.Fragment, null, " ", RenderedSubtext)), subText && !singleLineHeader && RenderedSubtext)), headerImage && /* @__PURE__ */ React27.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React27.createElement(UitkLayoutPosition3, {
        type: "absolute",
        position: {
            right: "three"
        }
    }, /* @__PURE__ */ React27.createElement(UitkAvatar, {
        border: false,
        image: {
            alt: headerImage.description,
            src: headerImage.url
        },
        size: "extra_large"
    })))))));
};
SectionHeader.displayName = "SectionHeader";
SectionHeader.fragment = fragment10;
// src/components/shared/__private/__fragments/property-content.tsx
var fragment11 = gql27(_templateObject26(), PropertyContentItemGraphics.fragment, PropertyContentItemImages.fragment, PropertyContentItemMarkup.fragment, PropertyContentItemText.fragment, PropertyContentItemTexts.fragment, SectionHeader.fragment);
var PropertyContent = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader;
    var _header, _propertyContentItems, _structuredData, _header1;
    var clickTracker = useClickTracker5();
    var header = data.header, items = data.items, expando = data.expando, maxColumns = data.maxColumns, structuredData = data.structuredData;
    var _React28_useState = _sliced_to_array(React28.useState(false), 2), isVisible = _React28_useState[0], setIsVisible = _React28_useState[1];
    var handleClick = React28.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var analytics = {
        id: "HOT.HIS.propertyContent.".concat((_header = header) === null || _header === void 0 ? void 0 : _header.text),
        description: "Shared ui property content section group expando",
        callback: React28.useCallback(function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }, [
            clickTracker
        ])
    };
    if (items.length === 0) {
        return null;
    }
    var getPropertyContentItemComponent = function(contentItem) {
        switch(contentItem.__typename){
            case "PropertyContentItemMarkup":
                return /* @__PURE__ */ React28.createElement(PropertyContentItemMarkup, {
                    data: contentItem
                });
            case "PropertyContentItemTexts":
                return /* @__PURE__ */ React28.createElement(PropertyContentItemTexts, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemText":
                return /* @__PURE__ */ React28.createElement(PropertyContentItemText, {
                    data: contentItem
                });
            case "PropertyContentItemImages":
                return /* @__PURE__ */ React28.createElement(PropertyContentItemImages, {
                    data: contentItem,
                    structuredData: structuredData
                });
            case "PropertyContentItemGraphics":
                return /* @__PURE__ */ React28.createElement(PropertyContentItemGraphics, {
                    data: contentItem
                });
            default:
                return null;
        }
    };
    var propertyContentItems = items.map(function(item, index) {
        var propertyContentItemComponent = getPropertyContentItemComponent(item);
        return propertyContentItemComponent && /* @__PURE__ */ React28.createElement(UitkLayoutGridItem4, {
            key: index
        }, /* @__PURE__ */ React28.createElement("div", null, propertyContentItemComponent));
    });
    var hasItems = propertyContentItems && ((_propertyContentItems = propertyContentItems) === null || _propertyContentItems === void 0 ? void 0 : _propertyContentItems.length) > 0;
    return /* @__PURE__ */ React28.createElement(UitkLayoutGridItem4, {
        colSpan: 1
    }, /* @__PURE__ */ React28.createElement("div", {
        "data-stid": "content-item",
        itemProp: (_structuredData = structuredData) === null || _structuredData === void 0 ? void 0 : _structuredData.itemprop
    }, header && /* @__PURE__ */ React28.createElement(SectionHeader, {
        tag: smallerHeader ? "h4" : "h3",
        size: smallerHeader ? 6 : 5,
        data: header
    }), hasItems && /* @__PURE__ */ React28.createElement(UitkSpacing10, {
        padding: {
            inlinestart: ((_header1 = header) === null || _header1 === void 0 ? void 0 : _header1.icon) ? "twelve" : void 0,
            blockstart: "two"
        }
    }, expando ? /* @__PURE__ */ React28.createElement(UitkExpandoPeek2, {
        handleClick: handleClick,
        items: 2,
        isVisible: isVisible,
        expandLabel: expando.expandButton.text,
        collapseLabel: expando.collapseButton.text,
        analytics: analytics
    }, /* @__PURE__ */ React28.createElement(UitkLayoutGrid4, {
        space: "two",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems)) : /* @__PURE__ */ React28.createElement(UitkLayoutGrid4, {
        space: "four",
        columns: maxColumns ? {
            small: 1,
            medium: maxColumns
        } : void 0
    }, propertyContentItems))));
};
PropertyContent.displayName = "PropertyContent";
PropertyContent.fragment = fragment11;
// src/components/content-section-groups/__private/__fragments/property-content-section.tsx
import React51 from "react";
import { gql as gql49 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { RefTarget } from "@shared-ui/ref-context";
import { UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
// src/components/content-section-groups/__private/__fragments/property-content-section-action.tsx
import React40 from "react";
import { gql as gql36 } from "@apollo/client";
// ../internal/src/components/lodging-link-message.tsx
import React29 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var __LodgingLinkMessageFragment = gql28(_templateObject27());
var LodgingLinkMessage = function(param) {
    var data = param.data;
    var link = data.link, value = data.value, icon = data.icon;
    var _ref = icon || {}, iconId = _ref.id, iconDescription = _ref.description;
    var uri = link.uri, clientSideAnalytics = link.clientSideAnalytics;
    var track = useClickTracker6();
    var href = uri.value;
    var handleClick = function() {
        var _ref = clientSideAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, href && /* @__PURE__ */ React29.createElement(UitkLink2, {
        onClickCapture: handleClick,
        "data-stid": "lodging-link-message"
    }, /* @__PURE__ */ React29.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer"
    }, value, iconId && /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React29.createElement(UitkIcon8, {
        "data-stid": "lodging-link-message-icon",
        name: iconId,
        size: UitkIconSize4.SMALL,
        title: iconDescription
    })))));
};
LodgingLinkMessage.displayName = "LodgingLinkMessage";
LodgingLinkMessage.fragment = __LodgingLinkMessageFragment;
var lodging_link_message_default = LodgingLinkMessage;
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog.tsx
import React31 from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSheet as UitkSheet3, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog-context.tsx
import { createContext as createContext2, useContext } from "react";
var PropertyContentSectionDetailedDialogContext = createContext2(void 0);
var usePropertyContentSectionDetailedDialogContext = function() {
    var context = useContext(PropertyContentSectionDetailedDialogContext);
    return context;
};
// src/components/content-section-groups/__private/__fragments/property-content-section-detailed-dialog.tsx
var fragment12 = gql29(_templateObject28());
var PropertyContentSectionDetailedDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _dialog, _dialogData;
    var dialog = data.dialog, trigger = data.trigger;
    var dialogData = ((_dialog = dialog) === null || _dialog === void 0 ? void 0 : _dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var linkRef = React31.useRef(null);
    var clickTracker = useClickTracker7();
    var _useDialog = _sliced_to_array(useDialog("property-content-section-detailed-dialog-".concat(actionId), "PropertyContentSectionDetailedDialog"), 3), dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var detailedDialogContent = usePropertyContentSectionDetailedDialogContext();
    var closeDialog = React31.useCallback(function() {
        var _dialogData;
        dialogActions.closeDialog();
        if ((_dialogData = dialogData) === null || _dialogData === void 0 ? void 0 : _dialogData.closeAnalytics) {
            var _dialogData1, _dialogData2;
            clickTracker((_dialogData1 = dialogData) === null || _dialogData1 === void 0 ? void 0 : _dialogData1.closeAnalytics.referrerId, (_dialogData2 = dialogData) === null || _dialogData2 === void 0 ? void 0 : _dialogData2.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        clickTracker,
        (_dialogData = dialogData) === null || _dialogData === void 0 ? void 0 : _dialogData.closeAnalytics
    ]);
    var openDialog = React31.useCallback(function() {
        dialogActions.openDialog();
        clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
    }, [
        dialogActions,
        clickTracker,
        trigger.analytics
    ]);
    if (!dialogData) {
        return null;
    }
    var dialogContent = function(sheetType) {
        var _dialogData_toolbar_closeText;
        return /* @__PURE__ */ React31.createElement(UitkSheet3, {
            type: sheetType,
            key: "property-content-section-detailed-dialog",
            returnFocusOnClose: true,
            isVisible: true,
            triggerRef: linkRef,
            ariaLabel: (_dialogData_toolbar_closeText = dialogData.toolbar.closeText) !== null && _dialogData_toolbar_closeText !== void 0 ? _dialogData_toolbar_closeText : void 0
        }, /* @__PURE__ */ React31.createElement(UitkToolbar3, {
            toolbarTitle: dialogData.toolbar.title,
            key: "UitkToolbar",
            navigationContent: {
                onClick: closeDialog,
                navType: "close",
                navButtonLabel: void 0
            }
        }), /* @__PURE__ */ React31.createElement(UitkSheetContent2, {
            padded: false
        }, detailedDialogContent));
    };
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(DialogComponent, null, /* @__PURE__ */ React31.createElement(Viewport6, null, /* @__PURE__ */ React31.createElement(ViewSmall6, null, dialogContent("full")), /* @__PURE__ */ React31.createElement(ViewMedium3, null, dialogContent("centered")))), /* @__PURE__ */ React31.createElement(UitkSpacing12, null, /* @__PURE__ */ React31.createElement(UitkLink3, {
        onClick: openDialog
    }, /* @__PURE__ */ React31.createElement("button", {
        ref: linkRef,
        type: "button"
    }, trigger.message))));
};
PropertyContentSectionDetailedDialog.displayName = "PropertyContentSectionDetailedDialog";
PropertyContentSectionDetailedDialog.fragment = fragment12;
// src/components/content-section-groups/__private/__fragments/property-content-section-dialog.tsx
import React33 from "react";
import { gql as gql30 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkSheet as UitkSheet4 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
// src/components/content-section-groups/__private/__fragments/property-content-section-action-item.tsx
import React32 from "react";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkParagraph, UitkText as UitkText11 } from "uitk-react-text";
var PropertyContentSectionActionItem = function(param) {
    var contentItem = param.contentItem, key = param.key;
    switch(contentItem.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React32.createElement(UitkSpacing13, {
                key: key,
                padding: {
                    blockend: "three"
                }
            }, /* @__PURE__ */ React32.createElement(UitkParagraph, null, " ", contentItem.text, " "));
        case "EGDSPlainText":
            return /* @__PURE__ */ React32.createElement(UitkText11, {
                key: key,
                inline: true
            }, contentItem.text);
        case "EGDSInlineLink":
            {
                var _contentItem_action;
                var resource = (_contentItem_action = contentItem.action) === null || _contentItem_action === void 0 ? void 0 : _contentItem_action.resource;
                return /* @__PURE__ */ React32.createElement(UitkLink4, {
                    key: key,
                    inline: true
                }, /* @__PURE__ */ React32.createElement("a", {
                    href: resource.value
                }, contentItem.text));
            }
        default:
            return null;
    }
};
PropertyContentSectionActionItem.displayName = "PropertyContentSectionActionItem";
// src/components/content-section-groups/__private/__fragments/property-content-section-dialog.tsx
var fragment13 = gql30(_templateObject29());
var PropertyContentSectionDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _dialog, _dialogContent_toolbar, _dialogContent;
    var _useDialog2 = _sliced_to_array(useDialog2("property-content-section-dialog-".concat(actionId), "PropertyContentSectionDialog"), 3), dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var content = data.content, dialog = data.dialog, trigger = data.trigger;
    var contents = content.contents;
    var dialogContent = ((_dialog = dialog) === null || _dialog === void 0 ? void 0 : _dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker8();
    var closeDialog = React33.useCallback(function() {
        dialogActions.closeDialog();
        if (dialog.closeAnalytics) {
            clickTracker(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        dialog.closeAnalytics,
        clickTracker
    ]);
    var openDialog = React33.useCallback(function() {
        dialogActions.openDialog();
        clickTracker(trigger.analytics.referrerId, trigger.analytics.linkName);
    }, [
        dialogActions,
        trigger.analytics,
        clickTracker
    ]);
    return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(DialogComponent, null, /* @__PURE__ */ React33.createElement(UitkSheet4, {
        type: "centered",
        isVisible: true,
        triggerRef: null,
        returnFocusOnClose: true,
        key: "property-content-section-dialog"
    }, /* @__PURE__ */ React33.createElement(UitkToolbar4, {
        toolbarTitle: (_dialogContent = dialogContent) === null || _dialogContent === void 0 ? void 0 : (_dialogContent_toolbar = _dialogContent.toolbar) === null || _dialogContent_toolbar === void 0 ? void 0 : _dialogContent_toolbar.title,
        key: "UitkToolbar",
        navigationContent: {
            onClick: closeDialog,
            navType: "close"
        }
    }), /* @__PURE__ */ React33.createElement(UitkDialogContent, null, contents.map(function(contentItem, index) {
        return /* @__PURE__ */ React33.createElement(PropertyContentSectionActionItem, {
            contentItem: contentItem,
            key: index
        });
    })))), /* @__PURE__ */ React33.createElement(UitkLink5, {
        inline: true
    }, /* @__PURE__ */ React33.createElement("button", {
        type: "button",
        onClick: openDialog
    }, trigger.message)));
};
PropertyContentSectionDialog.displayName = "PropertyContentSectionDialog";
PropertyContentSectionDialog.fragment = fragment13;
// src/components/content-section-groups/__private/__fragments/property-content-section-list-type-dialog.tsx
import React39 from "react";
import { gql as gql35 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium5, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon12 } from "uitk-react-icons";
import { UitkLink as UitkLink6 } from "uitk-react-link";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSheet as UitkSheet6, UitkSheetContent as UitkSheetContent4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar5 } from "uitk-react-toolbar";
// src/components/summary/__private/__fragments/shared/property-info-content-header.tsx
import React34 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText12 } from "uitk-react-text";
var __PropertyInfoContentHeader = gql31(_templateObject30());
var PropertyInfoContentHeader = function(param) {
    var data = param.data;
    var text = data.text, subText = data.subText;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React34.createElement(UitkSpacing14, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React34.createElement(UitkHeading8, {
        tag: "h3",
        size: 5
    }, text), subText && /* @__PURE__ */ React34.createElement(UitkSpacing14, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React34.createElement(UitkText12, {
        spacing: "two"
    }, subText)));
};
PropertyInfoContentHeader.displayName = "PropertyInfoContentHeader";
PropertyInfoContentHeader.fragment = __PropertyInfoContentHeader;
// src/components/summary/__private/__fragments/shared/property-info-content-items.tsx
import React37 from "react";
import { gql as gql33 } from "@apollo/client";
import { Experiment as Experiment4, ExperimentControl as ExperimentControl4, ExperimentVariant as ExperimentVariant4 } from "@shared-ui/experiment-context";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkLayoutColumns as UitkLayoutColumns2 } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex10 } from "uitk-react-layout-flex";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/shared/amenity-review-summary.tsx
import React36 from "react";
import { gql as gql32 } from "@apollo/client";
import { IntersectionTracker, useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize2, UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet5, UitkSheetCloseButton, UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkText as UitkText14 } from "uitk-react-text";
// src/components/summary/__private/__fragments/shared/property-info-content-text.tsx
import React35 from "react";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkText as UitkText13 } from "uitk-react-text";
var PropertyInfoContentText = function(param) {
    var infoContent = param.infoContent;
    var text = infoContent.text, state = infoContent.state, moreInfo = infoContent.moreInfo, accessibilityLabel = infoContent.accessibilityLabel;
    return /* @__PURE__ */ React35.createElement(React35.Fragment, null, state === "DISABLED" ? /* @__PURE__ */ React35.createElement("s", {
        "aria-hidden": true
    }, /* @__PURE__ */ React35.createElement(UitkText13, {
        size: 300,
        inline: true
    }, text)) : /* @__PURE__ */ React35.createElement(UitkText13, {
        size: 300,
        inline: true
    }, text), accessibilityLabel && /* @__PURE__ */ React35.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), moreInfo && /* @__PURE__ */ React35.createElement(UitkSpacing15, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React35.createElement(UitkText13, {
        size: 200,
        inline: true
    }, moreInfo)));
};
PropertyInfoContentText.displayName = "PropertyInfoContentText";
// src/components/summary/__private/__fragments/shared/amenity-review-summary.tsx
var __AmenityReviewSummary = gql32(_templateObject31());
var AmenityReviewSummary = function(props) {
    var _reviewSummaryHighlight, _reviewSummaryHighlight1, _infoContent, _summaryInfo, _impressionAnalytics, _impressionAnalytics1, _impressionAnalytics2, _impressionAnalytics3;
    var infoContent = props.infoContent, data = props.data;
    var icon = data.icon, reviewSummaryHighlight = data.reviewSummaryHighlight, clickAnalytics = data.clickAnalytics, impressionAnalytics = data.impressionAnalytics;
    var headerInfo = (_reviewSummaryHighlight = reviewSummaryHighlight) === null || _reviewSummaryHighlight === void 0 ? void 0 : _reviewSummaryHighlight.header;
    var summaryInfo = (_reviewSummaryHighlight1 = reviewSummaryHighlight) === null || _reviewSummaryHighlight1 === void 0 ? void 0 : _reviewSummaryHighlight1.content;
    var formatText = useLocalization().formatText;
    var dialogButtonText = formatText("property-amenity-review-summary.dialog.ok.label");
    var triggerRef = React36.useRef(null);
    var _useDialog3 = _sliced_to_array(useDialog3("amenity-review-summary-dialog-".concat((_infoContent = infoContent) === null || _infoContent === void 0 ? void 0 : _infoContent.text.replace(/\s/g, "-"))), 3), isDialogOpen = _useDialog3[0], dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    var _React36_useState = _sliced_to_array(React36.useState(false), 2), visible = _React36_useState[0], setVisible = _React36_useState[1];
    var trackClick = useClickTracker9();
    var trackClickAnalytics = function() {
        if (clickAnalytics) {
            trackClick(clickAnalytics.referrerId, clickAnalytics.linkName);
        }
    };
    var toggleVisibility = function() {
        setVisible(!visible);
        if (!visible) {
            trackClickAnalytics();
        }
    };
    var openDialog = function() {
        dialogActions.openDialog();
        trackClickAnalytics();
    };
    var closeDialog = function() {
        dialogActions.closeDialog();
    };
    var moreInfoTriggerRender = function(onClickHandler) {
        return /* @__PURE__ */ React36.createElement(UitkMoreInfoTrigger, null, /* @__PURE__ */ React36.createElement("button", {
            type: "button",
            ref: triggerRef,
            onClick: onClickHandler
        }, /* @__PURE__ */ React36.createElement(PropertyInfoContentText, {
            infoContent: infoContent
        }), icon && /* @__PURE__ */ React36.createElement(UitkIcon9, {
            name: icon.iconId,
            size: UitkIconSize5.MEDIUM
        })));
    };
    var amenityReviewSummarySheetContentRender = /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React36.createElement(UitkLayoutFlex9, {
        space: "two",
        justifyContent: "center",
        alignItems: "center"
    }, headerInfo && headerInfo.graphic.__typename === "Icon" && /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem8, {
        shrink: 0
    }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(UitkIcon9, {
        name: headerInfo.graphic.id,
        size: UitkIconSize5.MEDIUM,
        spotlight: {
            theme: "info",
            background: true
        }
    }))), headerInfo && /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React36.createElement(UitkHeading9, {
        tag: "h6",
        size: 6
    }, headerInfo.text)))), ((_summaryInfo = summaryInfo) === null || _summaryInfo === void 0 ? void 0 : _summaryInfo.length) && /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React36.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two"
        }
    }, summaryInfo.map(function(contentText, index) {
        return /* @__PURE__ */ React36.createElement(UitkText14, {
            size: 300,
            key: "".concat(contentText, "-").concat(index)
        }, contentText);
    }))));
    var amenityReviewSummaryRender = /* @__PURE__ */ React36.createElement(Viewport7, null, /* @__PURE__ */ React36.createElement(ViewSmall7, null, /* @__PURE__ */ React36.createElement(React36.Fragment, null, moreInfoTriggerRender(openDialog), /* @__PURE__ */ React36.createElement(DialogComponent, null, /* @__PURE__ */ React36.createElement(UitkSheet5, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: "small",
        returnFocusOnClose: true,
        liveAnnounceString: "Centered Sheet has opened",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React36.createElement(UitkSheetContent3, null, /* @__PURE__ */ React36.createElement(UitkLayoutFlex9, {
        direction: "column"
    }, amenityReviewSummarySheetContentRender, /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React36.createElement(UitkSpacing16, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React36.createElement(UitkTertiaryButton, {
        size: UitkButtonSize2.MEDIUM,
        onClick: closeDialog
    }, dialogButtonText))))))))), /* @__PURE__ */ React36.createElement(ViewMedium4, null, /* @__PURE__ */ React36.createElement(React36.Fragment, null, moreInfoTriggerRender(toggleVisibility), /* @__PURE__ */ React36.createElement(UitkSheet5, {
        autoPosition: false,
        position: {
            inline: "leading",
            block: "leading"
        },
        applyBlockStartMargin: true,
        width: 360,
        isVisible: visible,
        liveAnnounceString: "Popover Sheet has opened",
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: toggleVisibility
    }, /* @__PURE__ */ React36.createElement(UitkSheetCloseButton, null, /* @__PURE__ */ React36.createElement(UitkTertiaryButton, {
        type: "button",
        onClick: toggleVisibility
    }, /* @__PURE__ */ React36.createElement(UitkIcon9, {
        name: "close",
        size: UitkIconSize5.MEDIUM,
        title: "Close Sheet",
        id: "sheet-close-button"
    }))), /* @__PURE__ */ React36.createElement(UitkSheetContent3, {
        padded: false
    }, /* @__PURE__ */ React36.createElement(UitkSpacing16, {
        padding: {
            block: "six",
            inlinestart: "six",
            inlineend: "unset"
        }
    }, /* @__PURE__ */ React36.createElement(UitkLayoutFlex9, {
        direction: "column"
    }, amenityReviewSummarySheetContentRender)))))));
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React36.createElement(React36.Fragment, null, ((_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId) && ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) ? /* @__PURE__ */ React36.createElement(IntersectionTracker, {
        referrerId: (_impressionAnalytics_referrerId = (_impressionAnalytics2 = impressionAnalytics) === null || _impressionAnalytics2 === void 0 ? void 0 : _impressionAnalytics2.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = (_impressionAnalytics3 = impressionAnalytics) === null || _impressionAnalytics3 === void 0 ? void 0 : _impressionAnalytics3.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, amenityReviewSummaryRender) : amenityReviewSummaryRender);
};
AmenityReviewSummary.displayName = "AmenityReviewSummary";
AmenityReviewSummary.fragment = __AmenityReviewSummary;
// src/components/summary/__private/__fragments/shared/property-info-content-items.tsx
var __PropertyInfoContentItem = gql33(_templateObject32(), AmenityReviewSummary.fragment);
var PropertyInfoContentItem = function(param) {
    var className = param.className, data = param.data;
    var icon = data.icon, text = data.text, state = data.state, moreInfo = data.moreInfo, accessibilityLabel = data.accessibilityLabel, highlights = data.highlights;
    var infoContent = {
        text: text,
        state: state,
        moreInfo: moreInfo,
        accessibilityLabel: accessibilityLabel
    };
    var iconTheme = moreInfo ? "positive" : "default";
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, text && /* @__PURE__ */ React37.createElement(UitkListItem, {
        key: "amenity-".concat(text),
        className: className
    }, /* @__PURE__ */ React37.createElement(UitkLayoutFlex10, null, icon && /* @__PURE__ */ React37.createElement(UitkSpacing17, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React37.createElement(UitkIcon10, {
        name: icon.iconId.toLocaleLowerCase(),
        description: icon.description,
        theme: iconTheme
    })), /* @__PURE__ */ React37.createElement(Experiment4, {
        name: "Amenity_Review_Summary_Web_",
        logExposure: true
    }, /* @__PURE__ */ React37.createElement(ExperimentControl4, null, /* @__PURE__ */ React37.createElement(PropertyInfoContentText, {
        infoContent: infoContent
    })), /* @__PURE__ */ React37.createElement(ExperimentVariant4, {
        bucket: 1
    }, /* @__PURE__ */ React37.createElement(PropertyInfoContentText, {
        infoContent: infoContent
    })), /* @__PURE__ */ React37.createElement(ExperimentVariant4, {
        bucket: 2
    }, highlights ? /* @__PURE__ */ React37.createElement(AmenityReviewSummary, {
        infoContent: infoContent,
        data: highlights
    }) : /* @__PURE__ */ React37.createElement(PropertyInfoContentText, {
        infoContent: infoContent
    }))))));
};
PropertyInfoContentItem.displayName = "PropertyInfoContentItem";
PropertyInfoContentItem.fragment = __PropertyInfoContentItem;
var __PropertyInfoContentItems = gql33(_templateObject33(), PropertyInfoContentItem.fragment);
var PropertyInfoContentItems = function(param) {
    var columns = param.columns, data = param.data, space = param.space, prefix = param.prefix, subset = param.subset;
    var items = data.items;
    var contentItems = subset && subset > 0 ? items.slice(0, subset) : items;
    var bullet = contentItems.length > 0 && contentItems[0].icon ? "icon-alternate" : "default";
    return /* @__PURE__ */ React37.createElement(UitkList, {
        spacing: false,
        bullet: bullet,
        size: 2,
        type: "unordered"
    }, /* @__PURE__ */ React37.createElement(UitkLayoutColumns2, {
        columns: columns,
        space: space
    }, contentItems.map(function(item, idx) {
        return /* @__PURE__ */ React37.createElement(UitkSpacing17, {
            padding: "two",
            key: "".concat(prefix, "-item-space-").concat(idx)
        }, /* @__PURE__ */ React37.createElement(PropertyInfoContentItem, {
            key: "".concat(prefix, "-item-").concat(idx),
            data: item
        }));
    })));
};
PropertyInfoContentItems.displayName = "PropertyInfoContentItems";
PropertyInfoContentItems.fragment = __PropertyInfoContentItems;
// src/components/summary/__private/__fragments/shared/property-info-content.tsx
import React38 from "react";
import { gql as gql34 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge4, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
import { UitkDialog, UitkDialogContent as UitkDialogContent2, UitkDialogFooter } from "uitk-react-dialog";
import { UitkIcon as UitkIcon11 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex11 } from "uitk-react-layout-flex";
import { UitkList as UitkList2, UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10 } from "uitk-react-text";
var __PropertyInfoContent = gql34(_templateObject34(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, PropertyInfoContentItem.fragment);
var PropertyInfoContent = function(param) {
    var data = param.data, small = param.small, large = param.large;
    var _header, _header_icon, _header1;
    var header = data.header, icon = data.icon, iconAnalytics = data.iconAnalytics;
    var dialogKey = React38.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var dialogId = "location-highlights-".concat(dialogKey);
    var _useDialog4 = _sliced_to_array(useDialog4(dialogId), 3), isDialogOpen = _useDialog4[0], dialogActions = _useDialog4[1], DialogComponent = _useDialog4[2];
    var trackIconAnalytics = useClickTracker10();
    var _header_subText, _header_icon_description;
    var dialog = /* @__PURE__ */ React38.createElement(DialogComponent, null, /* @__PURE__ */ React38.createElement(UitkDialog, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React38.createElement(UitkDialogContent2, null, (_header_subText = (_header = header) === null || _header === void 0 ? void 0 : _header.subText) !== null && _header_subText !== void 0 ? _header_subText : "", /* @__PURE__ */ React38.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_header_icon_description = (_header1 = header) === null || _header1 === void 0 ? void 0 : (_header_icon = _header1.icon) === null || _header_icon === void 0 ? void 0 : _header_icon.description) !== null && _header_icon_description !== void 0 ? _header_icon_description : "",
            type: "tertiary"
        }
    }))));
    var handleClick = React38.useCallback(function() {
        dialogActions.openDialog();
        if (iconAnalytics) {
            trackIconAnalytics(iconAnalytics.referrerId, iconAnalytics.linkName, true);
        }
    }, [
        dialogActions,
        trackIconAnalytics,
        iconAnalytics
    ]);
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, /* @__PURE__ */ React38.createElement(UitkLayoutFlex11, {
        direction: "column"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex11, {
        alignItems: "start"
    }, header && /* @__PURE__ */ React38.createElement(PropertyInfoContentHeader, {
        data: header
    }), icon && /* @__PURE__ */ React38.createElement("button", {
        type: "button",
        onClick: handleClick,
        "aria-label": "property-info-content_icon"
    }, /* @__PURE__ */ React38.createElement(UitkSpacing18, {
        padding: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React38.createElement(UitkIcon11, {
        name: icon.id
    })))), /* @__PURE__ */ React38.createElement(Viewport8, null, /* @__PURE__ */ React38.createElement(ViewSmall8, null, /* @__PURE__ */ React38.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, small), {
        data: data
    }))), /* @__PURE__ */ React38.createElement(ViewLarge4, null, /* @__PURE__ */ React38.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, large), {
        data: data
    }))))), dialog);
};
PropertyInfoContent.displayName = "PropertyInfoContent";
PropertyInfoContent.fragment = __PropertyInfoContent;
var PropertyInfoContentList = function(param) {
    var data = param.data, prefix = param.prefix;
    var _items;
    var header = data.header, items = data.items;
    var renderList = function(item, idx) {
        var _item, _listItems;
        var listItems = (((_item = item) === null || _item === void 0 ? void 0 : _item.subItems) || {}).listItems;
        if (((_listItems = listItems) === null || _listItems === void 0 ? void 0 : _listItems.length) > 0) {
            return /* @__PURE__ */ React38.createElement(React38.Fragment, null, /* @__PURE__ */ React38.createElement(UitkHeading10, {
                tag: "h4",
                size: 6
            }, item.text), listItems.map(function(listItem, index) {
                return /* @__PURE__ */ React38.createElement(UitkListItem2, {
                    key: "".concat(prefix, "-list-item-").concat(index)
                }, listItem.text);
            }));
        }
        return /* @__PURE__ */ React38.createElement(UitkListItem2, {
            key: "".concat(prefix, "-item-").concat(idx)
        }, item.text);
    };
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, header && /* @__PURE__ */ React38.createElement(PropertyInfoContentHeader, {
        data: header
    }), ((_items = items) === null || _items === void 0 ? void 0 : _items.length) > 0 && /* @__PURE__ */ React38.createElement(UitkList2, {
        spacing: false
    }, items.map(function(item, idx) {
        return renderList(item, idx);
    })));
};
PropertyInfoContentList.displayName = "PropertyInfoContentList";
PropertyInfoContentList.fragment = __PropertyInfoContent;
// src/components/content-section-groups/__private/__fragments/property-content-section-list-type-dialog.tsx
var fragment14 = gql35(_templateObject35(), PropertyInfoContent.fragment);
var PropertyContentSectionListTypeDialog = function(param) {
    var data = param.data, actionId = param.actionId;
    var _dialog, _dialogData, _triggerIcon;
    var _useDialog5 = _sliced_to_array(useDialog5("property-content-section-list-type-dialog-".concat(actionId), "PropertyContentSectionListTypeDialog"), 3), dialogActions = _useDialog5[1], DialogComponent = _useDialog5[2];
    var dialogData = data.dialogData, dialog = data.dialog, trigger = data.trigger;
    var triggerIcon = trigger.icon;
    var dialogContent = ((_dialog = dialog) === null || _dialog === void 0 ? void 0 : _dialog.__typename) === "EGDSFullScreenDialog" ? dialog : void 0;
    var clickTracker = useClickTracker11();
    var closeDialog = React39.useCallback(function() {
        dialogActions.closeDialog();
        var closeAnalytics = dialog.closeAnalytics;
        if (closeAnalytics) {
            clickTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
    }, [
        dialogActions,
        dialog.closeAnalytics,
        clickTracker
    ]);
    var openDialog = React39.useCallback(function() {
        dialogActions.openDialog();
        var analytics = trigger.analytics;
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        dialogActions,
        trigger.analytics,
        clickTracker
    ]);
    if (!((_dialogData = dialogData) === null || _dialogData === void 0 ? void 0 : _dialogData.length)) {
        return null;
    }
    var dialogSheet = function(sheetType) {
        var _dialogContent_toolbar, _dialogContent;
        return /* @__PURE__ */ React39.createElement(UitkSheet6, {
            type: sheetType,
            key: "property-content-section-list-type-dialog",
            returnFocusOnClose: true,
            isVisible: true,
            triggerRef: null
        }, /* @__PURE__ */ React39.createElement(UitkToolbar5, {
            toolbarTitle: (_dialogContent = dialogContent) === null || _dialogContent === void 0 ? void 0 : (_dialogContent_toolbar = _dialogContent.toolbar) === null || _dialogContent_toolbar === void 0 ? void 0 : _dialogContent_toolbar.title,
            key: "UitkToolbar",
            navigationContent: {
                onClick: closeDialog,
                navType: "close"
            }
        }), /* @__PURE__ */ React39.createElement(UitkSheetContent4, {
            padded: true
        }, /* @__PURE__ */ React39.createElement(UitkScrollable, {
            direction: "vertical"
        }, dialogData.map(function(section, idx) {
            return /* @__PURE__ */ React39.createElement(UitkSpacing19, {
                key: "property-content-section-list-type-dialog-content-".concat(idx),
                padding: {
                    blockend: "four"
                }
            }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(PropertyInfoContentList, {
                data: section,
                prefix: "property-content-section-list-type-dialog-content"
            })));
        }))));
    };
    return /* @__PURE__ */ React39.createElement(React39.Fragment, null, trigger.message && /* @__PURE__ */ React39.createElement(UitkLink6, null, /* @__PURE__ */ React39.createElement("button", {
        type: "button",
        onClick: openDialog
    }, trigger.message, ((_triggerIcon = triggerIcon) === null || _triggerIcon === void 0 ? void 0 : _triggerIcon.id) && /* @__PURE__ */ React39.createElement(UitkIcon12, {
        id: triggerIcon.id,
        name: triggerIcon.id,
        title: triggerIcon.description
    }))), /* @__PURE__ */ React39.createElement(DialogComponent, null, /* @__PURE__ */ React39.createElement(Viewport9, null, /* @__PURE__ */ React39.createElement(ViewSmall9, null, dialogSheet("full")), /* @__PURE__ */ React39.createElement(ViewMedium5, null, dialogSheet("centered")))));
};
PropertyContentSectionListTypeDialog.displayName = "PropertyContentSectionListTypeDialog";
PropertyContentSectionListTypeDialog.fragment = fragment14;
// src/components/content-section-groups/__private/__fragments/property-content-section-action.tsx
var fragment15 = gql36(_templateObject36(), PropertyContentSectionDialog.fragment, PropertyContentSectionDetailedDialog.fragment, PropertyContentSectionListTypeDialog.fragment, lodging_link_message_default.fragment);
var PropertyContentSectionAction = function(param) {
    var data = param.data, actionId = param.actionId;
    var __typename = data.__typename;
    if (__typename !== "PropertyContentSectionDetailedDialog" && __typename !== "PropertyContentSectionDialog" && __typename !== "PropertyContentSectionListTypeDialog" && __typename !== "LodgingLinkMessage") {
        return null;
    }
    switch(__typename){
        case "PropertyContentSectionDialog":
            return /* @__PURE__ */ React40.createElement(PropertyContentSectionDialog, {
                data: data,
                actionId: actionId
            });
        case "PropertyContentSectionDetailedDialog":
            return /* @__PURE__ */ React40.createElement(PropertyContentSectionDetailedDialog, {
                data: data,
                actionId: actionId
            });
        case "PropertyContentSectionListTypeDialog":
            return /* @__PURE__ */ React40.createElement(PropertyContentSectionListTypeDialog, {
                data: data,
                actionId: actionId
            });
        case "LodgingLinkMessage":
            return /* @__PURE__ */ React40.createElement(lodging_link_message_default, {
                data: data
            });
        default:
            return null;
    }
};
PropertyContentSectionAction.displayName = "PropertyContentSectionAction";
PropertyContentSectionAction.fragment = fragment15;
// src/components/content-section-groups/__private/__fragments/property-content-sub-section.tsx
import React50 from "react";
import { gql as gql48 } from "@apollo/client";
import { UitkExpandoPeek as UitkExpandoPeek3 } from "uitk-react-expando";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
import React49 from "react";
import { gql as gql47 } from "@apollo/client";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React47 from "react";
import { gql as gql45 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkCard as UitkCard3, UitkCardBackgroundThemes, UitkCardContentSection as UitkCardContentSection3, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading11, UitkText as UitkText16 } from "uitk-react-text";
// ../internal/src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql as gql37 } from "@apollo/client";
import { ITrackType as ITrackType2, useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql37(_templateObject37());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics) {
    if (analytics) {
        var _uisPrimeMessages;
        var track = clickstreamAnalytics.track;
        var referrerId = analytics.referrerId, linkName = analytics.linkName, uisPrimeMessages = analytics.uisPrimeMessages;
        var _analytics_eventType;
        var eventType = referrerMap[(_analytics_eventType = analytics.eventType) !== null && _analytics_eventType !== void 0 ? _analytics_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.length) ? message : [
            message
        ].concat(_to_consumable_array(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType2.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics) {
    var clickstreamAnalytics = useClickstreamAnalytics2();
    return useCallback(function() {
        if (analytics) {
            trackAnalyticsList(clickstreamAnalytics, analytics);
        }
    }, [
        analytics,
        clickstreamAnalytics
    ]);
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
import React42 from "react";
import { gql as gql40 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React41 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkIcon as UitkIcon13, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
var fragment16 = gql38(_templateObject38());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React41.createElement(UitkIcon13, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize6[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment16;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql39 } from "@apollo/client";
var _obj4;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj4 = {}, _define_property(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
var fragment17 = gql39(_templateObject39());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment18 = gql40(_templateObject40(), clientSideAnalyticsFragment, fragment17, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton2
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps(action);
    var handleClick = React42.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React42.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React42.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment18;
LodgingEGDSButton.displayName = "EGDSButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React43 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkFloatingActionButton } from "uitk-react-button";
var fragment19 = gql41(_templateObject41());
var deriveLinkProps2 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React43.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React43.createElement(UitkFloatingActionButton, _object_spread({}, buttonProps), /* @__PURE__ */ React43.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment19;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React44 from "react";
import { gql as gql42 } from "@apollo/client";
import { UitkFloatingButton as UitkFloatingButton2 } from "uitk-react-button";
var fragment20 = gql42(_templateObject42());
var deriveLinkProps3 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React44.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React44.createElement(UitkFloatingButton2, _object_spread({}, buttonProps), icon ? /* @__PURE__ */ React44.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment20;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
import React45 from "react";
import { gql as gql43 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink7 } from "uitk-react-link";
import { UitkText as UitkText15 } from "uitk-react-text";
var _obj5;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj5 = {}, _define_property(_obj5, "SMALL" /* SMALL */ , "small"), _define_property(_obj5, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj5, "LARGE" /* LARGE */ , "large"), _obj5);
var _obj6;
var UILinkTargetMap2 = (_obj6 = {}, _define_property(_obj6, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj6, "INTERNAL" /* INTERNAL */ , "_self"), _obj6);
// ../internal/src/components/egds/egds-standard-link/egds-standard-link.tsx
var fragment21 = gql43(_templateObject43(), Icon.fragment);
var EGDSStandardLink = function(_param) {
    var _param_data = _param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text, dataStid = _param.dataStid, uitkLinkProps = _object_without_properties(_param, [
        "data",
        "dataStid"
    ]);
    var clickTracker = useClickTracker12();
    var onClick = React45.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    var path = React45.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React45.createElement(UitkLink7, _object_spread({
        "data-stid": dataStid,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        disabled: disabled
    }, uitkLinkProps), /* @__PURE__ */ React45.createElement("a", {
        target: UILinkTargetMap2[target],
        href: path
    }, standardLinkIcon ? /* @__PURE__ */ React45.createElement(React45.Fragment, null, iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React45.createElement(Icon, {
        data: standardLinkIcon
    }), text, iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React45.createElement(Icon, {
        data: standardLinkIcon
    })) : text, accessibility && /* @__PURE__ */ React45.createElement(UitkText15, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment21;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds/egds-ui-link-action/egds-ui-link-action.tsx
import React46 from "react";
import { gql as gql44 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
var __fragment = gql44(_templateObject44());
var EGDSUILinkAction = function(param) {
    var data = param.data;
    var resource = data.resource, target = data.target, analytics = data.analytics, accessibility = data.accessibility, useRelativePath = data.useRelativePath;
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var clickTracker = useClickTracker13();
    var onClickCapture = React46.useCallback(function() {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker
    ]);
    var path = React46.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React46.createElement("a", {
        href: path,
        target: navigationTarget,
        rel: "noopener noreferrer",
        onClickCapture: onClickCapture,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
    }, accessibility);
};
EGDSUILinkAction.fragment = __fragment;
EGDSUILinkAction.displayName = "EGDSUILinkAction";
// ../internal/src/components/egds/egds-standard-messaging-card/egds-standard-messaging-card.tsx
var fragment22 = gql45(_templateObject45(), Icon.fragment, UiGraphic.fragment, EGDSStandardLink.fragment, LodgingEGDSButton.fragment, clientSideAnalyticsFragment);
var EGDSStandardMessagingCard = function(param) {
    var data = param.data, dataStid = param.dataStid, markSize = param.markSize, className = param.className, actionProps = param.actionProps, _param_showBorder = param.showBorder, showBorder = _param_showBorder === void 0 ? true : _param_showBorder;
    var message = data.message, _data_background = data.background, background = _data_background === void 0 ? UitkCardBackgroundThemes.PRIMARY : _data_background, links = data.links, graphic = data.graphic, heading = data.heading, rightIcon = data.rightIcon, buttons = data.buttons, themes = data.themes, impressionTracking = data.impressionTracking;
    var cardPadding = background === UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD ? {
        inline: "three",
        block: "three"
    } : {
        inline: "one",
        block: "one"
    };
    var isBgColored = background !== null && background !== UitkCardBackgroundThemes.PRIMARY && background !== UitkCardBackgroundThemes.SECONDARY;
    var isBordered = themes ? themes.includes("BORDERED" /* BORDERED */ ) : showBorder;
    var isPadding = themes ? themes.includes("PADDED" /* PADDED */ ) : true;
    var cardPaddingTheme = isPadding ? cardPadding : {};
    var egdsLinksMemo = React47.useMemo(function() {
        var _links;
        return /* @__PURE__ */ React47.createElement(UitkSpacing20, null, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, null, (_links = links) === null || _links === void 0 ? void 0 : _links.map(function(linkData, linkIndex) {
            return /* @__PURE__ */ React47.createElement(UitkSpacing20, {
                margin: {
                    inlinestart: linkIndex === 0 ? "unset" : "two"
                },
                key: linkIndex
            }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(EGDSStandardLink, {
                data: linkData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(linkData.__typename) : void 0,
                theme: isBgColored ? "inverse" : "default"
            }))));
        })));
    }, [
        links,
        isBgColored
    ]);
    var egdsButtonsMemo = React47.useMemo(function() {
        var _buttons;
        return /* @__PURE__ */ React47.createElement(UitkSpacing20, null, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, null, (_buttons = buttons) === null || _buttons === void 0 ? void 0 : _buttons.map(function(buttonData, buttonIndex) {
            return /* @__PURE__ */ React47.createElement(UitkSpacing20, {
                margin: {
                    inlinestart: buttonIndex === 0 ? "unset" : "two"
                },
                key: buttonIndex
            }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(LodgingEGDSButton, {
                data: buttonData,
                dataStid: dataStid ? "".concat(dataStid, "-").concat(buttonData.__typename) : void 0,
                size: UitkButtonSize3.SMALL,
                inverse: isBgColored && buttonData.__typename === "UITertiaryButton"
            })));
        })));
    }, [
        buttons,
        isBgColored
    ]);
    var messageOrHeader = React47.useMemo(function() {
        if (!message) {
            return null;
        }
        if (heading) {
            return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkSpacing20, {
                margin: {
                    blockstart: "".concat(heading ? "half" : "unset")
                }
            }, /* @__PURE__ */ React47.createElement(UitkText16, {
                theme: isBgColored ? "inverse" : "default"
            }, message)));
        }
        return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkHeading11, {
            className: isBgColored ? "uitk-text-inverse-theme" : ""
        }, message));
    }, [
        message,
        heading,
        isBgColored
    ]);
    var EgdsStandardMessagingCard = /* @__PURE__ */ React47.createElement(UitkCard3, {
        className: className,
        border: isBordered,
        padded: true,
        backgroundTheme: background
    }, /* @__PURE__ */ React47.createElement(UitkCardContentSection3, {
        "data-stid": dataStid
    }, /* @__PURE__ */ React47.createElement(UitkSpacing20, {
        padding: cardPaddingTheme
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
        alignItems: "center"
    }, graphic && /* @__PURE__ */ React47.createElement(UitkSpacing20, {
        margin: {
            small: {
                inlineend: "three"
            },
            medium: {
                inlineend: isBgColored ? "six" : "three"
            }
        }
    }, /* @__PURE__ */ React47.createElement(UiGraphic, {
        data: graphic,
        markSize: markSize
    })), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, {
        grow: 1
    }, /* @__PURE__ */ React47.createElement(UitkCardContentSection3, {
        padded: false
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        space: "two",
        wrap: rightIcon ? "nowrap" : "wrap"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, {
        grow: 1,
        minWidth: "88x"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
        direction: "column"
    }, heading && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkHeading11, {
        className: isBgColored ? "uitk-text-inverse-theme" : ""
    }, heading)), messageOrHeader)), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement(UitkLayoutFlex12, {
        alignItems: "center",
        space: "four",
        justifyContent: "end"
    }, buttons && buttons.length > 0 && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, egdsButtonsMemo), links && links.length > 0 && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, egdsLinksMemo))), rightIcon && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(Icon, {
        data: rightIcon
    })))))))), actionProps && /* @__PURE__ */ React47.createElement(UitkCardLink, null, /* @__PURE__ */ React47.createElement(EGDSUILinkAction, {
        data: actionProps
    }))));
    if (impressionTracking) {
        var referrerId = impressionTracking.referrerId, linkName = impressionTracking.linkName;
        return /* @__PURE__ */ React47.createElement(IntersectionTracker2, {
            referrerId: referrerId,
            linkName: linkName,
            intersectionOptions: {
                threshold: 0.5
            }
        }, EgdsStandardMessagingCard);
    }
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, EgdsStandardMessagingCard);
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment22;
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
import { UitkLayoutGrid as UitkLayoutGrid5 } from "uitk-react-layout-grid";
// src/components/content-section-groups/__private/__fragments/property-content-item-card.tsx
import React48 from "react";
import { gql as gql46 } from "@apollo/client";
var fragment23 = gql46(_templateObject46(), EGDSStandardMessagingCard.fragment);
var PropertyContentItemCard = function(props) {
    var data = props.data;
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React48.createElement(EGDSStandardMessagingCard, {
        data: data
    });
};
PropertyContentItemCard.displayName = "PropertyContentItemCard";
PropertyContentItemCard.fragment = fragment23;
// src/components/content-section-groups/__private/__fragments/property-content-element-group.tsx
var fragment24 = gql47(_templateObject47(), EGDSStandardMessagingCard.fragment);
var PropertyContentElementGroup = function(param) {
    var data = param.data, smallerHeader = param.smallerHeader;
    var elements = data.elements, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var renderedElements = elements.map(function(element, indexElement) {
        switch(element.__typename){
            case "PropertyContent":
                return /* @__PURE__ */ React49.createElement(PropertyContent, {
                    key: indexElement,
                    data: element,
                    smallerHeader: smallerHeader
                });
            case "EGDSStandardMessagingCard":
                return /* @__PURE__ */ React49.createElement(PropertyContentItemCard, {
                    key: indexElement,
                    data: element
                });
            default:
                return null;
        }
    });
    if (maxColumns === 1) {
        return /* @__PURE__ */ React49.createElement(React49.Fragment, null, renderedElements);
    }
    return /* @__PURE__ */ React49.createElement(UitkLayoutGrid5, {
        space: "three",
        columns: maxColumns
    }, renderedElements);
};
PropertyContentElementGroup.displayName = "PropertyContentElementGroup";
PropertyContentElementGroup.fragment = fragment24;
// src/components/content-section-groups/__private/__fragments/property-content-sub-section.tsx
var fragment25 = gql48(_templateObject48(), PropertyContentElementGroup.fragment, PropertyContentSectionAction.fragment);
var PropertyContentSubSection = function(param) {
    var data = param.data;
    var _actions;
    var header = data.header, elementsV2 = data.elementsV2, actions = data.actions, expando = data.expando, _data_maxColumns = data.maxColumns, maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
    var _React50_useState = _sliced_to_array(React50.useState(false), 2), isVisible = _React50_useState[0], setIsVisible = _React50_useState[1];
    var subSectionContent = /* @__PURE__ */ React50.createElement(React50.Fragment, null, elementsV2.map(function(elementV2, i) {
        return /* @__PURE__ */ React50.createElement(PropertyContentElementGroup, {
            data: elementV2,
            smallerHeader: Boolean(header),
            key: i
        });
    }));
    var actionContent = (_actions = actions) === null || _actions === void 0 ? void 0 : _actions.map(function(action, index) {
        return /* @__PURE__ */ React50.createElement(PropertyContentSectionAction, {
            data: action,
            key: index,
            actionId: ""
        });
    });
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, header && /* @__PURE__ */ React50.createElement(SectionHeader, {
        tag: "h3",
        size: 5,
        singleLineHeader: true,
        data: header
    }), /* @__PURE__ */ React50.createElement(UitkSpacing21, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React50.createElement(UitkLayoutGrid6, {
        space: "three",
        columns: {
            medium: 1,
            large: maxColumns
        }
    }, !expando ? subSectionContent : /* @__PURE__ */ React50.createElement(UitkExpandoPeek3, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: 1,
        expandLabel: expando.expandButton.text,
        collapseLabel: expando.collapseButton.text
    }, subSectionContent), /* @__PURE__ */ React50.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React50.createElement("div", null, actionContent)))));
};
PropertyContentSubSection.displayName = "PropertyContentSubSection";
PropertyContentSubSection.fragment = fragment25;
// src/components/content-section-groups/__private/__fragments/property-content-section.tsx
var fragment26 = gql49(_templateObject49(), SectionHeader.fragment, PropertyContentSubSection.fragment, PropertyContentSectionAction.fragment);
var PropertyContentSection = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_isInDialog = param.isInDialog, isInDialog = _param_isInDialog === void 0 ? false : _param_isInDialog, _param_isFirstSection = param.isFirstSection, isFirstSection = _param_isFirstSection === void 0 ? false : _param_isFirstSection, _param_isLastSection = param.isLastSection, isLastSection = _param_isLastSection === void 0 ? false : _param_isLastSection, _param_isCardComponent = param.isCardComponent, isCardComponent = _param_isCardComponent === void 0 ? true : _param_isCardComponent, actionId = param.actionId;
    var subSectionName = data.sectionName, header = data.header, bodySubSections = data.bodySubSections, sectionAction = data.action, impressionAnalytics = data.impressionAnalytics;
    var border = !isLastSection ? "bottom" : void 0;
    var _ref = impressionAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var headerRowSpanLg = sectionAction ? bodySubSections.length + 1 : bodySubSections.length;
    var layoutComponent = /* @__PURE__ */ React51.createElement(UitkLayoutGrid7, {
        space: "six",
        columns: {
            medium: 1,
            large: columns
        }
    }, showHeader && /* @__PURE__ */ React51.createElement(UitkLayoutGridItem6, {
        colSpan: {
            medium: 1,
            large: 1
        },
        rowSpan: {
            medium: 1,
            large: headerRowSpanLg
        }
    }, header && /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(SectionHeader, {
        tag: "h2",
        size: 4,
        data: header
    }))), bodySubSections.map(function(bodySubSection, i) {
        return /* @__PURE__ */ React51.createElement(UitkLayoutGridItem6, {
            colSpan: {
                medium: 1,
                large: columns === 1 ? 1 : Math.max(columns - 1, 1)
            },
            key: i
        }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(PropertyContentSubSection, {
            data: bodySubSection
        })));
    }), sectionAction && /* @__PURE__ */ React51.createElement(UitkLayoutGridItem6, {
        colSpan: {
            medium: 1,
            large: columns === 1 ? 1 : Math.max(columns - 1, 1)
        }
    }, /* @__PURE__ */ React51.createElement("div", null, /* @__PURE__ */ React51.createElement(PropertyContentSectionAction, {
        data: sectionAction,
        actionId: actionId
    }))));
    var layoutGridComponent = referrerId && linkName ? /* @__PURE__ */ React51.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, layoutComponent) : layoutComponent;
    return isCardComponent ? /* @__PURE__ */ React51.createElement(UitkCardContentSection4, {
        border: border,
        padded: false
    }, /* @__PURE__ */ React51.createElement(RefTarget, {
        name: subSectionName,
        tabIndex: -1
    }, /* @__PURE__ */ React51.createElement(UitkSpacing22, {
        padding: {
            small: {
                inline: isInDialog ? "three" : "unset"
            },
            medium: {
                inline: isInDialog ? "three" : "unset"
            },
            large: {
                inline: "three"
            },
            extra_large: {
                inline: "three"
            },
            blockend: isLastSection ? "three" : "six",
            blockstart: isFirstSection ? "three" : "six"
        }
    }, layoutGridComponent))) : /* @__PURE__ */ React51.createElement("div", null, layoutGridComponent);
};
PropertyContentSection.displayName = "PropertyContentSection";
PropertyContentSection.fragment = fragment26;
// src/components/content-section-groups/__private/__fragments/property-content-section-group.tsx
var fragment27 = gql50(_templateObject50(), SectionHeader.fragment, PropertyContent.fragment, PropertyContentSection.fragment, PropertyContentSectionAction.fragment, PropertyContentSubSection.fragment);
var PropertyContentSectionGroup = function(param) {
    var data = param.data, _param_columns = param.columns, columns = _param_columns === void 0 ? 3 : _param_columns, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, _param_isCardComponent = param.isCardComponent, isCardComponent = _param_isCardComponent === void 0 ? true : _param_isCardComponent, _param_actionId = param.actionId, actionId = _param_actionId === void 0 ? "id" : _param_actionId;
    var expando = data.expando, sections = data.sections, action = data.action;
    var _ref = expando || {}, collapseButton = _ref.collapseButton, expandButton = _ref.expandButton;
    var _React52_useState = _sliced_to_array(React52.useState(false), 2), isVisible = _React52_useState[0], setIsVisible = _React52_useState[1];
    if (!sections || sections.length === 0) {
        return null;
    }
    var sectionContent = sections.map(function(section, index) {
        return /* @__PURE__ */ React52.createElement(PropertyContentSection, {
            data: section,
            columns: columns,
            showHeader: showHeader,
            isFirstSection: index === 0,
            isLastSection: index === sections.length - 1,
            key: "section-".concat(index),
            actionId: "".concat(actionId, "-section-").concat(index),
            isCardComponent: isCardComponent
        });
    });
    return isCardComponent ? /* @__PURE__ */ React52.createElement(UitkCard4, null, /* @__PURE__ */ React52.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React52.createElement(Viewport10, null, /* @__PURE__ */ React52.createElement(ViewSmall10, null, /* @__PURE__ */ React52.createElement("section", null, !collapseButton || !expandButton ? /* @__PURE__ */ React52.createElement(UitkCard4, null, sectionContent, " ") : /* @__PURE__ */ React52.createElement(UitkCard4, null, /* @__PURE__ */ React52.createElement(UitkExpandoPeek4, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: 1,
        expandLabel: expandButton.text,
        collapseLabel: collapseButton.text
    }, /* @__PURE__ */ React52.createElement(React52.Fragment, null, sectionContent))))), /* @__PURE__ */ React52.createElement(ViewLarge5, null, /* @__PURE__ */ React52.createElement("section", null, sectionContent))), action && /* @__PURE__ */ React52.createElement(PropertyContentSectionAction, {
        data: action,
        actionId: actionId
    }))) : /* @__PURE__ */ React52.createElement("div", null, sectionContent);
};
PropertyContentSectionGroup.displayName = "PropertyContentSectionGroup";
PropertyContentSectionGroup.fragment = fragment27;
// src/components/content-section-groups/cleanliness.tsx
var __CleanlinessFragment = gql51(_templateObject51(), PropertyContentSectionGroup.fragment);
var Cleanliness = function(props) {
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = data.propertyContentSectionGroups.cleanliness;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React53.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
Cleanliness.fragment = __CleanlinessFragment;
Cleanliness.displayName = "Cleanliness";
// src/components/property-cleanliness/property-cleanliness.tsx
var __Query = gql52(_templateObject52(), Cleanliness.fragment);
var PropertyCleanliness = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi4().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery2.data, loading = _useQuery2.loading;
    if (loading || !data) {
        return null;
    }
    return /* @__PURE__ */ React54.createElement(Cleanliness, {
        data: data.propertyInfo,
        columns: 1,
        showHeader: false
    });
};
PropertyCleanliness.displayName = "sharedui-PropertyCleanliness";
// src/components/property-info-details/property-info-details.tsx
import React97 from "react";
import { gql as gql88, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi7 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog11 } from "@shared-ui/dialog-context";
// ../internal/src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React55 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var fragment28 = gql53(_templateObject53());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var _icon;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React55.createElement(UitkRating, {
        icon: (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment28;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React59 from "react";
import { gql as gql57 } from "@apollo/client";
import { UitkText as UitkText18 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React56 from "react";
import { gql as gql54 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink8 } from "uitk-react-link";
var fragment29 = gql54(_templateObject54());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker14();
    var onClick = React56.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React56.createElement(UitkLink8, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React56.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap2[target]
    }, text, accessibility && /* @__PURE__ */ React56.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment29;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React57 from "react";
import { gql as gql55 } from "@apollo/client";
import { UitkParagraph as UitkParagraph2 } from "uitk-react-text";
var fragment30 = gql55(_templateObject55());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React57.createElement(UitkParagraph2, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment30;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React58 from "react";
import { gql as gql56 } from "@apollo/client";
import { UitkText as UitkText17 } from "uitk-react-text";
var _obj7;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj7 = {}, _define_property(_obj7, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj7, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj7, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj7, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj7, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj7, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj7, "INVERSE" /* INVERSE */ , "inverse"), _obj7);
var _obj8;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj8 = {}, _define_property(_obj8, "BOLD" /* BOLD */ , "bold"), _define_property(_obj8, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj8, "REGULAR" /* REGULAR */ , "regular"), _obj8);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment31 = gql56(_templateObject56());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    HIGHLIGHT: "mark",
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _object_without_properties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _object_spread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React58.createElement(Decorative, null, data.text) : data.text;
    return /* @__PURE__ */ React58.createElement(UitkText17, _object_spread({}, textProps), content, accessibility && /* @__PURE__ */ React58.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment31;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment32 = gql57(_templateObject57(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React59.createElement(UitkText18, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React59.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React59.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React59.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment32;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React60 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkHeading as UitkHeading12 } from "uitk-react-text";
var fragment33 = gql58(_templateObject58());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React60.createElement(UitkHeading12, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment33;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React64 from "react";
import { gql as gql62 } from "@apollo/client";
import { UitkText as UitkText21 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React63 from "react";
import { gql as gql61 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React61 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkIcon as UitkIcon14, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
import { UitkText as UitkText19 } from "uitk-react-text";
var fragment34 = gql59(_templateObject59());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var _graphic;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React61.createElement("div", null, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React61.createElement(UitkSpacing23, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React61.createElement(UitkIcon14, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize7[graphic.size] : UitkIconSize7.EXTRA_SMALL
    })), /* @__PURE__ */ React61.createElement(UitkText19, _object_spread_props(_object_spread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment34;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React62 from "react";
import { gql as gql60 } from "@apollo/client";
import { UitkText as UitkText20 } from "uitk-react-text";
var fragment35 = gql60(_templateObject60());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React62.createElement(UitkText20, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment35;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment36 = gql61(_templateObject61(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React63.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React63.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React63.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment36;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment37 = gql62(_templateObject62(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data, _data_inlineContent, _data1, _data_inlineContent1, _data2;
    var align = props.align, data = props.data, styleProps = _object_without_properties(props, [
        "align",
        "data"
    ]);
    if (((_data = data) === null || _data === void 0 ? void 0 : (_data_contents = _data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_inlineContent = _data1.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React64.createElement(UitkText21, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_inlineContent1 = _data2.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React64.createElement(React64.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React64.createElement(React64.Fragment, null, /* @__PURE__ */ React64.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React64.createElement(React64.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React64.createElement(React64.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React64.createElement(EGDSSpannableTextContent, _object_spread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment37;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React65 from "react";
import { gql as gql63 } from "@apollo/client";
var fragment38 = gql63(_templateObject63());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React65.createElement(React65.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment38;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// src/components/property-info-details/property-info-details.tsx
import { ViewMedium as ViewMedium9, Viewport as Viewport15, ViewSmall as ViewSmall15 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType5 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid11, UitkLayoutGridItem as UitkLayoutGridItem10 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing37 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading16 } from "uitk-react-text";
// src/components/gallery/property-image-gallery.tsx
import React74 from "react";
import { gql as gql70 } from "@apollo/client";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge7, ViewMedium as ViewMedium8, Viewport as Viewport13, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
import React67 from "react";
import { gql as gql65 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment5, ExperimentControl as ExperimentControl5, ExperimentVariant as ExperimentVariant5 } from "@shared-ui/experiment-context";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
// src/components/gallery/__private/utils/to-uitk-images.ts
function toUitkImages(images, useLowRes) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_image2, _img_thumbnail, _img_fallbackImage;
        var src = useLowRes && img.lowResImage ? img.lowResImage.url : (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.url;
        var _img_image_description, _img_alt;
        return {
            src: src,
            caption: (_img_image_description = (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image2 = img.image) === null || _img_image2 === void 0 ? void 0 : _img_image2.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url
        };
    });
}
// src/components/gallery/__private/__fragments/utils/additional-uis-prime-micro-messages-utils.ts
var getCarouselNextIndex = function(currentIndex, mediaLength, carouselActionId) {
    if (carouselActionId.includes("clickRight")) {
        return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
    }
    if (carouselActionId.includes("clickLeft")) {
        return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
    }
    return currentIndex;
};
function additionalUisPrimeMicroMessages(galleryPosition, algoMediaGuid, galleryMaxPosition, imageId, propertyId, galleryName, galleryCategory) {
    var timestamp = Date.now().toString();
    var messages = [
        {
            schemaName: "allHotelProducts",
            messageContent: {
                hotelProducts: [
                    {
                        propertyId: propertyId,
                        imageId: imageId,
                        imageGalleryAlgorithm: {
                            name: "heroaesthetics.v20190411-hsc.v20190223"
                        },
                        algoMediaGuid: algoMediaGuid
                    }
                ]
            }
        },
        {
            schemaName: "imageTracking",
            messageContent: {
                galleryName: galleryName,
                galleryType: "GALLERY_TYPE_SINGLE",
                galleryMaxPosition: galleryMaxPosition,
                galleryPosition: galleryPosition,
                repeatedGalleryIndex: null,
                imageGalleryMetaTagsList: [
                    {
                        imageGalleryMetaTagValue: timestamp,
                        imageGalleryMetaTagType: "DEVICE_TIME_STAMP"
                    }
                ]
            }
        }
    ];
    if (galleryCategory && messages[1].messageContent.imageGalleryMetaTagsList) {
        messages[1].messageContent.imageGalleryMetaTagsList.push({
            imageGalleryMetaTagValue: galleryCategory,
            imageGalleryMetaTagType: "GALLERY_FILTER"
        });
    }
    return messages;
}
// src/components/gallery/__private/__fragments/gallery-buttons/gallery-buttons.tsx
import React66 from "react";
import { gql as gql64 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkOverlayButton } from "uitk-react-button";
import { UitkIcon as UitkIcon15 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex13 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
var __GalleryButtonsFragment = gql64(_templateObject64());
var TRIGGER_POSITION = {
    position: {
        zindex: "layer2",
        bottom: "three",
        right: "three"
    },
    type: "absolute"
};
var GalleryButtons = function(props) {
    var _galleryButtons;
    var data = props.data, onThumbnailGalleryClick = props.onThumbnailGalleryClick, onVirtualTourClick = props.onVirtualTourClick, thumbnailButtonText = props.thumbnailButtonText, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel;
    var galleryButtons = data.galleryButtons;
    var track = useClickTracker15();
    var handleVirtualTourClick = React66.useCallback(function(index) {
        var _galleryButtons_index_action, _galleryButtons_index, _galleryButtons;
        if ((_galleryButtons = galleryButtons) === null || _galleryButtons === void 0 ? void 0 : (_galleryButtons_index = _galleryButtons[index]) === null || _galleryButtons_index === void 0 ? void 0 : (_galleryButtons_index_action = _galleryButtons_index.action) === null || _galleryButtons_index_action === void 0 ? void 0 : _galleryButtons_index_action.resource) {
            var _galleryButtons_index_action_resource, _galleryButtons_index_action1, _galleryButtons_index1, _galleryButtons1;
            var btnVal = ((_galleryButtons1 = galleryButtons) === null || _galleryButtons1 === void 0 ? void 0 : (_galleryButtons_index1 = _galleryButtons1[index]) === null || _galleryButtons_index1 === void 0 ? void 0 : (_galleryButtons_index_action1 = _galleryButtons_index1.action) === null || _galleryButtons_index_action1 === void 0 ? void 0 : (_galleryButtons_index_action_resource = _galleryButtons_index_action1.resource) === null || _galleryButtons_index_action_resource === void 0 ? void 0 : _galleryButtons_index_action_resource.value) || "";
            onVirtualTourClick(btnVal);
        }
    }, [
        galleryButtons,
        onVirtualTourClick
    ]);
    var thubnailButtonAnalytics = React66.useMemo(function() {
        return {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Open Room Gallery dialog",
            callback: function(id, desc) {
                return track(id, desc);
            }
        };
    }, [
        track
    ]);
    return /* @__PURE__ */ React66.createElement(UitkLayoutPosition4, _object_spread({}, TRIGGER_POSITION), /* @__PURE__ */ React66.createElement(UitkLayoutFlex13, {
        space: "two",
        wrap: "nowrap"
    }, (_galleryButtons = galleryButtons) === null || _galleryButtons === void 0 ? void 0 : _galleryButtons.map(function(galleryButton, buttonIndex) {
        var _galleryButton_icon, _galleryButton_icon1;
        return /* @__PURE__ */ React66.createElement(UitkOverlayButton, {
            key: "gallery-mosaic-action-".concat((_galleryButton_icon = galleryButton.icon) === null || _galleryButton_icon === void 0 ? void 0 : _galleryButton_icon.id),
            "aria-label": "gallery-mosaic-action",
            onClick: function() {
                return handleVirtualTourClick(buttonIndex);
            }
        }, /* @__PURE__ */ React66.createElement(UitkIcon15, {
            name: ((_galleryButton_icon1 = galleryButton.icon) === null || _galleryButton_icon1 === void 0 ? void 0 : _galleryButton_icon1.id) || "",
            id: "gallery-mosaic-action-trigger"
        }), galleryButton.accessibility);
    }), /* @__PURE__ */ React66.createElement(UitkOverlayButton, {
        "aria-label": thumbnailDialogTriggerAccessibilityLabel || "",
        onClick: onThumbnailGalleryClick,
        analytics: thubnailButtonAnalytics
    }, /* @__PURE__ */ React66.createElement(UitkIcon15, {
        name: "photo_library",
        id: "gallery-mosaic-thumbnail-trigger"
    }), thumbnailButtonText)));
};
GalleryButtons.displayName = "GalleryButtons";
GalleryButtons.fragment = __GalleryButtonsFragment;
// src/components/gallery/__private/__fragments/containers/carousel-container.tsx
var __CarouselContainerFragment = gql65(_templateObject65(), GalleryButtons.fragment);
var CarouselContainer = function(props) {
    var _galleryButtons, _virtualTourButton;
    var data = props.data, onImageClick = props.onImageClick, onVirtualTourClick = props.onVirtualTourClick, onTriggerClick = props.onTriggerClick, imageIndexState = props.imageIndexState, propertyId = props.propertyId;
    var galleryButtons = data.galleryButtons, images = data.images, label = data.label;
    var track = useClickTracker16();
    var _React67_useState = _sliced_to_array(React67.useState(false), 2), logExposure = _React67_useState[0], setLogExposure = _React67_useState[1];
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var controlAnalytics = React67.useMemo(function() {
        return {
            id: "HOT.HIS.Main",
            description: "Change image in gallery carousel",
            callback: function(id, desc) {
                var nextImageIndex = getCarouselNextIndex(imageIndex, images.length, id);
                var _images_nextImageIndex = images[nextImageIndex], trackingId = _images_nextImageIndex.trackingId, imageId = _images_nextImageIndex.imageId;
                track(id, desc, void 0, additionalUisPrimeMicroMessages(nextImageIndex, trackingId, images.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
            }
        };
    }, [
        track
    ]);
    var handleIndexChange = React67.useCallback(function(index) {
        setImageIndex(index);
        setLogExposure(true);
    }, [
        setImageIndex,
        setLogExposure
    ]);
    var handleImageClick = React67.useCallback(function() {
        var _images_imageIndex, _image;
        var image = (_images_imageIndex = images[imageIndex]) === null || _images_imageIndex === void 0 ? void 0 : _images_imageIndex.image;
        if ((_image = image) === null || _image === void 0 ? void 0 : _image.thumbnailClickAnalytics) {
            var _thumbnailClickAnalytics, _thumbnailClickAnalytics1;
            var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
            track((_thumbnailClickAnalytics = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics === void 0 ? void 0 : _thumbnailClickAnalytics.referrerId, (_thumbnailClickAnalytics1 = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics1 === void 0 ? void 0 : _thumbnailClickAnalytics1.linkName);
        }
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(imageIndex, images[imageIndex].trackingId, images.length, images[imageIndex].imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        onImageClick();
        setLogExposure(true);
    }, [
        track,
        onImageClick
    ]);
    var handleMediaButtonClick = React67.useCallback(function() {
        track("HOT.HIS.PhotoGalleryTrigger", "Open Room Gallery dialog");
        onTriggerClick();
        setLogExposure(true);
    }, [
        track,
        onTriggerClick
    ]);
    var virtualTourButton = (_galleryButtons = galleryButtons) === null || _galleryButtons === void 0 ? void 0 : _galleryButtons.find(function(button) {
        var _button_action_resource, _button_action;
        return (_button_action = button.action) === null || _button_action === void 0 ? void 0 : (_button_action_resource = _button_action.resource) === null || _button_action_resource === void 0 ? void 0 : _button_action_resource.value;
    });
    var handleonVirtualTourButtonClick = React67.useCallback(function() {
        var _virtualTourButton;
        if ((_virtualTourButton = virtualTourButton) === null || _virtualTourButton === void 0 ? void 0 : _virtualTourButton.action) {
            onVirtualTourClick(virtualTourButton.action.resource.value);
        }
    }, [
        onVirtualTourClick,
        virtualTourButton
    ]);
    var uitkImages = React67.useMemo(function() {
        return toUitkImages(images);
    }, [
        images
    ]);
    var buttonText;
    if ((_virtualTourButton = virtualTourButton) === null || _virtualTourButton === void 0 ? void 0 : _virtualTourButton.accessibility) {
        var _virtualTourButton1;
        buttonText = {
            virtualTourButton: (_virtualTourButton1 = virtualTourButton) === null || _virtualTourButton1 === void 0 ? void 0 : _virtualTourButton1.accessibility
        };
    }
    var GalleryCarousel = /* @__PURE__ */ React67.createElement(IntersectionTracker4, {
        tag: "span",
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(imageIndex),
        linkName: "Mosaic Tile Image Impression",
        trackOnce: true,
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(imageIndex, images[imageIndex].trackingId, images.length, images[imageIndex].imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ )
    }, /* @__PURE__ */ React67.createElement(UitkGalleryCarousel, {
        carouselId: "property-details-carousel",
        allyHeadingLevel: 2,
        analytics: controlAnalytics,
        allyHeadingText: label || "",
        buttonText: buttonText,
        carouselName: "PhotoGallery",
        images: uitkImages,
        onImageClick: handleImageClick,
        onIndexChange: handleIndexChange,
        showGalleryButton: true,
        showVirtualTourButton: Boolean(virtualTourButton),
        onMediaButtonClick: handleMediaButtonClick,
        onVirtualTourClick: handleonVirtualTourButtonClick,
        currentIndex: imageIndex,
        enablePreload: false,
        fetchPriority: "high"
    }));
    return /* @__PURE__ */ React67.createElement(Experiment5, {
        name: "mWeb_PDP_Full_image_gallery_ranking_algorithm_with_new_scene_classifier",
        logExposure: logExposure
    }, /* @__PURE__ */ React67.createElement(ExperimentControl5, null, GalleryCarousel), /* @__PURE__ */ React67.createElement(ExperimentVariant5, {
        bucket: 1
    }, GalleryCarousel));
};
CarouselContainer.displayName = "CarouselContainer";
CarouselContainer.fragment = __CarouselContainerFragment;
// src/components/gallery/__private/__fragments/containers/mosaic-container.tsx
import React69 from "react";
import { gql as gql67 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
// src/components/gallery/__private/__fragments/images/property-image.tsx
import React68 from "react";
import { gql as gql66 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker5, useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2, UitkImageLink } from "uitk-react-images";
var __PropertyImageFragment = gql66(_templateObject66());
var PropertyImage = function(props) {
    var data = props.data, onClick = props.onClick, index = props.index, className = props.className, fetchPriority = props.fetchPriority, galleryLength = props.galleryLength, propertyId = props.propertyId, attributes = _object_without_properties(props, [
        "data",
        "onClick",
        "index",
        "className",
        "fetchPriority",
        "galleryLength",
        "propertyId"
    ]);
    var alt = data.alt, image = data.image, lowResImage = data.lowResImage, trackingId = data.trackingId, imageId = data.imageId;
    var track = useClickTracker17();
    var thumbnailClickAnalytics = image.thumbnailClickAnalytics;
    var handleClick = React68.useCallback(function() {
        if (thumbnailClickAnalytics) {
            var _thumbnailClickAnalytics, _thumbnailClickAnalytics1;
            track((_thumbnailClickAnalytics = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics === void 0 ? void 0 : _thumbnailClickAnalytics.referrerId, (_thumbnailClickAnalytics1 = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics1 === void 0 ? void 0 : _thumbnailClickAnalytics1.linkName);
        }
        onClick(index);
    }, [
        onClick,
        index
    ]);
    var galleryImage = /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(UitkImage2, {
        alt: alt || image.description,
        placeholderImage: true,
        src: lowResImage ? lowResImage.url : image.url,
        additionalProps: {
            fetchPriority: fetchPriority
        }
    }), /* @__PURE__ */ React68.createElement(UitkImageLink, null, /* @__PURE__ */ React68.createElement("button", {
        onClick: handleClick,
        type: "button"
    }, /* @__PURE__ */ React68.createElement("span", {
        className: "is-visually-hidden"
    }, image.description))));
    return /* @__PURE__ */ React68.createElement(UitkFigure2, _object_spread_props(_object_spread({}, attributes), {
        className: className,
        ratio: UitkFigureAspectRatioType2.R16_9
    }), thumbnailClickAnalytics ? /* @__PURE__ */ React68.createElement(IntersectionTracker5, {
        trackOnce: true,
        referrerId: "HOT.HIS.MosaicTileImageImpression.".concat(index),
        linkName: "Mosaic Tile Image Impression",
        additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, trackingId, galleryLength, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ )
    }, galleryImage) : galleryImage);
};
PropertyImage.displayName = "PropertyImage";
PropertyImage.fragment = __PropertyImageFragment;
// src/components/gallery/__private/__fragments/containers/mosaic-container.tsx
var __MosaicContainerFragment = gql67(_templateObject67(), PropertyImage.fragment, GalleryButtons.fragment);
function numberOfColumns(numberOfImages) {
    switch(numberOfImages){
        case 5:
            return 4;
        case 3:
            return 3;
        default:
            return 1;
    }
}
var MosaicContainer = function(props) {
    var data = props.data, imagesToShow = props.imagesToShow, onVirtualTourClick = props.onVirtualTourClick, onImageClick = props.onImageClick, onTriggerClick = props.onTriggerClick, thumbnailDialogTriggerTitle = props.thumbnailDialogTriggerTitle, thumbnailDialogTriggerAccessibilityLabel = props.thumbnailDialogTriggerAccessibilityLabel, propertyId = props.propertyId;
    var images = data.images, label = data.label;
    var track = useClickTracker18();
    var handleImageClick = React69.useCallback(function(index) {
        var _mosaicImages_index = mosaicImages[index], trackingId = _mosaicImages_index.trackingId, imageId = _mosaicImages_index.imageId;
        track("HOT.HIS.ClickMosaicTileImage.".concat(index), "Property mosaic tile image click", void 0, additionalUisPrimeMicroMessages(index, trackingId, mosaicImages.length, imageId, propertyId, "PDP_MOSAIC" /* PDP_MOSAIC */ ));
        track("HOT.HIS.LaunchMainPhotoGallery", "Launch Photo Gallery From Image Click");
        onImageClick(index);
    }, [
        track,
        onImageClick
    ]);
    var mosaicImages = React69.useMemo(function() {
        var imageSlice = images.slice(0, imagesToShow);
        if (imageSlice.length % 2 === 0) {
            imageSlice.pop();
        }
        return imageSlice;
    }, [
        images,
        imagesToShow
    ]);
    var columns = numberOfColumns(mosaicImages.length);
    var overlayButtonText = images.length === 1 ? "1" : "".concat(images.length - 1, "+");
    return /* @__PURE__ */ React69.createElement(UitkLayoutPosition5, {
        type: "relative"
    }, /* @__PURE__ */ React69.createElement(UitkLayoutGrid8, {
        columns: columns,
        rows: 2,
        space: "half"
    }, /* @__PURE__ */ React69.createElement("meta", {
        itemProp: "image",
        content: mosaicImages[0].image.url
    }), /* @__PURE__ */ React69.createElement("h2", {
        className: "is-visually-hidden"
    }, label), mosaicImages.map(function(img, index) {
        return /* @__PURE__ */ React69.createElement(UitkLayoutGridItem7, {
            key: "mosaic-image-".concat(index),
            colSpan: index === 0 ? 2 : 1,
            rowSpan: index === 0 ? 2 : 1
        }, /* @__PURE__ */ React69.createElement(PropertyImage, {
            data: img,
            onClick: handleImageClick,
            index: index,
            fetchPriority: index === 0 ? "high" : void 0,
            galleryLength: imagesToShow,
            propertyId: propertyId
        }));
    }), /* @__PURE__ */ React69.createElement(GalleryButtons, {
        data: data,
        onThumbnailGalleryClick: onTriggerClick,
        onVirtualTourClick: onVirtualTourClick,
        thumbnailButtonText: overlayButtonText,
        thumbnailDialogTriggerTitle: thumbnailDialogTriggerTitle,
        thumbnailDialogTriggerAccessibilityLabel: thumbnailDialogTriggerAccessibilityLabel
    })));
};
MosaicContainer.fragment = __MosaicContainerFragment;
MosaicContainer.displayName = "MosaicContainer";
// src/components/gallery/__private/__fragments/dialogs/media-gallery-dialog.tsx
import React70 from "react";
import { gql as gql68 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkMediaGalleryImageDialog, UitkMediaGalleryImageView } from "uitk-react-media-gallery";
var __MediaGalleryDialogFragment = gql68(_templateObject68());
var MediaGalleryDialog = function(props) {
    var _galleryImages;
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, imageIndexState = props.imageIndexState, categoryImageIndexState = props.categoryImageIndexState, categoryIndexState = props.categoryIndexState, propertyId = props.propertyId;
    var categories = data.categories, images = data.images, mediaGalleryDialog = data.mediaGalleryDialog;
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), imageIndex = _imageIndexState[0], setImageIndex = _imageIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), categoryImageIndex = _categoryImageIndexState[0], setCategoryImageIndex = _categoryImageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var track = useClickTracker19();
    var galleryImages = React70.useMemo(function() {
        var _currentCategory;
        if (categoryIndex < 0) {
            return toUitkImages(images);
        }
        var currentCategory = categories ? categories[categoryIndex] : null;
        return toUitkImages(((_currentCategory = currentCategory) === null || _currentCategory === void 0 ? void 0 : _currentCategory.images) || []);
    }, [
        categoryIndex,
        categories,
        images
    ]);
    var toolbarProps = React70.useMemo(function() {
        var _mediaGalleryDialog_toolbar_icon, _mediaGalleryDialog_toolbar, _mediaGalleryDialog, _mediaGalleryDialog_toolbar_icon1, _mediaGalleryDialog_toolbar1, _mediaGalleryDialog1;
        return {
            type: (_mediaGalleryDialog = mediaGalleryDialog) === null || _mediaGalleryDialog === void 0 ? void 0 : (_mediaGalleryDialog_toolbar = _mediaGalleryDialog.toolbar) === null || _mediaGalleryDialog_toolbar === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon = _mediaGalleryDialog_toolbar.icon) === null || _mediaGalleryDialog_toolbar_icon === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon.iconId,
            navIconLabel: (_mediaGalleryDialog1 = mediaGalleryDialog) === null || _mediaGalleryDialog1 === void 0 ? void 0 : (_mediaGalleryDialog_toolbar1 = _mediaGalleryDialog1.toolbar) === null || _mediaGalleryDialog_toolbar1 === void 0 ? void 0 : (_mediaGalleryDialog_toolbar_icon1 = _mediaGalleryDialog_toolbar1.icon) === null || _mediaGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _mediaGalleryDialog_toolbar_icon1.description
        };
    }, [
        mediaGalleryDialog
    ]);
    var galleryControlAnalytics = React70.useMemo(function() {
        var callback = function(id, description) {
            var _categories_categoryIndex, _categories;
            var nextImageIndex = getCarouselNextIndex(categoryImageIndex, galleryImages.length, id);
            var categoryImages = ((_categories = categories) === null || _categories === void 0 ? void 0 : (_categories_categoryIndex = _categories[categoryIndex]) === null || _categories_categoryIndex === void 0 ? void 0 : _categories_categoryIndex.images) || images;
            var trackingId = (categoryImages[nextImageIndex] || "").trackingId;
            var imageId = (categoryImages[nextImageIndex] || "").imageId;
            track(id, description, void 0, additionalUisPrimeMicroMessages(categoryImageIndex, trackingId, galleryImages.length, imageId, propertyId, "PDP_FULL_SCREEN_IMAGE_GALLERY" /* PDP_FULL_SCREEN_IMAGE_GALLERY */ ));
        };
        var galleryControl = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Change image in media gallery",
            callback: callback
        };
        return galleryControl;
    }, [
        track
    ]);
    var dialogAnalytics = React70.useMemo(function() {
        var callback = function(id, description) {
            return track(id, description);
        };
        var dialog = {
            id: "HOT.HIS.PhotoGalleryTrigger",
            description: "Close review gallery dialog",
            callback: callback
        };
        return dialog;
    }, [
        track
    ]);
    var handleIndexChange = React70.useCallback(function(index) {
        if (categoryIndex < 0) {
            setImageIndex(index);
            return;
        }
        setCategoryImageIndex(index);
    }, [
        categoryIndex,
        setCategoryImageIndex,
        setImageIndex
    ]);
    if (!((_galleryImages = galleryImages) === null || _galleryImages === void 0 ? void 0 : _galleryImages.length)) {
        return null;
    }
    var mediaGalleryImageViewProps = {
        currentIndex: categoryIndex >= 0 ? categoryImageIndex : imageIndex,
        onIndexChange: handleIndexChange,
        galleryName: "Dialog",
        analytics: galleryControlAnalytics
    };
    return /* @__PURE__ */ React70.createElement(UitkMediaGalleryImageDialog, _object_spread({
        dialogShow: isDialogOpen,
        onDismiss: onDialogDismiss,
        strictFullscreen: true,
        analytics: dialogAnalytics
    }, toolbarProps), /* @__PURE__ */ React70.createElement(UitkMediaGalleryImageView, _object_spread_props(_object_spread({}, mediaGalleryImageViewProps), {
        images: galleryImages,
        stretchToFill: false
    })));
};
MediaGalleryDialog.displayName = "MediaGalleryDialog";
MediaGalleryDialog.fragment = __MediaGalleryDialogFragment;
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
import React73 from "react";
import { gql as gql69 } from "@apollo/client";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment6, ExperimentControl as ExperimentControl6, ExperimentVariant as ExperimentVariant6 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium7, Viewport as Viewport12, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet7, UitkSheetContent as UitkSheetContent5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar6 } from "uitk-react-toolbar";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-tabs.tsx
import React72 from "react";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge6, ViewMedium as ViewMedium6, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkHeading as UitkHeading13 } from "uitk-react-text";
// src/components/gallery/__private/utils/to-uitk-images-with-thumbnail-analytics.ts
function toUitkImagesWithThumbnailAnalytics(images, useLowRes) {
    return images.map(function(img) {
        var _img_image, _img_image1, _img_image2, _img_thumbnail, _img_fallbackImage, _img_image3;
        var src = useLowRes && img.lowResImage ? img.lowResImage.url : (_img_image = img.image) === null || _img_image === void 0 ? void 0 : _img_image.url;
        var _img_image_description, _img_alt;
        return {
            src: src,
            caption: (_img_image_description = (_img_image1 = img.image) === null || _img_image1 === void 0 ? void 0 : _img_image1.description) !== null && _img_image_description !== void 0 ? _img_image_description : "",
            alt: (_img_alt = img.alt) !== null && _img_alt !== void 0 ? _img_alt : (_img_image2 = img.image) === null || _img_image2 === void 0 ? void 0 : _img_image2.description,
            thumbnailSrc: (_img_thumbnail = img.thumbnail) === null || _img_thumbnail === void 0 ? void 0 : _img_thumbnail.url,
            fallbackImage: (_img_fallbackImage = img.fallbackImage) === null || _img_fallbackImage === void 0 ? void 0 : _img_fallbackImage.url,
            thumbnailClickAnalytics: (_img_image3 = img.image) === null || _img_image3 === void 0 ? void 0 : _img_image3.thumbnailClickAnalytics,
            trackingId: img.trackingId || null,
            imageId: img.imageId || null
        };
    });
}
// src/components/gallery/__private/__fragments/dialogs/media-gallery-thumbnail-view.tsx
import React71 from "react";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutGrid as UitkLayoutGrid9, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
import { UitkList as UitkList3 } from "uitk-react-list";
import { UitkMediaGalleryThumbnail } from "uitk-react-media-gallery";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
import { UitkText as UitkText22 } from "uitk-react-text";
var MediaGalleryThumbnailView = function(param) {
    var images = param.images, onImageSelected = param.onImageSelected, columns = param.columns, space = param.space, imagesRatio = param.imagesRatio, focusIndex = param.focusIndex, containerRef = param.containerRef, propertyId = param.propertyId, categoryId = param.categoryId;
    var _images;
    if (!((_images = images) === null || _images === void 0 ? void 0 : _images.length)) {
        return null;
    }
    return /* @__PURE__ */ React71.createElement(UitkList3, {
        bullet: "no-bullet",
        spacing: false
    }, /* @__PURE__ */ React71.createElement(UitkLayoutGrid9, {
        columns: columns,
        space: space
    }, images.map(function(image, index) {
        return /* @__PURE__ */ React71.createElement(UitkLayoutGridItem8, {
            key: index
        }, /* @__PURE__ */ React71.createElement("div", {
            "data-stid": "image-thumbnail-view-with-label"
        }, image.thumbnailClickAnalytics && /* @__PURE__ */ React71.createElement(IntersectionTracker6, {
            trackOnce: true,
            referrerId: "HOT.HIS.ThumbnailImageImpression.".concat(categoryId ? "".concat(categoryId, ".") : "").concat(image.imageId, ".").concat(index),
            linkName: "Thumbnail Image Impression",
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(index, image.trackingId, images.length, image.imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ , categoryId)
        }, /* @__PURE__ */ React71.createElement(UitkMediaGalleryThumbnail, _object_spread_props(_object_spread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        }))), !image.thumbnailClickAnalytics && /* @__PURE__ */ React71.createElement(UitkMediaGalleryThumbnail, _object_spread_props(_object_spread({}, image), {
            index: index,
            imagesRatio: imagesRatio,
            onImageSelected: function() {
                return onImageSelected(index);
            },
            focusIndex: focusIndex,
            containerRef: containerRef
        })), /* @__PURE__ */ React71.createElement(UitkSpacing24, {
            padding: {
                blockstart: "two",
                blockend: "three"
            }
        }, /* @__PURE__ */ React71.createElement(UitkText22, {
            align: "left",
            overflow: "truncate"
        }, image.caption))));
    })));
};
MediaGalleryThumbnailView.displayName = "MediaGalleryThumbnailView";
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-tabs.tsx
var ThumbnailGalleryTabs = function(param) {
    var categories = param.categories, images = param.images, _param_useCenteredSheet = param.useCenteredSheet, useCenteredSheet = _param_useCenteredSheet === void 0 ? false : _param_useCenteredSheet, onImageClick = param.onImageClick, categoryIndexState = param.categoryIndexState, imageIndexState = param.imageIndexState, propertyId = param.propertyId;
    var _categories, _categories1;
    var _imageIndexState = _sliced_to_array(imageIndexState, 1), imageIndex = _imageIndexState[0];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 1), categoryIndex = _categoryIndexState[0];
    var refTop = React72.useRef(null);
    var track = useClickTracker20();
    var exposure = useExperiment2("PEXO_PDP_CenteredSheet_gallery_with_1_column_of_images").exposure;
    var imageColumns = exposure.bucket === 2 ? 1 : 2;
    var _React72_useState = _sliced_to_array(React72.useState(categoryIndex >= 0 || !((_categories = categories) === null || _categories === void 0 ? void 0 : _categories.length) ? categoryIndex : 0), 2), currentLocalCategoryIndex = _React72_useState[0], setCurrentLocalCategoryIndex = _React72_useState[1];
    var handleTabSelect = React72.useCallback(function(selectedCategoryIndex) {
        var _refTop_current;
        if (categories) {
            var selectedCategoryId = selectedCategoryIndex >= 0 ? categories[selectedCategoryIndex].categoryId : "";
            track("HOT.HIS.PhotoGalleryTrigger.".concat(selectedCategoryId, ".").concat(selectedCategoryIndex), "Selected gallery tab");
        }
        setCurrentLocalCategoryIndex(selectedCategoryIndex);
        (_refTop_current = refTop.current) === null || _refTop_current === void 0 ? void 0 : _refTop_current.scrollIntoView({
            block: "nearest"
        });
    }, [
        setCurrentLocalCategoryIndex,
        categories,
        track
    ]);
    var handleImageSelected = React72.useCallback(function(index) {
        if (currentLocalCategoryIndex) {
            var _localCategory, _localCategory1, _localCategory_images_index, _localCategory2, _localCategory3, _localCategory4, _localCategory5;
            var localCategory = categories ? categories[currentLocalCategoryIndex] : null;
            var localCategoryId = ((_localCategory = localCategory) === null || _localCategory === void 0 ? void 0 : _localCategory.categoryId) || "";
            var imageSubjectId = (_localCategory1 = localCategory) === null || _localCategory1 === void 0 ? void 0 : _localCategory1.images[index].subjectId;
            var thumbnailClickAnalytics = (_localCategory2 = localCategory) === null || _localCategory2 === void 0 ? void 0 : (_localCategory_images_index = _localCategory2.images[index]) === null || _localCategory_images_index === void 0 ? void 0 : _localCategory_images_index.image.thumbnailClickAnalytics;
            var trackingId = ((_localCategory3 = localCategory) === null || _localCategory3 === void 0 ? void 0 : _localCategory3.images[index].trackingId) || null;
            var imageId = ((_localCategory4 = localCategory) === null || _localCategory4 === void 0 ? void 0 : _localCategory4.images[index].imageId) || null;
            var localCategoryImagesLength = ((_localCategory5 = localCategory) === null || _localCategory5 === void 0 ? void 0 : _localCategory5.images.length) || 0;
            track("HOT.HIS.ClickThumbnailImage.".concat(localCategoryId, ".").concat(imageSubjectId, ".").concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId, localCategoryImagesLength, imageId, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics) {
                var _thumbnailClickAnalytics, _thumbnailClickAnalytics1;
                track((_thumbnailClickAnalytics = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics === void 0 ? void 0 : _thumbnailClickAnalytics.referrerId, (_thumbnailClickAnalytics1 = thumbnailClickAnalytics) === null || _thumbnailClickAnalytics1 === void 0 ? void 0 : _thumbnailClickAnalytics1.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        } else {
            var imageSubjectId1 = images[index].subjectId;
            var thumbnailClickAnalytics1 = images[index].image.thumbnailClickAnalytics;
            var _images_index = images[index], trackingId1 = _images_index.trackingId, imageId1 = _images_index.imageId;
            track("HOT.HIS.ClickThumbnailImage.".concat(imageSubjectId1, ".").concat(index), "Launch Thumbnail Gallery From Image Click", void 0, additionalUisPrimeMicroMessages(index, trackingId1, images.length, imageId1, propertyId, "PDP_FULL_IMAGE_GALLERY" /* PDP_FULL_IMAGE_GALLERY */ ));
            if (thumbnailClickAnalytics1) {
                var _thumbnailClickAnalytics2, _thumbnailClickAnalytics3;
                track((_thumbnailClickAnalytics2 = thumbnailClickAnalytics1) === null || _thumbnailClickAnalytics2 === void 0 ? void 0 : _thumbnailClickAnalytics2.referrerId, (_thumbnailClickAnalytics3 = thumbnailClickAnalytics1) === null || _thumbnailClickAnalytics3 === void 0 ? void 0 : _thumbnailClickAnalytics3.linkName);
            }
            onImageClick(index, currentLocalCategoryIndex);
        }
    }, [
        currentLocalCategoryIndex,
        onImageClick,
        categories,
        track,
        images
    ]);
    var thumbnailViewWithImageLabel = React72.useCallback(function(galleryImages, columns, categoryId) {
        return /* @__PURE__ */ React72.createElement(MediaGalleryThumbnailView, {
            imagesRatio: UitkFigureAspectRatioType3.R16_9,
            images: galleryImages,
            onImageSelected: handleImageSelected,
            columns: columns,
            space: "three",
            focusIndex: imageIndex,
            propertyId: propertyId,
            categoryId: categoryId
        });
    }, [
        handleImageSelected,
        imageIndex
    ]);
    var mediaGalleryThumbnailViewBody = React72.useCallback(function(galleryImages, title, categoryId, columns, headingSize, headingTag) {
        var hasSpacing = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
        var body = /* @__PURE__ */ React72.createElement(React72.Fragment, null, title && /* @__PURE__ */ React72.createElement(UitkSpacing25, {
            padding: {
                blockend: "three"
            }
        }, /* @__PURE__ */ React72.createElement(UitkHeading13, {
            tag: headingTag,
            size: headingSize
        }, title)), thumbnailViewWithImageLabel(galleryImages, columns, categoryId));
        if (hasSpacing || useCenteredSheet) {
            return /* @__PURE__ */ React72.createElement(UitkSpacing25, {
                padding: {
                    inline: "three",
                    blockend: "three"
                }
            }, /* @__PURE__ */ React72.createElement("div", null, body));
        }
        return body;
    }, [
        thumbnailViewWithImageLabel,
        useCenteredSheet
    ]);
    var mediaGalleryThumbnailView = React72.useCallback(function(galleryImages, title, categoryId) {
        return /* @__PURE__ */ React72.createElement(Viewport11, null, /* @__PURE__ */ React72.createElement(ViewSmall11, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, 1, 4, "h4")), /* @__PURE__ */ React72.createElement(ViewMedium6, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3")), /* @__PURE__ */ React72.createElement(ViewLarge6, null, mediaGalleryThumbnailViewBody(galleryImages, title, categoryId, imageColumns, 3, "h3", false)));
    }, [
        mediaGalleryThumbnailViewBody
    ]);
    var tabContent = React72.useCallback(function(category) {
        var defaultTabView = mediaGalleryThumbnailView(toUitkImagesWithThumbnailAnalytics(category.images), category.name, category.categoryId);
        return defaultTabView;
    }, [
        mediaGalleryThumbnailView,
        useCenteredSheet
    ]);
    if (!((_categories1 = categories) === null || _categories1 === void 0 ? void 0 : _categories1.length)) {
        return mediaGalleryThumbnailView(toUitkImagesWithThumbnailAnalytics(images));
    }
    var tabsContent = /* @__PURE__ */ React72.createElement(UitkTabs, {
        tabsType: UitkTabsType.NATURAL,
        selectedTab: currentLocalCategoryIndex,
        onTabSelect: handleTabSelect
    }, categories.map(function(category) {
        return /* @__PURE__ */ React72.createElement(UitkTab, {
            key: "thumbail-gallery-tab-".concat(category.categoryId),
            id: category.categoryId,
            name: category.name,
            targetURI: "#"
        }, tabContent(category));
    }));
    if (useCenteredSheet) {
        return /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement("div", {
            ref: refTop
        }), /* @__PURE__ */ React72.createElement(UitkLayoutPosition6, {
            type: "sticky",
            position: {
                top: "zero",
                zindex: "layer2"
            },
            cloneElement: true
        }, tabsContent));
    }
    return tabsContent;
};
// src/components/gallery/__private/__fragments/dialogs/thumbnail-gallery-dialog.tsx
var __ThumbnailGalleryDialogFragment = gql69(_templateObject69());
var ThumbnailGalleryDialog = function(props) {
    var _thumbnailGalleryDialog_toolbar_icon, _thumbnailGalleryDialog_toolbar, _thumbnailGalleryDialog_toolbar_icon1, _thumbnailGalleryDialog_toolbar1, _thumbnailGalleryDialog_toolbar2;
    var data = props.data, isDialogOpen = props.isDialogOpen, onDialogDismiss = props.onDialogDismiss, onImageClick = props.onImageClick, categoryIndexState = props.categoryIndexState, imageIndexState = props.imageIndexState, triggerRef = props.triggerRef, propertyId = props.propertyId;
    var categories = data.categories, thumbnailGalleryDialog = data.thumbnailGalleryDialog, images = data.images;
    var _React73_useState = _sliced_to_array(React73.useState(0), 2), sheetHeight = _React73_useState[0], setSheetHeight = _React73_useState[1];
    var VERTICAL_MARGINS = 48;
    React73.useEffect(function() {
        setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        var handleWindowResize = function() {
            setSheetHeight(window.innerHeight - 2 * VERTICAL_MARGINS);
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var track = useClickTracker21();
    var toolbarAnalytics = {
        id: "HOT.HIS.PhotoGalleryTrigger",
        description: "Close thumbnail gallery dialog",
        callback: function(id, desc) {
            return track(id, desc);
        }
    };
    var toolbarComponent = thumbnailGalleryDialog && /* @__PURE__ */ React73.createElement(UitkToolbar6, {
        navigationContent: {
            onClick: onDialogDismiss,
            onClickAnalytics: toolbarAnalytics,
            navType: (_thumbnailGalleryDialog_toolbar = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon = _thumbnailGalleryDialog_toolbar.icon) === null || _thumbnailGalleryDialog_toolbar_icon === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon.iconId,
            navIconLabel: (_thumbnailGalleryDialog_toolbar1 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar1 === void 0 ? void 0 : (_thumbnailGalleryDialog_toolbar_icon1 = _thumbnailGalleryDialog_toolbar1.icon) === null || _thumbnailGalleryDialog_toolbar_icon1 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar_icon1.description
        },
        toolbarTitle: ((_thumbnailGalleryDialog_toolbar2 = thumbnailGalleryDialog.toolbar) === null || _thumbnailGalleryDialog_toolbar2 === void 0 ? void 0 : _thumbnailGalleryDialog_toolbar2.title) || ""
    });
    var centeredSheetThumbnailGalleryTabs = /* @__PURE__ */ React73.createElement(ThumbnailGalleryTabs, {
        categories: categories,
        images: images,
        useCenteredSheet: true,
        onImageClick: onImageClick,
        categoryIndexState: categoryIndexState,
        imageIndexState: imageIndexState,
        propertyId: propertyId
    });
    var sheetProps = {
        returnFocusOnClose: true,
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    var sheetContent = /* @__PURE__ */ React73.createElement(React73.Fragment, null, toolbarComponent, /* @__PURE__ */ React73.createElement(UitkSheetContent5, {
        padded: false
    }, centeredSheetThumbnailGalleryTabs));
    var fullScreenDialog = /* @__PURE__ */ React73.createElement(UitkSheet7, {
        type: "full",
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, toolbarComponent, /* @__PURE__ */ React73.createElement(UitkSpacing26, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React73.createElement(UitkSheetContent5, {
        padded: false
    }, /* @__PURE__ */ React73.createElement(UitkLayoutFlex14, {
        justifyContent: "center"
    }, /* @__PURE__ */ React73.createElement(UitkLayoutFlexItem10, {
        maxWidth: "312x",
        grow: 1
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(ThumbnailGalleryTabs, {
        categories: categories,
        images: images,
        useCenteredSheet: false,
        onImageClick: onImageClick,
        categoryIndexState: categoryIndexState,
        imageIndexState: imageIndexState,
        propertyId: propertyId
    })))))));
    return /* @__PURE__ */ React73.createElement(Viewport12, null, /* @__PURE__ */ React73.createElement(ViewSmall12, null, /* @__PURE__ */ React73.createElement(UitkSheet7, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), sheetContent)), /* @__PURE__ */ React73.createElement(ViewMedium7, null, /* @__PURE__ */ React73.createElement(Experiment6, {
        name: "PEXO_PDP_CenteredSheet_gallery_with_1_column_of_images"
    }, /* @__PURE__ */ React73.createElement(ExperimentControl6, null, fullScreenDialog), /* @__PURE__ */ React73.createElement(ExperimentVariant6, {
        bucket: 1
    }, /* @__PURE__ */ React73.createElement(UitkSheet7, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered",
        height: sheetHeight
    }), sheetContent)), /* @__PURE__ */ React73.createElement(ExperimentVariant6, {
        bucket: 2
    }, /* @__PURE__ */ React73.createElement(UitkSheet7, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered",
        height: sheetHeight
    }), sheetContent)))));
};
ThumbnailGalleryDialog.displayName = "ThumbnailGalleryDialog";
ThumbnailGalleryDialog.fragment = __ThumbnailGalleryDialogFragment;
// src/components/gallery/property-image-gallery.tsx
var __PropertyImageGalleryFragment = gql70(_templateObject70(), MosaicContainer.fragment, CarouselContainer.fragment, MediaGalleryDialog.fragment, ThumbnailGalleryDialog.fragment);
var PropertyImageGallery = function(param) {
    var data = param.data, propertyId = param.propertyId, className = param.className;
    var _data_thumbnailGalleryDialog_trigger, _data_thumbnailGalleryDialog, _data, _data_thumbnailGalleryDialog_trigger1, _data_thumbnailGalleryDialog1, _data1, _data_images, _data2;
    var _useDialog6 = _sliced_to_array(useDialog6("media-gallery", "pwaDialogNested"), 3), isMediaGalleryDialogOpen = _useDialog6[0], mediaGalleryDialogActions = _useDialog6[1], MediaGalleryDialogWrapper = _useDialog6[2];
    var _useDialog61 = _sliced_to_array(useDialog6("thumbnail-gallery", "pwaThumbnailDialog"), 3), isThumbnailGalleryDialogOpen = _useDialog61[0], thumbnailGalleryDialogActions = _useDialog61[1], ThumbnailGalleryDialogWrapper = _useDialog61[2];
    var triggerBtn = React74.useRef(null);
    var triggerImageBtn = React74.useRef(null);
    var imageIndexState = React74.useState(0);
    var categoryIndexState = React74.useState(-1);
    var categoryImageIndexState = React74.useState(0);
    var _imageIndexState = _sliced_to_array(imageIndexState, 2), setImageIndex = _imageIndexState[1];
    var _categoryIndexState = _sliced_to_array(categoryIndexState, 2), setCategoryIndex = _categoryIndexState[1];
    var _categoryImageIndexState = _sliced_to_array(categoryImageIndexState, 2), setCategoryImageIndex = _categoryImageIndexState[1];
    var onMosaicImageClick = React74.useCallback(function(index) {
        setImageIndex(index);
        setCategoryIndex(-1);
        triggerBtn.current = document.activeElement;
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex,
        setImageIndex
    ]);
    var onVirtualTourClick = React74.useCallback(function(imageResource) {
        if (typeof window !== "undefined") {
            window.open(imageResource);
        }
    }, []);
    var onCarouselImageClick = React74.useCallback(function() {
        setCategoryIndex(-1);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        mediaGalleryDialogActions,
        thumbnailGalleryDialogActions,
        setCategoryIndex
    ]);
    var onThumbnailImageClick = React74.useCallback(function(index, categoryIndex) {
        triggerImageBtn.current = document.activeElement;
        setCategoryIndex(categoryIndex);
        setCategoryImageIndex(index);
        if (categoryIndex < 0) {
            setImageIndex(index);
        }
        mediaGalleryDialogActions.openDialog();
    }, [
        setCategoryIndex,
        setCategoryImageIndex,
        mediaGalleryDialogActions,
        setImageIndex
    ]);
    var onOpenThumbnailGalleryDialog = React74.useCallback(function() {
        var activeEl = document.activeElement;
        triggerBtn.current = activeEl;
        setImageIndex(0);
        thumbnailGalleryDialogActions.openDialog();
    }, [
        thumbnailGalleryDialogActions,
        setImageIndex
    ]);
    var onDialogDismiss = React74.useCallback(function() {
        thumbnailGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerBtn_current;
            (_triggerBtn_current = triggerBtn.current) === null || _triggerBtn_current === void 0 ? void 0 : _triggerBtn_current.focus();
        }, 0);
    }, [
        thumbnailGalleryDialogActions
    ]);
    var onMediaDialogDismiss = React74.useCallback(function() {
        mediaGalleryDialogActions.closeDialog();
        setTimeout(function() {
            var _triggerImageBtn_current;
            (_triggerImageBtn_current = triggerImageBtn.current) === null || _triggerImageBtn_current === void 0 ? void 0 : _triggerImageBtn_current.focus();
        }, 0);
    }, [
        mediaGalleryDialogActions
    ]);
    var controlProps = {
        imageIndexState: imageIndexState,
        categoryImageIndexState: categoryImageIndexState,
        categoryIndexState: categoryIndexState
    };
    var containerProps = _object_spread({
        onTriggerClick: onOpenThumbnailGalleryDialog,
        thumbnailDialogTriggerTitle: (_data = data) === null || _data === void 0 ? void 0 : (_data_thumbnailGalleryDialog = _data.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger = _data_thumbnailGalleryDialog.trigger) === null || _data_thumbnailGalleryDialog_trigger === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger.value,
        thumbnailDialogTriggerAccessibilityLabel: (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_thumbnailGalleryDialog1 = _data1.thumbnailGalleryDialog) === null || _data_thumbnailGalleryDialog1 === void 0 ? void 0 : (_data_thumbnailGalleryDialog_trigger1 = _data_thumbnailGalleryDialog1.trigger) === null || _data_thumbnailGalleryDialog_trigger1 === void 0 ? void 0 : _data_thumbnailGalleryDialog_trigger1.accessibilityLabel
    }, controlProps);
    if (!((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_images = _data2.images) === null || _data_images === void 0 ? void 0 : _data_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React74.createElement("div", {
        className: className
    }, /* @__PURE__ */ React74.createElement(Viewport13, null, /* @__PURE__ */ React74.createElement(ViewSmall13, null, /* @__PURE__ */ React74.createElement(CarouselContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: onCarouselImageClick
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    }))), /* @__PURE__ */ React74.createElement(ViewMedium8, null, /* @__PURE__ */ React74.createElement(MosaicContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 3
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    }))), /* @__PURE__ */ React74.createElement(ViewLarge7, null, /* @__PURE__ */ React74.createElement(MosaicContainer, _object_spread_props(_object_spread({
        data: data,
        onVirtualTourClick: onVirtualTourClick,
        onImageClick: function(index) {
            return onMosaicImageClick(index);
        },
        imagesToShow: 5
    }, containerProps), {
        onTriggerClick: onOpenThumbnailGalleryDialog,
        propertyId: propertyId
    })))), /* @__PURE__ */ React74.createElement(ThumbnailGalleryDialogWrapper, null, /* @__PURE__ */ React74.createElement(ThumbnailGalleryDialog, _object_spread({
        data: data,
        isDialogOpen: isThumbnailGalleryDialogOpen,
        onDialogDismiss: onDialogDismiss,
        onImageClick: onThumbnailImageClick,
        triggerRef: triggerBtn,
        propertyId: propertyId
    }, controlProps))), /* @__PURE__ */ React74.createElement(MediaGalleryDialogWrapper, null, /* @__PURE__ */ React74.createElement(MediaGalleryDialog, _object_spread({
        data: data,
        isDialogOpen: isMediaGalleryDialogOpen,
        onDialogDismiss: onMediaDialogDismiss,
        propertyId: propertyId
    }, controlProps))));
};
PropertyImageGallery.displayName = "PropertyImageGallery";
PropertyImageGallery.fragment = __PropertyImageGalleryFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
import React76 from "react";
import { gql as gql72 } from "@apollo/client";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { UitkFigure as UitkFigure3, UitkImage as UitkImage3, UitkImageLink as UitkImageLink2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex16 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
var _obj9;
// src/components/summary/analytics.ts
var SummaryAnalyticsMapping = (_obj9 = {}, _define_property(_obj9, "REVIEWS" /* REVIEWS */ , [
    "HOT.HIS.UGC.ViewAllResults",
    "Display detailed reviews"
]), _define_property(_obj9, "AMENITIES" /* AMENITIES */ , [
    "HOT.HIS.ViewAllAmenities",
    "View all amenities"
]), _define_property(_obj9, "MAP_IMAGE" /* MAP_IMAGE */ , [
    "HOT.HIS.Map.StaticMap",
    "Click static map"
]), _define_property(_obj9, "MAP_LINK" /* MAP_LINK */ , [
    "HOT.HIS.ClickAddressCTALinkViewMap",
    "ClickAddressCTALinkViewMap"
]), _define_property(_obj9, "CLEANING_AND_SAFETY_LINK" /* CLEANING_AND_SAFETY_LINK */ , [
    "HOT.HIS.ViewAllCleanliness",
    "Click on see all cleanliness link"
]), _obj9);
var chatbotAnalyticsSchema = function(chatbotEntryPoint, chatbotName, propertyId) {
    return {
        schemaName: "chatbot",
        messageContent: {
            chatbotEntryPoint: chatbotEntryPoint,
            chatbotName: chatbotName,
            propertyId: propertyId
        }
    };
};
// src/components/summary/__private/__fragments/map-trigger/address.tsx
import React75 from "react";
import { gql as gql71 } from "@apollo/client";
import { Experiment as Experiment7, ExperimentControl as ExperimentControl7, ExperimentVariant as ExperimentVariant7 } from "@shared-ui/experiment-context";
import { UitkIcon as UitkIcon16 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink9 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
import { UitkText as UitkText23 } from "uitk-react-text";
var __AddressFragment = gql71(_templateObject71());
var Schema = function(param) {
    var coordinates = param.coordinates;
    var _coordinates, _coordinates1;
    var latitude = String((_coordinates = coordinates) === null || _coordinates === void 0 ? void 0 : _coordinates.latitude);
    var longitude = String((_coordinates1 = coordinates) === null || _coordinates1 === void 0 ? void 0 : _coordinates1.longitude);
    return /* @__PURE__ */ React75.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "http://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "latitude",
        content: latitude
    }), /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "longitude",
        content: longitude
    }));
};
Schema.displayName = "Schema";
var Address = function(param) {
    var data = param.data, onClick = param.onClick;
    var renderLink = function renderLink(padding, size) {
        return /* @__PURE__ */ React75.createElement(UitkSpacing27, {
            padding: padding
        }, /* @__PURE__ */ React75.createElement(UitkLink9, {
            onClick: onClick && onClick,
            size: size
        }, /* @__PURE__ */ React75.createElement("button", {
            type: "button"
        }, triggerLabel, /* @__PURE__ */ React75.createElement(UitkIcon16, {
            name: triggerIcon
        }))));
    };
    var _data_address, _data_mapDialog_trigger, _data_mapDialog, _data_address1, _data_address2, _data_address3, _data_address4, _data_mapDialog_trigger_icon, _data_mapDialog_trigger1, _data_mapDialog1;
    var addressLine = (_data_address = data.address) === null || _data_address === void 0 ? void 0 : _data_address.addressLine;
    var triggerLabel = (_data_mapDialog = data.mapDialog) === null || _data_mapDialog === void 0 ? void 0 : (_data_mapDialog_trigger = _data_mapDialog.trigger) === null || _data_mapDialog_trigger === void 0 ? void 0 : _data_mapDialog_trigger.value;
    var city = ((_data_address1 = data.address) === null || _data_address1 === void 0 ? void 0 : _data_address1.city) || void 0;
    var countryCode = ((_data_address2 = data.address) === null || _data_address2 === void 0 ? void 0 : _data_address2.countryCode) || void 0;
    var province = ((_data_address3 = data.address) === null || _data_address3 === void 0 ? void 0 : _data_address3.province) || void 0;
    var streetAddress = ((_data_address4 = data.address) === null || _data_address4 === void 0 ? void 0 : _data_address4.firstAddressLine) || void 0;
    var triggerIcon = ((_data_mapDialog1 = data.mapDialog) === null || _data_mapDialog1 === void 0 ? void 0 : (_data_mapDialog_trigger1 = _data_mapDialog1.trigger) === null || _data_mapDialog_trigger1 === void 0 ? void 0 : (_data_mapDialog_trigger_icon = _data_mapDialog_trigger1.icon) === null || _data_mapDialog_trigger_icon === void 0 ? void 0 : _data_mapDialog_trigger_icon.iconId) || "";
    return /* @__PURE__ */ React75.createElement(UitkSpacing27, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React75.createElement(UitkLayoutFlex15, {
        wrap: "wrap"
    }, /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React75.createElement(UitkText23, {
        "data-stid": "content-hotel-address"
    }, /* @__PURE__ */ React75.createElement("div", {
        itemProp: "address",
        itemScope: true,
        itemType: "http://schema.org/PostalAddress"
    }, /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "name",
        content: city
    }), /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "addressRegion",
        content: province
    }), /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "streetAddress",
        content: streetAddress
    }), /* @__PURE__ */ React75.createElement("meta", {
        itemProp: "addressCountry",
        content: countryCode
    })), addressLine)), /* @__PURE__ */ React75.createElement(Schema, _object_spread({}, data)), /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React75.createElement(Experiment7, {
        name: "PEXO_PDP_Increase_size_of_text_links_at_top"
    }, /* @__PURE__ */ React75.createElement(ExperimentControl7, null, renderLink({
        blockstart: "two"
    }, "")), /* @__PURE__ */ React75.createElement(ExperimentVariant7, {
        bucket: 1
    }, renderLink({
        blockstart: "two"
    }, "large"))))));
};
Address.displayName = "Address";
Address.fragment = __AddressFragment;
// src/components/summary/__private/__fragments/map-trigger/index.tsx
var __SummaryMapTriggerFragment = gql72(_templateObject72(), Address.fragment);
var SummaryMapTrigger = function(param) {
    var data = param.data, onClickMap = param.onClickMap, className = param.className, aspectRatio = param.aspectRatio, _param_spacing = param.spacing, spacing = _param_spacing === void 0 ? {} : _param_spacing;
    var _data_summary, _data_summary_location_staticImage, _data_summary_location_staticImage1;
    var track = useClickTracker22();
    var createHandlerClick = React76.useCallback(function(summaryEvent) {
        return function(event) {
            event.preventDefault();
            var _SummaryAnalyticsMapping_summaryEvent = _sliced_to_array(SummaryAnalyticsMapping[summaryEvent], 2), id = _SummaryAnalyticsMapping_summaryEvent[0], description2 = _SummaryAnalyticsMapping_summaryEvent[1];
            track(id, description2, true);
            onClickMap();
        };
    }, [
        onClickMap,
        track
    ]);
    if (!((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.location) || !(data.summary.location.staticImage && data.summary.location.mapDialog)) {
        return null;
    }
    var url = (_data_summary_location_staticImage = data.summary.location.staticImage) === null || _data_summary_location_staticImage === void 0 ? void 0 : _data_summary_location_staticImage.url;
    var description = (_data_summary_location_staticImage1 = data.summary.location.staticImage) === null || _data_summary_location_staticImage1 === void 0 ? void 0 : _data_summary_location_staticImage1.description;
    return /* @__PURE__ */ React76.createElement(UitkLayoutFlex16, {
        direction: "column",
        className: className
    }, url && /* @__PURE__ */ React76.createElement(UitkSpacing28, _object_spread({}, spacing), /* @__PURE__ */ React76.createElement(UitkFigure3, {
        roundcorner: true,
        ratio: aspectRatio
    }, /* @__PURE__ */ React76.createElement(UitkImage3, {
        alt: description,
        src: url
    }), /* @__PURE__ */ React76.createElement(UitkImageLink2, null, /* @__PURE__ */ React76.createElement("button", {
        type: "button",
        onClick: createHandlerClick("MAP_IMAGE" /* MAP_IMAGE */ )
    }, description)))), /* @__PURE__ */ React76.createElement(Address, {
        data: data.summary.location,
        onClick: createHandlerClick("MAP_LINK" /* MAP_LINK */ )
    }));
};
SummaryMapTrigger.displayName = "SummaryMapTrigger";
SummaryMapTrigger.fragment = __SummaryMapTriggerFragment;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
import React89 from "react";
import { gql as gql81 } from "@apollo/client";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
import React88 from "react";
import { gql as gql80 } from "@apollo/client";
import { ViewLarge as ViewLarge8, Viewport as Viewport14, ViewSmall as ViewSmall14 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex17 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid10, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
import React87 from "react";
import { gql as gql79 } from "@apollo/client";
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
import React80 from "react";
import { gql as gql75 } from "@apollo/client";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React77 from "react";
import { gql as gql73 } from "@apollo/client";
import { UitkToolbar as UitkToolbar7 } from "uitk-react-toolbar";
var fragment39 = gql73(_templateObject73());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React77.createElement(UitkToolbar7, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment39;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/lodging-dialog-trigger-message/lodging-dialog-trigger-message.tsx
import React78 from "react";
import { gql as gql74 } from "@apollo/client";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink10 } from "uitk-react-link";
var fragment40 = gql74(_templateObject74(), LodgingEGDSIcon.fragment);
var LodgingDialogTriggerMessage = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, value = _param_data.value, accessibilityLabel = _param_data.accessibilityLabel, icon = _param_data.icon, clientSideAnalytics = _param_data.clientSideAnalytics;
    var track = useClickTracker23();
    var onClick = function() {
        if (clientSideAnalytics) {
            track(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
        onClickAction();
    };
    return /* @__PURE__ */ React78.createElement(UitkLink10, null, /* @__PURE__ */ React78.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0,
        onClick: onClick
    }, value, icon && /* @__PURE__ */ React78.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingDialogTriggerMessage.fragment = fragment40;
LodgingDialogTriggerMessage.displayName = "LodgingDialogTriggerMessage";
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
import { UitkDialogContent as UitkDialogContent3 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet8 } from "uitk-react-sheet";
// src/components/property-info-details/property-info-details-inputs-provider.tsx
import React79 from "react";
var PropertyInfoDetailsInputsContext = React79.createContext(void 0);
var usePropertyInfoDetailsInputs = function() {
    var context = React79.useContext(PropertyInfoDetailsInputsContext);
    if (context === void 0) {
        throw new Error("usePropertyInfoDetailsInputs must be used with a PropertyInfoDetailsInputContext provider");
    }
    return context;
};
// src/components/summary/__private/__fragments/shared/cleanliness-dialog.tsx
var fragment41 = gql75(_templateObject75(), EGDSDialogToolbar.fragment, LodgingDialogTriggerMessage.fragment);
var CleanlinessDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog7 = _sliced_to_array(useDialog7("PropertyCleaningAndSafetyPracticesDialog", "pwaDialogNested"), 3), cleanlinessDialogActions = _useDialog7[1], CleanlinessDialogComponent = _useDialog7[2];
    var track = useClickTracker24();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React80.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        cleanlinessDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React80.createElement(React80.Fragment, null, /* @__PURE__ */ React80.createElement(LodgingDialogTriggerMessage, {
        onClickAction: cleanlinessDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React80.createElement(CleanlinessDialogComponent, null, /* @__PURE__ */ React80.createElement(UitkSheet8, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React80.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React80.createElement(UitkDialogContent3, null, /* @__PURE__ */ React80.createElement(PropertyCleanliness, {
        inputs: propertyId
    })))));
};
CleanlinessDialog.displayName = "CleanlinessDialog";
CleanlinessDialog.fragment = fragment41;
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
import React86 from "react";
import { gql as gql78 } from "@apollo/client";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet9 } from "uitk-react-sheet";
// src/components/property-amenities/property-amenities.tsx
import React85, { useEffect as useEffect2 } from "react";
import { gql as gql77, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
import { useInView as useInView2 } from "react-intersection-observer";
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
import React84 from "react";
import { gql as gql76 } from "@apollo/client";
import { UitkScrollable as UitkScrollable2 } from "uitk-react-scrollable";
// src/components/summary/__private/__fragments/amenities/amenity-closures.tsx
import React81 from "react";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
var AmenityClosures = function(props) {
    var _amenityClosures_items, _amenityClosures;
    var amenityClosures = props.amenityClosures;
    var baseIconItemsProps = {
        columns: 2
    };
    var smallIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "two"
    });
    var largeIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "three"
    });
    return amenityClosures && ((_amenityClosures = amenityClosures) === null || _amenityClosures === void 0 ? void 0 : (_amenityClosures_items = _amenityClosures.items) === null || _amenityClosures_items === void 0 ? void 0 : _amenityClosures_items.length) > 0 && /* @__PURE__ */ React81.createElement(UitkSpacing29, {
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React81.createElement("div", null, /* @__PURE__ */ React81.createElement(PropertyInfoContent, {
        data: amenityClosures,
        small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
            prefix: "temporaryClosures"
        }),
        large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
            prefix: "temporaryClosures"
        })
    })));
};
// src/components/summary/__private/__fragments/amenities/highlighted-amenities-section.tsx
import React82 from "react";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
var HighlightedAmenitiesSection = function(props) {
    var highlight = props.highlight;
    var baseIconItemsProps = {
        columns: 2
    };
    var smallIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "two"
    });
    var largeIconItemsProps = _object_spread_props(_object_spread({}, baseIconItemsProps), {
        space: "three"
    });
    return highlight.map(function(section, idx) {
        return section.items.length > 0 && /* @__PURE__ */ React82.createElement(UitkSpacing30, {
            key: "highlightedAmenities-section-".concat(idx),
            padding: {
                blockend: "four"
            }
        }, /* @__PURE__ */ React82.createElement("div", null, /* @__PURE__ */ React82.createElement(PropertyInfoContent, {
            data: section,
            small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
                prefix: "highlightedAmenities"
            }),
            large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
                prefix: "highlightedAmenities"
            })
        })));
    });
};
// src/components/summary/__private/__fragments/amenities/property-amenities-section.tsx
import React83 from "react";
import { Experiment as Experiment8, ExperimentControl as ExperimentControl8, ExperimentVariant as ExperimentVariant8 } from "@shared-ui/experiment-context";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
var PropertyAmenitiesSection = function(props) {
    var property = props.property;
    var PropertyAmenitiesSectionRender = property.map(function(section, idx) {
        return section.items.length > 0 && /* @__PURE__ */ React83.createElement(UitkSpacing31, {
            key: "propertyAmenities-section-".concat(idx),
            padding: {
                blockend: "four"
            }
        }, /* @__PURE__ */ React83.createElement("div", null, /* @__PURE__ */ React83.createElement(PropertyInfoContentList, {
            data: section,
            prefix: "propertyAmenities"
        })));
    });
    return /* @__PURE__ */ React83.createElement(Experiment8, {
        name: "Amenity_category_reordering_",
        logExposure: true
    }, /* @__PURE__ */ React83.createElement(ExperimentControl8, null, PropertyAmenitiesSectionRender), /* @__PURE__ */ React83.createElement(ExperimentVariant8, {
        bucket: 1
    }, PropertyAmenitiesSectionRender));
};
// src/components/summary/__private/__fragments/amenities/property-takeover-amenities.tsx
var __PropertyTakeoverAmenitiesFragment = gql76(_templateObject76(), PropertyInfoContent.fragment);
var PropertyTakeoverAmenities = React84.forwardRef(function(props, ref) {
    var data = props.data;
    var amenityClosures = data.amenityClosures, highlight = data.highlight, property = data.property;
    if (highlight.length === 0 && property.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React84.createElement("div", {
        ref: ref
    }, /* @__PURE__ */ React84.createElement(UitkScrollable2, {
        direction: "vertical"
    }, /* @__PURE__ */ React84.createElement(AmenityClosures, {
        amenityClosures: amenityClosures
    }), /* @__PURE__ */ React84.createElement(HighlightedAmenitiesSection, {
        highlight: highlight
    }), /* @__PURE__ */ React84.createElement(PropertyAmenitiesSection, {
        property: property
    })));
});
PropertyTakeoverAmenities.fragment = __PropertyTakeoverAmenitiesFragment;
PropertyTakeoverAmenities.displayName = "PropertyTakeoverAmenities";
// src/components/property-amenities/property-amenities.tsx
var __Query2 = gql77(_templateObject77(), PropertyTakeoverAmenities.fragment);
var PropertyAmenities = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyInfo_summary, _data_propertyInfo, _data;
    var context = useBexApi5().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query2, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery3.data, loading = _useQuery3.loading;
    var _ref = ((_data = data) === null || _data === void 0 ? void 0 : (_data_propertyInfo = _data.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : (_data_propertyInfo_summary = _data_propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : _data_propertyInfo_summary.amenities) || {}, takeover = _ref.takeover, adaptExAttemptEvents = _ref.viewAmenitiesAdaptExAttemptEvents;
    var track = useClickstreamAnalytics3().track;
    var _useInView2 = useInView2({
        triggerOnce: true,
        threshold: 0.1
    }), ref = _useInView2.ref, inView = _useInView2.inView;
    useEffect2(function() {
        var _adaptExAttemptEvents;
        if (inView && ((_adaptExAttemptEvents = adaptExAttemptEvents) === null || _adaptExAttemptEvents === void 0 ? void 0 : _adaptExAttemptEvents.length)) {
            adaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                track(ITrackType3.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: adaptExAttemptEvent.events[0].payloadId,
                        eventType: adaptExAttemptEvent.events[0].eventType,
                        eventTarget: adaptExAttemptEvent.events[0].eventTarget
                    })
                });
            });
        }
    }, [
        adaptExAttemptEvents,
        inView,
        track
    ]);
    if (loading || !takeover) {
        return null;
    }
    return /* @__PURE__ */ React85.createElement(PropertyTakeoverAmenities, {
        data: takeover,
        ref: ref
    });
};
PropertyAmenities.displayName = "sharedui-PropertyAmenities";
// src/components/summary/__private/__fragments/shared/see-more-property-amenities-dialog.tsx
var fragment42 = gql78(_templateObject78(), EGDSDialogToolbar.fragment, LodgingDialogTriggerMessage.fragment);
var SeeMorePropertyAmenitiesDialog = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var _useDialog8 = _sliced_to_array(useDialog8("PropertyAmenitiesDialog", "pwaDialogNested"), 3), seeMorePropertyAmenitiesDialogActions = _useDialog8[1], SeeMorePropertyAmenitiesDialogComponent = _useDialog8[2];
    var track = useClickTracker25();
    var propertyId = usePropertyInfoDetailsInputs();
    var triggerRef = React86.useRef(null);
    var closeDialog = function() {
        if (dialog.closeAnalytics) {
            track(dialog.closeAnalytics.referrerId, dialog.closeAnalytics.linkName);
        }
        seeMorePropertyAmenitiesDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement(LodgingDialogTriggerMessage, {
        data: trigger,
        onClickAction: seeMorePropertyAmenitiesDialogActions.openDialog,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React86.createElement(SeeMorePropertyAmenitiesDialogComponent, null, /* @__PURE__ */ React86.createElement(UitkSheet9, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React86.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: closeDialog,
        data: dialog.toolbar
    }), /* @__PURE__ */ React86.createElement(UitkDialogContent4, null, /* @__PURE__ */ React86.createElement(PropertyAmenities, {
        inputs: propertyId
    })))));
};
SeeMorePropertyAmenitiesDialog.displayName = "SeeMorePropertyAmenitiesDialog";
SeeMorePropertyAmenitiesDialog.fragment = fragment42;
// src/components/summary/__private/__fragments/shared/see-more-action.tsx
var fragment43 = gql79(_templateObject79(), SeeMorePropertyAmenitiesDialog.fragment, CleanlinessDialog.fragment);
var SeeMoreAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "AmenitiesDialog":
            return /* @__PURE__ */ React87.createElement(SeeMorePropertyAmenitiesDialog, {
                data: data
            });
        case "CleanlinessDialog":
            return /* @__PURE__ */ React87.createElement(CleanlinessDialog, {
                data: data
            });
        default:
            return null;
    }
};
SeeMoreAction.displayName = "SeeMoreAction";
SeeMoreAction.fragment = fragment43;
// src/components/summary/__private/__fragments/shared/property-info-content-with-see-more-action.tsx
var __PropertyInfoContentWithSeeMoreAction = gql80(_templateObject80(), PropertyInfoContentHeader.fragment, PropertyInfoContentItems.fragment, SeeMoreAction.fragment);
var PropertyInfoContentWithSeeMoreAction = function(param) {
    var data = param.data, small = param.small, large = param.large;
    var header = data.header, seeMoreAction = data.seeMoreAction;
    return /* @__PURE__ */ React88.createElement(UitkLayoutFlex17, {
        direction: "column"
    }, header && /* @__PURE__ */ React88.createElement(PropertyInfoContentHeader, {
        data: header
    }), /* @__PURE__ */ React88.createElement(Viewport14, null, /* @__PURE__ */ React88.createElement(ViewSmall14, null, /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, small), {
        data: data
    })), seeMoreAction && /* @__PURE__ */ React88.createElement(SeeMoreAction, {
        data: seeMoreAction
    }))), /* @__PURE__ */ React88.createElement(ViewLarge8, null, /* @__PURE__ */ React88.createElement(UitkLayoutGrid10, {
        space: "three",
        columns: 1
    }, /* @__PURE__ */ React88.createElement(UitkLayoutGridItem9, null, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(PropertyInfoContentItems, _object_spread_props(_object_spread({}, large), {
        data: data
    })))), /* @__PURE__ */ React88.createElement(UitkLayoutGridItem9, {
        justifySelf: "end"
    }, /* @__PURE__ */ React88.createElement("div", null, seeMoreAction && /* @__PURE__ */ React88.createElement(SeeMoreAction, {
        data: seeMoreAction
    })))))));
};
PropertyInfoContentWithSeeMoreAction.displayName = "PropertyInfoContentWithSeeMoreAction";
PropertyInfoContentWithSeeMoreAction.fragment = __PropertyInfoContentWithSeeMoreAction;
// src/components/property-info-details/__private/__fragments/property-description-and-more-info-section.tsx
var fragment44 = gql81(_templateObject81(), LodgingEGDSParagraph.fragment, PropertyInfoContentWithSeeMoreAction.fragment);
var contentItemsProps = Object.freeze({
    overflow: "wrap",
    prefix: "cleaningAndSafety",
    space: "four",
    subset: 6,
    columns: 2
});
var PropertyDescriptionAndMoreInfoSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React89.createElement("div", null, data.description && /* @__PURE__ */ React89.createElement(LodgingEGDSParagraph, {
        data: data.description,
        size: 2
    }), data.contentSections.map(function(contentSection, index) {
        return /* @__PURE__ */ React89.createElement(UitkSpacing32, {
            margin: {
                blockstart: "six"
            },
            key: index
        }, /* @__PURE__ */ React89.createElement("div", null, /* @__PURE__ */ React89.createElement(PropertyInfoContentWithSeeMoreAction, {
            data: contentSection,
            small: contentItemsProps,
            large: contentItemsProps
        })));
    }));
};
PropertyDescriptionAndMoreInfoSection.displayName = "PropertyDescriptionAndMoreInfoSection";
PropertyDescriptionAndMoreInfoSection.fragment = fragment44;
// src/components/property-info-details/__private/__fragments/property-details-reviews-breakdown.tsx
import React96 from "react";
import { gql as gql87 } from "@apollo/client";
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
import React95 from "react";
import { gql as gql86 } from "@apollo/client";
import { Experiment as Experiment10, ExperimentControl as ExperimentControl10, ExperimentVariant as ExperimentVariant10 } from "@shared-ui/experiment-context";
import { UitkLayoutFlex as UitkLayoutFlex20, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink12 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing36 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading15, UitkText as UitkText26 } from "uitk-react-text";
// ../internal/src/components/property-review-summary/utils/structured-data.ts
var getStructuredDataProps = function(itemProp, required) {
    if (!required) {
        return null;
    }
    var baseProps = {
        itemProp: itemProp
    };
    if (itemProp === "aggregateRating") {
        baseProps = _object_spread_props(_object_spread({}, baseProps), {
            itemScope: true,
            itemType: "http://schema.org/AggregateRating"
        });
    }
    return baseProps;
};
// ../internal/src/components/property-review-summary/__private/__fragments/rating-counts.tsx
import React90 from "react";
import { gql as gql82 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex18, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkProgressBar } from "uitk-react-progress-bar";
import { UitkSpacing as UitkSpacing33 } from "uitk-react-spacing";
var fragment45 = gql82(_templateObject82());
var RatingCounts = function(param) {
    var data = param.data;
    var ratingCounts = data.ratingCounts;
    if (!ratingCounts || ratingCounts.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React90.createElement(UitkSpacing33, {
        margin: {
            blockstart: "two",
            blockend: "four"
        }
    }, /* @__PURE__ */ React90.createElement(UitkLayoutFlex18, {
        space: "two",
        direction: "column"
    }, ratingCounts.map(function(ratingCount) {
        var _ratingCount;
        return /* @__PURE__ */ React90.createElement(UitkLayoutFlexItem12, {
            minWidth: "full_width",
            key: "rating-".concat(ratingCount.rating)
        }, /* @__PURE__ */ React90.createElement(UitkProgressBar, {
            accessibilityLabel: ((_ratingCount = ratingCount) === null || _ratingCount === void 0 ? void 0 : _ratingCount.accessibilityLabel) || "",
            percent: ratingCount.percent,
            progressDescription: ratingCount.count.formatted,
            title: ratingCount.description
        }));
    })));
};
RatingCounts.displayName = "RatingCounts";
RatingCounts.fragment = fragment45;
// ../internal/src/components/property-review-summary/__private/__fragments/summary-details.tsx
import React91 from "react";
import { gql as gql83 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex19, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing34 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading14, UitkText as UitkText24 } from "uitk-react-text";
var fragment46 = gql83(_templateObject83());
var SummaryDetails = function(param) {
    var data = param.data;
    var _reviewSummaryDetails_, _reviewSummaryDetails;
    var reviewSummaryDetails = data.reviewSummaryDetails;
    var track = useClickTracker26();
    React91.useEffect(function() {
        var _reviewSummaryDetails_, _reviewSummaryDetails;
        var cleanlinessRate = (_reviewSummaryDetails = reviewSummaryDetails) === null || _reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = _reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value;
        if (cleanlinessRate) {
            track("HOT.HIS.cleanliness.".concat(cleanlinessRate), "Property cleanliness score");
        }
    }, [
        (_reviewSummaryDetails = reviewSummaryDetails) === null || _reviewSummaryDetails === void 0 ? void 0 : (_reviewSummaryDetails_ = _reviewSummaryDetails[0]) === null || _reviewSummaryDetails_ === void 0 ? void 0 : _reviewSummaryDetails_.formattedRatingOutOfMaxA11y.value
    ]);
    if (!reviewSummaryDetails || reviewSummaryDetails.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React91.createElement(UitkLayoutFlex19, {
        wrap: "wrap"
    }, reviewSummaryDetails.map(function(reviewSummaryDetailItem) {
        var formattedRatingOutOfMaxA11y = reviewSummaryDetailItem.formattedRatingOutOfMaxA11y, label = reviewSummaryDetailItem.label;
        var _formattedRatingOutOfMaxA11y_accessibilityLabel;
        return /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem13, {
            minWidth: "half_width",
            key: "category-".concat(label)
        }, /* @__PURE__ */ React91.createElement(UitkSpacing34, {
            margin: {
                block: "three"
            }
        }, /* @__PURE__ */ React91.createElement(UitkLayoutFlex19, {
            direction: "column"
        }, /* @__PURE__ */ React91.createElement(UitkHeading14, {
            "aria-label": (_formattedRatingOutOfMaxA11y_accessibilityLabel = formattedRatingOutOfMaxA11y.accessibilityLabel) !== null && _formattedRatingOutOfMaxA11y_accessibilityLabel !== void 0 ? _formattedRatingOutOfMaxA11y_accessibilityLabel : void 0,
            tag: "h3",
            size: 5
        }, formattedRatingOutOfMaxA11y.value), /* @__PURE__ */ React91.createElement(UitkText24, {
            size: 300
        }, label))));
    }));
};
SummaryDetails.displayName = "SummaryDetails";
SummaryDetails.fragment = fragment46;
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
import React93 from "react";
import { gql as gql84 } from "@apollo/client";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent5 } from "uitk-react-dialog";
import { UitkSheet as UitkSheet10 } from "uitk-react-sheet";
// ../internal/src/components/property-review-summary/__private/providers/property-filtered-reviews-dialog-provider.tsx
import React92 from "react";
var PropertyFilteredReviewsDialogContext = React92.createContext(void 0);
var usePropertyFilteredReviewsDialogContext = function() {
    var context = React92.useContext(PropertyFilteredReviewsDialogContext);
    if (context === void 0) {
        throw new Error("usePropertyFilteredReviewsDialogContext must be used with a PropertyFilteredReviewsDialogContext.Provider");
    }
    return context;
};
// ../internal/src/components/property-review-summary/__private/__fragments/property-filtered-reviews-dialog.tsx
var fragment47 = gql84(_templateObject84(), LodgingDialogTriggerMessage.fragment, EGDSDialogToolbar.fragment);
var PropertyFilteredReviewsDialog = function(param) {
    var _param_data = param.data, ratingPercentage = _param_data.ratingPercentage, trigger = _param_data.trigger;
    var PropertyFilteredReviewsDialogContent = usePropertyFilteredReviewsDialogContext().PropertyFilteredReviewsDialogContent;
    var _useDialog9 = _sliced_to_array(useDialog9("PropertyDetailsReviewsBreakdownDialog", "pwaDialogNested"), 3), isVisible = _useDialog9[0], _useDialog9_ = _useDialog9[1], openDialog = _useDialog9_.openDialog, closeDialog = _useDialog9_.closeDialog, ReviewsDialog = _useDialog9[2];
    var track = useClickTracker27();
    var linkRef = React93.useRef(null);
    var memoizedCloseDialog = React93.useCallback(function() {
        if (ratingPercentage.closeAnalytics) {
            var closeAnalytics = ratingPercentage.closeAnalytics;
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        closeDialog();
    }, [
        closeDialog,
        ratingPercentage,
        track
    ]);
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(LodgingDialogTriggerMessage, {
        onClickAction: openDialog,
        data: trigger,
        triggerRef: linkRef
    }), /* @__PURE__ */ React93.createElement(ReviewsDialog, null, /* @__PURE__ */ React93.createElement(UitkSheet10, {
        type: "full",
        isVisible: isVisible,
        triggerRef: linkRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React93.createElement(EGDSDialogToolbar, {
        toolbarType: "close",
        toolbarAction: memoizedCloseDialog,
        data: ratingPercentage.toolbar
    }), /* @__PURE__ */ React93.createElement(UitkDialogContent5, null, /* @__PURE__ */ React93.createElement(PropertyFilteredReviewsDialogContent, null)))));
};
PropertyFilteredReviewsDialog.displayName = "PropertyFilteredReviewsDialog";
PropertyFilteredReviewsDialog.fragment = fragment47;
// ../internal/src/components/property-review-summary/review-disclaimer.tsx
import React94, { useState as useState2 } from "react";
import { gql as gql85 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog10 } from "@shared-ui/dialog-context";
import { Experiment as Experiment9, ExperimentControl as ExperimentControl9, ExperimentVariant as ExperimentVariant9 } from "@shared-ui/experiment-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkExpandoPeek as UitkExpandoPeek5 } from "uitk-react-expando";
import { UitkIcon as UitkIcon17, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLink as UitkLink11 } from "uitk-react-link";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet11, UitkSheetContent as UitkSheetContent6 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing35 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph3, UitkText as UitkText25 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar8 } from "uitk-react-toolbar";
var fragment48 = gql85(_templateObject85());
var ReviewDisclaimer = function(param) {
    var reviewPage = param.reviewPage, data = param.data;
    var _reviewDisclaimer, _reviewDisclaimerValues;
    var _React94_useState = _sliced_to_array(React94.useState(false), 2), showMenu = _React94_useState[0], setShowMenu = _React94_useState[1];
    var reviewDisclaimer = data.reviewDisclaimer, reviewDisclaimerHeading = data.reviewDisclaimerHeading, reviewDisclaimerValues = data.reviewDisclaimerValues, reviewDisclaimerAccessibilityLabel = data.reviewDisclaimerAccessibilityLabel, reviewDisclaimerLabel = data.reviewDisclaimerLabel, reviewDisclaimerUrl = data.reviewDisclaimerUrl, reviewDisclaimerAnalytics = data.reviewDisclaimerAnalytics, strategy = data.strategy;
    var _useState2 = _sliced_to_array(useState2(false), 2), isVerifyReviewsAccordionOpen = _useState2[0], setIsVerifyReviewsAccordionOpen = _useState2[1];
    var _React94_useState1 = _sliced_to_array(React94.useState(false), 2), isVisible = _React94_useState1[0], setIsVisible = _React94_useState1[1];
    var _useDialog10 = _sliced_to_array(useDialog10("centered-sheet-necessary-dialog-layer"), 3), isDialogOpen = _useDialog10[0], dialogActions = _useDialog10[1], DialogComponent = _useDialog10[2];
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var context = useBexApi6().context;
    var isTabletOrBigger = viewSize === 0 ? context.device.type === "DESKTOP" || context.device.type === "MOBILE_TABLET" : viewSize > defaultViewSizes.SMALL;
    var sheetSize = isTabletOrBigger ? "small" : "medium";
    var openDialog = function() {
        dialogActions.openDialog();
    };
    var handleToolbarCloseAction = function() {
        dialogActions.closeDialog();
    };
    var clickTracker = useClickTracker28();
    if (!reviewDisclaimer || reviewDisclaimer.length === 0) {
        return null;
    }
    var handleReviewDisclaimerLabelClick = function() {
        if (!showMenu && reviewDisclaimerAnalytics && reviewPage) {
            clickTracker(reviewDisclaimerAnalytics.referrerId, reviewDisclaimerAnalytics.linkName);
        }
        setShowMenu(!showMenu);
    };
    var renderReviewDisclaimerVrbexGeneric = function() {
        var _reviewDisclaimer;
        return ((_reviewDisclaimer = reviewDisclaimer) === null || _reviewDisclaimer === void 0 ? void 0 : _reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React94.createElement(React94.Fragment, null, /* @__PURE__ */ React94.createElement(UitkSpacing35, {
            padding: {
                blockstart: "four",
                blockend: "two"
            }
        }, /* @__PURE__ */ React94.createElement(UitkText25, {
            weight: "regular",
            size: 200
        }, reviewDisclaimer)), /* @__PURE__ */ React94.createElement(UitkSpacing35, {
            padding: {
                blockend: "four"
            }
        }, reviewDisclaimerUrl && /* @__PURE__ */ React94.createElement(UitkLink11, null, /* @__PURE__ */ React94.createElement("a", {
            href: reviewDisclaimerUrl.link.url,
            target: "_blank",
            rel: "noreferrer noopener"
        }, reviewDisclaimerUrl.value, /* @__PURE__ */ React94.createElement("span", {
            className: "is-visually-hidden"
        }, reviewDisclaimerUrl.accessibilityLabel)))));
    };
    var reviewsDisclaimerView = ((_reviewDisclaimer = reviewDisclaimer) === null || _reviewDisclaimer === void 0 ? void 0 : _reviewDisclaimer.length) && reviewDisclaimerLabel;
    var ThirdPartyReviewDisclaimer = reviewsDisclaimerView && /* @__PURE__ */ React94.createElement(React94.Fragment, null, /* @__PURE__ */ React94.createElement(UitkText25, null, /* @__PURE__ */ React94.createElement(UitkSpacing35, null, /* @__PURE__ */ React94.createElement(UitkMoreInfoTrigger2, {
        onClick: openDialog,
        size: "medium",
        weight: "regular"
    }, /* @__PURE__ */ React94.createElement(UitkText25, {
        size: 300
    }, reviewDisclaimerLabel, /* @__PURE__ */ React94.createElement(UitkIcon17, {
        name: "info_outline"
    }))))), /* @__PURE__ */ React94.createElement(DialogComponent, null, /* @__PURE__ */ React94.createElement(UitkSheet11, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: sheetSize,
        triggerRef: null
    }, /* @__PURE__ */ React94.createElement(UitkToolbar8, {
        navigationContent: {
            onClick: handleToolbarCloseAction,
            navIconLabel: "close toolbar",
            navType: "close"
        }
    }), /* @__PURE__ */ React94.createElement(UitkSheetContent6, null, /* @__PURE__ */ React94.createElement(UitkText25, {
        weight: "bold",
        size: 400
    }, reviewDisclaimerHeading), /* @__PURE__ */ React94.createElement(UitkSpacing35, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React94.createElement(UitkExpandoPeek5, {
        isVisible: isVisible,
        handleClick: function() {
            return setIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        items: 1
    }, (_reviewDisclaimerValues = reviewDisclaimerValues) === null || _reviewDisclaimerValues === void 0 ? void 0 : _reviewDisclaimerValues.map(function(value, key) {
        return /* @__PURE__ */ React94.createElement(UitkParagraph3, {
            key: key
        }, value.text);
    })))))));
    var ReviewDisclaimerComponent = /* @__PURE__ */ React94.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: handleReviewDisclaimerLabelClick
    }, /* @__PURE__ */ React94.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React94.createElement(UitkLink11, null, /* @__PURE__ */ React94.createElement("button", {
        type: "button",
        "aria-label": reviewDisclaimerAccessibilityLabel !== null && reviewDisclaimerAccessibilityLabel !== void 0 ? reviewDisclaimerAccessibilityLabel : void 0
    }, reviewDisclaimerLabel, /* @__PURE__ */ React94.createElement(UitkSpacing35, {
        padding: {
            inline: "one",
            block: "half"
        }
    }, /* @__PURE__ */ React94.createElement(UitkIcon17, {
        name: "info_outline",
        size: UitkIconSize8.SMALL
    }))))), /* @__PURE__ */ React94.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 300
    }, /* @__PURE__ */ React94.createElement(UitkSpacing35, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React94.createElement(UitkParagraph3, {
        size: 1
    }, reviewDisclaimer, reviewDisclaimerUrl && /* @__PURE__ */ React94.createElement(UitkLink11, null, /* @__PURE__ */ React94.createElement("a", {
        href: reviewDisclaimerUrl.link.url,
        target: "_blank",
        rel: "noreferrer noopener"
    }, reviewDisclaimerUrl.value, /* @__PURE__ */ React94.createElement("span", {
        className: "is-visually-hidden"
    }, reviewDisclaimerUrl.accessibilityLabel)))))));
    return /* @__PURE__ */ React94.createElement(React94.Fragment, null, reviewsDisclaimerView && /* @__PURE__ */ React94.createElement(Experiment9, {
        name: "External_reviews_display_SRP_and_PDP"
    }, /* @__PURE__ */ React94.createElement(ExperimentControl9, null, ReviewDisclaimerComponent), /* @__PURE__ */ React94.createElement(ExperimentVariant9, {
        bucket: 1
    }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */  ? ThirdPartyReviewDisclaimer : ReviewDisclaimerComponent)), /* @__PURE__ */ React94.createElement(Experiment9, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React94.createElement(ExperimentControl9, null), /* @__PURE__ */ React94.createElement(ExperimentVariant9, {
        bucket: 1
    }, renderReviewDisclaimerVrbexGeneric())));
};
ReviewDisclaimer.displayName = "ReviewDisclaimer";
ReviewDisclaimer.fragment = fragment48;
// ../internal/src/components/property-review-summary/property-reviews-breakdown.tsx
var fragment49 = gql86(_templateObject86(), ReviewDisclaimer.fragment, SummaryDetails.fragment, RatingCounts.fragment, PropertyFilteredReviewsDialog.fragment);
var PropertyReviewsBreakdown = function(param) {
    var data = param.data, onClickLink = param.onClickLink, _param_withAggregateRating = param.withAggregateRating, withAggregateRating = _param_withAggregateRating === void 0 ? false : _param_withAggregateRating, reviewPage = param.reviewPage;
    var _reviewDisclaimer, _averageOverallRatingValue, _propertyReviewCountDetails, _propertyReviewCountDetails1;
    var averageOverallRating = data.averageOverallRating, averageOverallRatingValue = data.averageOverallRatingValue, superlative = data.superlative, propertyReviewCountDetails = data.propertyReviewCountDetails, reviewDisclaimer = data.reviewDisclaimer, totalCount = data.totalCount, seeAllAction = data.seeAllAction, reviewDisclaimerLabel = data.reviewDisclaimerLabel, strategy = data.strategy;
    var ratingValueProps = getStructuredDataProps("ratingValue", withAggregateRating);
    var aggregateRatingValueProps = getStructuredDataProps("aggregateRating", withAggregateRating);
    var reviewCountValueProps = getStructuredDataProps("reviewCount", withAggregateRating);
    var renderPropertyReviewBreakdownVrbexGeneric = function() {
        var _reviewDisclaimer;
        return totalCount.raw !== 0 && ((_reviewDisclaimer = reviewDisclaimer) === null || _reviewDisclaimer === void 0 ? void 0 : _reviewDisclaimer.length) && reviewDisclaimerLabel === null && /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem14, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React95.createElement(ReviewDisclaimer, {
            data: data,
            reviewPage: reviewPage
        }));
    };
    var reviewsDisclaimerView = ((_reviewDisclaimer = reviewDisclaimer) === null || _reviewDisclaimer === void 0 ? void 0 : _reviewDisclaimer.length) && reviewDisclaimerLabel;
    var ThirdPartyReviewsBreakdown = /* @__PURE__ */ React95.createElement("div", _object_spread({}, aggregateRatingValueProps), totalCount.raw !== 0 && /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, {
        space: "three",
        alignItems: "center"
    }, /* @__PURE__ */ React95.createElement(UitkText26, {
        weight: "regular",
        size: 900
    }, /* @__PURE__ */ React95.createElement("span", _object_spread({}, ratingValueProps), (_averageOverallRatingValue = averageOverallRatingValue) === null || _averageOverallRatingValue === void 0 ? void 0 : _averageOverallRatingValue.formatted)), /* @__PURE__ */ React95.createElement(UitkSpacing36, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, {
        direction: "column"
    }, /* @__PURE__ */ React95.createElement(UitkHeading15, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, null, seeAllAction && /* @__PURE__ */ React95.createElement(UitkSpacing36, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React95.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React95.createElement(UitkLink12, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React95.createElement("button", _object_spread({
        type: "button"
    }, reviewCountValueProps), (_propertyReviewCountDetails = propertyReviewCountDetails) === null || _propertyReviewCountDetails === void 0 ? void 0 : _propertyReviewCountDetails.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React95.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))));
    var RenderPropertyReviewsBreakdown = /* @__PURE__ */ React95.createElement("div", _object_spread({}, aggregateRatingValueProps), totalCount.raw !== 0 && /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, {
        space: "three"
    }, /* @__PURE__ */ React95.createElement(UitkText26, {
        weight: "regular",
        size: 900
    }, /* @__PURE__ */ React95.createElement("span", _object_spread({}, ratingValueProps), averageOverallRating.formatted)), /* @__PURE__ */ React95.createElement(UitkSpacing36, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, {
        direction: "column"
    }, /* @__PURE__ */ React95.createElement(UitkHeading15, {
        tag: "h3",
        size: 6
    }, superlative), /* @__PURE__ */ React95.createElement(UitkLayoutFlex20, null, /* @__PURE__ */ React95.createElement(UitkSpacing36, {
        padding: {
            block: "two"
        }
    }, seeAllAction ? /* @__PURE__ */ React95.createElement(PropertyFilteredReviewsDialog, {
        data: seeAllAction
    }) : /* @__PURE__ */ React95.createElement(UitkLink12, {
        onClick: onClickLink,
        size: "medium"
    }, /* @__PURE__ */ React95.createElement("button", _object_spread({
        type: "button"
    }, reviewCountValueProps), (_propertyReviewCountDetails1 = propertyReviewCountDetails) === null || _propertyReviewCountDetails1 === void 0 ? void 0 : _propertyReviewCountDetails1.shortDescription)))), reviewsDisclaimerView && /* @__PURE__ */ React95.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React95.createElement(ReviewDisclaimer, {
        data: data,
        reviewPage: reviewPage
    }))))), /* @__PURE__ */ React95.createElement(Experiment10, {
        name: "Vrbex_generic"
    }, /* @__PURE__ */ React95.createElement(ExperimentControl10, null), /* @__PURE__ */ React95.createElement(ExperimentVariant10, {
        bucket: 1
    }, renderPropertyReviewBreakdownVrbexGeneric())), /* @__PURE__ */ React95.createElement(RatingCounts, {
        data: data
    }), /* @__PURE__ */ React95.createElement(SummaryDetails, {
        data: data
    }));
    return /* @__PURE__ */ React95.createElement(Experiment10, {
        name: "External_reviews_display_SRP_and_PDP"
    }, /* @__PURE__ */ React95.createElement(ExperimentControl10, null, RenderPropertyReviewsBreakdown), /* @__PURE__ */ React95.createElement(ExperimentVariant10, {
        bucket: 1
    }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */  ? ThirdPartyReviewsBreakdown : RenderPropertyReviewsBreakdown));
};
PropertyReviewsBreakdown.displayName = "PropertyReviewsBreakdownFragment";
PropertyReviewsBreakdown.fragment = fragment49;
// src/components/property-info-details/__private/__fragments/property-details-reviews-breakdown.tsx
import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";
var fragment50 = gql87(_templateObject87(), PropertyReviewsBreakdown.fragment);
var PropertyDetailsReviewsBreakdown = function(param) {
    var data = param.data, inputs = param.inputs;
    var PropertyFilteredReviewsDialogContent = React96.memo(function() {
        return /* @__PURE__ */ React96.createElement(PropertyFilteredReviews, {
            inputs: _object_spread_props(_object_spread({}, inputs), {
                includeRecentReviews: true
            })
        });
    });
    PropertyFilteredReviewsDialogContent.displayName = "PropertyFilteredReviewsDialogContent";
    return /* @__PURE__ */ React96.createElement(PropertyFilteredReviewsDialogContext.Provider, {
        value: {
            PropertyFilteredReviewsDialogContent: PropertyFilteredReviewsDialogContent
        }
    }, /* @__PURE__ */ React96.createElement(PropertyReviewsBreakdown, {
        data: data
    }));
};
PropertyDetailsReviewsBreakdown.displayName = "PropertyDetailsReviewsBreakdown";
PropertyDetailsReviewsBreakdown.fragment = fragment50;
// src/components/property-info-details/property-info-details.tsx
var __Query3 = gql88(_templateObject88(), PropertyImageGallery.fragment, LodgingEGDSHeading.fragment, LodgingEGDSRating.fragment, PropertyDescriptionAndMoreInfoSection.fragment, PropertyDetailsReviewsBreakdown.fragment, PropertyContentSectionGroup.fragment, SummaryMapTrigger.fragment);
var propertyContentSectionGroupsMargin = {
    blockstart: "twelve"
};
var mapHeadingMargin = {
    blockend: "three"
};
var propertyDescriptionAndMoreInfoSectionMargin = {
    large: {
        inlinestart: "six",
        blockstart: "unset"
    },
    small: {
        blockstart: "three"
    }
};
var PropertyInfoDetails = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _data_propertyInfo_summary_nearbyPOIs_header, _data_propertyInfo_summary_nearbyPOIs, _data_propertyInfo_summary;
    var context = useBexApi7().context;
    var _useDialog11 = _sliced_to_array(useDialog11("propertyInfoDetailsMap", "pwaMapDialog"), 3), dialogActions = _useDialog11[1], MapDialogComponent = _useDialog11[2];
    var triggerRef = React97.useRef(null);
    var onClickMap = React97.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var onClose = React97.useCallback(function() {
        dialogActions.closeDialog();
    }, [
        dialogActions
    ]);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery4 = useQuery4(__Query3, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery4.data, loading = _useQuery4.loading;
    var propertyId = inputs.propertyId, shoppingContext = inputs.shoppingContext;
    var mapInputs = React97.useMemo(function() {
        return {
            propertyId: propertyId,
            shoppingContext: shoppingContext
        };
    }, [
        propertyId,
        shoppingContext
    ]);
    if (loading || !data) {
        return null;
    }
    var _data_propertyInfo_propertyDetails = data.propertyInfo.propertyDetails, heading = _data_propertyInfo_propertyDetails.heading, rating = _data_propertyInfo_propertyDetails.rating, gallery = _data_propertyInfo_propertyDetails.gallery;
    var _data_propertyInfo_propertyContentSectionGroups = data.propertyInfo.propertyContentSectionGroups, policies = _data_propertyInfo_propertyContentSectionGroups.policies, importantInfo = _data_propertyInfo_propertyContentSectionGroups.importantInfo;
    var mapHeading = (_data_propertyInfo_summary = data.propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : (_data_propertyInfo_summary_nearbyPOIs = _data_propertyInfo_summary.nearbyPOIs) === null || _data_propertyInfo_summary_nearbyPOIs === void 0 ? void 0 : (_data_propertyInfo_summary_nearbyPOIs_header = _data_propertyInfo_summary_nearbyPOIs.header) === null || _data_propertyInfo_summary_nearbyPOIs_header === void 0 ? void 0 : _data_propertyInfo_summary_nearbyPOIs_header.text;
    return /* @__PURE__ */ React97.createElement(PropertyInfoDetailsInputsContext.Provider, {
        value: inputs
    }, gallery && /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React97.createElement(PropertyImageGallery, {
        data: gallery,
        propertyId: inputs.propertyId
    })), /* @__PURE__ */ React97.createElement(LodgingEGDSHeading, {
        data: heading,
        tag: "h3",
        size: 3
    }), rating && /* @__PURE__ */ React97.createElement(LodgingEGDSRating, {
        data: rating
    }), /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(UitkLayoutGrid11, {
        columns: {
            large: [
                "1fr",
                "2fr"
            ]
        }
    }, /* @__PURE__ */ React97.createElement(UitkLayoutGridItem10, null, /* @__PURE__ */ React97.createElement("div", null, mapHeading && /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: mapHeadingMargin
    }, /* @__PURE__ */ React97.createElement(UitkHeading16, {
        tag: "h3",
        size: 5
    }, mapHeading)), /* @__PURE__ */ React97.createElement(Viewport15, null, /* @__PURE__ */ React97.createElement(ViewSmall15, null, /* @__PURE__ */ React97.createElement(SummaryMapTrigger, {
        onClickMap: onClickMap,
        data: data.propertyInfo
    })), /* @__PURE__ */ React97.createElement(ViewMedium9, null, /* @__PURE__ */ React97.createElement(SummaryMapTrigger, {
        onClickMap: onClickMap,
        data: data.propertyInfo,
        aspectRatio: UitkFigureAspectRatioType5.R4_1
    }))), data.propertyReviewSummaries.length === 1 && /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(PropertyDetailsReviewsBreakdown, {
        data: data.propertyReviewSummaries[0],
        inputs: inputs
    }))))), /* @__PURE__ */ React97.createElement(UitkLayoutGridItem10, null, /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: propertyDescriptionAndMoreInfoSectionMargin
    }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(PropertyDescriptionAndMoreInfoSection, {
        data: data.propertyInfo.propertyDetails
    }))))))), /* @__PURE__ */ React97.createElement(UitkSpacing37, {
        margin: propertyContentSectionGroupsMargin
    }, /* @__PURE__ */ React97.createElement(UitkLayoutGrid11, null, policies && /* @__PURE__ */ React97.createElement(PropertyContentSectionGroup, {
        data: policies,
        isCardComponent: false
    }), importantInfo && /* @__PURE__ */ React97.createElement(PropertyContentSectionGroup, {
        data: importantInfo,
        isCardComponent: false
    }))), /* @__PURE__ */ React97.createElement(MapDialogComponent, null, /* @__PURE__ */ React97.createElement(Map, {
        inputs: mapInputs,
        triggerRef: triggerRef,
        onClose: onClose
    })));
};
PropertyInfoDetails.displayName = "sharedui-PropertyInfoDetails";
// src/components/similar-properties/similar-properties.tsx
import React109 from "react";
import { gql as gql99, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi8 } from "@shared-ui/bex-api-context";
// src/components/similar-properties/__private/__fragments/similar-properties-footer.tsx
import React98 from "react";
import { gql as gql89 } from "@apollo/client";
import { UitkSpacing as UitkSpacing38 } from "uitk-react-spacing";
import { UitkText as UitkText27 } from "uitk-react-text";
var __SimilarPropertiesFooterFragment = gql89(_templateObject89());
var SimilarPropertiesFooter = function(param) {
    var data = param.data;
    var footer = data.footer;
    return /* @__PURE__ */ React98.createElement(UitkSpacing38, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React98.createElement(UitkText27, {
        size: 200,
        theme: "default"
    }, footer));
};
SimilarPropertiesFooter.fragment = __SimilarPropertiesFooterFragment;
SimilarPropertiesFooter.displayName = "SimilarPropertiesFooter";
// src/components/similar-properties/__private/__fragments/similar-properties-header.tsx
import React99 from "react";
import { gql as gql90 } from "@apollo/client";
import { UitkHeading as UitkHeading17 } from "uitk-react-text";
var __SimilarPropertiesHeaderFragment = gql90(_templateObject90());
var SimilarPropertiesHeader = function(param) {
    var data = param.data;
    var header = data.header;
    return /* @__PURE__ */ React99.createElement(UitkHeading17, {
        tag: "h3",
        size: 4
    }, header);
};
SimilarPropertiesHeader.fragment = __SimilarPropertiesHeaderFragment;
SimilarPropertiesHeader.displayName = "SimilarPropertiesHeader";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
import React107 from "react";
import { gql as gql98 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker7, useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-egds-image/lodging-egds-image.tsx
import React100 from "react";
import { gql as gql91 } from "@apollo/client";
import { UitkFigure as UitkFigure4, UitkImage as UitkImage4 } from "uitk-react-images";
var fragment51 = gql91(_templateObject91());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React100.createElement(UitkFigure4, _object_spread({}, figureProps), /* @__PURE__ */ React100.createElement(UitkImage4, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad
    }));
};
LodgingEGDSImage.fragment = fragment51;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// ../internal/src/components/lodging-header/lodging-header.tsx
import React101 from "react";
import { gql as gql92 } from "@apollo/client";
import { UitkHeading as UitkHeading18, UitkText as UitkText28 } from "uitk-react-text";
var fragment52 = gql92(_templateObject92());
var LodgingHeader = function(param) {
    var data = param.data;
    var text = data.text, label = data.label, subText = data.subText;
    return /* @__PURE__ */ React101.createElement(React101.Fragment, null, /* @__PURE__ */ React101.createElement(UitkText28, {
        size: 200,
        theme: "default"
    }, subText), /* @__PURE__ */ React101.createElement(UitkHeading18, {
        tag: "h4",
        size: 7,
        overflow: "truncate-2-lines"
    }, text), /* @__PURE__ */ React101.createElement(UitkText28, {
        size: 200,
        theme: "default"
    }, label));
};
LodgingHeader.fragment = fragment52;
LodgingHeader.displayName = "LodgingHeaderFragment";
// ../internal/src/components/property-reviews-summary/property-reviews-summary.tsx
import React102 from "react";
import { gql as gql93 } from "@apollo/client";
import { UitkSpacing as UitkSpacing39 } from "uitk-react-spacing";
import { UitkText as UitkText29 } from "uitk-react-text";
var fragment53 = gql93(_templateObject93());
var PropertyReviewsSummary = function(param) {
    var data = param.data;
    var _localizedSubtitleA11y;
    var localizedScore = data.localizedScore, localizedSubtitleA11y = data.localizedSubtitleA11y, localizedTotal = data.localizedTotal;
    return /* @__PURE__ */ React102.createElement(React102.Fragment, null, /* @__PURE__ */ React102.createElement(UitkSpacing39, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React102.createElement("div", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React102.createElement(UitkText29, {
        size: 200,
        theme: "default"
    }, /* @__PURE__ */ React102.createElement(UitkSpacing39, {
        padding: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React102.createElement(UitkText29, {
        weight: "bold",
        theme: "emphasis",
        inline: true
    }, localizedScore)), localizedTotal))), ((_localizedSubtitleA11y = localizedSubtitleA11y) === null || _localizedSubtitleA11y === void 0 ? void 0 : _localizedSubtitleA11y.accessibilityLabel) && /* @__PURE__ */ React102.createElement("span", {
        className: "is-visually-hidden"
    }, localizedSubtitleA11y.accessibilityLabel));
};
PropertyReviewsSummary.fragment = fragment53;
PropertyReviewsSummary.displayName = "PropertyReviewsSummary";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType7 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex23, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing43 } from "uitk-react-spacing";
// src/components/similar-properties/utility/analytics.ts
var getRecommendation = function(name, index, imageUrl, price, propertyId) {
    var _price_price_options_, _price_price_options, _price_price, _price, _displayPrice_currencyInfo, _displayPrice, _displayPrice1, _displayPrice_currencyInfo1, _displayPrice2;
    var displayPrice = (_price = price) === null || _price === void 0 ? void 0 : (_price_price = _price.price) === null || _price_price === void 0 ? void 0 : (_price_price_options = _price_price.options) === null || _price_price_options === void 0 ? void 0 : (_price_price_options_ = _price_price_options[0]) === null || _price_price_options_ === void 0 ? void 0 : _price_price_options_.displayPrice;
    return {
        recommendationId: propertyId,
        rank: index,
        presentationDetails: _object_spread({
            name: name,
            imageUrl: imageUrl,
            badges: ""
        }, ((_displayPrice = displayPrice) === null || _displayPrice === void 0 ? void 0 : (_displayPrice_currencyInfo = _displayPrice.currencyInfo) === null || _displayPrice_currencyInfo === void 0 ? void 0 : _displayPrice_currencyInfo.name) && {
            price: {
                displayPrice: (_displayPrice1 = displayPrice) === null || _displayPrice1 === void 0 ? void 0 : _displayPrice1.amount,
                currency: (_displayPrice2 = displayPrice) === null || _displayPrice2 === void 0 ? void 0 : (_displayPrice_currencyInfo1 = _displayPrice2.currencyInfo) === null || _displayPrice_currencyInfo1 === void 0 ? void 0 : _displayPrice_currencyInfo1.name
            }
        })
    };
};
var getRecommendations = function(results) {
    var _results;
    return (_results = results) === null || _results === void 0 ? void 0 : _results.map(function(resultItem, index) {
        var _resultItem_title, _resultItem, _resultItem_image_image, _resultItem_image, _resultItem1, _resultItem2;
        return getRecommendation((_resultItem = resultItem) === null || _resultItem === void 0 ? void 0 : (_resultItem_title = _resultItem.title) === null || _resultItem_title === void 0 ? void 0 : _resultItem_title.text, index, (_resultItem1 = resultItem) === null || _resultItem1 === void 0 ? void 0 : (_resultItem_image = _resultItem1.image) === null || _resultItem_image === void 0 ? void 0 : (_resultItem_image_image = _resultItem_image.image) === null || _resultItem_image_image === void 0 ? void 0 : _resultItem_image_image.url, resultItem.price, (_resultItem2 = resultItem) === null || _resultItem2 === void 0 ? void 0 : _resultItem2.propertyId);
    });
};
var getRecommendationSeenMessage = function(egrResponseId, header, properties, from, to, scroll) {
    var _getRecommendations, _recommendations;
    var recommendations = (_getRecommendations = getRecommendations(properties)) === null || _getRecommendations === void 0 ? void 0 : _getRecommendations.slice(from, to + 1);
    var recommendationEvent = {
        eventType: "recommendationInteraction",
        eventName: "recommendationSeen",
        egRecommendationResponseId: egrResponseId,
        recommendationTitle: header,
        component: "carousel",
        componentElement: "thumbnail",
        scroll: scroll,
        recommendations: recommendations
    };
    return ((_recommendations = recommendations) === null || _recommendations === void 0 ? void 0 : _recommendations.length) ? [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ] : void 0;
};
var getRecommendationClickedMessage = function(index, egrResponseId, name, imageUrl, header, price, propertyId) {
    var recommendationEvent = {
        eventType: "recommendationInteraction",
        eventName: "recommendationClicked",
        egRecommendationResponseId: egrResponseId,
        recommendationTitle: header,
        component: "carousel",
        componentElement: "thumbnail",
        recommendations: [
            getRecommendation(name, index, imageUrl, price, propertyId)
        ]
    };
    return [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ];
};
// src/components/similar-properties/__private/__fragments/similar-properties-action.tsx
import React103 from "react";
import { gql as gql94 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics4, useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useRefTargetScroll as useRefTargetScroll3 } from "@shared-ui/ref-context";
import { UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
var __SimilarPropertiesActionFragment = gql94(_templateObject94());
var SimilarPropertiesAction = function(props) {
    var _title, _action_actionDetails, _action;
    var data = props.data, index = props.index, header = props.header, recommendationsResponseId = props.recommendationsResponseId, scrollToTarget = props.scrollTo;
    var action = data.action, title = data.title, image = data.image, price = data.price, propertyId = data.propertyId;
    var scrollTo = useRefTargetScroll3().scrollTo;
    var trackerEvent = useClickTracker29();
    var _useClickstreamAnalytics4 = useClickstreamAnalytics4(), clickStreamTrack = _useClickstreamAnalytics4.track;
    var referrerId = React103.useMemo(function() {
        var _action;
        var rfrrId = ((_action = action) === null || _action === void 0 ? void 0 : _action.referrerId) || "HOT.HIS.SIMILAR.PROPERTIES.DATELESS";
        return "".concat(rfrrId, ".").concat(index, ".click");
    }, [
        action,
        index
    ]);
    var isCurrentViewingProperty = referrerId.includes("RESERVE");
    var trackEvent = React103.useCallback(function() {
        var _title, _image_image, _image;
        var additionalUisPrimeMicroMessages2 = getRecommendationClickedMessage(index, recommendationsResponseId, (_title = title) === null || _title === void 0 ? void 0 : _title.text, (_image = image) === null || _image === void 0 ? void 0 : (_image_image = _image.image) === null || _image_image === void 0 ? void 0 : _image_image.url, header, price, propertyId);
        var idType = referrerId.includes("NEARBY") ? "nearby" : "similar";
        trackerEvent(referrerId, "Property ".concat(idType, " Carousel"), void 0, recommendationsResponseId ? additionalUisPrimeMicroMessages2 : void 0);
    }, [
        trackerEvent,
        referrerId,
        index,
        (_title = title) === null || _title === void 0 ? void 0 : _title.text,
        image,
        header,
        price,
        recommendationsResponseId,
        propertyId,
        clickStreamTrack
    ]);
    var clickToScroll = React103.useCallback(function(e) {
        if (scrollToTarget) {
            e.preventDefault();
            scrollTo(scrollToTarget, []);
        }
    }, [
        scrollTo,
        scrollToTarget
    ]);
    var buttonProps = {
        href: action.linkUrl,
        onClickCapture: isCurrentViewingProperty && scrollToTarget ? clickToScroll : trackEvent
    };
    return /* @__PURE__ */ React103.createElement(UitkCardLink2, null, /* @__PURE__ */ React103.createElement("a", _object_spread_props(_object_spread({}, buttonProps), {
        rel: "noopener",
        target: "_blank"
    }), (_action = action) === null || _action === void 0 ? void 0 : (_action_actionDetails = _action.actionDetails) === null || _action_actionDetails === void 0 ? void 0 : _action_actionDetails.accessibilityLabel));
};
SimilarPropertiesAction.fragment = __SimilarPropertiesActionFragment;
SimilarPropertiesAction.displayName = "SimilarPropertiesAction";
// src/components/similar-properties/__private/__fragments/similar-properties-items.tsx
import React105 from "react";
import { gql as gql96 } from "@apollo/client";
// ../internal/src/components/lodging-enriched-message/lodging-enriched-message.tsx
import React104 from "react";
import { gql as gql95 } from "@apollo/client";
import { UitkIcon as UitkIcon18, UitkIconSize as UitkIconSize9 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex21 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid12, UitkLayoutGridItem as UitkLayoutGridItem11 } from "uitk-react-layout-grid";
import { UitkMark as UitkMark4, UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing40 } from "uitk-react-spacing";
import { UitkText as UitkText30 } from "uitk-react-text";
import { UitkUnformattedHtml as UitkUnformattedHtml2 } from "uitk-react-unformatted-html";
var fragment54 = gql95(_templateObject95());
var highlightedMessagesThemeToUitkTextTheme = {
    AGGRESSIVE: "negative",
    HIGHLIGHT: "positive",
    LOYALTY: "loyalty"
};
var highlightedMessagesThemeToUitkTextWeight = {
    STRONG: "bold"
};
var LodgingEnrichedMessage = function(param) {
    var data = param.data, markSize = param.markSize, textSize = param.textSize;
    var _egdsMark_url;
    var subText = data.subText, value = data.value, theme = data.theme, icon = data.icon, mark = data.mark, egdsMark = data.egdsMark, state = data.state, accessibilityLabel = data.accessibilityLabel;
    if (!value) {
        return null;
    }
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React104.createElement("span", null, /* @__PURE__ */ React104.createElement(UitkText30, {
            size: textSize,
            weight: stateTheme && highlightedMessagesThemeToUitkTextWeight[stateTheme] || void 0,
            theme: stateTheme && highlightedMessagesThemeToUitkTextTheme[stateTheme] || void 0
        }, props.children));
    };
    var stateTheme = state || theme;
    return /* @__PURE__ */ React104.createElement(UitkLayoutGrid12, null, /* @__PURE__ */ React104.createElement(UitkLayoutGridItem11, null, /* @__PURE__ */ React104.createElement(UitkLayoutFlex21, {
        alignItems: "center"
    }, mark && !egdsMark && /* @__PURE__ */ React104.createElement(UitkSpacing40, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React104.createElement(UitkMark4, {
        name: mark.id,
        size: markSize
    })), icon && /* @__PURE__ */ React104.createElement(UitkSpacing40, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React104.createElement(UitkIcon18, {
        name: icon.id,
        size: icon.size ? UitkIconSize9[icon.size] : UitkIconSize9.MEDIUM,
        theme: icon.theme || "default"
    })), egdsMark && /* @__PURE__ */ React104.createElement(UitkSpacing40, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React104.createElement(UitkMark4, {
        url: (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value,
        size: markSize !== null && markSize !== void 0 ? markSize : UitkMarkSize3.MEDIUM
    })), accessibilityLabel && /* @__PURE__ */ React104.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React104.createElement("div", null, /* @__PURE__ */ React104.createElement(UitkUnformattedHtml2, {
        htmlToParse: value,
        plainTextElement: plainTextElement
    })))), subText && /* @__PURE__ */ React104.createElement(UitkLayoutGridItem11, null, /* @__PURE__ */ React104.createElement(UitkText30, {
        size: 200,
        theme: "default"
    }, subText)));
};
LodgingEnrichedMessage.fragment = fragment54;
LodgingEnrichedMessage.displayName = "LodgingEnrichedMessage";
// src/components/similar-properties/__private/__fragments/similar-properties-items.tsx
import { UitkLayoutFlex as UitkLayoutFlex22, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing41 } from "uitk-react-spacing";
var fragment55 = gql96(_templateObject96(), LodgingEnrichedMessage.fragment);
var SimilarPropertiesItems = function(param) {
    var data = param.data;
    var amenities = data.items;
    if (!amenities || amenities.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React105.createElement(UitkSpacing41, {
        margin: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React105.createElement("div", null, /* @__PURE__ */ React105.createElement(UitkLayoutFlex22, {
        direction: "column"
    }, amenities.map(function(amenity, idx) {
        return amenity && /* @__PURE__ */ React105.createElement(UitkLayoutFlexItem15, {
            key: "prop-items-".concat(idx)
        }, /* @__PURE__ */ React105.createElement(LodgingEnrichedMessage, {
            data: amenity,
            textSize: 200
        }));
    }))));
};
SimilarPropertiesItems.fragment = fragment55;
SimilarPropertiesItems.displayName = "SimilarPropertiesItems";
// src/components/similar-properties/__private/__fragments/similar-properties-price.tsx
import React106 from "react";
import { gql as gql97 } from "@apollo/client";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing42 } from "uitk-react-spacing";
import { UitkText as UitkText31 } from "uitk-react-text";
var __SimilarPropertiesPriceFragment = gql97(_templateObject97());
var SimilarPropertiesPrice = function(param) {
    var data = param.data;
    var _price_price_options, _price, _price1, _price_qualifier, _price2, _price_subText, _price3, _options__displayPrice, _options__displayPrice1;
    var price = data.price;
    var options = ((_price = price) === null || _price === void 0 ? void 0 : (_price_price_options = _price.price.options) === null || _price_price_options === void 0 ? void 0 : _price_price_options.length) && ((_price1 = price) === null || _price1 === void 0 ? void 0 : _price1.price.options);
    if (!options || !options.length) return null;
    var qualifier = ((_price2 = price) === null || _price2 === void 0 ? void 0 : (_price_qualifier = _price2.qualifier) === null || _price_qualifier === void 0 ? void 0 : _price_qualifier.value) || "";
    var subText = ((_price3 = price) === null || _price3 === void 0 ? void 0 : (_price_subText = _price3.subText) === null || _price_subText === void 0 ? void 0 : _price_subText.text) || "";
    return /* @__PURE__ */ React106.createElement(React106.Fragment, null, options[0].leadingCaption && /* @__PURE__ */ React106.createElement(UitkText31, {
        size: 100,
        theme: "default"
    }, options[0].leadingCaption), /* @__PURE__ */ React106.createElement(UitkSpacing42, {
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React106.createElement(UitkPriceLockup, {
        align: UitkPriceLockupAlign.LEFT,
        lockupPrice: (_options__displayPrice = options[0].displayPrice) === null || _options__displayPrice === void 0 ? void 0 : _options__displayPrice.formatted,
        priceSubtextFirst: "".concat(qualifier, " ").concat(subText),
        a11yPrice: "".concat((_options__displayPrice1 = options[0].displayPrice) === null || _options__displayPrice1 === void 0 ? void 0 : _options__displayPrice1.formatted, " ").concat(qualifier, " ").concat(subText),
        stids: {
            lockupId: "simlar_properties_lockup_price"
        }
    })));
};
SimilarPropertiesPrice.fragment = __SimilarPropertiesPriceFragment;
SimilarPropertiesPrice.displayName = "SimilarPropertiesPrice";
// src/components/similar-properties/__private/__fragments/similar-properties-properties.tsx
var __SimilarPropertiesPropertiesFragment = gql98(_templateObject98(), LodgingHeader.fragment, LodgingEGDSImage.fragment, LodgingEGDSGraphicText.fragment, PropertyReviewsSummary.fragment, SimilarPropertiesItems.fragment, SimilarPropertiesPrice.fragment, SimilarPropertiesAction.fragment);
var SimilarPropertiesProperties = function(param) {
    var data = param.data, scrollTo = param.scrollTo, lazyLoadImages = param.lazyLoadImages;
    var trackEvent = function trackEvent(index, propertiesToTrack, lastShownPropertyIndex) {
        var _lodgingRecommendationClickstreamEvent;
        if (((_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId) && index > lastShownPropertyIndex) {
            var microMessages = getRecommendationSeenMessage(lodgingRecommendationClickstreamEvent.recommendationResponseId, header, propertiesToTrack, index, index, lastIndex.current < index ? "right" : "left");
            if (microMessages) {
                trackerEvent("".concat(referrerId, ".scroll"), linkName, void 0, microMessages);
            }
            lastIndex.current = index;
        }
    };
    var _properties__action_referrerId, _properties__action, _properties_, _properties, _splitReferId, _splitReferId1, _properties__action_referrerId1, _properties__action1, _lodgingRecommendationClickstreamEvent, _galleryCarousel, _galleryCarousel1;
    var properties = data.properties, header = data.header, lodgingRecommendationClickstreamEvent = data.lodgingRecommendationClickstreamEvent, galleryCarousel = data.galleryCarousel;
    var splitReferId = ((_properties = properties) === null || _properties === void 0 ? void 0 : (_properties_ = _properties[0]) === null || _properties_ === void 0 ? void 0 : (_properties__action = _properties_.action) === null || _properties__action === void 0 ? void 0 : (_properties__action_referrerId = _properties__action.referrerId) === null || _properties__action_referrerId === void 0 ? void 0 : _properties__action_referrerId.split(".")) || [];
    var carouselType = ((_splitReferId = splitReferId) === null || _splitReferId === void 0 ? void 0 : _splitReferId[2]) || "SIMILAR";
    var linkName = "Property ".concat(carouselType.toLowerCase(), " Carousel");
    var datedType = ((_splitReferId1 = splitReferId) === null || _splitReferId1 === void 0 ? void 0 : _splitReferId1[4]) || "DATELESS";
    var referrerId = "HOT.HIS.".concat(carouselType, ".PROPERTIES.").concat(datedType);
    var hasCurrentViewingProperty = (_properties__action1 = properties[0].action) === null || _properties__action1 === void 0 ? void 0 : (_properties__action_referrerId1 = _properties__action1.referrerId) === null || _properties__action_referrerId1 === void 0 ? void 0 : _properties__action_referrerId1.includes("RESERVE");
    var trackerEvent = useClickTracker30();
    var lastIndex = React107.useRef(0);
    var viewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    var propertiesToShow = React107.useMemo(function() {
        if (viewSize !== defaultViewSizes2.LARGE && viewSize !== defaultViewSizes2.EXTRA_LARGE) {
            return viewSize === defaultViewSizes2.SMALL ? 2 : 3;
        }
        return 5;
    }, [
        viewSize
    ]);
    var getRecommendationMicroMessages = React107.useMemo(function() {
        var _lodgingRecommendationClickstreamEvent;
        var trackingProperties = hasCurrentViewingProperty ? properties.slice(1) : properties;
        var trackingTo = hasCurrentViewingProperty ? propertiesToShow - 1 : propertiesToShow;
        return ((_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId) ? getRecommendationSeenMessage(lodgingRecommendationClickstreamEvent.recommendationResponseId, header, trackingProperties, 0, trackingTo, "") : void 0;
    }, [
        properties,
        propertiesToShow
    ]);
    var itemViewedCallback = React107.useCallback(function(index) {
        if (hasCurrentViewingProperty) {
            if (index > 0) {
                trackEvent(index - 1, properties.slice(1), propertiesToShow - 1);
            }
            return;
        }
        trackEvent(index, properties, propertiesToShow);
    }, [
        header,
        properties,
        trackerEvent,
        propertiesToShow,
        (_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId
    ]);
    if (!properties.length) {
        return null;
    }
    var _galleryCarousel_nextButtonText;
    var carouselNextButtonText = (_galleryCarousel_nextButtonText = (_galleryCarousel = galleryCarousel) === null || _galleryCarousel === void 0 ? void 0 : _galleryCarousel.nextButtonText) !== null && _galleryCarousel_nextButtonText !== void 0 ? _galleryCarousel_nextButtonText : "";
    var _galleryCarousel_previousButtonText;
    var carouselPrevButtonText = (_galleryCarousel_previousButtonText = (_galleryCarousel1 = galleryCarousel) === null || _galleryCarousel1 === void 0 ? void 0 : _galleryCarousel1.previousButtonText) !== null && _galleryCarousel_previousButtonText !== void 0 ? _galleryCarousel_previousButtonText : "";
    var lazyLoad = lazyLoadImages ? "lazy" : "off";
    return /* @__PURE__ */ React107.createElement(IntersectionTracker7, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getRecommendationMicroMessages
    }, /* @__PURE__ */ React107.createElement(UitkSpacing43, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React107.createElement(UitkCarousel, {
        buttonText: {
            nextButton: carouselNextButtonText,
            prevButton: carouselPrevButtonText
        },
        itemsVisible: {
            lg: 5,
            md: 3,
            sm: 2
        },
        itemViewedCallback: itemViewedCallback,
        pageBy: 1,
        peek: true,
        wrapItems: false
    }, properties.map(function(item, index) {
        var _lodgingRecommendationClickstreamEvent;
        return item && /* @__PURE__ */ React107.createElement(UitkLayoutFlex23, {
            key: "".concat(item.title.text, "-").concat(index),
            tag: "li"
        }, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem16, {
            grow: 1
        }, /* @__PURE__ */ React107.createElement(UitkCard5, null, /* @__PURE__ */ React107.createElement(SimilarPropertiesAction, {
            data: item,
            index: hasCurrentViewingProperty ? index - 1 : index,
            header: header,
            recommendationsResponseId: (_lodgingRecommendationClickstreamEvent = lodgingRecommendationClickstreamEvent) === null || _lodgingRecommendationClickstreamEvent === void 0 ? void 0 : _lodgingRecommendationClickstreamEvent.recommendationResponseId,
            scrollTo: scrollTo
        }), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem16, {
            grow: 1
        }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex23, {
            direction: "column",
            blockSize: "full_size"
        }, /* @__PURE__ */ React107.createElement(React107.Fragment, null, item.image && /* @__PURE__ */ React107.createElement(LodgingEGDSImage, {
            data: item.image.image,
            ratio: UitkFigureAspectRatioType7.R16_9,
            lazyLoad: lazyLoad,
            "data-stid": "SimilarPropertiesImage"
        }), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem16, {
            grow: 1,
            className: "uitk-layout-flex"
        }, /* @__PURE__ */ React107.createElement(UitkCardContentSection6, null, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem16, {
            grow: 1
        }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex23, {
            direction: "column"
        }, /* @__PURE__ */ React107.createElement(React107.Fragment, null, /* @__PURE__ */ React107.createElement(UitkSpacing43, {
            margin: {
                blockend: "one"
            }
        }, /* @__PURE__ */ React107.createElement("div", null, item.featuredMessages.map(function(graphicText, i) {
            return /* @__PURE__ */ React107.createElement(LodgingEGDSGraphicText, {
                key: i,
                data: graphicText,
                textProps: {
                    theme: "emphasis",
                    weight: "medium"
                }
            });
        }))), /* @__PURE__ */ React107.createElement(LodgingHeader, {
            data: item.title
        }), /* @__PURE__ */ React107.createElement(SimilarPropertiesItems, {
            data: item
        }), item.reviews && /* @__PURE__ */ React107.createElement(PropertyReviewsSummary, {
            data: item.reviews
        }), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem16, {
            grow: 1
        }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex23, {
            direction: "column",
            justifyContent: "end"
        }, /* @__PURE__ */ React107.createElement(SimilarPropertiesPrice, {
            data: item
        }))))))))))))));
    }))));
};
SimilarPropertiesProperties.fragment = __SimilarPropertiesPropertiesFragment;
SimilarPropertiesProperties.displayName = "SimilarPropertiesProperties";
// src/components/similar-properties/similar-properties-placeholder.tsx
import React108 from "react";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection7 } from "uitk-react-cards";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
import { UitkFigure as UitkFigure5, UitkFigureAspectRatioType as UitkFigureAspectRatioType8 } from "uitk-react-images";
import { UitkBlockSkeleton, UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing44 } from "uitk-react-spacing";
var carouselProps = {
    carouselName: "SimilarPropertiesPlaceholderCarousel",
    itemsVisible: {
        sm: 2,
        md: 3,
        lg: 4,
        xl: 5
    },
    pageBy: 1,
    peek: true,
    wrapItems: false,
    buttonText: {
        nextButton: "",
        prevButton: ""
    }
};
var numberOfPlaceholders = 6;
var SimilarPropertiesPlaceholder = function() {
    return /* @__PURE__ */ React108.createElement(UitkCarousel2, _object_spread({}, carouselProps), _to_consumable_array(Array(numberOfPlaceholders)).map(function(_, index) {
        return /* @__PURE__ */ React108.createElement("div", {
            key: "similar-properties-placeholder-".concat(index)
        }, /* @__PURE__ */ React108.createElement(UitkCard6, {
            padded: true
        }, /* @__PURE__ */ React108.createElement(UitkFigure5, {
            ratio: UitkFigureAspectRatioType8.R16_9,
            className: "uitk-card-roundcorner-all"
        }, /* @__PURE__ */ React108.createElement(UitkBlockSkeleton, null)), /* @__PURE__ */ React108.createElement(UitkCardContentSection7, {
            padded: false
        }, /* @__PURE__ */ React108.createElement(UitkSpacing44, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React108.createElement(UitkLineSkeleton, {
            animation: true
        })), /* @__PURE__ */ React108.createElement(UitkSpacing44, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React108.createElement(UitkLineSkeleton, {
            animation: true
        })), /* @__PURE__ */ React108.createElement(UitkSpacing44, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React108.createElement(UitkLineSkeleton, {
            animation: true,
            type: "secondary"
        })), /* @__PURE__ */ React108.createElement(UitkSpacing44, {
            margin: {
                block: "four"
            }
        }, /* @__PURE__ */ React108.createElement(UitkLineSkeleton, {
            animation: true,
            type: "secondary"
        })))));
    }));
};
// src/components/similar-properties/similar-properties.tsx
var __Query4 = gql99(_templateObject99(), SimilarPropertiesHeader.fragment, SimilarPropertiesProperties.fragment, SimilarPropertiesFooter.fragment);
var SimilarProperties = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, scrollTo = param.scrollTo, lazyLoadImages = param.lazyLoadImages;
    var _data_propertyInfo, _data, _similarProperties;
    var context = useBexApi8().context;
    var variables = _object_spread({
        context: context
    }, inputs);
    var _useQuery5 = useQuery5(__Query4, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), loading = _useQuery5.loading, data = _useQuery5.data;
    if (loading) {
        return /* @__PURE__ */ React109.createElement(SimilarPropertiesPlaceholder, null);
    }
    var similarProperties = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyInfo = _data.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : _data_propertyInfo.similarProperties;
    if (!((_similarProperties = similarProperties) === null || _similarProperties === void 0 ? void 0 : _similarProperties.properties.length)) {
        return null;
    }
    return /* @__PURE__ */ React109.createElement("div", {
        "data-testid": "similar-properties"
    }, /* @__PURE__ */ React109.createElement(SimilarPropertiesHeader, {
        data: similarProperties
    }), /* @__PURE__ */ React109.createElement(SimilarPropertiesProperties, {
        data: similarProperties,
        scrollTo: scrollTo,
        lazyLoadImages: lazyLoadImages
    }), /* @__PURE__ */ React109.createElement(SimilarPropertiesFooter, {
        data: similarProperties
    }));
};
SimilarProperties.displayName = "SimilarProperties";
var PropertySimilar = function(props) {
    return SimilarProperties(props);
};
// src/components/property-spaces/property-spaces.tsx
import React110 from "react";
import { gql as gql100, useQuery as useQuery6 } from "@apollo/client";
import { useBexApi as useBexApi9 } from "@shared-ui/bex-api-context";
var __Query5 = gql100(_templateObject100(), PropertyContentSectionGroup.fragment);
var PropertySpaces = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _detailed_sections, _detailed;
    var context = useBexApi9().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery6 = useQuery6(__Query5, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery6.data, loading = _useQuery6.loading;
    if (loading || !data) {
        return null;
    }
    var summary = data.summary, detailed = data.detailed;
    if (!summary) {
        return null;
    }
    var detailedDialogContent = ((_detailed = detailed) === null || _detailed === void 0 ? void 0 : (_detailed_sections = _detailed.sections) === null || _detailed_sections === void 0 ? void 0 : _detailed_sections.length) ? /* @__PURE__ */ React110.createElement(React110.Fragment, null, detailed.sections.map(function(section, index) {
        return /* @__PURE__ */ React110.createElement(PropertyContentSection, {
            data: section,
            columns: 1,
            key: "detailed-section-".concat(index),
            isInDialog: true,
            actionId: "spaces"
        });
    })) : void 0;
    return /* @__PURE__ */ React110.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React110.createElement(PropertyContentSectionGroup, {
        data: summary,
        columns: 1,
        actionId: "spaces"
    }));
};
PropertySpaces.displayName = "PropertySpaces";
// src/components/property-details.tsx
import React166, { useContext as useContext2, useEffect as useEffect4 } from "react";
import { gql as gql146, useQuery as useQuery8 } from "@apollo/client";
import { useBexApi as useBexApi13 } from "@shared-ui/bex-api-context";
// src/components/amenities-simplified-view/amenities-simplified-view.tsx
import React111 from "react";
import { gql as gql101 } from "@apollo/client";
import { UitkSpacing as UitkSpacing45 } from "uitk-react-spacing";
var __AmenitiesSimplifiedViewFragment = gql101(_templateObject101(), PropertyInfoContent.fragment);
var AmenitiesSimplifiedView = function(props) {
    var _data_summary_amenities, _data_summary, _data, _topAmenities;
    var data = props.data;
    var topAmenities = (_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var items = (_topAmenities = topAmenities) === null || _topAmenities === void 0 ? void 0 : _topAmenities.items;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var smallIconItemsProps = {
        columns: 2,
        space: "two",
        subset: 6
    };
    var largeIconItemsProps = {
        columns: 6,
        rows: 1,
        space: "three",
        subset: 6
    };
    return /* @__PURE__ */ React111.createElement(UitkSpacing45, {
        margin: {
            blockend: "three"
        },
        padding: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React111.createElement("div", null, /* @__PURE__ */ React111.createElement(PropertyInfoContent, {
        data: topAmenities,
        small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
            prefix: "highlightedAmenities"
        }),
        large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
            prefix: "highlightedAmenities"
        })
    })));
};
AmenitiesSimplifiedView.displayName = "AmenitiesSimplifiedView";
AmenitiesSimplifiedView.fragment = __AmenitiesSimplifiedViewFragment;
// src/components/book-by-phone/book-by-phone.tsx
import React112 from "react";
import { gql as gql102 } from "@apollo/client";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex24 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink13 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing46 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph4 } from "uitk-react-text";
var __BookByPhoneFragment = gql102(_templateObject102());
var BookByPhone = function(props) {
    var _data;
    var data = props.data, className = props.className;
    var track = useClickTracker31();
    var handleClick = React112.useCallback(function(linkName2, referrerId2) {
        track(referrerId2, linkName2);
    }, [
        track
    ]);
    if (!((_data = data) === null || _data === void 0 ? void 0 : _data.telesales)) {
        return null;
    }
    var telesales = data.telesales;
    var telesalesNumber = telesales.telesalesNumber, description = telesales.description, tracking = telesales.tracking;
    var phoneNumber = telesalesNumber.phoneNumber, teleUri = telesalesNumber.value;
    var teleDescription = description.value;
    var linkName = tracking.linkName, referrerId = tracking.referrerId;
    return /* @__PURE__ */ React112.createElement(UitkLayoutFlex24, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React112.createElement(UitkSpacing46, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React112.createElement(UitkParagraph4, {
        size: 1
    }, teleDescription)), /* @__PURE__ */ React112.createElement(UitkLink13, {
        onClick: function() {
            return handleClick(linkName, referrerId);
        },
        inline: true
    }, /* @__PURE__ */ React112.createElement("a", {
        href: teleUri
    }, /* @__PURE__ */ React112.createElement("span", {
        "data-stid": "telesales-number"
    }, phoneNumber))));
};
BookByPhone.displayName = "BookByPhone";
BookByPhone.fragment = __BookByPhoneFragment;
// src/components/book-by-phone/book-by-phone-placeholder.tsx
import React113 from "react";
import { UitkLayoutFlex as UitkLayoutFlex25 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing47 } from "uitk-react-spacing";
var BookByPhonePlaceholder = function(param) {
    var data = param.data, className = param.className;
    var _data;
    if ((_data = data) === null || _data === void 0 ? void 0 : _data.telesales) {
        return /* @__PURE__ */ React113.createElement(BookByPhone, {
            data: data,
            className: className
        });
    }
    return /* @__PURE__ */ React113.createElement(UitkLayoutFlex25, {
        justifyContent: "center",
        className: className
    }, /* @__PURE__ */ React113.createElement(UitkSpacing47, {
        margin: "one"
    }, /* @__PURE__ */ React113.createElement(UitkLineSkeleton2, {
        animation: true,
        type: "primary"
    })));
};
// src/components/content-section-groups/policies.tsx
import React114 from "react";
import { gql as gql103 } from "@apollo/client";
var __PoliciesFragment = gql103(_templateObject103(), PropertyContentSectionGroup.fragment);
var Policies = function(props) {
    var _data_propertyContentSectionGroups, _data;
    var data = props.data, columns = props.columns, contentProps = _object_without_properties(props, [
        "data",
        "columns"
    ]);
    var content = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyContentSectionGroups = _data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.policies;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React114.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
Policies.displayName = "Policies";
Policies.fragment = __PoliciesFragment;
// src/components/content-section-groups/special-features.tsx
import React115 from "react";
import { gql as gql104 } from "@apollo/client";
var __SpecialFeaturesFragment = gql104(_templateObject104(), PropertyContentSectionGroup.fragment);
var SpecialFeatures = function(props) {
    var _data_propertyContentSectionGroups, _data;
    var data = props.data, columns = props.columns, contentProps = _object_without_properties(props, [
        "data",
        "columns"
    ]);
    var content = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyContentSectionGroups = _data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.specialFeatures;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React115.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
SpecialFeatures.displayName = "SpecialFeatures";
SpecialFeatures.fragment = __SpecialFeaturesFragment;
// src/components/content-section-groups/important-info.tsx
import React116 from "react";
import { gql as gql105 } from "@apollo/client";
var __ImportantInfoFragment = gql105(_templateObject105(), PropertyContentSectionGroup.fragment);
var ImportantInfo = function(props) {
    var _data_propertyContentSectionGroups, _data;
    var data = props.data, columns = props.columns, contentProps = _object_without_properties(props, [
        "data",
        "columns"
    ]);
    var content = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyContentSectionGroups = _data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.importantInfo;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React116.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
ImportantInfo.displayName = "ImportantInfo";
ImportantInfo.fragment = __ImportantInfoFragment;
// src/components/content-section-groups/about-this-property.tsx
import React117 from "react";
import { gql as gql106 } from "@apollo/client";
var __AboutThisPropertyFragment = gql106(_templateObject106(), PropertyContentSectionGroup.fragment);
var AboutThisProperty = function(props) {
    var _data_propertyContentSectionGroups, _data;
    var data = props.data, columns = props.columns, contentProps = _object_without_properties(props, [
        "data",
        "columns"
    ]);
    var content = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyContentSectionGroups = _data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisProperty;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React117.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: content
    }, contentProps), {
        columns: columns
    }));
};
AboutThisProperty.fragment = __AboutThisPropertyFragment;
AboutThisProperty.displayName = "AboutThisProperty";
// src/components/content-section-groups/host-profile.tsx
import React118 from "react";
import { gql as gql107 } from "@apollo/client";
var __HostProfileFragment = gql107(_templateObject107(), PropertyContentSectionGroup.fragment);
var HostProfile = function(props) {
    var _data_propertyContentSectionGroups, _data;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    var content = (_data = data) === null || _data === void 0 ? void 0 : (_data_propertyContentSectionGroups = _data.propertyContentSectionGroups) === null || _data_propertyContentSectionGroups === void 0 ? void 0 : _data_propertyContentSectionGroups.aboutThisHost;
    if (!content) {
        return null;
    }
    return /* @__PURE__ */ React118.createElement(PropertyContentSectionGroup, _object_spread({
        data: content
    }, contentProps));
};
HostProfile.fragment = __HostProfileFragment;
HostProfile.displayName = "HostProfile";
// src/components/content-section-groups/property-detailed-amenities.tsx
import React119 from "react";
import { gql as gql108 } from "@apollo/client";
var DetailedAmenitiesFragment = gql108(_templateObject108(), PropertyContentSectionGroup.fragment);
var DetailedAmenities = function(props) {
    var _detailedAmenitiesContent_amenities, _detailedAmenitiesContent;
    var data = props.data, contentProps = _object_without_properties(props, [
        "data"
    ]);
    if (!data) {
        return null;
    }
    var amenitiesSummary = data.amenitiesSummary, detailedAmenitiesContent = data.detailedAmenitiesContent;
    if (!amenitiesSummary || !amenitiesSummary.amenities) {
        return null;
    }
    var amenities = amenitiesSummary.amenities;
    var detailedDialogContent = ((_detailedAmenitiesContent = detailedAmenitiesContent) === null || _detailedAmenitiesContent === void 0 ? void 0 : (_detailedAmenitiesContent_amenities = _detailedAmenitiesContent.amenities) === null || _detailedAmenitiesContent_amenities === void 0 ? void 0 : _detailedAmenitiesContent_amenities.sections.length) ? /* @__PURE__ */ React119.createElement(React119.Fragment, null, detailedAmenitiesContent.amenities.sections.map(function(section, index) {
        return /* @__PURE__ */ React119.createElement(PropertyContentSection, {
            data: section,
            columns: 1,
            key: "detailed-section-".concat(index),
            actionId: "amenities"
        });
    })) : void 0;
    return /* @__PURE__ */ React119.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React119.createElement(PropertyContentSectionGroup, _object_spread_props(_object_spread({
        data: amenities
    }, contentProps), {
        actionId: "amenities"
    })));
};
DetailedAmenities.displayName = "DetailedAmenities";
DetailedAmenities.fragment = DetailedAmenitiesFragment;
// src/components/direct-feedback/direct-feedback-call-to-action.tsx
import React120 from "react";
import { gql as gql109, useQuery as useQuery7 } from "@apollo/client";
import { useBexApi as useBexApi10 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker8, useClickTracker as useClickTracker32 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog12 } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog } from "@shared-ui/retail-customer-direct-feedback";
import { UitkIcon as UitkIcon19, UitkIconSize as UitkIconSize10 } from "uitk-react-icons";
import { UitkLink as UitkLink14 } from "uitk-react-link";
import { UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing48 } from "uitk-react-spacing";
var query = gql109(_templateObject109());
var DirectFeedbackCallToAction = function(props) {
    var _data_directFeedbackPromptById_callToAction_action, _data_directFeedbackPromptById_callToAction, _data_directFeedbackPromptById, _data, _data_directFeedbackPromptById_callToAction1, _data_directFeedbackPromptById1, _data1, _data_directFeedbackPromptById_callToAction2, _data_directFeedbackPromptById2, _data2, _ctaIcon, _ctaIcon1, _ctaIcon2, _analytics, _analytics1;
    var _props_inputs = props.inputs, promptId = _props_inputs.promptId, contextValues = _props_inputs.contextValues;
    var context = useBexApi10().context;
    var _useQuery7 = useQuery7(query, {
        variables: {
            id: promptId,
            context: context
        },
        fetchPolicy: "cache-first"
    }), data = _useQuery7.data, error = _useQuery7.error, loading = _useQuery7.loading;
    var track = useClickTracker32();
    var _useDialog12 = _sliced_to_array(useDialog12(promptId, "cdfPromptDialog"), 2), actions = _useDialog12[1];
    var analytics = (_data = data) === null || _data === void 0 ? void 0 : (_data_directFeedbackPromptById = _data.directFeedbackPromptById) === null || _data_directFeedbackPromptById === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction = _data_directFeedbackPromptById.callToAction) === null || _data_directFeedbackPromptById_callToAction === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction_action = _data_directFeedbackPromptById_callToAction.action) === null || _data_directFeedbackPromptById_callToAction_action === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction_action.analytics;
    var ctaText = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_directFeedbackPromptById1 = _data1.directFeedbackPromptById) === null || _data_directFeedbackPromptById1 === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction1 = _data_directFeedbackPromptById1.callToAction) === null || _data_directFeedbackPromptById_callToAction1 === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction1.primary;
    var ctaIcon = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_directFeedbackPromptById2 = _data2.directFeedbackPromptById) === null || _data_directFeedbackPromptById2 === void 0 ? void 0 : (_data_directFeedbackPromptById_callToAction2 = _data_directFeedbackPromptById2.callToAction) === null || _data_directFeedbackPromptById_callToAction2 === void 0 ? void 0 : _data_directFeedbackPromptById_callToAction2.icon;
    if (error) {
        return null;
    }
    var handleOnClick = function() {
        actions.openDialog();
        if (analytics) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var skeleton = /* @__PURE__ */ React120.createElement(UitkSpacing48, {
        padding: {
            blockstart: "one",
            blockend: "half"
        }
    }, /* @__PURE__ */ React120.createElement("div", null, /* @__PURE__ */ React120.createElement(UitkLineSkeleton3, null)));
    var callToAction = /* @__PURE__ */ React120.createElement(UitkLink14, {
        onClick: handleOnClick
    }, /* @__PURE__ */ React120.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React120.createElement(UitkIcon19, {
        name: ((_ctaIcon = ctaIcon) === null || _ctaIcon === void 0 ? void 0 : _ctaIcon.id) || "",
        key: (_ctaIcon1 = ctaIcon) === null || _ctaIcon1 === void 0 ? void 0 : _ctaIcon1.id,
        size: ((_ctaIcon2 = ctaIcon) === null || _ctaIcon2 === void 0 ? void 0 : _ctaIcon2.size) && UitkIconSize10[ctaIcon.size]
    }), ctaText));
    var impressionAnalytics = {
        // e.g. DirectFeedback.2b633e34-98cb-4d1c-a834-ee11a65ac2ac.CallToAction.impressed
        referrerId: "".concat((_analytics = analytics) === null || _analytics === void 0 ? void 0 : _analytics.referrerId, ".impressed"),
        linkName: "Direct feedback call to action"
    };
    var content = /* @__PURE__ */ React120.createElement(React120.Fragment, null, loading ? skeleton : callToAction, /* @__PURE__ */ React120.createElement(DirectFeedbackDialog, {
        contextValues: contextValues,
        inputs: {
            promptId: promptId
        }
    }));
    return ((_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.referrerId) ? /* @__PURE__ */ React120.createElement(IntersectionTracker8, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.linkName
    }, content) : content;
};
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
// src/components/direct-feedback/direct-feedback-prompt-id-fragment.tsx
import React121 from "react";
import { gql as gql110 } from "@apollo/client";
var PropertyDirectFeedbackPromptIdFragment = gql110(_templateObject110());
var PropertyDirectFeedbackCallToAction = function(param) {
    var directFeedback = param.data.directFeedback;
    var _directFeedback_callToAction, _directFeedback, _directFeedback1;
    return ((_directFeedback = directFeedback) === null || _directFeedback === void 0 ? void 0 : (_directFeedback_callToAction = _directFeedback.callToAction) === null || _directFeedback_callToAction === void 0 ? void 0 : _directFeedback_callToAction.promptId) ? /* @__PURE__ */ React121.createElement(DirectFeedbackCallToAction, {
        inputs: (_directFeedback1 = directFeedback) === null || _directFeedback1 === void 0 ? void 0 : _directFeedback1.callToAction
    }) : null;
};
PropertyDirectFeedbackCallToAction.displayName = "PropertyDirectFeedbackCallToAction";
PropertyDirectFeedbackCallToAction.fragment = PropertyDirectFeedbackPromptIdFragment;
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
import React124, { useCallback as useCallback2 } from "react";
import { gql as gql112 } from "@apollo/client";
import { useClickTracker as useClickTracker34 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog13 } from "@shared-ui/dialog-context";
import { Experiment as Experiment11, ExperimentControl as ExperimentControl11, ExperimentVariant as ExperimentVariant11 } from "@shared-ui/experiment-context";
import { DirectFeedbackDialog as DirectFeedbackDialog2 } from "@shared-ui/retail-customer-direct-feedback";
import { AnsweringTravellerQuestions } from "@shared-ui/retail-product-answering-traveller-questions";
import { ViewLarge as ViewLarge9, Viewport as Viewport16, ViewSmall as ViewSmall16 } from "@shared-ui/viewport-context";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection8 } from "uitk-react-cards";
import { UitkExpandoList } from "uitk-react-expando";
import { UitkLayoutFlex as UitkLayoutFlex26, UitkLayoutFlexItem as UitkLayoutFlexItem17 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid13, UitkLayoutGridItem as UitkLayoutGridItem12 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing49 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading19, UitkParagraph as UitkParagraph5 } from "uitk-react-text";
// src/components/frequently-asked-questions/__private/__fragments/faq.tsx
import React122 from "react";
import { gql as gql111 } from "@apollo/client";
import { useClickTracker as useClickTracker33 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoListItem } from "uitk-react-expando";
import { UitkText as UitkText32 } from "uitk-react-text";
var __FaqFragment = gql111(_templateObject111());
var Faq = function(param) {
    var data = param.data, rfrr = param.rfrr;
    var _question, _answer;
    var _ref = data || {}, question = _ref.question, answer = _ref.answer;
    var _React122_useState = _sliced_to_array(React122.useState(false), 2), isVisible = _React122_useState[0], setIsVisible = _React122_useState[1];
    var track = useClickTracker33();
    var onToggle = React122.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var callback = React122.useCallback(function(id, description) {
        track(id, description);
    }, [
        track
    ]);
    if (!((_question = question) === null || _question === void 0 ? void 0 : _question.text) || !((_answer = answer) === null || _answer === void 0 ? void 0 : _answer.text)) {
        return null;
    }
    return /* @__PURE__ */ React122.createElement(UitkExpandoListItem, {
        expandoTitle: /* @__PURE__ */ React122.createElement(UitkText32, {
            size: 400,
            weight: "bold"
        }, question.text),
        expandoDescription: /* @__PURE__ */ React122.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: answer.text
            }
        }),
        isVisible: isVisible,
        onToggle: onToggle,
        analytics: {
            id: "".concat(rfrr, ".").concat(isVisible ? "close" : "open"),
            description: "See frequently asked questions",
            callback: callback
        }
    });
};
Faq.displayName = "Faq";
Faq.fragment = __FaqFragment;
// src/components/frequently-asked-questions/structured-data.tsx
import React123 from "react";
var generateSchema = function(faqs) {
    if (!faqs || !faqs.length) {
        return null;
    }
    var faqsMainEntity = faqs.map(function(faq) {
        var textValue = faq.answer.text.replace(/"/g, '\\"');
        return {
            name: faq.question.text,
            "@type": "Question",
            acceptedAnswer: {
                "@type": "Answer",
                text: textValue
            }
        };
    });
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqsMainEntity
    };
    return JSON.stringify(schemaJson);
};
var FaqStructuredData = function(param) {
    var faqs = param.faqs;
    var structuredData = generateSchema(faqs);
    if (!structuredData) {
        return null;
    }
    return /* @__PURE__ */ React123.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: structuredData
        }
    });
};
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
var __FrequentlyAskedQuestionsFragment = gql112(_templateObject112(), Faq.fragment);
var AnsweringTravellerQuestionsWrapper = function() {
    return /* @__PURE__ */ React124.createElement(Experiment11, {
        name: "Enabling_traveller_questions_and_answers"
    }, /* @__PURE__ */ React124.createElement(ExperimentControl11, null), /* @__PURE__ */ React124.createElement(ExperimentVariant11, {
        bucket: 1
    }, /* @__PURE__ */ React124.createElement(AnsweringTravellerQuestions, {
        inputs: {}
    })));
};
var FrequentlyAskedQuestions = function(param) {
    var data = param.data;
    var _data, _frequentlyAskedQuestions, _frequentlyAskedQuestions1, _frequentlyAskedQuestions2, _frequentlyAskedQuestions_askAQuestion, _frequentlyAskedQuestions3, _data_offers_pricingFrequentlyAskedQuestions, _data_offers, _data1, _frequentlyAskedQuestions_askAQuestion1, _frequentlyAskedQuestions4;
    var frequentlyAskedQuestions = (_data = data) === null || _data === void 0 ? void 0 : _data.frequentlyAskedQuestions;
    var title = (_frequentlyAskedQuestions = frequentlyAskedQuestions) === null || _frequentlyAskedQuestions === void 0 ? void 0 : _frequentlyAskedQuestions.title.text;
    var subTitle = (_frequentlyAskedQuestions1 = frequentlyAskedQuestions) === null || _frequentlyAskedQuestions1 === void 0 ? void 0 : _frequentlyAskedQuestions1.title.subText;
    var faqs = (_frequentlyAskedQuestions2 = frequentlyAskedQuestions) === null || _frequentlyAskedQuestions2 === void 0 ? void 0 : _frequentlyAskedQuestions2.faqs;
    var directFeedbackDialogPromptId = "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9";
    var _useDialog13 = _sliced_to_array(useDialog13(directFeedbackDialogPromptId, "cdfPromptDialog"), 2), openDialog = _useDialog13[1].openDialog;
    var askAQuestionText = (_frequentlyAskedQuestions3 = frequentlyAskedQuestions) === null || _frequentlyAskedQuestions3 === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion = _frequentlyAskedQuestions3.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion.primary;
    var pricingFaq = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_offers = _data1.offers) === null || _data_offers === void 0 ? void 0 : (_data_offers_pricingFrequentlyAskedQuestions = _data_offers.pricingFrequentlyAskedQuestions) === null || _data_offers_pricingFrequentlyAskedQuestions === void 0 ? void 0 : _data_offers_pricingFrequentlyAskedQuestions[0];
    var _ref = ((_frequentlyAskedQuestions4 = frequentlyAskedQuestions) === null || _frequentlyAskedQuestions4 === void 0 ? void 0 : (_frequentlyAskedQuestions_askAQuestion1 = _frequentlyAskedQuestions4.askAQuestion) === null || _frequentlyAskedQuestions_askAQuestion1 === void 0 ? void 0 : _frequentlyAskedQuestions_askAQuestion1.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var track = useClickTracker34();
    var handleAskAQuestionClick = useCallback2(function() {
        openDialog();
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    }, [
        linkName,
        referrerId,
        track,
        openDialog
    ]);
    if (!faqs || faqs.length === 0) {
        return null;
    }
    var mergedFaqs = faqs.slice(0);
    if (pricingFaq) {
        mergedFaqs.splice(1, 0, pricingFaq);
    }
    var titleAndSubTitleSection = /* @__PURE__ */ React124.createElement(React124.Fragment, null, title && /* @__PURE__ */ React124.createElement(UitkLayoutFlex26, {
        direction: "column"
    }, /* @__PURE__ */ React124.createElement(UitkSpacing49, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React124.createElement(UitkHeading19, {
        tag: "h2",
        size: 4
    }, title)), subTitle && /* @__PURE__ */ React124.createElement(React124.Fragment, null, /* @__PURE__ */ React124.createElement(UitkSpacing49, {
        margin: {
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React124.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React124.createElement(UitkParagraph5, {
        size: 1
    }, subTitle))), /* @__PURE__ */ React124.createElement(UitkLayoutFlexItem17, {
        alignSelf: "start"
    }, /* @__PURE__ */ React124.createElement(UitkSpacing49, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React124.createElement(UitkSecondaryButton2, {
        id: "ask-a-question",
        onClick: handleAskAQuestionClick
    }, askAQuestionText))))));
    var faqExpandoList = /* @__PURE__ */ React124.createElement(UitkLayoutGridItem12, {
        colSpan: {
            medium: 1,
            large: 2
        }
    }, /* @__PURE__ */ React124.createElement(UitkExpandoList, null, mergedFaqs.map(function(faq, index) {
        return /* @__PURE__ */ React124.createElement(Faq, {
            key: "faq-".concat(index),
            data: faq,
            rfrr: "HOT.HIS.question.".concat(index)
        });
    })));
    return /* @__PURE__ */ React124.createElement(UitkSpacing49, {
        padding: {
            block: "six",
            large: {
                inline: "six"
            },
            extra_large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React124.createElement(UitkCard7, null, /* @__PURE__ */ React124.createElement(UitkCardContentSection8, null, /* @__PURE__ */ React124.createElement(DirectFeedbackDialog2, {
        inputs: {
            promptId: "6fa1b1cb-a4b4-4e36-8560-b9349b8d72e9"
        },
        contextValues: [
            {
                key: "property_id",
                value: data.id
            }
        ]
    }), /* @__PURE__ */ React124.createElement(Viewport16, null, /* @__PURE__ */ React124.createElement(ViewLarge9, null, /* @__PURE__ */ React124.createElement(UitkLayoutGrid13, {
        space: "six",
        columns: {
            medium: 1,
            large: 3
        }
    }, /* @__PURE__ */ React124.createElement(UitkLayoutGridItem12, {
        colSpan: 1
    }, /* @__PURE__ */ React124.createElement(UitkLayoutFlex26, {
        direction: "column"
    }, titleAndSubTitleSection, /* @__PURE__ */ React124.createElement(UitkLayoutFlexItem17, {
        alignSelf: "start"
    }, /* @__PURE__ */ React124.createElement(AnsweringTravellerQuestionsWrapper, null)))), faqExpandoList)), /* @__PURE__ */ React124.createElement(ViewSmall16, null, /* @__PURE__ */ React124.createElement(React124.Fragment, null, /* @__PURE__ */ React124.createElement(UitkLayoutGrid13, {
        space: "six",
        columns: {
            medium: 1,
            large: 3
        }
    }, /* @__PURE__ */ React124.createElement(UitkLayoutGridItem12, {
        colSpan: 1
    }, titleAndSubTitleSection), faqExpandoList), /* @__PURE__ */ React124.createElement(AnsweringTravellerQuestionsWrapper, null)))), /* @__PURE__ */ React124.createElement(FaqStructuredData, {
        faqs: mergedFaqs
    }))));
};
FrequentlyAskedQuestions.displayName = "FrequentlyAskedQuestions";
FrequentlyAskedQuestions.fragment = __FrequentlyAskedQuestionsFragment;
// src/components/gallery/gallery.tsx
import React125 from "react";
import { gql as gql113 } from "@apollo/client";
var __GalleryFragment = gql113(_templateObject113(), PropertyImageGallery.fragment);
var Gallery = function(props) {
    var _propertyGallery_images, _propertyGallery, _overview;
    var data = props.data;
    var propertyGallery = data.propertyGallery, summary = data.summary, id = data.id;
    var _ref = summary || {
        name: ""
    }, propertyName = _ref.name, overview = _ref.overview;
    if (!((_propertyGallery = propertyGallery) === null || _propertyGallery === void 0 ? void 0 : (_propertyGallery_images = _propertyGallery.images) === null || _propertyGallery_images === void 0 ? void 0 : _propertyGallery_images.length)) {
        return null;
    }
    return /* @__PURE__ */ React125.createElement(React125.Fragment, null, propertyName && /* @__PURE__ */ React125.createElement("h1", {
        className: "is-visually-hidden"
    }, propertyName), propertyName && /* @__PURE__ */ React125.createElement("meta", {
        itemProp: "name",
        content: propertyName
    }), /* @__PURE__ */ React125.createElement(PropertyImageGallery, {
        data: propertyGallery,
        propertyId: id
    }), ((_overview = overview) === null || _overview === void 0 ? void 0 : _overview.accessibilityLabel) && /* @__PURE__ */ React125.createElement("h2", {
        className: "is-visually-hidden"
    }, overview.accessibilityLabel));
};
Gallery.displayName = "Gallery";
Gallery.fragment = __GalleryFragment;
// src/components/gallery/placeholder.tsx
import React126 from "react";
import { ViewMedium as ViewMedium10, Viewport as Viewport17, ViewSmall as ViewSmall17 } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure6, UitkFigureAspectRatioType as UitkFigureAspectRatioType9, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid14, UitkLayoutGridItem as UitkLayoutGridItem13 } from "uitk-react-layout-grid";
var GalleryPlaceholder = /* istanbul ignore next -- @preserve */ function(param) {
    var data = param.data;
    return /* @__PURE__ */ React126.createElement(Viewport17, null, /* @__PURE__ */ React126.createElement(ViewSmall17, null, /* @__PURE__ */ React126.createElement(PlaceholderImage, {
        data: data
    })), /* @__PURE__ */ React126.createElement(ViewMedium10, null, /* @__PURE__ */ React126.createElement(UitkLayoutGrid14, {
        rows: 2,
        columns: 4,
        space: "half"
    }, Array.from(Array(5)).map(function(_, index) {
        return /* @__PURE__ */ React126.createElement(UitkLayoutGridItem13, {
            rowSpan: index === 0 ? 2 : 1,
            colSpan: index === 0 ? 2 : 1,
            key: "gallery-placeholder-".concat(index)
        }, /* @__PURE__ */ React126.createElement(PlaceholderImage, null));
    }))));
};
var PlaceholderImage = function(param) {
    var data = param.data, className = param.className;
    var _data_propertyGallery_images, _data_propertyGallery, _data, _data_propertyGallery_images_;
    var image = ((_data = data) === null || _data === void 0 ? void 0 : (_data_propertyGallery = _data.propertyGallery) === null || _data_propertyGallery === void 0 ? void 0 : (_data_propertyGallery_images = _data_propertyGallery.images) === null || _data_propertyGallery_images === void 0 ? void 0 : _data_propertyGallery_images.length) ? (_data_propertyGallery_images_ = data.propertyGallery.images[0]) === null || _data_propertyGallery_images_ === void 0 ? void 0 : _data_propertyGallery_images_.image : void 0;
    if (image) {
        var url = image.url;
        return /* @__PURE__ */ React126.createElement(UitkFigure6, {
            ratio: UitkFigureAspectRatioType9.R16_9,
            className: className
        }, /* @__PURE__ */ React126.createElement(UitkImage5, {
            src: url,
            alt: image.description
        }));
    }
    return /* @__PURE__ */ React126.createElement(UitkFigure6, {
        ratio: UitkFigureAspectRatioType9.R16_9,
        className: className
    }, /* @__PURE__ */ React126.createElement(UitkImage5, {
        placeholderImage: true
    }));
};
// src/components/inputs-context.tsx
import React127 from "react";
var InputsContext = React127.createContext({});
var usePropertyDetailsInputs = function() {
    return React127.useContext(InputsContext);
};
var InputsContextSummary = React127.createContext({});
var InputsContextActions = React127.createContext({});
var usePropertiesAditionalActionsInputs = function() {
    return React127.useContext(InputsContextActions);
};
var usePropertiesSummaryInputs = function() {
    return React127.useContext(InputsContextSummary);
};
// src/components/inventory-source/inventory-source.tsx
import React128 from "react";
import { gql as gql114 } from "@apollo/client";
import { ViewLarge as ViewLarge10, Viewport as Viewport18, ViewSmall as ViewSmall18 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex27, UitkLayoutFlexItem as UitkLayoutFlexItem18 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark5, UitkMarkSize as UitkMarkSize4 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing50 } from "uitk-react-spacing";
import { UitkText as UitkText33 } from "uitk-react-text";
var __InventorySourceFragment = gql114(_templateObject114());
var InventorySource = function(param) {
    var data = param.data;
    var _data_summary, _data, _graphic, _url, _url1;
    var _ref = ((_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.propertySource) || {}, text = _ref.text, graphic = _ref.graphic;
    if (!text || text === "") {
        return null;
    }
    var _ref1 = ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Mark" && graphic || {}, id = _ref1.id, description = _ref1.description, url = _ref1.url;
    return /* @__PURE__ */ React128.createElement(Viewport18, null, /* @__PURE__ */ React128.createElement(ViewSmall18, null, /* @__PURE__ */ React128.createElement(React128.Fragment, null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex27, {
        space: "one",
        direction: "column"
    }, /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React128.createElement(React128.Fragment, null, /* @__PURE__ */ React128.createElement(UitkSpacing50, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React128.createElement("div", null, ((_url = url) === null || _url === void 0 ? void 0 : _url.value) ? /* @__PURE__ */ React128.createElement(UitkMark5, {
        url: url.value,
        size: UitkMarkSize4.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React128.createElement(UitkMark5, {
        name: id,
        size: UitkMarkSize4.MEDIUM,
        description: description
    }))))), /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React128.createElement(UitkText33, {
        size: 300,
        "data-stid": "inventory-source"
    }, text))))), /* @__PURE__ */ React128.createElement(ViewLarge10, null, /* @__PURE__ */ React128.createElement(React128.Fragment, null, /* @__PURE__ */ React128.createElement(UitkLayoutFlex27, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React128.createElement(React128.Fragment, null, ((_url1 = url) === null || _url1 === void 0 ? void 0 : _url1.value) ? /* @__PURE__ */ React128.createElement(UitkMark5, {
        url: url.value,
        size: UitkMarkSize4.EXTRA_SMALL,
        description: description
    }) : /* @__PURE__ */ React128.createElement(UitkSpacing50, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React128.createElement("div", null, /* @__PURE__ */ React128.createElement(UitkMark5, {
        name: id,
        size: UitkMarkSize4.MEDIUM,
        description: description
    }))))), /* @__PURE__ */ React128.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React128.createElement(UitkText33, {
        size: 300,
        overflow: "truncate",
        "data-stid": "property-source"
    }, text))))));
};
InventorySource.fragment = __InventorySourceFragment;
InventorySource.displayName = "InventorySource";
// src/components/location-highlights/location-highlights.tsx
import React129 from "react";
import { gql as gql115 } from "@apollo/client";
var __LocationHighlightsFragment = gql115(_templateObject115(), PropertyInfoContent.fragment);
var LocationHighlights = function(param) {
    var data = param.data, className = param.className;
    var _data_reviewInfo_summary;
    var reviewHighlights = (_data_reviewInfo_summary = data.reviewInfo.summary) === null || _data_reviewInfo_summary === void 0 ? void 0 : _data_reviewInfo_summary.reviewHighlights;
    if (!reviewHighlights || reviewHighlights.items.length === 0) {
        return null;
    }
    var smallIconItemsProps = {
        columns: 1,
        space: "three"
    };
    var largeIconItemsProps = {
        columns: 2,
        rows: 3,
        space: "three"
    };
    return /* @__PURE__ */ React129.createElement("div", {
        className: className
    }, /* @__PURE__ */ React129.createElement(PropertyInfoContent, {
        data: reviewHighlights,
        small: _object_spread_props(_object_spread({}, smallIconItemsProps), {
            prefix: "reviewHighlights"
        }),
        large: _object_spread_props(_object_spread({}, largeIconItemsProps), {
            prefix: "reviewHighlights"
        })
    }));
};
LocationHighlights.displayName = "LocationHighlights";
LocationHighlights.fragment = __LocationHighlightsFragment;
// src/components/navigation-bar/navigation-bar.tsx
import React131 from "react";
import { gql as gql117 } from "@apollo/client";
import { useRefContext } from "@shared-ui/ref-context";
// src/components/navigation-bar/__private/__fragments/navigation-bar-tabs.tsx
import React130 from "react";
import { gql as gql116 } from "@apollo/client";
import { useClickTracker as useClickTracker35 } from "@shared-ui/clickstream-analytics-context";
import { useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { UitkNavigationType, UitkTab as UitkTab2, UitkTabs as UitkTabs2, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
var SCROLL_TIMEOUT2 = 1500;
var VISIBILITY_OPTIONS = {
    rootMargin: -60,
    thresholds: new Array(51).fill(0).map(function(v, i) {
        return i * 0.02;
    })
};
var fragment56 = gql116(_templateObject116());
var NavigationBarTabs = function(props) {
    var data = props.data, targets = props.targets;
    var tabs = data.navigationBarTabs || [];
    var track = useClickTracker35();
    var _React130_useState = _sliced_to_array(React130.useState(0), 2), activeTabIndex = _React130_useState[0], setActiveTabIndex = _React130_useState[1];
    var tabList = React130.useMemo(function() {
        return tabs.map(function(tab) {
            return {
                id: tab.sectionName,
                ref: targets[tab.sectionName]
            };
        });
    }, [
        tabs,
        targets
    ]);
    var onVisibilityChange = React130.useCallback(function(visibilityEvents) {
        var newActiveTabIndex = -1;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            if (visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.SPAN_VIEWPORT) {
                newActiveTabIndex = tabs.findIndex(function(tab) {
                    return tab.sectionName === sectionName;
                });
            }
        });
        if (newActiveTabIndex >= 0) {
            setActiveTabIndex(newActiveTabIndex);
        }
    }, [
        tabs
    ]);
    var _useVisibility = useVisibility(tabList, onVisibilityChange, VISIBILITY_OPTIONS), disableObserver = _useVisibility.disableObserver, enableObserver = _useVisibility.enableObserver;
    var onTabSelect = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        disableObserver();
        setTimeout(enableObserver, SCROLL_TIMEOUT2);
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        setActiveTabIndex(selectedTabIndex);
    };
    var onTabClick = function(selectedTabIndex) {
        if (selectedTabIndex === activeTabIndex) {
            return;
        }
        var navigationTab = tabs[selectedTabIndex];
        if (!navigationTab) {
            return;
        }
        track("HOT.HIS.NavBar.".concat(navigationTab.sectionName), navigationTab.sectionName);
    };
    return /* @__PURE__ */ React130.createElement(UitkTabs2, {
        navigationType: UitkNavigationType.JUMPLINK,
        onTabSelect: onTabSelect,
        onTabClickCB: onTabClick,
        selectedTab: activeTabIndex,
        tabsType: UitkTabsType2.NATURAL,
        scrollOffsetSelf: true,
        "data-stid": "navigation-tabs"
    }, tabs.map(function(tab) {
        return /* @__PURE__ */ React130.createElement(UitkTab2, {
            id: tab.sectionName,
            key: "uitk-tab-key-".concat(tab.sectionName),
            name: tab.localizedName,
            targetRef: targets[tab.sectionName],
            targetURI: "#".concat(tab.sectionName)
        });
    }));
};
NavigationBarTabs.displayName = "NavigationBarTabs";
NavigationBarTabs.fragment = fragment56;
// src/components/navigation-bar/navigation-bar.tsx
var __NavigationBarFragment = gql117(_templateObject117(), NavigationBarTabs.fragment);
var NavigationBar = function(props) {
    var _data, _summary, _tabs;
    var data = props.data;
    var summary = (_data = data) === null || _data === void 0 ? void 0 : _data.summary;
    var tabs = ((_summary = summary) === null || _summary === void 0 ? void 0 : _summary.navigationBarTabs) || [];
    var getTargets = useRefContext().getTargets;
    var targets = getTargets((_tabs = tabs) === null || _tabs === void 0 ? void 0 : _tabs.map(function(tab) {
        return tab.sectionName;
    }));
    if (!summary || tabs.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React131.createElement(NavigationBarTabs, {
        data: summary,
        targets: targets
    });
};
NavigationBar.displayName = "NavigationBar";
NavigationBar.fragment = __NavigationBarFragment;
// src/components/navigation-bar/navigation-bar-placeholder.tsx
import React132 from "react";
import { UitkTabs as UitkTabs3 } from "uitk-react-tabs";
var NavigationBarPlaceholder = /* istanbul ignore next -- @preserve */ function() {
    return /* @__PURE__ */ React132.createElement(UitkTabs3, null);
};
// src/components/relevant-amenities/relevant-amenities.tsx
import React133 from "react";
import { gql as gql118 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid15, UitkLayoutGridItem as UitkLayoutGridItem14 } from "uitk-react-layout-grid";
import { UitkList as UitkList4, UitkListItem as UitkListItem3 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing51 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading20 } from "uitk-react-text";
var __RelevantAmenitiesItem = gql118(_templateObject118());
var RelevantAmenitiesItem = function(param) {
    var data = param.data;
    var _header;
    var header = data.header, contents = data.contents;
    var listMap = contents.map(function(element) {
        return element.items.map(function(item, idx) {
            return item && /* @__PURE__ */ React133.createElement(UitkListItem3, {
                key: "amenities-list-item-".concat(idx)
            }, item.text);
        });
    });
    return listMap && /* @__PURE__ */ React133.createElement(UitkLayoutGridItem14, {
        colSpan: {
            small: 3,
            medium: 1
        }
    }, /* @__PURE__ */ React133.createElement("div", null, /* @__PURE__ */ React133.createElement(UitkHeading20, {
        tag: "h6",
        size: 6
    }, (_header = header) === null || _header === void 0 ? void 0 : _header.text), /* @__PURE__ */ React133.createElement(UitkList4, {
        bullet: "no-bullet"
    }, listMap)));
};
RelevantAmenitiesItem.displayName = "RelevantAmenitiesItem";
RelevantAmenitiesItem.fragment = __RelevantAmenitiesItem;
var __RelevantAmenitiesFragment = gql118(_templateObject119(), RelevantAmenitiesItem.fragment);
var RelevantAmenities = function(param) {
    var data = param.data, className = param.className;
    var _summary_amenities_relevantAmenities, _summary_amenities, _summary, _summary_amenities1, _summary1, _relevantAmenities;
    var summary = data.summary;
    if (((_summary = summary) === null || _summary === void 0 ? void 0 : (_summary_amenities = _summary.amenities) === null || _summary_amenities === void 0 ? void 0 : (_summary_amenities_relevantAmenities = _summary_amenities.relevantAmenities) === null || _summary_amenities_relevantAmenities === void 0 ? void 0 : _summary_amenities_relevantAmenities.length) === 0) {
        return null;
    }
    var _summary_amenities_relevantAmenities1;
    var relevantAmenities = (_summary_amenities_relevantAmenities1 = (_summary1 = summary) === null || _summary1 === void 0 ? void 0 : (_summary_amenities1 = _summary1.amenities) === null || _summary_amenities1 === void 0 ? void 0 : _summary_amenities1.relevantAmenities) !== null && _summary_amenities_relevantAmenities1 !== void 0 ? _summary_amenities_relevantAmenities1 : null;
    var relevantAmenitiesColumns = (_relevantAmenities = relevantAmenities) === null || _relevantAmenities === void 0 ? void 0 : _relevantAmenities.map(function(item, idx) {
        var _item_contents, _item_contents__items, _item_contents_;
        if (!item || !item.header || !item.header.text || ((_item_contents = item.contents) === null || _item_contents === void 0 ? void 0 : _item_contents.length) === 0 || ((_item_contents_ = item.contents[0]) === null || _item_contents_ === void 0 ? void 0 : (_item_contents__items = _item_contents_.items) === null || _item_contents__items === void 0 ? void 0 : _item_contents__items.length) === 0) {
            return null;
        }
        return item && /* @__PURE__ */ React133.createElement(RelevantAmenitiesItem, {
            data: item,
            key: "amenities-list-".concat(idx)
        });
    }).filter(function(element) {
        return element !== null;
    });
    return /* @__PURE__ */ React133.createElement(React133.Fragment, null, relevantAmenitiesColumns && relevantAmenitiesColumns.length > 0 && /* @__PURE__ */ React133.createElement("div", {
        className: className
    }, /* @__PURE__ */ React133.createElement(UitkSpacing51, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React133.createElement(UitkLayoutGrid15, {
        columns: 3,
        space: "six"
    }, relevantAmenitiesColumns))));
};
RelevantAmenities.displayName = "RelevantAmenities";
RelevantAmenities.fragment = __RelevantAmenitiesFragment;
// src/components/save-trip-item/save-trip-item.tsx
import React136 from "react";
import { gql as gql121 } from "@apollo/client";
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React135 from "react";
import { gql as gql120 } from "@apollo/client";
import { ITrackType as ITrackType5, useClickstreamAnalytics as useClickstreamAnalytics5 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React134 from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var _filteredEvents;
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if (((_filteredEvents = filteredEvents) === null || _filteredEvents === void 0 ? void 0 : _filteredEvents.length) > 0) {
                    results.push(_object_spread_props(_object_spread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React134.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React134.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
// ../internal/src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql119 } from "@apollo/client";
var AdaptexTrackingFragment = gql119(_templateObject120());
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
var fragment57 = gql120(_templateObject121(), AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics5().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React135.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType5.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React135.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType5.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React135.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React135.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment57;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// src/components/save-trip-item/save-trip-item.tsx
import { buildStateProvider as buildStateProvider2 } from "@shared-ui/provided-state-context";
import { Source as Source2, TripSaveItem as TripSaveItem2, ValidatedInputsState as ValidatedInputsState2 } from "@shared-ui/trips-save-item";
// src/components/save-trip-item/_private/use-to-update-attributes.tsx
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var EVENTS = {
    SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME: new SystemEvent(SystemEventLevel.INFO, "SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME")
};
function useUpdateAttributesWithSearchCriteria() {
    var loggerEvents = useLoggerEvents(EVENTS);
    return function(param) {
        var dataSaveItemAttributes = param.originalAttributes, searchCriteria = param.searchCriteria;
        return getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents);
    };
}
function getNewAttributesWithSearchCriteria(dataSaveItemAttributes, searchCriteria, loggerEvents) {
    var _searchCriteria;
    if (!((_searchCriteria = searchCriteria) === null || _searchCriteria === void 0 ? void 0 : _searchCriteria.dateRange) || !dataSaveItemAttributes) {
        return dataSaveItemAttributes;
    }
    switch(dataSaveItemAttributes.__typename){
        case "TripsSaveStayAttributes":
            return _object_spread_props(_object_spread({}, dataSaveItemAttributes), {
                checkInDate: _object_spread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkInDate),
                checkoutDate: _object_spread({
                    __typename: "Date"
                }, searchCriteria.dateRange.checkOutDate),
                roomConfiguration: searchCriteria.rooms.map(function(room) {
                    return {
                        __typename: "PropertyRoom",
                        numberOfAdults: room.adults,
                        childAges: room.children ? room.children.map(function(child) {
                            return child.age;
                        }) : []
                    };
                })
            });
        default:
            loggerEvents.SAVE_TRIP_ITEM_ATTRIBUTES_UNSUPPORTED_TYPENAME.log({});
            return dataSaveItemAttributes;
    }
}
// src/components/save-trip-item/save-trip-item.tsx
var __SaveTripItemFragment = gql121(_templateObject122(), LodgingTripsSaveItemAdapter.fragment);
var ValidatedInputsStateProvider2 = buildStateProvider2(new ValidatedInputsState2());
var SaveTripItem = function(param) {
    var data = param.data, searchCriteria = param.searchCriteria;
    var updateAttributes = useUpdateAttributesWithSearchCriteria();
    if (!data.saveTripItem) {
        return null;
    }
    var updatedAttributes = updateAttributes({
        originalAttributes: data.saveTripItem.attributes,
        searchCriteria: searchCriteria
    });
    return /* @__PURE__ */ React136.createElement(ValidatedInputsStateProvider2, null, /* @__PURE__ */ React136.createElement(TripSaveItem2, {
        data: _object_spread_props(_object_spread({}, data.saveTripItem), {
            attributes: updatedAttributes
        }),
        source: Source2.LODGING_DETAILS
    }));
};
SaveTripItem.fragment = __SaveTripItemFragment;
SaveTripItem.displayName = "SaveTripItem";
// src/components/shortlist/shortlist.tsx
import React137 from "react";
import { gql as gql122 } from "@apollo/client";
import { useClickTracker as useClickTracker36 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var __fragment2 = gql122(_templateObject123());
var Shortlist = function(param) {
    var data = param.data;
    var track = useClickTracker36();
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyIdFromDetailsQuery = _usePropertyDetailsInputs.propertyId;
    var _usePropertiesAditionalActionsInputs = usePropertiesAditionalActionsInputs(), propertyIdFromActionsQuery = _usePropertiesAditionalActionsInputs.propertyId;
    var propertyId = propertyIdFromDetailsQuery !== void 0 ? propertyIdFromDetailsQuery : propertyIdFromActionsQuery;
    var button = (data.shortList || {}).button;
    var name = (data.summary || {}).name;
    if (!button) {
        return null;
    }
    var handleChange = function(previousChecked, currentChecked, dispatch) {
        if (!currentChecked) {
            track(button.uncheckedAnalytics.referrerId, button.uncheckedAnalytics.linkName);
            return;
        }
        track(button.checkedAnalytics.referrerId, button.checkedAnalytics.linkName);
        dispatch({
            message: name
        });
    };
    var _button_checkedAccessibilityLabel;
    return /* @__PURE__ */ React137.createElement(ShortlistToggle, {
        label: (_button_checkedAccessibilityLabel = button.checkedAccessibilityLabel) !== null && _button_checkedAccessibilityLabel !== void 0 ? _button_checkedAccessibilityLabel : "",
        initialChecked: button.checked,
        onChange: handleChange,
        inputs: {
            productId: propertyId,
            productType: ProductType.PROPERTY_DETAILS
        }
    });
};
Shortlist.displayName = "Shortlist";
Shortlist.fragment = __fragment2;
// src/components/space-overview/space-overview.tsx
import React140 from "react";
import { gql as gql125 } from "@apollo/client";
// src/components/space-overview/__private/__fragments/space-overview-info.tsx
import React138 from "react";
import { gql as gql123 } from "@apollo/client";
import { UitkIcon as UitkIcon20 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex28, UitkLayoutFlexItem as UitkLayoutFlexItem19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing52 } from "uitk-react-spacing";
import { UitkText as UitkText34 } from "uitk-react-text";
var __SpaceOverviewInfoFragment = gql123(_templateObject124());
var SpaceOverviewInfo = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React138.createElement(UitkLayoutFlex28, {
        wrap: "wrap"
    }, /* @__PURE__ */ React138.createElement(React138.Fragment, null, data.items.map(function(item, index) {
        return /* @__PURE__ */ React138.createElement(UitkLayoutFlexItem19, {
            key: "".concat(item.__typename, "-").concat(index),
            grow: 1
        }, /* @__PURE__ */ React138.createElement(UitkText34, {
            size: 300,
            inline: true,
            spacing: "three",
            theme: "default"
        }, item.icon && /* @__PURE__ */ React138.createElement(UitkSpacing52, {
            margin: {
                inlineend: "two"
            }
        }, /* @__PURE__ */ React138.createElement(UitkIcon20, {
            name: item.icon.iconId,
            "aria-hidden": "true"
        })), item.text));
    })));
};
SpaceOverviewInfo.fragment = __SpaceOverviewInfoFragment;
SpaceOverviewInfo.displayName = "SpaceOverviewInfo";
// src/components/space-overview/__private/__fragments/space-overview-title.tsx
import React139 from "react";
import { gql as gql124 } from "@apollo/client";
import { UitkHeading as UitkHeading21 } from "uitk-react-text";
var __SpaceOverviewTitleFragment = gql124(_templateObject125());
var SpaceOverviewTitle = function(param) {
    var data = param.data;
    var _header;
    var header = data.header;
    if (!((_header = header) === null || _header === void 0 ? void 0 : _header.text)) {
        return null;
    }
    return /* @__PURE__ */ React139.createElement(UitkHeading21, {
        tag: "h3",
        size: 5
    }, header.text);
};
SpaceOverviewTitle.fragment = __SpaceOverviewTitleFragment;
SpaceOverviewTitle.displayName = "SpaceOverviewTitle";
// src/components/space-overview/space-overview.tsx
var __SpaceOverviewFragment = gql125(_templateObject126(), SpaceOverviewTitle.fragment, SpaceOverviewInfo.fragment);
var SpaceOverview = function(param) {
    var data = param.data, className = param.className;
    var _propertyHighlightedDetails_items, _propertyHighlightedDetails;
    var propertyHighlightedDetails = data.propertyHighlightedDetails;
    if (!((_propertyHighlightedDetails = propertyHighlightedDetails) === null || _propertyHighlightedDetails === void 0 ? void 0 : (_propertyHighlightedDetails_items = _propertyHighlightedDetails.items) === null || _propertyHighlightedDetails_items === void 0 ? void 0 : _propertyHighlightedDetails_items.length)) {
        return null;
    }
    return /* @__PURE__ */ React140.createElement("div", {
        className: className
    }, /* @__PURE__ */ React140.createElement(SpaceOverviewTitle, {
        data: propertyHighlightedDetails
    }), /* @__PURE__ */ React140.createElement(SpaceOverviewInfo, {
        data: propertyHighlightedDetails
    }));
};
SpaceOverview.fragment = __SpaceOverviewFragment;
SpaceOverview.displayName = "SpaceOverview";
// src/components/summary/summary.tsx
import React156 from "react";
import { Experiment as Experiment14, ExperimentControl as ExperimentControl14, ExperimentVariant as ExperimentVariant14 } from "@shared-ui/experiment-context";
// ../internal/src/utils/find-react-child-by-type.ts
import React141 from "react";
var findReactChildByType = function(children, type) {
    return React141.Children.toArray(children).find(function(child) {
        return React141.isValidElement(child) && child.type === type;
    });
};
// src/components/summary/summary.tsx
import { IdentifierType as IdentifierType2, RelevantContent } from "@shared-ui/retail-product-relevant-content";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection10 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid16, UitkLayoutGridItem as UitkLayoutGridItem15 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing64 } from "uitk-react-spacing";
// src/components/summary/__private/__fragments/reviews/index.tsx
import React145 from "react";
import { gql as gql129 } from "@apollo/client";
import { useBexApi as useBexApi11 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker37 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog14 } from "@shared-ui/dialog-context";
import { Experiment as Experiment12, ExperimentControl as ExperimentControl12, ExperimentVariant as ExperimentVariant12 } from "@shared-ui/experiment-context";
import { IdentifierType, UserGeneratedContentContainer } from "@shared-ui/retail-product-user-generated-content-container";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { UitkExpandoPeek as UitkExpandoPeek6 } from "uitk-react-expando";
import { UitkIcon as UitkIcon22 } from "uitk-react-icons";
import { UitkLink as UitkLink15 } from "uitk-react-link";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger3 } from "uitk-react-more-info-trigger";
import { UitkSheet as UitkSheet12, UitkSheetContent as UitkSheetContent7 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing55 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph6, UitkSubheading as UitkSubheading2, UitkText as UitkText36 } from "uitk-react-text";
import { UitkToolbar as UitkToolbar9 } from "uitk-react-toolbar";
// src/components/summary/__private/__fragments/reviews/property-info-top-review.tsx
import React142 from "react";
import { gql as gql126 } from "@apollo/client";
import { UitkIcon as UitkIcon21, UitkIconSize as UitkIconSize11 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex29, UitkLayoutFlexItem as UitkLayoutFlexItem20 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing53 } from "uitk-react-spacing";
import { UitkText as UitkText35 } from "uitk-react-text";
var __PropertyInfoTopReview = gql126(_templateObject127());
var PropertyInfoTopReview = function(param) {
    var data = param.data;
    var _topReviews, _topReviews_highlighted_icon, _topReviews_highlighted_icon1, _topReviews_highlighted_icon2;
    var topReviews = data.topReviews;
    if (!((_topReviews = topReviews) === null || _topReviews === void 0 ? void 0 : _topReviews.highlighted)) {
        return null;
    }
    var icon = ((_topReviews_highlighted_icon = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon === void 0 ? void 0 : _topReviews_highlighted_icon.iconId) || "";
    return /* @__PURE__ */ React142.createElement(UitkSpacing53, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React142.createElement(UitkLayoutFlex29, {
        space: "two"
    }, /* @__PURE__ */ React142.createElement(React142.Fragment, null, /* @__PURE__ */ React142.createElement(UitkLayoutFlexItem20, null, /* @__PURE__ */ React142.createElement(UitkIcon21, {
        name: icon,
        size: UitkIconSize11.SMALL,
        description: (_topReviews_highlighted_icon1 = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon1 === void 0 ? void 0 : _topReviews_highlighted_icon1.description,
        id: (_topReviews_highlighted_icon2 = topReviews.highlighted.icon) === null || _topReviews_highlighted_icon2 === void 0 ? void 0 : _topReviews_highlighted_icon2.iconId
    })), /* @__PURE__ */ React142.createElement(UitkLayoutFlexItem20, null, /* @__PURE__ */ React142.createElement(UitkText35, null, /* @__PURE__ */ React142.createElement("span", {
        "data-stid": "top-review-text",
        className: "truncate-lines-2"
    }, topReviews.highlighted.value))))));
};
PropertyInfoTopReview.displayName = "PropertyInfoTopReview";
PropertyInfoTopReview.fragment = __PropertyInfoTopReview;
// src/components/summary/__private/__fragments/reviews/property-review-rating.tsx
import React144 from "react";
import { gql as gql128 } from "@apollo/client";
// ../internal/src/components/egds/egds-badge/egds-badge.tsx
import React143 from "react";
import { gql as gql127 } from "@apollo/client";
import { UitkBadgeSize, UitkBadgeStandard } from "uitk-react-badge";
// ../internal/src/components/egds/egds-badge/__private/egds-standard-badge-theme.ts
var standardBadgeThemes = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// ../internal/src/components/egds/egds-badge/egds-badge.tsx
var fragment58 = gql127(_templateObject128());
var EGDSBadge = function(param) {
    var data = param.data;
    var _theme;
    var accessibility = data.accessibility, text = data.text, size = data.size, theme = data.theme;
    var _ref;
    var badgeSize = (_ref = size && UitkBadgeSize[size.toUpperCase()]) !== null && _ref !== void 0 ? _ref : UitkBadgeSize.LARGE;
    if (!text) {
        return null;
    }
    var _theme_toLowerCase;
    var selectedTheme = standardBadgeThemes[(_theme_toLowerCase = (_theme = theme) === null || _theme === void 0 ? void 0 : _theme.toLowerCase()) !== null && _theme_toLowerCase !== void 0 ? _theme_toLowerCase : "standard"];
    return /* @__PURE__ */ React143.createElement(UitkBadgeStandard, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        text: text,
        size: badgeSize,
        theme: selectedTheme
    });
};
EGDSBadge.fragment = fragment58;
EGDSBadge.displayName = "EGDSBadge";
// src/components/summary/__private/__fragments/reviews/property-review-rating.tsx
import { UitkLayoutFlex as UitkLayoutFlex30 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing54 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading22 } from "uitk-react-text";
var __PropertyReviewRatingFragment = gql128(_templateObject129(), EGDSBadge.fragment);
var PropertyReviewRatingPhrase = function(param) {
    var phrase = param.phrase;
    var _phraseParts;
    var phraseParts = phrase.phraseParts;
    var _phrasePart_accessibility;
    return /* @__PURE__ */ React144.createElement(React144.Fragment, null, (_phraseParts = phraseParts) === null || _phraseParts === void 0 ? void 0 : _phraseParts.map(function(phrasePart, index) {
        return /* @__PURE__ */ React144.createElement(UitkHeading22, {
            tag: "h3",
            size: 5,
            key: index,
            "aria-label": (_phrasePart_accessibility = phrasePart.accessibility) !== null && _phrasePart_accessibility !== void 0 ? _phrasePart_accessibility : void 0
        }, phrasePart.text);
    }));
};
var PropertyReviewRating = function(param) {
    var data = param.data;
    var _phrases;
    if (!data.badge || !data.phrases) {
        return null;
    }
    var badge = data.badge, phrases = data.phrases;
    return /* @__PURE__ */ React144.createElement(UitkSpacing54, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React144.createElement(UitkLayoutFlex30, {
        alignItems: "center",
        space: "two"
    }, badge.text && badge.theme && /* @__PURE__ */ React144.createElement(EGDSBadge, {
        data: badge
    }), (_phrases = phrases) === null || _phrases === void 0 ? void 0 : _phrases.map(function(phrase, index) {
        return /* @__PURE__ */ React144.createElement(PropertyReviewRatingPhrase, {
            phrase: phrase,
            key: index
        });
    })));
};
PropertyReviewRating.displayName = "PropertyReviewRating";
PropertyReviewRating.fragment = __PropertyReviewRatingFragment;
// src/components/summary/__private/__fragments/reviews/index.tsx
var __SummaryReviewsFragment = gql129(_templateObject130(), PropertyInfoTopReview.fragment, LodgingEnrichedMessage.fragment, PropertyReviewRating.fragment);
var SummaryReviews = function(param) {
    var data = param.data, onClickReviews = param.onClickReviews, className = param.className, triggerRef = param.triggerRef;
    var _shoppingContextFromDetailsQuery, _shoppingContextFromSummaryQuery, _topReviews, _averageOverallRatingValue, _seoData, _reviewDisclaimerValues, _highlightMessage_subtitle, _highlightMessage, _highlightMessage_subtitle1, _highlightMessage1, _highlightMessage_subtitle2, _highlightMessage2, _propertyReviewCountDetails;
    var summary = data.reviewInfo.summary, topReviews = data.topReviews;
    var averageOverallRating = summary.averageOverallRating, averageOverallRatingValue = summary.averageOverallRatingValue, totalCount = summary.totalCount, superlative = summary.superlative, strategy = summary.strategy, overallScoreWithDescriptionA11y = summary.overallScoreWithDescriptionA11y, propertyReviewCountDetails = summary.propertyReviewCountDetails, reviewDisclaimerHeading = summary.reviewDisclaimerHeading, reviewDisclaimerValues = summary.reviewDisclaimerValues, reviewDisclaimerLabel = summary.reviewDisclaimerLabel, highlightMessage = summary.highlightMessage, seoData = summary.seoData, reviewRating = summary.reviewRating;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyIdFromDetailsQuery = _usePropertyDetailsInputs.propertyId, shoppingContextFromDetailsQuery = _usePropertyDetailsInputs.shoppingContext;
    var _usePropertiesSummaryInputs = usePropertiesSummaryInputs(), propertyIdFromSummaryQuery = _usePropertiesSummaryInputs.propertyId, shoppingContextFromSummaryQuery = _usePropertiesSummaryInputs.shoppingContext;
    var propertyId = propertyIdFromDetailsQuery !== void 0 ? propertyIdFromDetailsQuery : propertyIdFromSummaryQuery;
    var isMultiItem = shoppingContextFromDetailsQuery !== void 0 ? (_shoppingContextFromDetailsQuery = shoppingContextFromDetailsQuery) === null || _shoppingContextFromDetailsQuery === void 0 ? void 0 : _shoppingContextFromDetailsQuery.multiItem : (_shoppingContextFromSummaryQuery = shoppingContextFromSummaryQuery) === null || _shoppingContextFromSummaryQuery === void 0 ? void 0 : _shoppingContextFromSummaryQuery.multiItem;
    var _useDialog14 = _sliced_to_array(useDialog14("centered-sheet-necessary-dialog-layer"), 3), isDialogOpen = _useDialog14[0], dialogActions = _useDialog14[1], DialogComponent = _useDialog14[2];
    var _React145_useState = _sliced_to_array(React145.useState(false), 2), isDialogDataExpanded = _React145_useState[0], setIsDialogDataExpanded = _React145_useState[1];
    var viewSize = useMediaQueries3({
        viewSizes: defaultViewSizes3
    });
    var context = useBexApi11().context;
    var isTabletOrBigger = viewSize === 0 ? context.device.type === "DESKTOP" || context.device.type === "MOBILE_TABLET" : viewSize > defaultViewSizes3.SMALL;
    var sheetSize = isTabletOrBigger ? "small" : "medium";
    var openReviewDisclaimerDialog = function() {
        dialogActions.openDialog();
    };
    var handleToolbarCloseAction = function() {
        dialogActions.closeDialog();
    };
    var track = useClickTracker37();
    var handleClick = React145.useCallback(function(event) {
        event.preventDefault();
        var _SummaryAnalyticsMapping_REVIEWS = _sliced_to_array(SummaryAnalyticsMapping["REVIEWS" /* REVIEWS */ ], 2), id = _SummaryAnalyticsMapping_REVIEWS[0], description = _SummaryAnalyticsMapping_REVIEWS[1];
        track(id, description, true);
        onClickReviews();
    }, [
        onClickReviews,
        track
    ]);
    if (!overallScoreWithDescriptionA11y && !propertyReviewCountDetails && !highlightMessage && !((_topReviews = topReviews) === null || _topReviews === void 0 ? void 0 : _topReviews.highlighted)) {
        return null;
    }
    var showAggregateRating = averageOverallRating.raw > 0 && totalCount.raw > 0;
    if (!showAggregateRating) {
        return null;
    }
    var paddingWithElements = {
        blockend: "two"
    };
    var userGeneratedContentVariants = function() {
        return /* @__PURE__ */ React145.createElement(UserGeneratedContentContainer, {
            inputs: {
                productIdentifier: {
                    id: propertyId,
                    type: IdentifierType.PROPERTY_ID
                }
            },
            skipSsr: true
        });
    };
    var userGeneratedContentWrapper = function() {
        return /* @__PURE__ */ React145.createElement(Experiment12, {
            name: "MPD_non_numerical_gex_and_UGC_sentiments"
        }, /* @__PURE__ */ React145.createElement(ExperimentControl12, null), /* @__PURE__ */ React145.createElement(ExperimentVariant12, {
            bucket: 1
        }, userGeneratedContentVariants()), /* @__PURE__ */ React145.createElement(ExperimentVariant12, {
            bucket: 2
        }, userGeneratedContentVariants()));
    };
    var renderUitkLink = function(size) {
        var _propertyReviewCountDetails;
        return /* @__PURE__ */ React145.createElement(UitkLink15, {
            onClick: handleClick,
            domRef: triggerRef,
            size: size
        }, /* @__PURE__ */ React145.createElement("button", {
            type: "button",
            "data-stid": "reviews-link"
        }, (_propertyReviewCountDetails = propertyReviewCountDetails) === null || _propertyReviewCountDetails === void 0 ? void 0 : _propertyReviewCountDetails.shortDescription, /* @__PURE__ */ React145.createElement(UitkIcon22, {
            name: "chevron_right"
        })));
    };
    var overallScoreWithDescription = function() {
        return overallScoreWithDescriptionA11y && /* @__PURE__ */ React145.createElement(UitkSpacing55, {
            padding: paddingWithElements
        }, /* @__PURE__ */ React145.createElement("div", null, /* @__PURE__ */ React145.createElement(LodgingEnrichedMessage, {
            data: overallScoreWithDescriptionA11y,
            textSize: 500
        })));
    };
    var ThirdPartyReviewsSummary = /* @__PURE__ */ React145.createElement("div", {
        className: className,
        "data-stid": "content-hotel-reviewsummary"
    }, /* @__PURE__ */ React145.createElement("div", {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating"
    }, /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "ratingValue",
        content: (_averageOverallRatingValue = averageOverallRatingValue) === null || _averageOverallRatingValue === void 0 ? void 0 : _averageOverallRatingValue.formatted
    }), superlative && /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "description",
        content: superlative
    }), (_seoData = seoData) === null || _seoData === void 0 ? void 0 : _seoData.map(function(param) {
        var itemscope = param.itemscope, itemprop = param.itemprop, content = param.content;
        return !itemscope && content ? /* @__PURE__ */ React145.createElement("meta", {
            itemProp: itemprop,
            content: content,
            key: itemprop
        }) : null;
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "reviewCount",
        content: totalCount.formatted
    })), /* @__PURE__ */ React145.createElement("div", null, overallScoreWithDescriptionA11y && /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: paddingWithElements
    }, /* @__PURE__ */ React145.createElement(UitkText36, {
        size: 500,
        theme: "default",
        weight: "bold"
    }, overallScoreWithDescriptionA11y.value)), reviewDisclaimerLabel && /* @__PURE__ */ React145.createElement(UitkText36, null, /* @__PURE__ */ React145.createElement(UitkSpacing55, null, /* @__PURE__ */ React145.createElement(UitkMoreInfoTrigger3, {
        onClick: openReviewDisclaimerDialog,
        size: "medium",
        weight: "regular"
    }, /* @__PURE__ */ React145.createElement(UitkText36, {
        size: 300
    }, reviewDisclaimerLabel, /* @__PURE__ */ React145.createElement(UitkIcon22, {
        name: "info_outline"
    }))))), /* @__PURE__ */ React145.createElement(DialogComponent, null, /* @__PURE__ */ React145.createElement(UitkSheet12, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: sheetSize,
        triggerRef: null
    }, /* @__PURE__ */ React145.createElement(UitkToolbar9, {
        navigationContent: {
            onClick: handleToolbarCloseAction,
            navIconLabel: "close toolbar",
            navType: "close"
        }
    }), /* @__PURE__ */ React145.createElement(UitkSheetContent7, null, /* @__PURE__ */ React145.createElement(UitkText36, {
        weight: "bold",
        size: 400
    }, reviewDisclaimerHeading), /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React145.createElement(UitkExpandoPeek6, {
        isVisible: isDialogDataExpanded,
        handleClick: function() {
            return setIsDialogDataExpanded(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        items: 1
    }, (_reviewDisclaimerValues = reviewDisclaimerValues) === null || _reviewDisclaimerValues === void 0 ? void 0 : _reviewDisclaimerValues.map(function(value, key) {
        return /* @__PURE__ */ React145.createElement(UitkParagraph6, {
            key: key
        }, value.text);
    }))))))));
    var ReviewSummary = /* @__PURE__ */ React145.createElement("div", {
        className: className,
        "data-stid": "content-hotel-reviewsummary"
    }, /* @__PURE__ */ React145.createElement("div", {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating"
    }, /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "ratingValue",
        content: averageOverallRating.formatted
    }), superlative && /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "description",
        content: superlative
    }), seoData.map(function(param) {
        var itemscope = param.itemscope, itemprop = param.itemprop, content = param.content;
        return !itemscope && content ? /* @__PURE__ */ React145.createElement("meta", {
            itemProp: itemprop,
            content: content,
            key: itemprop
        }) : null;
    }), /* @__PURE__ */ React145.createElement("meta", {
        itemProp: "reviewCount",
        content: totalCount.formatted
    })), /* @__PURE__ */ React145.createElement("div", null, reviewRating ? /* @__PURE__ */ React145.createElement("div", {
        "data-stid": "prominence-highly-rated-property"
    }, /* @__PURE__ */ React145.createElement(Experiment12, {
        name: "Web_Increase_prominence_of_highly_rated_properties_on_PDP"
    }, /* @__PURE__ */ React145.createElement(ExperimentControl12, null, overallScoreWithDescription()), /* @__PURE__ */ React145.createElement(ExperimentVariant12, {
        bucket: 1
    }, /* @__PURE__ */ React145.createElement(PropertyReviewRating, {
        data: reviewRating
    })))) : overallScoreWithDescription(), !isMultiItem ? userGeneratedContentWrapper() : null, ((_highlightMessage = highlightMessage) === null || _highlightMessage === void 0 ? void 0 : (_highlightMessage_subtitle = _highlightMessage.subtitle) === null || _highlightMessage_subtitle === void 0 ? void 0 : _highlightMessage_subtitle.text) && /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: paddingWithElements
    }, /* @__PURE__ */ React145.createElement(UitkSubheading2, {
        tag: "h4",
        "aria-label": ((_highlightMessage1 = highlightMessage) === null || _highlightMessage1 === void 0 ? void 0 : (_highlightMessage_subtitle1 = _highlightMessage1.subtitle) === null || _highlightMessage_subtitle1 === void 0 ? void 0 : _highlightMessage_subtitle1.accessibilityLabel) || void 0
    }, (_highlightMessage2 = highlightMessage) === null || _highlightMessage2 === void 0 ? void 0 : (_highlightMessage_subtitle2 = _highlightMessage2.subtitle) === null || _highlightMessage_subtitle2 === void 0 ? void 0 : _highlightMessage_subtitle2.text)), ((_propertyReviewCountDetails = propertyReviewCountDetails) === null || _propertyReviewCountDetails === void 0 ? void 0 : _propertyReviewCountDetails.shortDescription) && /* @__PURE__ */ React145.createElement(UitkSpacing55, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React145.createElement(Experiment12, {
        name: "PEXO_PDP_Increase_size_of_text_links_at_top"
    }, /* @__PURE__ */ React145.createElement(ExperimentControl12, null, renderUitkLink("")), /* @__PURE__ */ React145.createElement(ExperimentVariant12, {
        bucket: 1
    }, renderUitkLink("large"))))), /* @__PURE__ */ React145.createElement(PropertyInfoTopReview, {
        data: data
    }));
    return /* @__PURE__ */ React145.createElement(Experiment12, {
        name: "External_reviews_display_SRP_and_PDP"
    }, /* @__PURE__ */ React145.createElement(ExperimentControl12, null, ReviewSummary), /* @__PURE__ */ React145.createElement(ExperimentVariant12, {
        bucket: 1
    }, strategy === "EXTERNAL_REVIEWS" /* EXTERNAL_REVIEWS */  ? ThirdPartyReviewsSummary : ReviewSummary, " "));
};
SummaryReviews.displayName = "SummaryReviews";
SummaryReviews.fragment = __SummaryReviewsFragment;
// src/components/summary/__private/__fragments/amenities/index.tsx
import React149 from "react";
import { gql as gql132 } from "@apollo/client";
import { useClickTracker as useClickTracker39 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog15 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge11, Viewport as Viewport20, ViewSmall as ViewSmall20 } from "@shared-ui/viewport-context";
// src/components/summary/__private/__fragments/amenities/amenities-dialog.tsx
import React146, { useEffect as useEffect3 } from "react";
import { gql as gql130 } from "@apollo/client";
import { ITrackType as ITrackType6, useClickstreamAnalytics as useClickstreamAnalytics6 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium11, Viewport as Viewport19, ViewSmall as ViewSmall19 } from "@shared-ui/viewport-context";
import { useInView as useInView3 } from "react-intersection-observer";
import { UitkSheet as UitkSheet13, UitkSheetContent as UitkSheetContent8 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar10 } from "uitk-react-toolbar";
var __AmenitiesDialog = gql130(_templateObject131(), PropertyTakeoverAmenities.fragment);
var SheetComponent = function(param) {
    var type = param.type, title = param.title, description = param.description, takeover = param.takeover, closeDialog = param.closeDialog, isDialogOpen = param.isDialogOpen, _param_triggerRef = param.triggerRef, triggerRef = _param_triggerRef === void 0 ? null : _param_triggerRef, _param_forwardRef = param.forwardRef, forwardRef = _param_forwardRef === void 0 ? null : _param_forwardRef, dialogPreviouslyViewed = param.dialogPreviouslyViewed;
    return /* @__PURE__ */ React146.createElement(UitkSheet13, {
        returnFocusOnClose: true,
        triggerRef: triggerRef,
        isVisible: isDialogOpen,
        type: type
    }, /* @__PURE__ */ React146.createElement(UitkToolbar10, {
        toolbarTitle: title !== null && title !== void 0 ? title : void 0,
        navigationContent: {
            onClick: closeDialog,
            navType: "close",
            navIconLabel: description
        }
    }), /* @__PURE__ */ React146.createElement(UitkSheetContent8, null, /* @__PURE__ */ React146.createElement(PropertyTakeoverAmenities, {
        data: takeover,
        ref: forwardRef
    })));
};
var AmenitiesDialog = function(param) {
    var closeDialog = param.closeDialog, data = param.data, isDialogOpen = param.isDialogOpen, triggerRef = param.triggerRef, dialogPreviouslyViewed = param.dialogPreviouslyViewed;
    var _amenitiesDialog_toolbar, _amenitiesDialog_toolbar_icon, _amenitiesDialog_toolbar1;
    var amenitiesDialog = data.amenitiesDialog, takeover = data.takeover, viewAmenitiesAdaptExAttemptEvents = data.viewAmenitiesAdaptExAttemptEvents;
    var track = useClickstreamAnalytics6().track;
    var _useInView3 = useInView3({
        triggerOnce: true,
        threshold: 0
    }), forwardRef = _useInView3.ref, inView = _useInView3.inView;
    useEffect3(function() {
        if (!dialogPreviouslyViewed && inView && viewAmenitiesAdaptExAttemptEvents) {
            viewAmenitiesAdaptExAttemptEvents.forEach(function(adaptExAttemptEvent) {
                track(ITrackType6.EVENT, {
                    data: lightweightAdaptExMicroMessage({
                        campaignId: adaptExAttemptEvent.campaignId,
                        payloadId: adaptExAttemptEvent.events[0].payloadId,
                        eventType: adaptExAttemptEvent.events[0].eventType,
                        eventTarget: adaptExAttemptEvent.events[0].eventTarget
                    })
                });
            });
        }
    }, [
        viewAmenitiesAdaptExAttemptEvents,
        inView,
        track,
        dialogPreviouslyViewed
    ]);
    if (!amenitiesDialog || !takeover) {
        return null;
    }
    var title = (_amenitiesDialog_toolbar = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar === void 0 ? void 0 : _amenitiesDialog_toolbar.title;
    var description = (_amenitiesDialog_toolbar1 = amenitiesDialog.toolbar) === null || _amenitiesDialog_toolbar1 === void 0 ? void 0 : (_amenitiesDialog_toolbar_icon = _amenitiesDialog_toolbar1.icon) === null || _amenitiesDialog_toolbar_icon === void 0 ? void 0 : _amenitiesDialog_toolbar_icon.description;
    var sheetProps = {
        title: title,
        description: description,
        takeover: takeover,
        isDialogOpen: isDialogOpen,
        closeDialog: closeDialog,
        triggerRef: triggerRef,
        forwardRef: forwardRef,
        dialogPreviouslyViewed: dialogPreviouslyViewed
    };
    return /* @__PURE__ */ React146.createElement(Viewport19, null, /* @__PURE__ */ React146.createElement(ViewSmall19, null, /* @__PURE__ */ React146.createElement(SheetComponent, _object_spread({
        type: "full"
    }, sheetProps))), /* @__PURE__ */ React146.createElement(ViewMedium11, null, /* @__PURE__ */ React146.createElement(SheetComponent, _object_spread({
        type: "centered"
    }, sheetProps))));
};
AmenitiesDialog.displayName = "AmenitiesDialog";
AmenitiesDialog.fragment = __AmenitiesDialog;
// src/components/summary/__private/__fragments/amenities/amenities-link.tsx
import React147 from "react";
import { gql as gql131 } from "@apollo/client";
import { useClickTracker as useClickTracker38 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment13, ExperimentControl as ExperimentControl13, ExperimentVariant as ExperimentVariant13 } from "@shared-ui/experiment-context";
import { UitkIcon as UitkIcon23 } from "uitk-react-icons";
import { UitkLink as UitkLink16 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing56 } from "uitk-react-spacing";
var __AmenitiesLinkFragment = gql131(_templateObject132());
var AmenitiesLink = function(param) {
    var data = param.data, onClick = param.onClick, triggerRef = param.triggerRef;
    var renderButtonLink = function renderButtonLink(padding, size) {
        return /* @__PURE__ */ React147.createElement(UitkSpacing56, {
            padding: padding
        }, /* @__PURE__ */ React147.createElement(UitkLink16, {
            align: "left",
            onClick: handleClick,
            domRef: triggerRef,
            size: size
        }, /* @__PURE__ */ React147.createElement("button", {
            type: "button"
        }, /* @__PURE__ */ React147.createElement("span", {
            "aria-hidden": true
        }, text), accessibilityLabel && /* @__PURE__ */ React147.createElement("span", {
            className: "is-visually-hidden"
        }, accessibilityLabel), /* @__PURE__ */ React147.createElement(UitkIcon23, {
            name: iconId
        }))));
    };
    var _icon;
    var _SummaryAnalyticsMapping_AMENITIES = _sliced_to_array(SummaryAnalyticsMapping["AMENITIES" /* AMENITIES */ ], 2), id = _SummaryAnalyticsMapping_AMENITIES[0], description = _SummaryAnalyticsMapping_AMENITIES[1];
    var track = useClickTracker38();
    var handleClick = React147.useCallback(function(event) {
        event.preventDefault();
        track(id, description, true);
        onClick();
    }, [
        track,
        id,
        description,
        onClick
    ]);
    var amenitiesDialog = data.amenitiesDialog;
    if (!amenitiesDialog) {
        return null;
    }
    var _amenitiesDialog_trigger = amenitiesDialog.trigger, text = _amenitiesDialog_trigger.value, accessibilityLabel = _amenitiesDialog_trigger.accessibilityLabel, icon = _amenitiesDialog_trigger.icon;
    var iconId = ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.iconId) || "";
    return /* @__PURE__ */ React147.createElement(Experiment13, {
        name: "PEXO_PDP_Increase_size_of_text_links_at_top"
    }, /* @__PURE__ */ React147.createElement(ExperimentControl13, null, renderButtonLink({
        blockstart: "three",
        blockend: "unset"
    }, "")), /* @__PURE__ */ React147.createElement(ExperimentVariant13, {
        bucket: 1
    }, renderButtonLink({
        blockstart: "six",
        blockend: "unset"
    }, "large")));
};
AmenitiesLink.displayName = "AmenitiesLink";
AmenitiesLink.fragment = __AmenitiesLinkFragment;
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
import React148 from "react";
import { UitkSpacing as UitkSpacing57 } from "uitk-react-spacing";
// src/utils/react-children-to-display-name-map.ts
import { Children } from "react";
function reactChildrenToDisplayNameMap(children) {
    if (!children) {
        return {};
    }
    var map = {};
    Children.forEach(children, function(c) {
        var _c_type, _c;
        var displayName = (_c = c) === null || _c === void 0 ? void 0 : (_c_type = _c.type) === null || _c_type === void 0 ? void 0 : _c_type.displayName;
        if (!displayName) {
            return;
        }
        if (!map[displayName]) {
            map[displayName] = [];
        }
        map[displayName].push(c);
    });
    return map;
}
// src/components/summary/__private/__fragments/amenities/amenity-view.tsx
var AmenityView = function(param) {
    var children = param.children, data = param.data;
    var _data_summary_amenities, _data_summary, _data_summary_amenities1, _data_summary1, _topAmenities;
    var topAmenities = (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_amenities = _data_summary.amenities) === null || _data_summary_amenities === void 0 ? void 0 : _data_summary_amenities.topAmenities;
    var propertyContentPreferences = (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_amenities1 = _data_summary1.amenities) === null || _data_summary_amenities1 === void 0 ? void 0 : _data_summary_amenities1.propertyContentPreferences;
    var items = (_topAmenities = topAmenities) === null || _topAmenities === void 0 ? void 0 : _topAmenities.items;
    if (!topAmenities || !items || items.length === 0) {
        return null;
    }
    var _reactChildrenToDisplayNameMap = reactChildrenToDisplayNameMap(children), AmenitiesLink2 = _reactChildrenToDisplayNameMap.AmenitiesLink;
    var baseItemsProps = {
        overflow: "wrap",
        prefix: "cleaningAndSafety",
        space: "four",
        subset: 6
    };
    var contentItemsProps2 = _object_spread_props(_object_spread({}, baseItemsProps), {
        columns: 2
    });
    return /* @__PURE__ */ React148.createElement(React148.Fragment, null, propertyContentPreferences && /* @__PURE__ */ React148.createElement(UitkSpacing57, {
        padding: {
            blockend: "six"
        },
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React148.createElement("div", null, /* @__PURE__ */ React148.createElement(PropertyContent, {
        data: propertyContentPreferences
    }))), /* @__PURE__ */ React148.createElement(PropertyInfoContent, {
        data: topAmenities,
        small: contentItemsProps2,
        large: contentItemsProps2
    }), AmenitiesLink2);
};
AmenityView.displayName = "AmenityView";
// src/components/summary/__private/__fragments/amenities/index.tsx
var __SummaryAmenitiesFragment = gql132(_templateObject133(), __PropertyInfoContent, PropertyContent.fragment, AmenitiesLink.fragment, AmenitiesDialog.fragment);
var SummaryAmenities = function(param) {
    var data = param.data, className = param.className;
    var _amenities_topAmenities_items, _amenities_topAmenities, _amenities, _amenities_amenitiesDialog_toolbar, _amenities_amenitiesDialog, _amenities1, _amenities2, _amenities3;
    var amenities = (data.summary || {}).amenities;
    var _useDialog15 = _sliced_to_array(useDialog15("amenities-dialog", "pwaDialog"), 3), isDialogOpen = _useDialog15[0], dialogActions = _useDialog15[1], DialogComponent = _useDialog15[2];
    var analyticsTracker = useClickTracker39();
    var triggerAmenitiesRef = React149.useRef(null);
    var _React149_useState = _sliced_to_array(React149.useState(false), 2), dialogPreviouslyViewed = _React149_useState[0], setDialogPreviouslyViewed = _React149_useState[1];
    if (!((_amenities = amenities) === null || _amenities === void 0 ? void 0 : (_amenities_topAmenities = _amenities.topAmenities) === null || _amenities_topAmenities === void 0 ? void 0 : (_amenities_topAmenities_items = _amenities_topAmenities.items) === null || _amenities_topAmenities_items === void 0 ? void 0 : _amenities_topAmenities_items.length)) {
        return null;
    }
    var clientSideAnalytics = (_amenities1 = amenities) === null || _amenities1 === void 0 ? void 0 : (_amenities_amenitiesDialog = _amenities1.amenitiesDialog) === null || _amenities_amenitiesDialog === void 0 ? void 0 : (_amenities_amenitiesDialog_toolbar = _amenities_amenitiesDialog.toolbar) === null || _amenities_amenitiesDialog_toolbar === void 0 ? void 0 : _amenities_amenitiesDialog_toolbar.clientSideAnalytics;
    var onClose = function() {
        dialogActions.closeDialog();
        setDialogPreviouslyViewed(true);
        if (clientSideAnalytics) {
            analyticsTracker(clientSideAnalytics.referrerId, clientSideAnalytics.linkName, true);
        }
    };
    var amenitiesLink = ((_amenities2 = amenities) === null || _amenities2 === void 0 ? void 0 : _amenities2.amenitiesDialog) && /* @__PURE__ */ React149.createElement(AmenitiesLink, {
        key: "amenities-link",
        data: amenities,
        onClick: dialogActions.openDialog,
        triggerRef: triggerAmenitiesRef
    });
    return /* @__PURE__ */ React149.createElement(React149.Fragment, null, /* @__PURE__ */ React149.createElement("div", {
        className: className,
        "data-stid": "hotel-amenities-list"
    }, /* @__PURE__ */ React149.createElement(Viewport20, null, /* @__PURE__ */ React149.createElement(ViewSmall20, null, /* @__PURE__ */ React149.createElement(AmenityView, {
        data: data
    }, amenitiesLink)), /* @__PURE__ */ React149.createElement(ViewLarge11, null, /* @__PURE__ */ React149.createElement(AmenityView, {
        data: data
    }, amenitiesLink)))), ((_amenities3 = amenities) === null || _amenities3 === void 0 ? void 0 : _amenities3.amenitiesDialog) && /* @__PURE__ */ React149.createElement(DialogComponent, null, /* @__PURE__ */ React149.createElement(AmenitiesDialog, {
        data: amenities,
        closeDialog: onClose,
        isDialogOpen: isDialogOpen,
        triggerRef: triggerAmenitiesRef,
        dialogPreviouslyViewed: dialogPreviouslyViewed
    })));
};
SummaryAmenities.displayName = "SummaryAmenities";
SummaryAmenities.fragment = __SummaryAmenitiesFragment;
// src/components/summary/__private/__fragments/near-by-pois/index.tsx
import React150 from "react";
import { gql as gql133 } from "@apollo/client";
import { UitkIcon as UitkIcon24, UitkIconSize as UitkIconSize12 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex31, UitkLayoutFlexItem as UitkLayoutFlexItem21 } from "uitk-react-layout-flex";
import { UitkList as UitkList5 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing58 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading23 } from "uitk-react-text";
var __SummaryNearByPoisFragment = gql133(_templateObject134());
var Icon2 = /* @__PURE__ */ function(Icon3) {
    Icon3["flight"] = "lob_flights";
    return Icon3;
}(Icon2 || {});
var getIconProps = function(icon, index) {
    return {
        id: "nearByPOIs-".concat(index),
        name: Icon2[icon.iconId] || icon.iconId,
        title: icon.description,
        size: UitkIconSize12.MEDIUM
    };
};
var SummaryNearByPois = function(param) {
    var data = param.data, className = param.className;
    var _data_summary, /* eslint-disable-next-line react/display-name */ _items;
    if (!((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.nearbyPOIs)) {
        return null;
    }
    var _data_summary_nearbyPOIs = data.summary.nearbyPOIs, heading = _data_summary_nearbyPOIs.heading, items = _data_summary_nearbyPOIs.items;
    return /* @__PURE__ */ React150.createElement(UitkLayoutFlex31, {
        direction: "column",
        className: className
    }, /* @__PURE__ */ React150.createElement(UitkSpacing58, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React150.createElement(UitkHeading23, {
        tag: "h3",
        size: 5
    }, heading)), /* @__PURE__ */ React150.createElement(UitkList5, {
        bullet: "no-bullet"
    }, (_items = items) === null || _items === void 0 ? void 0 : _items.map(function(param, index) {
        var icon = param.icon, text = param.text, moreInfo = param.moreInfo;
        var iconProps = icon && getIconProps(icon, index);
        return /* @__PURE__ */ React150.createElement(UitkLayoutFlex31, {
            key: text,
            space: "two",
            wrap: "nowrap",
            tag: "li"
        }, iconProps && /* @__PURE__ */ React150.createElement(UitkSpacing58, {
            padding: {
                inlineend: "three"
            }
        }, /* @__PURE__ */ React150.createElement(UitkIcon24, _object_spread({}, iconProps))), /* @__PURE__ */ React150.createElement(UitkLayoutFlexItem21, {
            grow: 1
        }, /* @__PURE__ */ React150.createElement("span", null, text)), /* @__PURE__ */ React150.createElement(UitkLayoutFlexItem21, {
            shrink: 0
        }, /* @__PURE__ */ React150.createElement("span", null, moreInfo)));
    })));
};
SummaryNearByPois.displayName = "SummaryNearByPois";
SummaryNearByPois.fragment = __SummaryNearByPoisFragment;
// src/components/summary/__private/__fragments/banner-message/index.tsx
import React151 from "react";
import { gql as gql134 } from "@apollo/client";
import { UitkCard as UitkCard8 } from "uitk-react-cards";
import { UitkIcon as UitkIcon25, UitkIconSize as UitkIconSize13 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex32, UitkLayoutFlexItem as UitkLayoutFlexItem22 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing59 } from "uitk-react-spacing";
import { UitkText as UitkText37 } from "uitk-react-text";
var __SummaryBannerMessageFragment = gql134(_templateObject135());
var SummaryBannerMessage = function(param) {
    var data = param.data;
    var _data_summary, _data, _bannerMessage_title_icon, _bannerMessage_title, _bannerMessage_title_icon1, _bannerMessage_title1, _bannerMessage_title_icon2, _bannerMessage_title2, _bannerMessage_subtitle;
    var bannerMessage = (_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.bannerMessage;
    if (!bannerMessage) {
        return null;
    }
    var _bannerMessage_title_icon_id;
    return /* @__PURE__ */ React151.createElement(UitkSpacing59, {
        margin: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React151.createElement(UitkCard8, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React151.createElement(UitkLayoutFlex32, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React151.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React151.createElement("div", null, /* @__PURE__ */ React151.createElement(UitkIcon25, {
        name: (_bannerMessage_title_icon_id = (_bannerMessage_title = bannerMessage.title) === null || _bannerMessage_title === void 0 ? void 0 : (_bannerMessage_title_icon = _bannerMessage_title.icon) === null || _bannerMessage_title_icon === void 0 ? void 0 : _bannerMessage_title_icon.id) !== null && _bannerMessage_title_icon_id !== void 0 ? _bannerMessage_title_icon_id : "",
        size: UitkIconSize13.MEDIUM,
        id: "banner-message-".concat((_bannerMessage_title1 = bannerMessage.title) === null || _bannerMessage_title1 === void 0 ? void 0 : (_bannerMessage_title_icon1 = _bannerMessage_title1.icon) === null || _bannerMessage_title_icon1 === void 0 ? void 0 : _bannerMessage_title_icon1.id),
        title: (_bannerMessage_title2 = bannerMessage.title) === null || _bannerMessage_title2 === void 0 ? void 0 : (_bannerMessage_title_icon2 = _bannerMessage_title2.icon) === null || _bannerMessage_title_icon2 === void 0 ? void 0 : _bannerMessage_title_icon2.description
    }))), /* @__PURE__ */ React151.createElement(UitkSpacing59, {
        margin: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React151.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React151.createElement("div", null, /* @__PURE__ */ React151.createElement(UitkText37, {
        size: 300
    }, (_bannerMessage_subtitle = bannerMessage.subtitle) === null || _bannerMessage_subtitle === void 0 ? void 0 : _bannerMessage_subtitle.text)))))));
};
SummaryBannerMessage.displayName = "SummaryBannerMessage";
SummaryBannerMessage.fragment = __SummaryBannerMessageFragment;
// src/components/summary/__private/__fragments/header/header.tsx
import React152 from "react";
import { gql as gql135 } from "@apollo/client";
import { ViewLarge as ViewLarge12, Viewport as Viewport21, ViewSmall as ViewSmall21 } from "@shared-ui/viewport-context";
import { UitkVipBadge } from "uitk-react-badge";
import { UitkIcon as UitkIcon26, UitkIconSize as UitkIconSize14 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex33, UitkLayoutFlexItem as UitkLayoutFlexItem23 } from "uitk-react-layout-flex";
import { UitkRating as UitkRating2 } from "uitk-react-rating";
import { UitkSpacing as UitkSpacing60 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading24, UitkSubheading as UitkSubheading3, UitkText as UitkText38 } from "uitk-react-text";
var __SummaryHeaderFragment = gql135(_templateObject136());
var SummaryHeader = function(param) {
    var data = param.data, _param_propertyTopHeader = param.propertyTopHeader, propertyTopHeader = _param_propertyTopHeader === void 0 ? false : _param_propertyTopHeader;
    var _overview, _overview1, _messages, _starRatingIcon, _overview2, _overview_propertyRating, _overview3, _overview4;
    var _ref = data.summary || {}, name = _ref.name, latinAlphabetName = _ref.latinAlphabetName, overview = _ref.overview, starRatingIcon = _ref.starRatingIcon, featuredMessages = _ref.featuredMessages, tagline = _ref.tagline, messages = _ref.messages;
    var shouldDisplayRating = Boolean(((_overview = overview) === null || _overview === void 0 ? void 0 : _overview.starRating) && starRatingIcon);
    if (!name) {
        return null;
    }
    var _overview_propertyRating_accessibility;
    return /* @__PURE__ */ React152.createElement(UitkSpacing60, {
        padding: {
            blockend: propertyTopHeader ? "two" : "unset"
        }
    }, /* @__PURE__ */ React152.createElement("div", null, /* @__PURE__ */ React152.createElement(UitkSpacing60, {
        padding: {
            blockend: propertyTopHeader ? "one" : "two"
        }
    }, /* @__PURE__ */ React152.createElement(UitkLayoutFlex33, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, ((_overview1 = overview) === null || _overview1 === void 0 ? void 0 : _overview1.vipMessaging) && !propertyTopHeader && /* @__PURE__ */ React152.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React152.createElement(UitkVipBadge, {
        text: overview.vipMessaging
    })), featuredMessages && featuredMessages.length > 0 && /* @__PURE__ */ React152.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React152.createElement("div", null, featuredMessages.map(function(message, index) {
        return /* @__PURE__ */ React152.createElement(UitkText38, {
            theme: "default",
            key: index,
            inline: true
        }, index !== 0 && /* @__PURE__ */ React152.createElement(UitkSpacing60, {
            margin: {
                inline: "half"
            }
        }, /* @__PURE__ */ React152.createElement("span", {
            "aria-hidden": "true",
            className: "uitk-type-300 uitk-type-bold"
        }, "\xb7")), message.icon && /* @__PURE__ */ React152.createElement(UitkIcon26, {
            name: message.icon.iconId,
            size: UitkIconSize14.SMALL,
            "aria-hidden": "true"
        }), message.value);
    }))))), /* @__PURE__ */ React152.createElement(Viewport21, null, /* @__PURE__ */ React152.createElement(ViewSmall21, null, /* @__PURE__ */ React152.createElement(UitkHeading24, {
        tag: "h1",
        size: 4,
        "aria-hidden": "true"
    }, name)), /* @__PURE__ */ React152.createElement(ViewLarge12, null, /* @__PURE__ */ React152.createElement(UitkHeading24, {
        tag: "h1",
        size: 3,
        "aria-hidden": "true"
    }, name))), latinAlphabetName && /* @__PURE__ */ React152.createElement(UitkSubheading3, {
        tag: "h2"
    }, latinAlphabetName), (_messages = messages) === null || _messages === void 0 ? void 0 : _messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React152.createElement(UitkSpacing60, {
            key: "message-".concat(messageIndex),
            margin: {
                blockstart: propertyTopHeader ? "one" : "unset"
            }
        }, /* @__PURE__ */ React152.createElement("div", null, /* @__PURE__ */ React152.createElement(LodgingEGDSText, {
            data: message
        })));
    }), shouldDisplayRating && /* @__PURE__ */ React152.createElement(UitkSpacing60, {
        margin: {
            blockstart: propertyTopHeader ? "one" : "unset"
        }
    }, /* @__PURE__ */ React152.createElement(UitkRating2, {
        icon: ((_starRatingIcon = starRatingIcon) === null || _starRatingIcon === void 0 ? void 0 : _starRatingIcon.iconId) === "STAR" ? "star" : "alternate",
        rating: String((_overview2 = overview) === null || _overview2 === void 0 ? void 0 : _overview2.starRating),
        a11yText: (_overview_propertyRating_accessibility = (_overview3 = overview) === null || _overview3 === void 0 ? void 0 : (_overview_propertyRating = _overview3.propertyRating) === null || _overview_propertyRating === void 0 ? void 0 : _overview_propertyRating.accessibility) !== null && _overview_propertyRating_accessibility !== void 0 ? _overview_propertyRating_accessibility : void 0
    })), tagline && /* @__PURE__ */ React152.createElement(UitkText38, {
        theme: "default"
    }, tagline), ((_overview4 = overview) === null || _overview4 === void 0 ? void 0 : _overview4.vipMessaging) && propertyTopHeader && /* @__PURE__ */ React152.createElement(UitkLayoutFlex33, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, /* @__PURE__ */ React152.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React152.createElement(UitkSpacing60, {
        padding: {
            blockstart: "three",
            blockend: "one"
        }
    }, /* @__PURE__ */ React152.createElement("div", null, /* @__PURE__ */ React152.createElement(UitkVipBadge, {
        text: overview.vipMessaging
    })))))));
};
SummaryHeader.fragment = __SummaryHeaderFragment;
SummaryHeader.displayName = "SummaryHeader";
// src/components/summary/__private/__fragments/header/placeholder.tsx
import React153 from "react";
import { UitkLineSkeleton as UitkLineSkeleton4 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing61 } from "uitk-react-spacing";
var SummaryHeaderPlaceholder = function(param) {
    var data = param.data;
    var _data;
    if ((_data = data) === null || _data === void 0 ? void 0 : _data.summary) {
        return /* @__PURE__ */ React153.createElement(SummaryHeader, {
            data: data
        });
    }
    return /* @__PURE__ */ React153.createElement(React153.Fragment, null, /* @__PURE__ */ React153.createElement(UitkSpacing61, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React153.createElement(UitkLineSkeleton4, {
        animation: true,
        type: "primary"
    })), /* @__PURE__ */ React153.createElement(UitkLineSkeleton4, {
        animation: true,
        type: "secondary"
    }));
};
// src/components/summary/__private/__fragments/chatbot-launch/index.tsx
import React154, { useState as useState3 } from "react";
import { gql as gql136 } from "@apollo/client";
import { useBexApi as useBexApi12 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker40 } from "@shared-ui/clickstream-analytics-context";
import { VirtualAgentControl } from "@shared-ui/customer-virtual-agent-control";
import { VirtualAgentControlExitSurvey, VirtualAgentControlExitSurveyFeedback } from "@shared-ui/customer-virtual-agent-control-exit-survey";
import { useDialog as useDialog16 } from "@shared-ui/dialog-context";
import { useLogger } from "@shared-ui/logger-context";
import { ViewLarge as ViewLarge13, Viewport as Viewport22, ViewSmall as ViewSmall22 } from "@shared-ui/viewport-context";
import { UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkCard as UitkCard9, UitkCardContentSection as UitkCardContentSection9 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex34, UitkLayoutFlexItem as UitkLayoutFlexItem24 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing62 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading25, UitkText as UitkText39 } from "uitk-react-text";
var __SummaryChatbotLaunchFragment = gql136(_templateObject137());
var SummaryChatbotLaunch = function(param) {
    var data = param.data, applicationName = param.applicationName, pageName = param.pageName;
    var _data_summary, _identity, _action, _header, _action1, _searchCriteria_primary_dateRange, _searchCriteria, _searchCriteria_primary_dateRange1, _searchCriteria1, _searchCriteria_primary_rooms__children, _searchCriteria2, _searchCriteria3;
    var _ref = ((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.lodgingChatbot) || {}, header = _ref.header, action = _ref.action, content = _ref.content;
    var context = useBexApi12().context;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyIdFromDetailsQuery = _usePropertyDetailsInputs.propertyId, searchCriteriaFromDetailsQuery = _usePropertyDetailsInputs.searchCriteria;
    var _usePropertiesSummaryInputs = usePropertiesSummaryInputs(), propertyIdFromSummaryQuery = _usePropertiesSummaryInputs.propertyId, searchCriteriaFromSummaryQuery = _usePropertiesSummaryInputs.searchCriteria;
    var propertyId = propertyIdFromDetailsQuery !== void 0 ? propertyIdFromDetailsQuery : propertyIdFromSummaryQuery;
    var searchCriteria = searchCriteriaFromDetailsQuery !== void 0 ? searchCriteriaFromDetailsQuery : searchCriteriaFromSummaryQuery;
    var _useState3 = _sliced_to_array(useState3(false), 2), loaded = _useState3[0], setLoad = _useState3[1];
    var _useState31 = _sliced_to_array(useState3(false), 2), shouldLoadSurvey = _useState31[0], setShouldLoadSurvey = _useState31[1];
    var _useDialog16 = _sliced_to_array(useDialog16("virtual-agent-control-exit-survey-feedback"), 3), isDialogOpen = _useDialog16[0], dialogActions = _useDialog16[1], DialogComponent = _useDialog16[2];
    var clickTracker = useClickTracker40();
    var _useLogger = useLogger(), logInfo = _useLogger.info;
    var message = chatbotAnalyticsSchema("VR-SHOPPING", applicationName, propertyId);
    var currency = context.currency;
    var identity = context.identity;
    var havId = (_identity = identity) === null || _identity === void 0 ? void 0 : _identity.expUserId;
    var VAC_EVENTS = {
        VAC_WidgetOpened: "chatbot.presented",
        VAC_WidgetClosed: "chatbot.hidden",
        VAC_ConversationCreated: "chatbot_conversation.created",
        VAC_ChatMsgReceived: "chatbot_user_message.submitted",
        VAC_ChatMsgSent: "chatbot_response_message.presented"
    };
    if (!header) {
        return null;
    }
    if (currency == null) {
        currency = void 0;
    }
    if (havId == null) {
        havId = void 0;
    }
    var dateToString = function(date) {
        return "".concat(date.year, "-").concat(date.month, "-").concat(date.day);
    };
    var launchChatUi = function() {
        if (!loaded) {
            clickTracker("HOT.HIS.ChatbotLaunch", "chatbot_entrypoint.selected", void 0, [
                message
            ]);
            setLoad(true);
        } else {
            try {
                window.virtualAgentControl.openChatWidget();
            } catch (e) {
                logInfo("Virtual agent control not loaded");
            }
        }
    };
    var eventHandler = function(event) {
        clickTracker(event.type, VAC_EVENTS[event.type], void 0, [
            message
        ]);
        if (event.type === "VAC_WidgetClosed") {
            setShouldLoadSurvey(true);
        }
    };
    return /* @__PURE__ */ React154.createElement("div", null, /* @__PURE__ */ React154.createElement(Viewport22, null, /* @__PURE__ */ React154.createElement(ViewLarge13, null, /* @__PURE__ */ React154.createElement(UitkLayoutFlex34, {
        justifyContent: "center",
        wrap: "wrap"
    }, /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem24, {
        minWidth: "full_width",
        alignSelf: "center"
    }, /* @__PURE__ */ React154.createElement(UitkSpacing62, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React154.createElement(UitkText39, {
        size: 300,
        align: "center"
    }, content))), /* @__PURE__ */ React154.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React154.createElement(UitkSpacing62, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React154.createElement("div", null, /* @__PURE__ */ React154.createElement(UitkSecondaryButton3, {
        onClick: launchChatUi
    }, (_action = action) === null || _action === void 0 ? void 0 : _action.primary)))))), /* @__PURE__ */ React154.createElement(ViewSmall22, null, /* @__PURE__ */ React154.createElement(UitkCard9, {
        overflow: false,
        padded: true
    }, /* @__PURE__ */ React154.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React154.createElement(UitkHeading25, {
        size: 5,
        tag: "h2"
    }, (_header = header) === null || _header === void 0 ? void 0 : _header.text)), /* @__PURE__ */ React154.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React154.createElement(UitkText39, {
        spacing: "four"
    }, content)), /* @__PURE__ */ React154.createElement(UitkSpacing62, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React154.createElement(UitkCardContentSection9, {
        padded: false
    }, /* @__PURE__ */ React154.createElement(UitkSecondaryButton3, {
        onClick: launchChatUi
    }, (_action1 = action) === null || _action1 === void 0 ? void 0 : _action1.primary)))))), loaded && /* @__PURE__ */ React154.createElement(VirtualAgentControl, {
        applicationName: applicationName,
        pageName: pageName,
        clientOverrides: {
            enableAutoOpenChatWidget: true,
            conversationProperties: {
                listingId: String(propertyId),
                checkin: dateToString((_searchCriteria = searchCriteria) === null || _searchCriteria === void 0 ? void 0 : (_searchCriteria_primary_dateRange = _searchCriteria.primary.dateRange) === null || _searchCriteria_primary_dateRange === void 0 ? void 0 : _searchCriteria_primary_dateRange.checkInDate),
                checkout: dateToString((_searchCriteria1 = searchCriteria) === null || _searchCriteria1 === void 0 ? void 0 : (_searchCriteria_primary_dateRange1 = _searchCriteria1.primary.dateRange) === null || _searchCriteria_primary_dateRange1 === void 0 ? void 0 : _searchCriteria_primary_dateRange1.checkOutDate),
                children: (_searchCriteria2 = searchCriteria) === null || _searchCriteria2 === void 0 ? void 0 : (_searchCriteria_primary_rooms__children = _searchCriteria2.primary.rooms[0].children) === null || _searchCriteria_primary_rooms__children === void 0 ? void 0 : _searchCriteria_primary_rooms__children.length,
                adults: (_searchCriteria3 = searchCriteria) === null || _searchCriteria3 === void 0 ? void 0 : _searchCriteria3.primary.rooms[0].adults,
                pets: 0,
                device: "WEB",
                currency: currency,
                bookNow: "",
                havId: havId,
                site: "expedia",
                hostname: window.location.hostname,
                chatbotName: "shopping-pwa.pdp",
                chatbotEntryPoint: "VR-SHOPPING"
            },
            subscribedEvents: _to_consumable_array(Object.keys(VAC_EVENTS)),
            eventHandler: eventHandler
        },
        inputs: {}
    }), shouldLoadSurvey && /* @__PURE__ */ React154.createElement(VirtualAgentControlExitSurvey, {
        chatbotEntryPoint: "chat-now-button",
        chatbotName: "shopping-pwa",
        timeoutMs: 1e4,
        onDismiss: function() {
            return setShouldLoadSurvey(false);
        },
        inputs: {
            propertyId: String(propertyId)
        }
    }), isDialogOpen && /* @__PURE__ */ React154.createElement(DialogComponent, null, /* @__PURE__ */ React154.createElement(VirtualAgentControlExitSurveyFeedback, {
        inputs: {
            propertyId: String(propertyId)
        },
        onDismiss: dialogActions.closeDialog
    })));
};
SummaryChatbotLaunch.fragment = __SummaryChatbotLaunchFragment;
SummaryChatbotLaunch.displayName = "SummaryChatbotLaunch";
// src/components/summary/__private/__fragments/geo/index.tsx
import React155 from "react";
import { gql as gql137 } from "@apollo/client";
import { ViewLarge as ViewLarge14, ViewMedium as ViewMedium12, Viewport as Viewport23, ViewSmall as ViewSmall23 } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType10 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex35, UitkLayoutFlexItem as UitkLayoutFlexItem25 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing63 } from "uitk-react-spacing";
var __SummaryGeoFragment = gql137(_templateObject138(), SummaryMapTrigger.fragment, SummaryNearByPois.fragment);
var SummaryGeo = function(param) {
    var data = param.data, onClickMap = param.onClickMap;
    var _data_summary_location, _data_summary, _data_summary_location1, _data_summary1;
    var areMapsEnabled = ((_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_location = _data_summary.location) === null || _data_summary_location === void 0 ? void 0 : _data_summary_location.staticImage) && ((_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : (_data_summary_location1 = _data_summary1.location) === null || _data_summary_location1 === void 0 ? void 0 : _data_summary_location1.mapDialog);
    return /* @__PURE__ */ React155.createElement(Viewport23, null, /* @__PURE__ */ React155.createElement(ViewSmall23, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex35, {
        direction: "column",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType10.R21_9
    }))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))), /* @__PURE__ */ React155.createElement(ViewMedium12, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex35, {
        direction: "row",
        space: "three"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType10.R21_9
    }))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, {
        minWidth: "full_width"
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))), /* @__PURE__ */ React155.createElement(ViewLarge14, null, /* @__PURE__ */ React155.createElement(UitkLayoutFlex35, {
        direction: "column"
    }, areMapsEnabled && /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React155.createElement(UitkSpacing63, {
        padding: {
            large: {
                blockend: "six"
            }
        }
    }, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "map-image-link"
    }, /* @__PURE__ */ React155.createElement(SummaryMapTrigger, {
        data: data,
        onClickMap: onClickMap,
        aspectRatio: UitkFigureAspectRatioType10.R16_9
    })))), /* @__PURE__ */ React155.createElement(UitkLayoutFlexItem25, null, /* @__PURE__ */ React155.createElement("div", {
        "data-stid": "location-summary"
    }, /* @__PURE__ */ React155.createElement(SummaryNearByPois, {
        data: data
    }))))));
};
SummaryGeo.displayName = "SummaryGeo";
SummaryGeo.fragment = __SummaryGeoFragment;
// src/components/summary/summary-fragment.ts
import { gql as gql138 } from "@apollo/client";
var __SummaryFragment = gql138(_templateObject139(), SummaryAmenities.fragment, SummaryHeader.fragment, SummaryMapTrigger.fragment, SummaryNearByPois.fragment, SummaryReviews.fragment, SummaryBannerMessage.fragment, SummaryChatbotLaunch.fragment, LocationHighlights.fragment, RelevantAmenities.fragment);
// src/components/summary/summary.tsx
var CarouselComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React156.createElement(React156.Fragment, null, children);
};
var HighlightedBenefitsComponent = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React156.createElement(React156.Fragment, null, children);
};
var Summary = function(param) {
    var data = param.data, onClickReviews = param.onClickReviews, onClickMap = param.onClickMap, children = param.children, triggerRef = param.triggerRef, _param_hideHeader = param.hideHeader, hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader;
    var _searchCriteriaFromDetailsQuery_secondary, _searchCriteriaFromDetailsQuery, _searchCriteriaFromSummaryQuery_secondary, _searchCriteriaFromSummaryQuery;
    var _usePropertyDetailsInputs = usePropertyDetailsInputs(), propertyIdFromDetailsQuery = _usePropertyDetailsInputs.propertyId, searchCriteriaFromDetailsQuery = _usePropertyDetailsInputs.searchCriteria;
    var _usePropertiesSummaryInputs = usePropertiesSummaryInputs(), propertyIdFromSummaryQuery = _usePropertiesSummaryInputs.propertyId, searchCriteriaFromSummaryQuery = _usePropertiesSummaryInputs.searchCriteria;
    var propertyId = propertyIdFromDetailsQuery !== void 0 ? propertyIdFromDetailsQuery : propertyIdFromSummaryQuery;
    var searchCriteriaSelections = searchCriteriaFromDetailsQuery !== void 0 ? (_searchCriteriaFromDetailsQuery = searchCriteriaFromDetailsQuery) === null || _searchCriteriaFromDetailsQuery === void 0 ? void 0 : (_searchCriteriaFromDetailsQuery_secondary = _searchCriteriaFromDetailsQuery.secondary) === null || _searchCriteriaFromDetailsQuery_secondary === void 0 ? void 0 : _searchCriteriaFromDetailsQuery_secondary.selections : ((_searchCriteriaFromSummaryQuery = searchCriteriaFromSummaryQuery) === null || _searchCriteriaFromSummaryQuery === void 0 ? void 0 : (_searchCriteriaFromSummaryQuery_secondary = _searchCriteriaFromSummaryQuery.secondary) === null || _searchCriteriaFromSummaryQuery_secondary === void 0 ? void 0 : _searchCriteriaFromSummaryQuery_secondary.selections) || [];
    return /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        margin: {
            blockend: "three"
        },
        padding: {
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React156.createElement(UitkCard10, {
        className: "uitk-flat-border-top",
        overflow: true
    }, /* @__PURE__ */ React156.createElement(UitkCardContentSection10, null, /* @__PURE__ */ React156.createElement(UitkLayoutGrid16, {
        columns: {
            small: 1,
            medium: 1,
            large: 12
        }
    }, /* @__PURE__ */ React156.createElement(UitkLayoutGridItem15, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 8
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            large: {
                inlineend: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", null, !hideHeader && /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            small: {
                blockend: "four"
            },
            large: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", {
        "data-stid": "content-hotel-title"
    }, /* @__PURE__ */ React156.createElement(SummaryHeader, {
        data: data
    }))), findReactChildByType(children, HighlightedBenefitsComponent), /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryBannerMessage, {
        data: data
    })), /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryReviews, {
        data: data,
        onClickReviews: onClickReviews,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(LocationHighlights, {
        data: data
    })), findReactChildByType(children, CarouselComponent), /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement(SummaryAmenities, {
        data: data
    })), /* @__PURE__ */ React156.createElement(Experiment14, {
        name: "Amenity_Module_Web_"
    }, /* @__PURE__ */ React156.createElement(ExperimentControl14, null), /* @__PURE__ */ React156.createElement(ExperimentVariant14, {
        bucket: 1
    }, /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(RelevantContent, {
        inputs: {
            productIdentifier: {
                id: propertyId,
                type: IdentifierType2.PROPERTY_ID,
                searchCriteriaSelections: searchCriteriaSelections
            }
        }
    }))))))))), /* @__PURE__ */ React156.createElement(UitkLayoutGridItem15, {
        colSpan: {
            small: 1,
            medium: 1,
            large: 4
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        margin: {
            large: {
                inlinestart: "three",
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React156.createElement("div", null, /* @__PURE__ */ React156.createElement(SummaryGeo, {
        data: data,
        onClickMap: onClickMap
    })))))), /* @__PURE__ */ React156.createElement(UitkSpacing64, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React156.createElement(RelevantAmenities, {
        data: data
    })))));
};
Summary.displayName = "Summary";
Summary.fragment = __SummaryFragment;
// src/components/summary/placeholder.tsx
import React157 from "react";
import { UitkCard as UitkCard11, UitkCardContentSection as UitkCardContentSection11 } from "uitk-react-cards";
import { UitkLineSkeleton as UitkLineSkeleton5 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing65 } from "uitk-react-spacing";
var SummaryPlaceholder = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React157.createElement(UitkSpacing65, {
        margin: {
            blockend: "three"
        },
        padding: {
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React157.createElement(UitkCard11, {
        className: "uitk-flat-border-top"
    }, /* @__PURE__ */ React157.createElement(UitkCardContentSection11, null, /* @__PURE__ */ React157.createElement(UitkSpacing65, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React157.createElement("div", null, /* @__PURE__ */ React157.createElement(SummaryHeaderPlaceholder, {
        data: data
    }))), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null), /* @__PURE__ */ React157.createElement(SummaryComponentPlaceholder, null))));
};
var SummaryComponentPlaceholder = function() {
    return /* @__PURE__ */ React157.createElement(UitkSpacing65, {
        margin: {
            blockstart: "three"
        },
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React157.createElement("div", null, /* @__PURE__ */ React157.createElement(UitkSpacing65, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React157.createElement(UitkLineSkeleton5, {
        animation: false,
        type: "primary"
    })), /* @__PURE__ */ React157.createElement(UitkLineSkeleton5, {
        animation: false,
        type: "secondary"
    })));
};
// src/components/whats-around/whats-around.tsx
import React164 from "react";
import { gql as gql145 } from "@apollo/client";
import { UitkCard as UitkCard13, UitkCardContentSection as UitkCardContentSection13 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid17, UitkLayoutGridItem as UitkLayoutGridItem16 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing71 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading28 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
import React159 from "react";
import { gql as gql140 } from "@apollo/client";
import { UitkSpacing as UitkSpacing67 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading26, UitkText as UitkText40 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-link.tsx
import React158 from "react";
import { gql as gql139 } from "@apollo/client";
import { useClickTracker as useClickTracker41 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium13, Viewport as Viewport24, ViewSmall as ViewSmall24 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon27 } from "uitk-react-icons";
import { UitkLink as UitkLink17 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing66 } from "uitk-react-spacing";
var __WhatsAroundLinkFragment = gql139(_templateObject140());
var WhatsAroundLink = function(param) {
    var data = param.data, index = param.index;
    var _data, _data_link_uri, _data_link, _data1, _icon;
    var track = useClickTracker41();
    if (!((_data = data) === null || _data === void 0 ? void 0 : _data.value) || !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_link = _data1.link) === null || _data_link === void 0 ? void 0 : (_data_link_uri = _data_link.uri) === null || _data_link_uri === void 0 ? void 0 : _data_link_uri.value)) {
        return null;
    }
    var handleClick = function() {
        if (data.link.clientSideAnalytics) {
            track(data.link.clientSideAnalytics.referrerId, data.link.clientSideAnalytics.linkName);
        }
    };
    var text = data.value;
    var linkUrl = data.link.uri.value;
    var icon = data.icon;
    return /* @__PURE__ */ React158.createElement(Viewport24, null, /* @__PURE__ */ React158.createElement(ViewSmall24, null, /* @__PURE__ */ React158.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick
    }, text)), /* @__PURE__ */ React158.createElement(ViewMedium13, null, /* @__PURE__ */ React158.createElement(Link, {
        href: linkUrl,
        onClickCapture: handleClick,
        target: "_blank"
    }, text, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React158.createElement(UitkIcon27, {
        id: "".concat(icon.id, "-").concat(index),
        name: icon.id,
        title: icon.description
    }))));
};
WhatsAroundLink.displayName = "WhatsAroundLink";
WhatsAroundLink.fragment = __WhatsAroundLinkFragment;
var Link = function(_param) /* @__PURE__ */ {
    var href = _param.href, target = _param.target, children = _param.children, props = _object_without_properties(_param, [
        "href",
        "target",
        "children"
    ]);
    return React158.createElement(UitkSpacing66, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React158.createElement(UitkLink17, _object_spread({}, props), /* @__PURE__ */ React158.createElement("a", {
        href: href,
        target: target
    }, children)));
};
var whats_around_link_default = WhatsAroundLink;
// src/components/whats-around/__private/__fragments/whats-around-editorial.tsx
var __WhatsAroundEditorialFragment = gql140(_templateObject141(), whats_around_link_default.fragment);
var WhatsAroundEditorial = function(param) {
    var data = param.data;
    var _crossLinks;
    if (!data || !data.content || data.content.length <= 0) {
        return null;
    }
    var title = data.title, crossLinks = data.crossLinks, contentList = data.content;
    var content = contentList[0];
    return /* @__PURE__ */ React159.createElement("section", null, title && /* @__PURE__ */ React159.createElement(UitkHeading26, {
        tag: "h3",
        size: 5
    }, title), content && /* @__PURE__ */ React159.createElement(React159.Fragment, null, /* @__PURE__ */ React159.createElement(UitkSpacing67, {
        padding: {
            blockstart: "three",
            blockend: "three"
        }
    }, /* @__PURE__ */ React159.createElement("div", {
        itemProp: "geo",
        itemScope: true,
        itemType: "https://schema.org/GeoCoordinates"
    }, /* @__PURE__ */ React159.createElement("meta", {
        itemProp: "description",
        content: content
    }), /* @__PURE__ */ React159.createElement(UitkText40, {
        size: 300
    }, content))), (_crossLinks = crossLinks) === null || _crossLinks === void 0 ? void 0 : _crossLinks.map(function(crossLink, index) {
        return /* @__PURE__ */ React159.createElement(UitkSpacing67, {
            padding: {
                blockend: "two"
            },
            key: index
        }, /* @__PURE__ */ React159.createElement("div", null, /* @__PURE__ */ React159.createElement(whats_around_link_default, {
            data: crossLink,
            index: index
        })));
    })));
};
WhatsAroundEditorial.displayName = "WhatsAroundEditorial";
WhatsAroundEditorial.fragment = __WhatsAroundEditorialFragment;
// src/components/whats-around/__private/__fragments/whats-around-map.tsx
import React160 from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql141 } from "@apollo/client";
import { useClickTracker as useClickTracker42 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog17 } from "@shared-ui/dialog-context";
import { UitkCard as UitkCard12, UitkCardContentSection as UitkCardContentSection12, UitkCardLink as UitkCardLink3 } from "uitk-react-cards";
import { UitkFigure as UitkFigure7, UitkFigureAspectRatioType as UitkFigureAspectRatioType11, UitkImage as UitkImage6 } from "uitk-react-images";
import { UitkLink as UitkLink18 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing68 } from "uitk-react-spacing";
var __WhatsAroundMapFragment = gql141(_templateObject142());
var WhatsAroundMap = function(param) {
    var data = param.data, mapCTALabel = param.mapCTALabel, propertyId = param.propertyId;
    var _data;
    var _useDialog17 = _sliced_to_array(useDialog17("whats-around-map"), 3), mapDialogActions = _useDialog17[1], MapDialogWrapper = _useDialog17[2];
    var mapTriggerRef = React160.useRef(null);
    var _ref = ((_data = data) === null || _data === void 0 ? void 0 : _data.staticImage) || {}, description = _ref.description, url = _ref.url;
    var hasMapCTALabel = Boolean(mapCTALabel);
    var track = useClickTracker42();
    var handleMapTrigger = React160.useCallback(function(id, desc) {
        return function(e) {
            e.preventDefault();
            track(id, desc);
            mapDialogActions.openDialog();
        };
    }, [
        track,
        mapDialogActions
    ]);
    var closeMapDialog = React160.useCallback(function() {
        mapDialogActions.closeDialog();
    }, [
        mapDialogActions
    ]);
    return /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(MapDialogWrapper, null, /* @__PURE__ */ React160.createElement(Map, {
        inputs: {
            propertyId: propertyId
        },
        onClose: closeMapDialog,
        triggerRef: mapTriggerRef
    })), /* @__PURE__ */ React160.createElement(UitkSpacing68, {
        margin: {
            blockend: "six"
        },
        "data-stid": "whats-around-map"
    }, /* @__PURE__ */ React160.createElement(UitkCard12, {
        border: hasMapCTALabel
    }, /* @__PURE__ */ React160.createElement(UitkCardContentSection12, {
        padded: false
    }, /* @__PURE__ */ React160.createElement(LazyLoad, {
        height: 200
    }, /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement("h3", {
        className: "is-visually-hidden"
    }, description), /* @__PURE__ */ React160.createElement(UitkFigure7, {
        ratio: UitkFigureAspectRatioType11.R21_9,
        imageFit: "cover"
    }, /* @__PURE__ */ React160.createElement(UitkImage6, {
        alt: "",
        src: url || ""
    }))))), /* @__PURE__ */ React160.createElement(UitkCardLink3, null, /* @__PURE__ */ React160.createElement("section", {
        className: "uitk-button",
        onClickCapture: handleMapTrigger("HOT.HIS:WhatsAroundMap.Open", "Launch dynamic map")
    }, description)), mapCTALabel && /* @__PURE__ */ React160.createElement(UitkCardContentSection12, {
        className: "uitk-type-300",
        border: "top"
    }, /* @__PURE__ */ React160.createElement(UitkCardLink3, null, /* @__PURE__ */ React160.createElement("button", {
        ref: mapTriggerRef,
        type: "button",
        onClickCapture: handleMapTrigger("WhatsAroundMap.ClickLinkViewMap", "Launch dynamic map")
    }, mapCTALabel)), /* @__PURE__ */ React160.createElement(UitkLink18, {
        inline: true
    }, /* @__PURE__ */ React160.createElement("button", {
        type: "button"
    }, mapCTALabel))))));
};
WhatsAroundMap.displayName = "WhatsAroundMap";
WhatsAroundMap.fragment = __WhatsAroundMapFragment;
var whats_around_map_default = WhatsAroundMap;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
import React163 from "react";
import { gql as gql144 } from "@apollo/client";
import { UitkLayoutColumns as UitkLayoutColumns3, UitkLayoutColumnsItem as UitkLayoutColumnsItem2 } from "uitk-react-layout-columns";
import { UitkLayoutFlex as UitkLayoutFlex36, UitkLayoutFlexItem as UitkLayoutFlexItem26 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing70 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading27 } from "uitk-react-text";
// src/components/whats-around/__private/__fragments/whats-around-icon.tsx
import React161 from "react";
import { gql as gql142 } from "@apollo/client";
import { UitkIcon as UitkIcon28 } from "uitk-react-icons";
var __WhatsAroundIconFragment = gql142(_templateObject143());
var WhatsAroundIcon = function(param) {
    var data = param.data;
    if (!data) {
        return null;
    }
    var icon = data.iconId;
    return /* @__PURE__ */ React161.createElement(UitkIcon28, {
        id: "".concat(icon, "-icon"),
        name: icon
    });
};
WhatsAroundIcon.displayName = "WhatsAroundIcon";
WhatsAroundIcon.fragment = __WhatsAroundIconFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois-item.tsx
import React162 from "react";
import { gql as gql143 } from "@apollo/client";
import { UitkList as UitkList6, UitkListItem as UitkListItem4 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing69 } from "uitk-react-spacing";
import { UitkText as UitkText41 } from "uitk-react-text";
var __WhatsAroundPoisItemFragment = gql143(_templateObject144(), WhatsAroundIcon.fragment);
var WhatsAroundPoisItem = function(param) {
    var data = param.data, hideIcon = param.hideIcon;
    var bullet = hideIcon ? "no-bullet" : "icon-standard";
    return /* @__PURE__ */ React162.createElement(UitkSpacing69, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React162.createElement(UitkList6, {
        bullet: bullet,
        spacing: false
    }, data.items.map(function(item, idx) {
        return /* @__PURE__ */ React162.createElement(UitkListItem4, {
            key: "whats-around-pois-list-".concat(idx)
        }, !hideIcon && /* @__PURE__ */ React162.createElement(WhatsAroundIcon, {
            data: item.icon
        }), /* @__PURE__ */ React162.createElement(UitkText41, null, item.text, item.moreInfo && " - ".concat(item.moreInfo)));
    })));
};
WhatsAroundPoisItem.displayName = "WhatsAroundPoisItem";
WhatsAroundPoisItem.fragment = __WhatsAroundPoisItemFragment;
// src/components/whats-around/__private/__fragments/whats-around-pois.tsx
var __WhatsAroundPoisFragment = gql144(_templateObject145(), WhatsAroundIcon.fragment, WhatsAroundPoisItem.fragment);
var sortAndByIcon = function(poisType) {
    return poisType.reduce(function(sortedList, item) {
        var _item_icon;
        var newSortedList = _to_consumable_array(sortedList);
        switch((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.iconId){
            case "place":
                newSortedList[0] = item;
                break;
            case "lob_cars":
                newSortedList[1] = item;
                break;
            case "local_dining":
                newSortedList[2] = item;
                break;
            default:
                newSortedList.push(item);
                break;
        }
        return newSortedList;
    }, []);
};
var WhatsAroundPois = function(param) {
    var data = param.data;
    if (!data || !data.nearbyPOIs || data.nearbyPOIs.length <= 0) {
        return null;
    }
    var sortedPois = sortAndByIcon(data.nearbyPOIs);
    return /* @__PURE__ */ React163.createElement(UitkLayoutColumns3, {
        columns: 2,
        minWidth: "seventy_two"
    }, sortedPois.map(function(section, idx) {
        return /* @__PURE__ */ React163.createElement(WhatsAroundPoiSection, _object_spread_props(_object_spread({}, section), {
            key: idx
        }));
    }));
};
var WhatsAroundPoiSection = function(props) {
    var _icon;
    var title = props.title, items = props.items, icon = props.icon;
    if (!title || !items || !items.length) {
        return null;
    }
    var hideIcon = ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.iconId) !== "lob_cars";
    return /* @__PURE__ */ React163.createElement(UitkLayoutColumnsItem2, {
        forceNoBreak: true
    }, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(UitkSpacing70, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React163.createElement(UitkLayoutFlex36, {
        space: "three"
    }, /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem26, null, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(WhatsAroundIcon, {
        data: icon
    }))), /* @__PURE__ */ React163.createElement(UitkLayoutFlexItem26, null, /* @__PURE__ */ React163.createElement("div", null, /* @__PURE__ */ React163.createElement(UitkHeading27, {
        tag: "h4",
        size: 5
    }, title), /* @__PURE__ */ React163.createElement(WhatsAroundPoisItem, {
        data: props,
        hideIcon: hideIcon
    })))))));
};
WhatsAroundPois.displayName = "WhatsAroundPois";
WhatsAroundPois.fragment = __WhatsAroundPoisFragment;
// src/components/whats-around/whats-around.tsx
var __WhatsAroundFragment = gql145(_templateObject146(), WhatsAroundEditorial.fragment, WhatsAroundPois.fragment, whats_around_map_default.fragment);
var WhatsAround = function(props) {
    var _data_summary_map, _data_summary, _data, _data_summary1, _data1, _data_summary2;
    var data = props.data;
    var mapProps = {
        mapCTALabel: (_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = (((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_summary1 = _data1.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.location) || {
        whatsAround: null
    }).whatsAround;
    if (!data || !whatsAround) {
        return null;
    }
    return /* @__PURE__ */ React164.createElement(UitkSpacing71, {
        padding: {
            small: {
                block: "six",
                inline: "three"
            },
            large: {
                block: "six",
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React164.createElement(UitkCard13, null, /* @__PURE__ */ React164.createElement(UitkCardContentSection13, null, /* @__PURE__ */ React164.createElement(UitkLayoutGrid17, {
        columns: {
            small: 1,
            medium: 1,
            large: 3
        },
        space: "six"
    }, /* @__PURE__ */ React164.createElement(UitkLayoutGridItem16, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 1
        }
    }, /* @__PURE__ */ React164.createElement("div", null, /* @__PURE__ */ React164.createElement(UitkSpacing71, {
        padding: {
            inlineend: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React164.createElement(UitkHeading28, {
        tag: "h2",
        size: 4,
        tabIndex: -1
    }, whatsAround.title)), /* @__PURE__ */ React164.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))), /* @__PURE__ */ React164.createElement(UitkLayoutGridItem16, {
        colSpan: {
            small: 3,
            medium: 3,
            large: 2
        }
    }, /* @__PURE__ */ React164.createElement("div", null, ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map) && /* @__PURE__ */ React164.createElement(whats_around_map_default, _object_spread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React164.createElement(WhatsAroundPois, {
        data: whatsAround
    })))))));
};
WhatsAround.displayName = "WhatsAround";
WhatsAround.fragment = __WhatsAroundFragment;
// src/components/whats-around/whats-around-pois-view.tsx
import React165 from "react";
import { ViewLarge as ViewLarge15, Viewport as Viewport25, ViewSmall as ViewSmall25 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard14, UitkCardContentSection as UitkCardContentSection14 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid18, UitkLayoutGridItem as UitkLayoutGridItem17 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing72 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading29 } from "uitk-react-text";
var WhatsAroundPoisView = function(param) {
    var data = param.data;
    var _data_summary_map, _data_summary, _data, _data_summary1, _data1, _data_summary2;
    var mapProps = {
        mapCTALabel: (_data = data) === null || _data === void 0 ? void 0 : (_data_summary = _data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_map = _data_summary.map) === null || _data_summary_map === void 0 ? void 0 : _data_summary_map.trigger.value,
        propertyId: data.id
    };
    var whatsAround = (((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_summary1 = _data1.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.location) || {
        whatsAround: null
    }).whatsAround;
    if (!data || !whatsAround) {
        return null;
    }
    var poisColumn = /* @__PURE__ */ React165.createElement(UitkLayoutGridItem17, {
        colSpan: 1
    }, /* @__PURE__ */ React165.createElement("div", null, /* @__PURE__ */ React165.createElement(UitkSpacing72, {
        padding: {
            inlineend: "three",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React165.createElement(UitkHeading29, {
        tag: "h2",
        size: 4
    }, whatsAround.title)), /* @__PURE__ */ React165.createElement(WhatsAroundPois, {
        data: whatsAround
    })));
    return /* @__PURE__ */ React165.createElement(React165.Fragment, null, /* @__PURE__ */ React165.createElement(Viewport25, null, /* @__PURE__ */ React165.createElement(ViewSmall25, null, whatsAround.nearbyPOIs.length > 0 ? /* @__PURE__ */ React165.createElement(UitkSpacing72, {
        padding: {
            block: "six",
            inline: "three"
        }
    }, /* @__PURE__ */ React165.createElement(UitkCard14, null, /* @__PURE__ */ React165.createElement(UitkCardContentSection14, null, /* @__PURE__ */ React165.createElement(UitkLayoutGrid18, {
        columns: 1,
        space: "six"
    }, poisColumn)))) : /* @__PURE__ */ React165.createElement(React165.Fragment, null)), /* @__PURE__ */ React165.createElement(ViewLarge15, null, /* @__PURE__ */ React165.createElement(UitkSpacing72, {
        padding: {
            block: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React165.createElement(UitkCard14, null, /* @__PURE__ */ React165.createElement(UitkCardContentSection14, null, /* @__PURE__ */ React165.createElement(UitkLayoutGrid18, {
        columns: 2,
        space: "six"
    }, poisColumn, /* @__PURE__ */ React165.createElement(UitkLayoutGridItem17, {
        colSpan: 1
    }, /* @__PURE__ */ React165.createElement("div", null, ((_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.map) && /* @__PURE__ */ React165.createElement(WhatsAroundMap, _object_spread({
        data: whatsAround
    }, mapProps)), /* @__PURE__ */ React165.createElement(WhatsAroundEditorial, {
        data: whatsAround.editorial
    }))))))))));
};
WhatsAroundPoisView.displayName = "WhatsAroundPoisView";
WhatsAroundPoisView.fragment = __WhatsAroundFragment;
// src/components/property-details.tsx
var __Query6 = gql146(_templateObject147(), AmenityDescription.fragment, Policies.fragment, DetailedAmenities.fragment, ImportantInfo.fragment, FrequentlyAskedQuestions.fragment, NavigationBar.fragment, AboutThisProperty.fragment, WhatsAround.fragment, Gallery.fragment, BookByPhone.fragment, __SummaryFragment, SpaceOverview.fragment, InventorySource.fragment, Shortlist.fragment, SaveTripItem.fragment, AmenitiesSimplifiedView.fragment, RelevantAmenities.fragment, SpecialFeatures.fragment, LocationHighlights.fragment, HostProfile.fragment, PropertyDirectFeedbackPromptIdFragment);
function withPropertyDetailsQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertyDetailsComponent = function(props) {
        var _data, _data_propertyInfo_summary_amenities, _data_propertyInfo_summary, _data_propertyInfo, _data1;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi13().context;
        var _useContext2 = _sliced_to_array(useContext2(AmenitiesAdaptExContext), 2), setAdaptExState = _useContext2[1];
        var _inputs_isDateless;
        var variables = _object_spread_props(_object_spread({
            context: context
        }, inputs || {}), {
            isDateless: (_inputs_isDateless = inputs.isDateless) !== null && _inputs_isDateless !== void 0 ? _inputs_isDateless : true
        });
        var _useQuery8 = useQuery8(__Query6, {
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery8.data, loading = _useQuery8.loading;
        var propertyInfo = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyInfo;
        var reserveAdaptExSuccessEvents = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_propertyInfo = _data1.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : (_data_propertyInfo_summary = _data_propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : (_data_propertyInfo_summary_amenities = _data_propertyInfo_summary.amenities) === null || _data_propertyInfo_summary_amenities === void 0 ? void 0 : _data_propertyInfo_summary_amenities.reserveAdaptExSuccessEvents;
        useEffect4(function() {
            if (reserveAdaptExSuccessEvents) {
                setAdaptExState({
                    reserveAdaptExSuccessEvents: reserveAdaptExSuccessEvents
                });
            }
        }, [
            reserveAdaptExSuccessEvents
        ]);
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React166.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React166.createElement(InputsContext.Provider, {
            value: inputs
        }, /* @__PURE__ */ React166.createElement(WrappedComponent, _object_spread({
            data: propertyInfo
        }, props)));
    };
    PropertyDetailsComponent.displayName = displayName;
    return PropertyDetailsComponent;
}
var PropertyFaq = withPropertyDetailsQuery(FrequentlyAskedQuestions, "PropertyFaq");
var PropertyAmenityDescription = withPropertyDetailsQuery(AmenityDescription, "PropertyAmenityDescription");
var PropertyPolicies = withPropertyDetailsQuery(Policies, "PropertyPolicies");
var PropertyImportantInfo = withPropertyDetailsQuery(ImportantInfo, "PropertyImportantInfo");
var PropertySpecialFeatures = withPropertyDetailsQuery(SpecialFeatures, "PropertySpecialFeatures");
var PropertyNavigationBar = withPropertyDetailsQuery(NavigationBar, "PropertyNavigationBar", NavigationBarPlaceholder);
var PropertyAboutThisProperty = withPropertyDetailsQuery(AboutThisProperty, "PropertyAboutThisProperty");
var PropertyWhatsAround = withPropertyDetailsQuery(WhatsAround, "PropertyImportantInfo");
var PropertyWhatsAroundPoisView = withPropertyDetailsQuery(WhatsAroundPoisView, "PropertyImportantInfo");
var PropertyGallery = withPropertyDetailsQuery(Gallery, "PropertyGallery", GalleryPlaceholder);
var PropertyBookByPhone = withPropertyDetailsQuery(BookByPhone, "PropertyBookByPhone", BookByPhonePlaceholder);
var PropertySpaceOverview = withPropertyDetailsQuery(SpaceOverview, "PropertySpaceOverview");
var PropertyInventorySource = withPropertyDetailsQuery(InventorySource, "PropertyInventorySource");
var PropertyAmenitiesSimplifiedView = withPropertyDetailsQuery(AmenitiesSimplifiedView, "PropertyAmenitiesSimplifiedView");
var PropertyRelevantAmenities = withPropertyDetailsQuery(RelevantAmenities, "PropertyRelevantAmenities");
var PropertyLocationHighlights = withPropertyDetailsQuery(LocationHighlights, "PropertyLocationHighlights");
var PropertyHostProfile = withPropertyDetailsQuery(HostProfile, "PropertyHostProfile");
var PropertySummary = Object.assign(withPropertyDetailsQuery(Summary, "PropertySummary", SummaryPlaceholder), {
    CarouselComponent: CarouselComponent,
    HighlightedBenefitsComponent: HighlightedBenefitsComponent
});
var PropertySummaryHeader = withPropertyDetailsQuery(SummaryHeader, "PropertySummaryHeader", SummaryHeaderPlaceholder);
var PropertySummaryReviews = withPropertyDetailsQuery(SummaryReviews, "PropertySummaryReviews", SummaryComponentPlaceholder);
var PropertySummaryAmenities = withPropertyDetailsQuery(SummaryAmenities, "PropertySummaryAmenities", SummaryComponentPlaceholder);
var PropertyDetailedAmenities = withPropertyDetailsQuery(DetailedAmenities, "PropertyDetailedAmenities", SummaryComponentPlaceholder);
var PropertySummaryNearByPois = withPropertyDetailsQuery(SummaryNearByPois, "PropertySummaryNearByPois");
var PropertySummaryMapTrigger = withPropertyDetailsQuery(SummaryMapTrigger, "PropertySummaryMapTrigger");
var PropertySummaryChatbotLaunch = withPropertyDetailsQuery(SummaryChatbotLaunch, "PropertySummaryChatbotLaunch", SummaryComponentPlaceholder);
var PropertyShortlist = withPropertyDetailsQuery(Shortlist, "PropertyShortlist");
var PropertySaveTripItem = withPropertyDetailsQuery(SaveTripItem, "PropertySaveTripItem");
var PropertyDirectFeedbackPromptId = withPropertyDetailsQuery(PropertyDirectFeedbackCallToAction, "PropertyDirectFeedbackPromptId");
var PropertySummaryGeo = withPropertyDetailsQuery(SummaryGeo, "PropertySummaryGeo");
var PropertySummaryBannerMessage = withPropertyDetailsQuery(SummaryBannerMessage, "PropertyBannerMessage");
// src/components/property-additional-actions/property-additional-actions.tsx
import React167 from "react";
import { gql as gql147, useQuery as useQuery9 } from "@apollo/client";
import { useBexApi as useBexApi14 } from "@shared-ui/bex-api-context";
var __Query7 = gql147(_templateObject148(), FrequentlyAskedQuestions.fragment, HostProfile.fragment, SaveTripItem.fragment, Shortlist.fragment, InventorySource.fragment, PropertyDirectFeedbackPromptIdFragment, BookByPhone.fragment);
function withAdditionalActionsQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertySecSectionComponent = function(props) {
        var _data;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi14().context;
        var _inputs_isDateless;
        var variables = _object_spread_props(_object_spread({
            context: context
        }, inputs || {}), {
            isDateless: (_inputs_isDateless = inputs.isDateless) !== null && _inputs_isDateless !== void 0 ? _inputs_isDateless : true
        });
        var _useQuery9 = useQuery9(__Query7, {
            context: {
                useApq: true
            },
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery9.data, loading = _useQuery9.loading;
        var propertyInfo = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyInfo;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React167.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React167.createElement(InputsContextActions.Provider, {
            value: inputs
        }, /* @__PURE__ */ React167.createElement(WrappedComponent, _object_spread({
            data: propertyInfo
        }, props)));
    };
    PropertySecSectionComponent.displayName = displayName;
    return PropertySecSectionComponent;
}
var AdditionalActionsFaq = withAdditionalActionsQuery(FrequentlyAskedQuestions, "AdditionalActionsFaq");
var AdditionalActionsBookByPhone = withAdditionalActionsQuery(BookByPhone, "AdditionalActionsBookByPhone", BookByPhonePlaceholder);
var AdditionalActionsShortlist = withAdditionalActionsQuery(Shortlist, "AdditionalActionsShortlist");
var AdditionalActionsSaveTripItem = withAdditionalActionsQuery(SaveTripItem, "AdditionalActionsSaveTripItem");
var AdditionalActionsDirectFeedbackPromptId = withAdditionalActionsQuery(PropertyDirectFeedbackCallToAction, "AdditionalActionsDirectFeedbackPromptId");
var AdditionalActionsInventorySource = withAdditionalActionsQuery(InventorySource, "AdditionalActionsInventorySource");
var AdditionalActionsHostProfile = withAdditionalActionsQuery(HostProfile, "AdditionalActionsHostProfile");
// src/components/property-amenities-features/property-amenities-features.tsx
import React168, { useContext as useContext3, useEffect as useEffect5 } from "react";
import { gql as gql148, useQuery as useQuery10 } from "@apollo/client";
import { useBexApi as useBexApi15 } from "@shared-ui/bex-api-context";
var __Query8 = gql148(_templateObject149(), AmenityDescription.fragment, Policies.fragment, WhatsAround.fragment, AboutThisProperty.fragment, SpecialFeatures.fragment, DetailedAmenities.fragment, AmenitiesSimplifiedView.fragment, ImportantInfo.fragment);
var InputsContextAmenitiesFeatures = React168.createContext({});
function withPropertyAmenitiesFeatureQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertyAmenitiesFeatureSectionComponent = function(props) {
        var _data, _data_propertyInfo_summary_amenities, _data_propertyInfo_summary, _data_propertyInfo, _data1;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi15().context;
        var _useContext3 = _sliced_to_array(useContext3(AmenitiesAdaptExContext), 2), setAdaptExState = _useContext3[1];
        var variables = _object_spread({
            context: context
        }, inputs || {});
        var _useQuery10 = useQuery10(__Query8, {
            context: {
                useApq: true
            },
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery10.data, loading = _useQuery10.loading;
        var propertyInfo = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyInfo;
        var reserveAdaptExSuccessEvents = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_propertyInfo = _data1.propertyInfo) === null || _data_propertyInfo === void 0 ? void 0 : (_data_propertyInfo_summary = _data_propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : (_data_propertyInfo_summary_amenities = _data_propertyInfo_summary.amenities) === null || _data_propertyInfo_summary_amenities === void 0 ? void 0 : _data_propertyInfo_summary_amenities.reserveAdaptExSuccessEvents;
        useEffect5(function() {
            if (reserveAdaptExSuccessEvents) {
                setAdaptExState({
                    reserveAdaptExSuccessEvents: reserveAdaptExSuccessEvents
                });
            }
        }, [
            reserveAdaptExSuccessEvents
        ]);
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React168.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React168.createElement(InputsContextAmenitiesFeatures.Provider, {
            value: inputs
        }, /* @__PURE__ */ React168.createElement(WrappedComponent, _object_spread({
            data: propertyInfo
        }, props)));
    };
    PropertyAmenitiesFeatureSectionComponent.displayName = displayName;
    return PropertyAmenitiesFeatureSectionComponent;
}
var AmenityDescription2 = withPropertyAmenitiesFeatureQuery(AmenityDescription, "AmenityDescription");
var Policies2 = withPropertyAmenitiesFeatureQuery(Policies, "Policies");
var SpecialFeatures2 = withPropertyAmenitiesFeatureQuery(SpecialFeatures, "SpecialFeatures");
var AboutThisProperty2 = withPropertyAmenitiesFeatureQuery(AboutThisProperty, "AboutThisProperty");
var WhatsAround2 = withPropertyAmenitiesFeatureQuery(WhatsAround, "ImportantInfo");
var WhatsAroundPoisView2 = withPropertyAmenitiesFeatureQuery(WhatsAroundPoisView, "ImportantInfo");
var DetailedAmenities2 = withPropertyAmenitiesFeatureQuery(DetailedAmenities, "DetailedAmenities", SummaryComponentPlaceholder);
var AmenitiesSimplifiedView2 = withPropertyAmenitiesFeatureQuery(AmenitiesSimplifiedView, "AmenitiesSimplifiedView");
var ImportantInfo2 = withPropertyAmenitiesFeatureQuery(ImportantInfo, "ImportantInfo");
// src/components/property-main-section/property-main-section.tsx
import React169 from "react";
import { gql as gql149, useQuery as useQuery11 } from "@apollo/client";
import { useBexApi as useBexApi16 } from "@shared-ui/bex-api-context";
var __Query9 = gql149(_templateObject150(), Gallery.fragment);
var InputsContextMain = React169.createContext({});
function withPropertyMainSectionQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertyMainSectionComponent = function(props) {
        var _data;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi16().context;
        var variables = _object_spread({
            context: context
        }, inputs || {});
        var _useQuery11 = useQuery11(__Query9, {
            context: {
                useApq: true
            },
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery11.data, loading = _useQuery11.loading;
        var propertyInfo = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyInfo;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React169.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React169.createElement(InputsContextMain.Provider, {
            value: inputs
        }, /* @__PURE__ */ React169.createElement(WrappedComponent, _object_spread({
            data: propertyInfo
        }, props)));
    };
    PropertyMainSectionComponent.displayName = displayName;
    return PropertyMainSectionComponent;
}
var MainSectionPropertyGallery = withPropertyMainSectionQuery(Gallery, "MainSectionPropertyGallery", GalleryPlaceholder);
// src/components/property-summary/property-summary.tsx
import React170 from "react";
import { gql as gql150, useQuery as useQuery12 } from "@apollo/client";
import { useBexApi as useBexApi17 } from "@shared-ui/bex-api-context";
var __Query10 = gql150(_templateObject151(), __SummaryFragment, RelevantAmenities.fragment, LocationHighlights.fragment, SpaceOverview.fragment, NavigationBar.fragment);
function withSummaryQuery(WrappedComponent, displayName, LoadingPlaceholder) {
    var PropertyMainSectionComponent = function(props) {
        var _data;
        var skipSsr = props.skipSsr, placeholderData = props.placeholderData, inputs = props.inputs;
        var context = useBexApi17().context;
        var variables = _object_spread({
            context: context
        }, inputs || {});
        var _useQuery12 = useQuery12(__Query10, {
            context: {
                useApq: true
            },
            variables: variables,
            ssr: !skipSsr,
            errorPolicy: "all"
        }), data = _useQuery12.data, loading = _useQuery12.loading;
        var propertyInfo = (_data = data) === null || _data === void 0 ? void 0 : _data.propertyInfo;
        if (loading) {
            return LoadingPlaceholder ? /* @__PURE__ */ React170.createElement(LoadingPlaceholder, {
                data: placeholderData
            }) : null;
        }
        if (!propertyInfo) {
            return null;
        }
        return /* @__PURE__ */ React170.createElement(InputsContextSummary.Provider, {
            value: inputs
        }, /* @__PURE__ */ React170.createElement(WrappedComponent, _object_spread({
            data: propertyInfo
        }, props)));
    };
    PropertyMainSectionComponent.displayName = displayName;
    return PropertyMainSectionComponent;
}
var HighlightedSummary = Object.assign(withSummaryQuery(Summary, "MainSectionPropertySummary", SummaryPlaceholder), {
    CarouselComponent: CarouselComponent,
    HighlightedBenefitsComponent: HighlightedBenefitsComponent
});
var SummaryHeader2 = withSummaryQuery(SummaryHeader, "SummaryHeader", SummaryHeaderPlaceholder);
var SummaryReviews2 = withSummaryQuery(SummaryReviews, "SummaryReviews", SummaryComponentPlaceholder);
var SummaryAmenities2 = withSummaryQuery(SummaryAmenities, "SummaryAmenities", SummaryComponentPlaceholder);
var SummaryNearByPois2 = withSummaryQuery(SummaryNearByPois, "SummaryNearByPois");
var SummaryMapTrigger2 = withSummaryQuery(SummaryMapTrigger, "SummaryMapTrigger");
var SummaryChatbotLaunch2 = withSummaryQuery(SummaryChatbotLaunch, "SummaryChatbotLaunch", SummaryComponentPlaceholder);
var SummaryGeo2 = withSummaryQuery(SummaryGeo, "SummaryGeo");
var SummaryBannerMessage2 = withSummaryQuery(SummaryBannerMessage, "SummaryBannerMessage");
var SummaryRelevantAmenities = withSummaryQuery(RelevantAmenities, "SummaryRelevantAmenities");
var SummaryLocationHighlights = withSummaryQuery(LocationHighlights, "SummaryLocationHighlights");
var SummarySpaceOverview = withSummaryQuery(SpaceOverview, "SummarySpaceOverview");
var SummaryNavigationBar = withSummaryQuery(NavigationBar, "SummaryNavigationBar", NavigationBarPlaceholder);
export { AboutThisProperty2 as AboutThisProperty, AdditionalActionsBookByPhone, AdditionalActionsDirectFeedbackPromptId, AdditionalActionsFaq, AdditionalActionsHostProfile, AdditionalActionsInventorySource, AdditionalActionsSaveTripItem, AdditionalActionsShortlist, AmenitiesAdaptExContext, AmenitiesAdaptExProvider, AmenitiesSimplifiedView2 as AmenitiesSimplifiedView, AmenityDescription2 as AmenityDescription, DetailedAmenities2 as DetailedAmenities, HighlightedSummary, ImportantInfo2 as ImportantInfo, MainSectionPropertyGallery, Map, Policies2 as Policies, PropertyAboutThisProperty, PropertyAmenities, PropertyAmenitiesSimplifiedView, PropertyAmenityDescription, PropertyBookByPhone, PropertyCleanliness, PropertyDetailedAmenities, PropertyDirectFeedbackPromptId, PropertyFaq, PropertyGallery, PropertyHostProfile, PropertyImportantInfo, PropertyInfoDetails, PropertyInventorySource, PropertyLocationHighlights, PropertyNavigationBar, PropertyPolicies, PropertyRelevantAmenities, PropertySaveTripItem, PropertyShortlist, PropertySimilar, PropertySpaceOverview, PropertySpaces, PropertySpecialFeatures, PropertySummary, PropertySummaryAmenities, PropertySummaryBannerMessage, PropertySummaryChatbotLaunch, PropertySummaryGeo, PropertySummaryHeader, PropertySummaryMapTrigger, PropertySummaryNearByPois, PropertySummaryReviews, PropertyWhatsAround, PropertyWhatsAroundPoisView, SpecialFeatures2 as SpecialFeatures, SummaryAmenities2 as SummaryAmenities, SummaryBannerMessage2 as SummaryBannerMessage, SummaryChatbotLaunch2 as SummaryChatbotLaunch, SummaryGeo2 as SummaryGeo, SummaryHeader2 as SummaryHeader, SummaryLocationHighlights, SummaryMapTrigger2 as SummaryMapTrigger, SummaryNavigationBar, SummaryNearByPois2 as SummaryNearByPois, SummaryRelevantAmenities, SummaryReviews2 as SummaryReviews, SummarySpaceOverview, WhatsAround2 as WhatsAround, WhatsAroundPoisView2 as WhatsAroundPoisView }; /* istanbul ignore file -- @preserve */  // istanbul ignore next -- @preserve
 /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map